import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.agent');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-agent',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.agent/view.scss */
:host {
  display: block;
  height: 100%;
}

/* Administrator model workspaces */
.admin-settings-tabs {
  display: flex;
  gap: 6px;
  margin-top: 16px;
  overflow-x: auto;
  scrollbar-width: none;
}

.admin-settings-tabs::-webkit-scrollbar {
  display: none;
}

.admin-settings-tabs button {
  display: inline-flex;
  min-height: 38px;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  border: 1px solid transparent;
  border-radius: 999px !important;
  padding: 0 14px;
  color: #64748b;
  font-size: 13px;
  font-weight: 650;
  transition: 150ms ease;
}

.admin-settings-tabs button:hover {
  background: #f4f7fb;
  color: #0f172a;
}

.admin-settings-tabs button.is-active {
  border-color: #dbeafe;
  background: #eff6ff;
  color: #1d4ed8;
}

.document-pipeline-settings {
  overflow: hidden;
  border: 1px solid #d9e1ec;
  border-radius: 16px !important;
  background: #fff;
}

.document-pipeline-settings__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid #e8edf5;
  padding: 16px 18px;
}

.document-pipeline-settings__version {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border-radius: 999px !important;
  background: #eef2ff;
  padding: 0 9px;
  color: #4338ca;
  font-size: 12px;
  font-weight: 700;
}

.document-pipeline-button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 999px !important;
  padding: 0 14px;
  font-size: 12px;
  font-weight: 700;
}

.document-pipeline-button.is-secondary {
  border: 1px solid #d9e1ec;
  background: #fff;
  color: #334155;
}

.document-pipeline-button.is-primary {
  border: 1px solid #0f172a;
  background: #0f172a;
  color: #fff;
}

.document-pipeline-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.document-pipeline-settings__error {
  border-bottom: 1px solid #fee2e2;
  background: #fef2f2;
  padding: 10px 18px;
  color: #b91c1c;
  font-size: 12px;
  line-height: 1.55;
}

.document-pipeline-flow {
  display: grid;
  grid-template-columns: repeat(7, minmax(120px, 1fr));
  gap: 8px;
  overflow-x: auto;
  border-bottom: 1px solid #e8edf5;
  background: #f8fafc;
  padding: 14px 18px;
}

.document-pipeline-stage {
  position: relative;
  display: grid;
  min-width: 132px;
  grid-template-columns: 24px minmax(0, 1fr);
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 12px !important;
  background: #fff;
  padding: 10px;
}

.document-pipeline-stage__index {
  display: grid;
  width: 24px;
  height: 24px;
  place-items: center;
  border-radius: 999px !important;
  background: #f1f5f9;
  color: #475569;
  font-size: 12px;
  font-weight: 750;
}

.document-pipeline-stage p {
  overflow: hidden;
  color: #0f172a;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-pipeline-stage span {
  display: -webkit-box;
  margin-top: 3px;
  overflow: hidden;
  color: #64748b;
  font-size: 12px;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.document-pipeline-stage > strong {
  grid-column: 2;
  width: fit-content;
  border-radius: 999px !important;
  background: #f1f5f9;
  padding: 2px 7px;
  color: #64748b;
  font-size: 12px;
}

.document-pipeline-stage.is-ready {
  border-color: #bbf7d0;
}

.document-pipeline-stage.is-ready .document-pipeline-stage__index,
.document-pipeline-stage.is-ready > strong {
  background: #ecfdf5;
  color: #047857;
}

.document-pipeline-stage.is-warning {
  border-color: #fed7aa;
}

.document-pipeline-stage.is-warning .document-pipeline-stage__index,
.document-pipeline-stage.is-warning > strong {
  background: #fff7ed;
  color: #b45309;
}

.document-pipeline-stage.is-blocked {
  border-color: #fecaca;
}

.document-pipeline-stage.is-blocked .document-pipeline-stage__index,
.document-pipeline-stage.is-blocked > strong {
  background: #fef2f2;
  color: #b91c1c;
}

.document-pipeline-flow__empty {
  grid-column: 1/-1;
  padding: 18px;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}

.document-pipeline-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(320px, 0.75fr);
  gap: 14px;
  background: #f7f9fc;
  padding: 14px;
}

.document-pipeline-main,
.document-pipeline-aside {
  display: grid;
  align-content: start;
  gap: 14px;
}

.document-pipeline-card {
  border: 1px solid #dfe6ef;
  border-radius: 14px !important;
  background: #fff;
  padding: 16px;
}

.document-pipeline-card__heading {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 16px;
}

.document-pipeline-card__heading h3 {
  color: #0f172a;
  font-size: 14px;
  font-weight: 750;
}

.document-pipeline-card__heading p {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.55;
}

.document-pipeline-card__icon {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 10px !important;
  font-size: 14px;
}

.document-pipeline-card__icon.is-blue {
  background: #eff6ff;
  color: #2563eb;
}

.document-pipeline-card__icon.is-violet {
  background: #f5f3ff;
  color: #7c3aed;
}

.document-pipeline-card__icon.is-amber {
  background: #fffbeb;
  color: #b45309;
}

.document-pipeline-card__icon.is-emerald {
  background: #ecfdf5;
  color: #047857;
}

.document-pipeline-card__icon.is-red {
  background: #fef2f2;
  color: #dc2626;
}

.document-pipeline-fieldset {
  min-width: 0;
  border: 0;
  padding: 0;
}

.document-pipeline-fieldset legend,
.document-pipeline-field > span {
  display: block;
  margin-bottom: 7px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.document-format-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(70px, 1fr));
  gap: 7px;
}

.document-format-option {
  position: relative;
  display: flex;
  min-height: 42px;
  cursor: pointer;
  align-items: center;
  gap: 7px;
  border: 1px solid #d9e1ec;
  border-radius: 10px !important;
  padding: 0 9px;
  color: #475569;
}

.document-format-option.is-checked {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}

.document-format-option input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.document-format-option__mark {
  display: grid;
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid #cbd5e1;
  border-radius: 5px !important;
  background: #fff;
  color: transparent;
  font-size: 12px;
}

.document-format-option.is-checked .document-format-option__mark {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
}

.document-format-option strong {
  font-size: 12px;
  font-weight: 700;
}

.document-pipeline-two-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.document-pipeline-field input,
.document-pipeline-field select {
  width: 100%;
  min-height: 40px;
  border: 1px solid #d9e1ec;
  border-radius: 9px !important;
  background: #fff;
  padding: 0 11px;
  color: #0f172a;
  font-size: 13px;
  outline: none;
}

.document-pipeline-field input:focus,
.document-pipeline-field select:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.document-pipeline-field input:disabled,
.document-pipeline-field select:disabled,
.is-disabled .document-pipeline-field {
  cursor: not-allowed;
  opacity: 0.58;
}

.document-toggle-row {
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-radius: 10px !important;
  background: #f8fafc;
  padding: 10px 12px;
}

.document-toggle-row.is-bordered {
  border: 1px solid #e2e8f0;
}

.document-toggle-row strong,
.document-toggle-row small {
  display: block;
}

.document-toggle-row strong {
  color: #334155;
  font-size: 13px;
}

.document-toggle-row small {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.document-toggle-row input[role=switch] {
  width: 38px;
  height: 22px;
  flex: 0 0 auto;
  cursor: pointer;
  accent-color: #2563eb;
}

.document-structure-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.document-structure-options label {
  position: relative;
  cursor: pointer;
}

.document-structure-options input {
  position: absolute;
  opacity: 0;
}

.document-structure-options span {
  display: flex;
  min-height: 46px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #d9e1ec;
  border-radius: 10px !important;
  color: #64748b;
}

.document-structure-options input:checked + span {
  border-color: #c4b5fd;
  background: #f5f3ff;
  color: #6d28d9;
}

.document-structure-options strong {
  font-size: 12px;
}

.document-pipeline-input-with-unit {
  position: relative;
}

.document-pipeline-input-with-unit input {
  padding-right: 36px;
}

.document-pipeline-input-with-unit small {
  position: absolute;
  top: 50%;
  right: 12px;
  color: #94a3b8;
  font-size: 12px;
  transform: translateY(-50%);
}

.document-pipeline-help {
  margin-top: 10px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.document-pipeline-capability-note,
.document-category-policy {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  border-radius: 9px !important;
  background: #f8fafc;
  padding: 9px 10px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.document-pipeline-capability-note.is-ready {
  background: #ecfdf5;
  color: #047857;
}

.document-pipeline-capability-note.is-warning,
.document-category-policy {
  background: #fffbeb;
  color: #92400e;
}

.document-qdrant-status {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 13px;
  border-radius: 10px !important;
  background: #f8fafc;
  padding: 11px;
}

.document-qdrant-status__dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  margin-top: 5px;
  border-radius: 999px;
  background: #94a3b8;
}

.document-qdrant-status strong,
.document-qdrant-status p {
  display: block;
  font-size: 12px;
}

.document-qdrant-status strong {
  color: #334155;
}

.document-qdrant-status p {
  margin-top: 3px;
  color: #64748b;
  line-height: 1.45;
}

.document-qdrant-status.is-ready {
  background: #ecfdf5;
}

.document-qdrant-status.is-ready .document-qdrant-status__dot {
  background: #10b981;
}

.document-qdrant-status.is-warning {
  background: #fff7ed;
}

.document-qdrant-status.is-warning .document-qdrant-status__dot {
  background: #f59e0b;
}

.document-pipeline-test-result {
  border: 1px solid #d9e1ec;
  border-radius: 12px !important;
  background: #fff;
  padding: 13px;
  color: #475569;
  font-size: 12px;
}

.document-pipeline-test-result.is-loading {
  display: flex;
  align-items: center;
  gap: 10px;
}

.document-pipeline-test-result.is-ready {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.document-pipeline-test-result.is-warning {
  border-color: #fed7aa;
  background: #fff7ed;
}

.document-pipeline-test-result p {
  margin-top: 6px;
  line-height: 1.5;
}

.document-pipeline-test-result ul {
  display: grid;
  gap: 5px;
  margin-top: 10px;
}

.document-pipeline-test-result li {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

@media (max-width: 1100px) {
  .document-pipeline-layout {
    grid-template-columns: 1fr;
  }
  .document-format-grid {
    grid-template-columns: repeat(3, minmax(80px, 1fr));
  }
}
@media (max-width: 680px) {
  .document-pipeline-settings__header {
    align-items: stretch;
    flex-direction: column;
  }
  .document-pipeline-button {
    flex: 1 1 140px;
  }
  .document-pipeline-layout {
    padding: 10px;
  }
  .document-pipeline-two-columns,
  .document-structure-options {
    grid-template-columns: 1fr;
  }
  .document-format-grid {
    grid-template-columns: repeat(2, minmax(80px, 1fr));
  }
}
/* Agent document hub ------------------------------------------------------ */
.agent-document-hub {
  background: radial-gradient(circle at 88% 0%, color-mix(in srgb, var(--nf-brand) 8%, transparent), transparent 27%), var(--nf-page-bg);
  color: var(--nf-text);
}

.agent-document-hub__header {
  display: flex;
  width: 100%;
  min-height: 168px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 30px 20px 26px;
}

.agent-document-hub__header-inner {
  position: relative;
  display: grid;
  width: min(1320px, 100%);
  min-width: 0;
  grid-template-columns: minmax(130px, 150px) minmax(0, 780px) minmax(130px, 150px);
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.agent-document-hub__header-copy {
  display: flex;
  width: 100%;
  min-width: 0;
  grid-column: 2;
  flex-direction: column;
  align-items: center;
  margin-top: 18px;
  text-align: center;
}

.agent-document-hub__eyebrow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: var(--nf-brand);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.13em;
}

.agent-document-hub__sample-pill,
.agent-document-card__sample {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid var(--nf-warning-border);
  border-radius: 999px;
  background: var(--nf-warning-soft);
  color: var(--nf-warning);
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0;
}

.agent-document-hub__sample-pill {
  padding: 4px 8px;
}

.agent-document-hub__header h2 {
  max-width: 760px;
  margin: 10px 0 0;
  color: var(--nf-ink);
  font-size: clamp(27px, 2.25vw, 34px);
  font-weight: 760;
  letter-spacing: -0.045em;
  line-height: 1.25;
}

.agent-document-hub__header-copy > p {
  max-width: 720px;
  margin: 11px 0 0;
  color: var(--nf-muted);
  font-size: 14px;
  line-height: 1.65;
}

.agent-document-hub__export {
  display: inline-flex;
  min-height: 40px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  grid-column: 3;
  justify-self: end;
  gap: 8px;
  border: 1px solid var(--nf-border);
  border-radius: 10px;
  background: var(--nf-panel);
  padding: 0 14px;
  color: var(--nf-text);
  font-size: 12px;
  font-weight: 850;
  transition: border-color 160ms ease, color 160ms ease, box-shadow 160ms ease;
}

.agent-document-hub__export:hover {
  border-color: var(--nf-border-strong);
  color: var(--nf-brand);
  box-shadow: 0 8px 20px color-mix(in srgb, var(--nf-brand) 8%, transparent);
}

.agent-document-hub__content {
  width: min(1320px, 100% - 40px);
  margin: 0 auto;
  padding: 20px 0 36px;
}

.agent-document-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.agent-document-metric {
  display: grid;
  min-width: 0;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  border: 1px solid var(--nf-border-soft);
  border-radius: 14px;
  background: var(--nf-panel);
  padding: 14px;
  box-shadow: 0 9px 24px rgba(15, 23, 42, 0.045);
}

.agent-document-metric__icon {
  display: inline-grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 12px;
  background: color-mix(in srgb, var(--metric-color, var(--nf-brand)) 11%, var(--nf-panel));
  color: var(--metric-color, var(--nf-brand));
  font-size: 17px;
  line-height: 1;
}

.agent-document-metric__icon i {
  display: inline-flex;
  width: 1.15em;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-align: center;
}

.agent-document-metric.is-blue {
  --metric-color: #2563eb;
}

.agent-document-metric.is-violet {
  --metric-color: #7c3aed;
}

.agent-document-metric.is-cyan {
  --metric-color: #0891b2;
}

.agent-document-metric.is-green {
  --metric-color: #0f9f7f;
}

.agent-document-metric p,
.agent-document-metric div > span,
.agent-document-metric strong {
  display: block;
}

.agent-document-metric p {
  margin: 0;
  color: var(--nf-muted);
  font-size: 12px;
  font-weight: 750;
}

.agent-document-metric strong {
  overflow: hidden;
  margin-top: 3px;
  color: var(--nf-ink);
  font-size: 21px;
  font-weight: 900;
  letter-spacing: -0.035em;
  line-height: 1.05;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-metric strong small {
  display: inline;
  margin-left: 3px;
  color: var(--nf-muted);
  font-size: 12px;
  font-weight: 750;
}

.agent-document-metric div > span {
  margin-top: 4px;
  overflow: hidden;
  color: var(--nf-muted);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-pipeline {
  display: grid;
  grid-template-columns: minmax(210px, 0.68fr) minmax(0, 1.7fr);
  align-items: center;
  gap: 20px;
  margin-top: 12px;
  border: 1px solid color-mix(in srgb, var(--nf-brand) 20%, var(--nf-border-soft));
  border-radius: 14px;
  background: linear-gradient(120deg, color-mix(in srgb, var(--nf-brand) 6%, var(--nf-panel)), var(--nf-panel) 52%);
  padding: 13px 16px;
}

.agent-document-pipeline__title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 11px;
}

.agent-document-pipeline__mark {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: color-mix(in srgb, var(--nf-brand) 12%, var(--nf-panel));
  color: var(--nf-brand);
}

.agent-document-pipeline h3,
.agent-document-pipeline p {
  margin: 0;
}

.agent-document-pipeline h3 {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 900;
}

.agent-document-pipeline p {
  margin-top: 3px;
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-pipeline ol {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  column-gap: 24px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.agent-document-pipeline li {
  position: relative;
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
  padding-right: 0;
}

.agent-document-pipeline li strong,
.agent-document-pipeline li small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-pipeline li strong {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 850;
}

.agent-document-pipeline li small {
  margin-top: 2px;
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-pipeline__arrow {
  position: absolute;
  right: -16px;
  color: var(--nf-border-strong);
  font-size: 12px;
}

.agent-document-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 16px;
  margin-top: 16px;
}

.agent-document-categories {
  position: sticky;
  top: 16px;
  overflow: hidden;
  border: 1px solid var(--nf-border-soft);
  border-radius: 14px;
  background: var(--nf-panel);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.045);
}

.agent-document-categories__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid var(--nf-border-soft);
  padding: 15px 14px 13px;
}

.agent-document-categories__head h3,
.agent-document-categories__head p {
  margin: 0;
}

.agent-document-categories__head h3 {
  color: var(--nf-ink);
  font-size: 13px;
  font-weight: 900;
}

.agent-document-categories__head p {
  margin-top: 4px;
  color: var(--nf-muted);
  font-size: 12px;
  line-height: 1.45;
}

.agent-document-categories__head > span {
  display: inline-flex;
  min-width: 26px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--nf-panel-soft);
  color: var(--nf-muted);
  font-size: 12px;
  font-weight: 850;
}

.agent-document-categories nav {
  max-height: min(505px, 100vh - 330px);
  overflow-y: auto;
  padding: 7px;
}

.agent-document-categories nav button {
  display: grid;
  width: 100%;
  min-width: 0;
  grid-template-columns: 30px minmax(0, 1fr) 24px;
  align-items: center;
  gap: 9px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  padding: 8px;
  color: var(--nf-text);
  text-align: left;
  transition: border-color 150ms ease, background 150ms ease;
}

.agent-document-categories nav button + button {
  margin-top: 2px;
}

.agent-document-categories nav button:hover {
  background: var(--nf-panel-soft);
}

.agent-document-categories nav button.is-active {
  border-color: color-mix(in srgb, var(--nf-brand) 28%, var(--nf-border));
  background: color-mix(in srgb, var(--nf-brand) 8%, var(--nf-panel));
}

.agent-document-category__icon {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: color-mix(in srgb, var(--category-color, var(--nf-brand)) 11%, var(--nf-panel));
  color: var(--category-color, var(--nf-brand));
  font-size: 12px;
}

.agent-document-category__icon.is-all {
  --category-color: var(--nf-brand);
}

.tone-1 {
  --category-color: #2563eb;
}

.tone-2 {
  --category-color: #7c3aed;
}

.tone-3 {
  --category-color: #0891b2;
}

.tone-4 {
  --category-color: #0f9f7f;
}

.tone-5 {
  --category-color: #d97706;
}

.tone-6 {
  --category-color: #db2777;
}

.tone-7 {
  --category-color: #4f46e5;
}

.tone-8 {
  --category-color: #0d9488;
}

.tone-9 {
  --category-color: #ea580c;
}

.tone-10 {
  --category-color: #e11d48;
}

.tone-11 {
  --category-color: #65a30d;
}

.tone-12 {
  --category-color: #9333ea;
}

.agent-document-category__copy {
  min-width: 0;
}

.agent-document-category__copy strong,
.agent-document-category__copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-category__copy strong {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 800;
}

.agent-document-category__copy small {
  margin-top: 2px;
  color: var(--nf-muted);
  font-size: 12px;
  line-height: 1.4;
}

.agent-document-categories nav button:hover .agent-document-category__copy small,
.agent-document-categories nav button:focus-visible .agent-document-category__copy small {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
}

.agent-document-categories nav button em {
  color: var(--nf-muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 750;
  text-align: right;
}

.agent-document-results {
  min-width: 0;
}

.agent-document-search {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) auto;
  align-items: end;
  gap: 10px;
  overflow: visible;
  border: 1px solid var(--nf-border-soft);
  border-radius: 14px;
  background: var(--nf-panel);
  padding: 11px;
}

.agent-document-search__field {
  position: relative;
  z-index: 1;
  display: grid;
  min-width: 0;
  height: 43px;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  align-items: stretch;
  overflow: hidden;
  border: 1px solid var(--nf-border);
  border-radius: 11px;
  background: var(--nf-panel-soft);
  color: var(--nf-muted);
  transition: border-color 150ms ease, box-shadow 150ms ease, background-color 150ms ease;
}

.agent-document-search__field > i {
  display: grid;
  width: 40px;
  height: 100%;
  place-items: center;
  margin: 0;
  font-size: 12px;
  line-height: 1;
  text-align: center;
}

.agent-document-search__field input {
  min-width: 0;
  width: 100%;
  height: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  padding: 0 8px 0 0;
  color: var(--nf-ink);
  font-size: 12px;
  box-shadow: none !important;
}

.agent-document-search__field input:focus,
.agent-document-search__field input:focus-visible {
  border: 0;
  outline: 0;
  box-shadow: none !important;
}

.agent-document-search__field input::placeholder {
  color: var(--nf-muted);
}

.agent-document-search__field button {
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  align-self: center;
  border-radius: 8px;
  color: var(--nf-muted);
}

.agent-document-search__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.agent-document-search__action {
  display: inline-flex;
  min-width: 132px;
  height: 43px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid var(--nf-border);
  border-radius: 10px;
  background: var(--nf-panel);
  padding: 0 12px;
  color: var(--nf-text);
  font-size: 12px;
  font-weight: 800;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
}

.agent-document-search__action:hover,
.agent-document-search__action.is-active {
  border-color: color-mix(in srgb, var(--nf-brand) 34%, var(--nf-border));
  background: color-mix(in srgb, var(--nf-brand) 7%, var(--nf-panel));
  color: var(--nf-brand);
}

.agent-document-search__action.is-reset {
  min-width: 116px;
  border: 0;
  background: transparent;
  color: var(--nf-muted);
}

.agent-document-search__action.is-reset:hover:not(:disabled) {
  border-color: transparent;
  background: var(--nf-panel-soft);
  color: var(--nf-brand);
}

.agent-document-search__action:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.agent-document-search__action em {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--nf-brand);
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
}

.agent-document-search__action .fa-chevron-down {
  font-size: 12px;
  transition: transform 150ms ease;
}

.agent-document-search__action .fa-chevron-down.is-rotated {
  transform: rotate(180deg);
}

.agent-document-search__field:focus-within {
  border-color: var(--nf-brand);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--nf-brand) 8%, transparent);
}

.agent-document-filter-panel {
  grid-column: 1/-1;
  border: 1px solid var(--nf-border-soft);
  border-radius: 12px;
  background: var(--nf-panel-soft);
  padding: 14px;
}

.agent-document-filter-panel > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid var(--nf-border-soft);
  padding-bottom: 11px;
}

.agent-document-filter-panel > header strong,
.agent-document-filter-panel > header p,
.agent-document-filter-section > p {
  margin: 0;
}

.agent-document-filter-panel > header strong {
  color: var(--nf-ink);
  font-size: 13px;
  font-weight: 900;
}

.agent-document-filter-panel > header p {
  margin-top: 3px;
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-filter-panel > header > button {
  display: grid;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 8px;
  color: var(--nf-muted);
}

.agent-document-filter-panel > header > button:hover {
  background: var(--nf-panel);
  color: var(--nf-ink);
}

.agent-document-filter-panel__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 15px 20px;
  padding-top: 13px;
}

.agent-document-filter-section.is-category {
  grid-column: 1/-1;
}

.agent-document-filter-section > p {
  margin-bottom: 7px;
  color: var(--nf-text);
  font-size: 12px;
  font-weight: 850;
}

.agent-document-filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.agent-document-filter-options button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid var(--nf-border);
  border-radius: 9px;
  background: var(--nf-panel);
  padding: 0 11px;
  color: var(--nf-text);
  font-size: 12px;
  font-weight: 750;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
}

.agent-document-filter-options button:hover {
  border-color: var(--nf-border-strong);
  background: #fff;
}

.agent-document-filter-options button.is-active {
  border-color: color-mix(in srgb, var(--nf-brand) 34%, var(--nf-border));
  background: color-mix(in srgb, var(--nf-brand) 9%, var(--nf-panel));
  color: var(--nf-brand);
  font-weight: 850;
}

.agent-document-results__category.is-all {
  --category-color: var(--nf-brand);
}

.agent-document-results__head {
  display: flex;
  min-height: 52px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 8px 2px;
}

.agent-document-results__head h3,
.agent-document-results__head p {
  margin: 0;
}

.agent-document-results__heading {
  display: flex;
  align-items: center;
  gap: 7px;
}

.agent-document-results__category {
  --category-color: var(--nf-brand);
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  gap: 5px;
  border: 1px solid color-mix(in srgb, var(--category-color) 25%, var(--nf-border));
  border-radius: 999px;
  background: color-mix(in srgb, var(--category-color) 8%, var(--nf-panel));
  padding: 0 8px;
  color: var(--category-color);
  font-size: 12px;
  font-weight: 800;
}

.agent-document-results__head h3 {
  color: var(--nf-ink);
  font-size: 13px;
  font-weight: 900;
}

.agent-document-results__head p {
  margin-top: 2px;
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-results__head p strong {
  color: var(--nf-brand);
}

.agent-document-results__sort {
  position: relative;
  display: inline-block;
  width: fit-content;
  max-width: 100%;
  flex: 0 0 auto;
  margin-left: auto;
}

.agent-document-results__sort select {
  width: auto;
  max-width: 100%;
  height: 36px;
  appearance: none;
  border: 0;
  border-bottom: 1px solid var(--nf-border);
  border-radius: 0;
  outline: 0;
  background: transparent !important;
  background-image: none !important;
  padding: 0 29px 0 8px;
  color: var(--nf-text);
  font-size: 12px;
  font-weight: 750;
  text-align: right;
  text-align-last: right;
}

.agent-document-results__sort select:focus {
  border-bottom-color: var(--nf-brand);
  box-shadow: none;
}

.agent-document-results__sort > i {
  position: absolute;
  top: 50%;
  right: 5px;
  color: var(--nf-muted);
  font-size: 12px;
  line-height: 1;
  pointer-events: none;
  transform: translateY(-50%);
}

.agent-document-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.agent-document-card {
  display: flex;
  min-width: 0;
  min-height: 315px;
  flex-direction: column;
  border: 1px solid var(--nf-border-soft);
  border-radius: 14px;
  background: var(--nf-panel);
  padding: 15px;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.045);
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.agent-document-card:hover {
  border-color: color-mix(in srgb, var(--nf-brand) 34%, var(--nf-border));
  box-shadow: 0 15px 34px color-mix(in srgb, var(--nf-brand) 9%, transparent);
  transform: translateY(-2px);
}

.agent-document-card__top,
.agent-document-card__top > div,
.agent-document-card footer,
.agent-document-card footer > div {
  display: flex;
  align-items: center;
}

.agent-document-card__top,
.agent-document-card footer {
  justify-content: space-between;
  gap: 10px;
}

.agent-document-card__top > div {
  gap: 5px;
}

.agent-document-card__type {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  gap: 6px;
  border-radius: 7px;
  background: color-mix(in srgb, var(--doc-type-color, var(--nf-brand)) 10%, var(--nf-panel));
  padding: 0 8px;
  color: var(--doc-type-color, var(--nf-brand));
  font-size: 12px;
  font-weight: 850;
}

.agent-document-card__type.is-paper {
  --doc-type-color: #2563eb;
}

.agent-document-card__type.is-technical {
  --doc-type-color: #7c3aed;
}

.agent-document-card__type.is-manual {
  --doc-type-color: #0891b2;
}

.agent-document-card__type.is-glossary {
  --doc-type-color: #0f9f7f;
}

.agent-document-card__sample {
  min-height: 21px;
  padding: 0 6px;
  font-size: 12px;
}

.agent-document-card__language {
  color: var(--nf-muted);
  font-size: 12px;
  font-weight: 750;
}

.agent-document-card__title {
  display: -webkit-box;
  width: fit-content;
  max-width: 100%;
  margin-top: 13px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: var(--nf-ink);
  font-size: 15px;
  font-weight: 900;
  letter-spacing: -0.02em;
  line-height: 1.38;
  text-align: left;
}

.agent-document-card__title:hover {
  color: var(--nf-brand);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.agent-document-card__subtitle {
  margin: 5px 0 0;
  overflow: hidden;
  color: var(--nf-muted);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-card__summary {
  display: -webkit-box;
  min-height: 51px;
  margin: 11px 0 0;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  color: var(--nf-text);
  font-size: 12px;
  line-height: 1.55;
}

.agent-document-card__categories,
.agent-document-insight__categories {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.agent-document-card__categories {
  min-height: 45px;
  align-content: flex-start;
  margin-top: 11px;
}

.agent-document-card__categories span,
.agent-document-insight__categories span {
  display: inline-flex;
  align-items: center;
  border: 1px solid color-mix(in srgb, var(--category-color, var(--nf-brand)) 23%, var(--nf-border));
  border-radius: 999px;
  background: color-mix(in srgb, var(--category-color, var(--nf-brand)) 7%, var(--nf-panel));
  color: color-mix(in srgb, var(--category-color, var(--nf-brand)) 82%, var(--nf-ink));
  font-size: 12px;
  font-weight: 750;
}

.agent-document-card__categories span {
  min-height: 21px;
  padding: 0 7px;
}

.agent-document-card__facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: auto 0 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 9px;
  background: var(--nf-panel-soft);
}

.agent-document-card__facts div {
  min-width: 0;
  padding: 7px 9px;
}

.agent-document-card__facts div + div {
  border-left: 1px solid var(--nf-border-soft);
}

.agent-document-card__facts dt,
.agent-document-card__facts dd {
  margin: 0;
}

.agent-document-card__facts dt {
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-card__facts dd {
  margin-top: 2px;
  overflow: hidden;
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-card__facts dd i {
  margin-right: 3px;
  color: var(--nf-success);
}

.agent-document-card footer {
  margin-top: 11px;
  border-top: 1px solid var(--nf-border-soft);
  padding-top: 10px;
}

.agent-document-card footer > div {
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
}

.agent-document-card footer span,
.agent-document-card footer small {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-card footer > div span {
  color: var(--nf-text);
  font-size: 12px;
  font-weight: 750;
}

.agent-document-card footer small {
  margin-top: 2px;
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-card footer > button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  color: var(--nf-brand);
  font-size: 12px;
  font-weight: 850;
}

.agent-document-empty {
  display: flex;
  min-height: 330px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px dashed var(--nf-border-strong);
  border-radius: 14px;
  background: color-mix(in srgb, var(--nf-panel) 72%, transparent);
  padding: 32px;
  text-align: center;
}

.agent-document-empty > span {
  display: inline-flex;
  width: 52px;
  height: 52px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: var(--nf-panel-soft);
  color: var(--nf-muted);
  font-size: 20px;
}

.agent-document-empty h3 {
  margin: 14px 0 0;
  color: var(--nf-ink);
  font-size: 15px;
  font-weight: 900;
}

.agent-document-empty p {
  margin: 6px 0 0;
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-empty button {
  margin-top: 17px;
  border-radius: 9px;
  background: var(--nf-brand-button);
  padding: 9px 13px;
  color: #fff;
  font-size: 12px;
  font-weight: 850;
}

.agent-document-modal-backdrop {
  position: fixed;
  z-index: 90;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(4, 10, 20, 0.72);
  padding: 24px;
  backdrop-filter: blur(8px);
}

.agent-document-modal {
  display: grid;
  width: min(1360px, 100%);
  height: min(840px, 100vh - 48px);
  overflow: hidden;
  grid-template-rows: auto minmax(0, 1fr);
  border: 1px solid var(--nf-border);
  border-radius: 18px;
  outline: 0;
  background: var(--nf-panel);
  box-shadow: 0 34px 90px rgba(0, 0, 0, 0.36);
}

.agent-document-modal:focus-visible {
  box-shadow: 0 0 0 3px var(--nf-brand), 0 34px 90px rgba(0, 0, 0, 0.36);
}

.agent-document-modal__header {
  display: flex;
  min-height: 74px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 12px 16px 12px 20px;
}

.agent-document-modal__identity {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.agent-document-modal__identity > div {
  min-width: 0;
}

.agent-document-modal__identity h2,
.agent-document-modal__identity p {
  margin: 0;
}

.agent-document-modal__identity h2 {
  overflow: hidden;
  color: var(--nf-ink);
  font-size: 16px;
  font-weight: 900;
  letter-spacing: -0.02em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-modal__identity p {
  margin-top: 4px;
  overflow: hidden;
  color: var(--nf-muted);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-modal__close {
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--nf-border);
  border-radius: 10px;
  background: var(--nf-panel-soft);
  color: var(--nf-text);
  font-size: 14px;
}

.agent-document-modal__close:hover {
  border-color: var(--nf-border-strong);
  color: var(--nf-ink);
}

.agent-document-modal__body {
  display: grid;
  min-height: 0;
  grid-template-columns: minmax(0, 1.75fr) minmax(330px, 0.78fr);
}

.agent-document-viewer {
  display: grid;
  min-width: 0;
  min-height: 0;
  grid-template-columns: 170px minmax(0, 1fr);
  border-right: 1px solid var(--nf-border-soft);
  background: color-mix(in srgb, var(--nf-page-bg) 76%, #dbe4ef);
}

.agent-document-page-list {
  min-width: 0;
  overflow-y: auto;
  border-right: 1px solid var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 12px 9px;
}

.agent-document-page-list > p {
  margin: 0 5px 9px;
  color: var(--nf-muted);
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0.06em;
}

.agent-document-page-list button {
  display: grid;
  width: 100%;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 9px;
  padding: 7px;
  text-align: left;
}

.agent-document-page-list button + button {
  margin-top: 4px;
}

.agent-document-page-list button:hover {
  background: var(--nf-panel-soft);
}

.agent-document-page-list button.is-active {
  border-color: color-mix(in srgb, var(--nf-brand) 30%, var(--nf-border));
  background: color-mix(in srgb, var(--nf-brand) 8%, var(--nf-panel));
}

.agent-document-page-list button > span {
  display: inline-flex;
  width: 30px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--nf-border);
  border-radius: 5px;
  background: #fff;
  color: #64748b;
  box-shadow: 0 3px 8px rgba(15, 23, 42, 0.07);
}

.agent-document-page-list button strong,
.agent-document-page-list button small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-document-page-list button strong {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 850;
}

.agent-document-page-list button small {
  margin-top: 3px;
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-viewer__main {
  display: grid;
  min-width: 0;
  min-height: 0;
  grid-template-rows: 50px minmax(0, 1fr);
}

.agent-document-viewer__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--nf-border-soft);
  background: color-mix(in srgb, var(--nf-panel) 94%, transparent);
  padding: 7px 12px;
}

.agent-document-viewer__toolbar > div:first-child strong,
.agent-document-viewer__toolbar > div:first-child span {
  display: block;
}

.agent-document-viewer__toolbar > div:first-child strong {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 850;
}

.agent-document-viewer__toolbar > div:first-child span {
  margin-top: 2px;
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-viewer__paging {
  display: flex;
  align-items: center;
  gap: 7px;
}

.agent-document-viewer__paging button {
  display: inline-flex;
  width: 29px;
  height: 29px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--nf-border);
  border-radius: 8px;
  background: var(--nf-panel);
  color: var(--nf-text);
  font-size: 12px;
}

.agent-document-viewer__paging button:disabled {
  opacity: 0.34;
}

.agent-document-viewer__paging span {
  min-width: 48px;
  color: var(--nf-muted);
  font-size: 12px;
  text-align: center;
}

.agent-document-viewer__paging strong {
  color: var(--nf-ink);
}

.agent-document-page-scroll {
  min-height: 0;
  overflow: auto;
  padding: 24px;
}

.agent-document-page {
  width: min(720px, 100%);
  min-height: 880px;
  margin: 0 auto;
  border: 1px solid #d9dee7;
  background: #fff;
  padding: clamp(36px, 6vw, 70px);
  color: #263244;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.15);
}

.agent-document-page > header,
.agent-document-page > footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: #8691a2;
  font-size: 12px;
  letter-spacing: 0.08em;
}

.agent-document-page > header {
  border-bottom: 1px solid #e5e9ef;
  padding-bottom: 11px;
}

.agent-document-page__title {
  margin: 58px 0 34px;
}

.agent-document-page__title small {
  color: #2563eb;
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.agent-document-page__title h3 {
  margin: 9px 0 0;
  color: #101827;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(22px, 2.4vw, 31px);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.3;
}

.agent-document-page > p {
  margin: 0;
  color: #354155;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 13px;
  line-height: 1.95;
  text-align: justify;
}

.agent-document-page > p + p {
  margin-top: 18px;
}

.agent-document-page > ul {
  margin: 24px 0 0;
  border-left: 3px solid #93b4ff;
  background: #f5f8ff;
  padding: 16px 18px 16px 34px;
}

.agent-document-page > ul li {
  color: #354155;
  font-size: 12px;
  line-height: 1.65;
}

.agent-document-page > ul li + li {
  margin-top: 7px;
}

.agent-document-page > aside {
  margin-top: 25px;
  border: 1px solid #dfe6f1;
  border-radius: 8px;
  background: #f8fafc;
  padding: 13px;
}

.agent-document-page > aside strong {
  color: #2563eb;
  font-size: 12px;
  letter-spacing: 0.08em;
}

.agent-document-page > aside p {
  margin: 6px 0 0;
  color: #536174;
  font-size: 12px;
  line-height: 1.6;
}

.agent-document-page > footer {
  margin-top: 70px;
  border-top: 1px solid #e5e9ef;
  padding-top: 11px;
}

.agent-document-page > footer strong {
  color: #526075;
  font-size: 12px;
}

.agent-document-insight {
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  background: var(--nf-panel);
  padding: 15px;
}

.agent-document-insight__sample {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 9px;
  border: 1px solid var(--nf-warning-border);
  border-radius: 10px;
  background: var(--nf-warning-soft);
  padding: 10px;
  color: var(--nf-warning);
}

.agent-document-insight__sample > i {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: color-mix(in srgb, var(--nf-warning) 10%, var(--nf-panel));
}

.agent-document-insight__sample strong,
.agent-document-insight__sample p {
  display: block;
  margin: 0;
}

.agent-document-insight__sample strong {
  font-size: 12px;
  font-weight: 900;
}

.agent-document-insight__sample p {
  margin-top: 3px;
  color: var(--nf-text);
  font-size: 12px;
  line-height: 1.5;
}

.agent-document-insight > section {
  border-bottom: 1px solid var(--nf-border-soft);
  padding: 16px 2px;
}

.agent-document-insight > section:last-child {
  border-bottom: 0;
}

.agent-document-insight__heading {
  display: flex;
  align-items: center;
  gap: 9px;
}

.agent-document-insight__heading > span {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: color-mix(in srgb, var(--nf-brand) 10%, var(--nf-panel));
  color: var(--nf-brand);
  font-size: 12px;
}

.agent-document-insight__heading small,
.agent-document-insight__heading h3 {
  display: block;
  margin: 0;
}

.agent-document-insight__heading small {
  color: var(--nf-brand);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.agent-document-insight__heading h3,
.agent-document-insight > section > h3 {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 900;
}

.agent-document-insight__heading h3 {
  margin-top: 2px;
}

.agent-document-insight > section > h3 {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0 0 10px;
}

.agent-document-insight > section > h3 small {
  border-radius: 999px;
  background: var(--nf-panel-soft);
  padding: 2px 5px;
  color: var(--nf-muted);
  font-size: 12px;
}

.agent-document-insight__summary {
  margin: 12px 0 0;
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 750;
  line-height: 1.65;
}

.agent-document-insight__description {
  margin: 8px 0 0;
  color: var(--nf-muted);
  font-size: 12px;
  line-height: 1.65;
}

.agent-document-insight__findings {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.agent-document-insight__findings li {
  display: grid;
  grid-template-columns: 19px minmax(0, 1fr);
  gap: 7px;
  color: var(--nf-text);
  font-size: 12px;
  line-height: 1.55;
}

.agent-document-insight__findings i {
  display: inline-flex;
  width: 19px;
  height: 19px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--nf-success-soft);
  color: var(--nf-success);
  font-size: 12px;
}

.agent-document-insight__categories span {
  min-height: 25px;
  gap: 5px;
  padding: 0 8px;
  font-size: 12px;
}

.agent-document-insight__metadata,
.agent-document-insight__pipeline dl {
  display: grid;
  gap: 7px;
  margin: 0;
}

.agent-document-insight__metadata div,
.agent-document-insight__pipeline dl div {
  display: grid;
  grid-template-columns: 80px minmax(0, 1fr);
  gap: 9px;
}

.agent-document-insight__metadata dt,
.agent-document-insight__metadata dd,
.agent-document-insight__pipeline dt,
.agent-document-insight__pipeline dd {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
}

.agent-document-insight__metadata dt,
.agent-document-insight__pipeline dt {
  color: var(--nf-muted);
}

.agent-document-insight__metadata dd,
.agent-document-insight__pipeline dd {
  min-width: 0;
  overflow-wrap: anywhere;
  color: var(--nf-text);
  font-weight: 750;
}

.agent-document-insight__pipeline dd.is-ready {
  color: var(--nf-success);
}

.agent-document-insight__pipeline dd.is-ready i {
  margin-right: 4px;
}

.agent-document-hub button:focus-visible,
.agent-document-hub input:not(.agent-document-search__input):focus-visible,
.agent-document-hub select:focus-visible,
.agent-document-modal button:focus-visible {
  outline: 2px solid var(--nf-brand);
  outline-offset: 2px;
}

@media (max-width: 1180px) {
  .agent-document-pipeline {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .agent-document-workspace {
    grid-template-columns: 1fr;
  }
  .agent-document-modal__body {
    grid-template-columns: minmax(0, 1.5fr) minmax(310px, 0.8fr);
  }
  .agent-document-viewer {
    grid-template-columns: 145px minmax(0, 1fr);
  }
}
@media (max-width: 920px) {
  .agent-document-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .agent-document-workspace {
    grid-template-columns: 1fr;
  }
  .agent-document-categories {
    position: static;
  }
  .agent-document-categories nav {
    display: flex;
    max-height: none;
    gap: 5px;
    overflow-x: auto;
    padding: 8px;
  }
  .agent-document-categories nav button {
    width: 176px;
    flex: 0 0 176px;
  }
  .agent-document-categories nav button + button {
    margin-top: 0;
  }
  .agent-document-modal-backdrop {
    align-items: flex-start;
    overflow-y: auto;
    padding: 12px;
  }
  .agent-document-modal {
    height: auto;
    min-height: calc(100vh - 24px);
  }
  .agent-document-modal__body {
    display: block;
  }
  .agent-document-viewer {
    height: 670px;
    border-right: 0;
    border-bottom: 1px solid var(--nf-border-soft);
  }
  .agent-document-insight {
    overflow: visible;
  }
}
@media (max-width: 640px) {
  .agent-document-hub__header {
    min-height: 0;
    padding: 24px 16px 20px;
  }
  .agent-document-hub__header-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .agent-document-hub__header-copy {
    width: 100%;
  }
  .agent-document-hub__header h2 {
    font-size: 24px;
  }
  .agent-document-hub__export {
    width: 100%;
  }
  .agent-document-hub__content {
    width: calc(100% - 24px);
    padding-top: 12px;
  }
  .agent-document-metrics,
  .agent-document-grid {
    grid-template-columns: 1fr;
  }
  .agent-document-pipeline ol {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .agent-document-pipeline li {
    padding-right: 0;
  }
  .agent-document-pipeline__arrow {
    display: none;
  }
  .agent-document-search {
    grid-template-columns: 1fr;
  }
  .agent-document-search__actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .agent-document-search__action {
    width: 100%;
    min-width: 0;
    padding: 0 8px;
  }
  .agent-document-search__action.is-reset {
    min-width: 0;
  }
  .agent-document-filter-panel__grid {
    grid-template-columns: 1fr;
  }
  .agent-document-filter-section.is-category {
    grid-column: auto;
  }
  .agent-document-modal-backdrop {
    display: block;
    overflow: hidden;
    padding: 0;
  }
  .agent-document-modal {
    width: 100%;
    height: 100vh;
    min-height: 0;
    border: 0;
    border-radius: 0;
  }
  .agent-document-modal__identity .agent-document-card__type {
    display: none;
  }
  .agent-document-modal__identity h2 {
    font-size: 13px;
  }
  .agent-document-modal__body {
    overflow-y: auto;
  }
  .agent-document-viewer {
    display: flex;
    height: 620px;
    flex-direction: column;
  }
  .agent-document-page-list {
    display: flex;
    flex: 0 0 auto;
    gap: 5px;
    overflow-x: auto;
    border-right: 0;
    border-bottom: 1px solid var(--nf-border-soft);
    padding: 7px;
  }
  .agent-document-page-list > p {
    display: none;
  }
  .agent-document-page-list button {
    width: 132px;
    flex: 0 0 132px;
  }
  .agent-document-page-list button + button {
    margin-top: 0;
  }
  .agent-document-viewer__main {
    flex: 1;
  }
  .agent-document-page-scroll {
    padding: 12px;
  }
  .agent-document-page {
    min-height: 720px;
    padding: 30px 24px;
  }
  .agent-document-page__title {
    margin: 38px 0 25px;
  }
  .agent-document-page > p {
    font-size: 12px;
    line-height: 1.8;
  }
}
.analysis-catalog {
  background: radial-gradient(circle at 86% 4%, color-mix(in srgb, var(--nf-brand) 11%, transparent), transparent 28%), var(--nf-page-bg);
  color: var(--nf-text);
}

.analysis-catalog__header {
  display: flex;
  width: 100%;
  min-height: 238px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 30px 20px 26px;
}

.analysis-catalog__header-inner {
  display: flex;
  width: min(1120px, 100%);
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.analysis-catalog__header-copy {
  display: flex;
  width: min(900px, 100%);
  min-width: 0;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.analysis-catalog__breadcrumb {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: var(--nf-brand);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.analysis-catalog__breadcrumb i {
  color: var(--nf-border-strong);
  font-size: 12px;
}

.analysis-catalog__breadcrumb strong {
  border: 1px solid color-mix(in srgb, var(--nf-brand) 22%, var(--nf-border-soft));
  border-radius: 999px;
  background: color-mix(in srgb, var(--nf-brand) 7%, var(--nf-panel));
  padding: 4px 8px;
  font-weight: 900;
  letter-spacing: 0;
}

.analysis-catalog__header h2 {
  max-width: 860px;
  margin: 8px 0 0;
  color: var(--nf-ink);
  font-size: clamp(28px, 3vw, 40px);
  font-weight: 900;
  letter-spacing: -0.04em;
  line-height: 1.16;
}

.analysis-catalog__header-copy > p {
  max-width: 720px;
  margin: 11px 0 0;
  color: var(--nf-muted);
  font-size: 14px;
  line-height: 1.65;
}

.analysis-catalog__scope,
.analysis-catalog__models,
.analysis-catalog__test {
  width: min(1120px, 100% - 40px);
  margin-inline: auto;
}

.analysis-catalog__scope {
  border-top: 1px solid var(--nf-border-soft);
  padding: 20px 0;
}

.analysis-catalog__eyebrow,
.analysis-catalog-card__head small,
.analysis-catalog__test small,
.analysis-result-branch__head small {
  color: var(--nf-brand);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.analysis-catalog__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.analysis-catalog__badges span,
.analysis-catalog-card__footer span {
  border: 1px solid var(--nf-border-soft);
  border-radius: 999px;
  background: var(--nf-panel-soft);
  padding: 5px 9px;
  color: var(--nf-text);
  font-size: 12px;
  font-weight: 800;
}

.analysis-catalog__boundary {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  border: 1px solid var(--nf-warning-border);
  border-radius: 14px;
  background: var(--nf-warning-soft);
  padding: 14px 16px;
}

.analysis-catalog__boundary strong,
.analysis-catalog__boundary span {
  display: block;
}

.analysis-catalog__boundary strong {
  color: var(--nf-warning);
  font-size: 13px;
  font-weight: 900;
}

.analysis-catalog__boundary span {
  margin-top: 0;
  color: var(--nf-text);
  font-size: 12px;
  line-height: 1.6;
}

.analysis-catalog__models {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.analysis-catalog-card {
  display: flex;
  min-width: 0;
  min-height: 360px;
  flex-direction: column;
  border: 1px solid var(--nf-border);
  border-radius: 18px;
  background: var(--nf-panel);
  box-shadow: var(--nf-card-shadow);
  padding: 22px;
  text-align: left;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.analysis-catalog-card:hover,
.analysis-catalog-card.is-selected {
  border-color: var(--nf-border-strong);
  box-shadow: 0 16px 34px color-mix(in srgb, var(--nf-brand) 13%, transparent);
  transform: translateY(-2px);
}

.analysis-catalog-card.is-selected {
  outline: 3px solid color-mix(in srgb, var(--nf-brand) 14%, transparent);
}

.analysis-catalog-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.analysis-catalog-card__head h3 {
  margin: 6px 0 0;
  color: var(--nf-ink);
  font-size: 19px;
  font-weight: 900;
  line-height: 1.3;
}

.analysis-catalog-card__head div > span {
  display: block;
  margin-top: 5px;
  color: var(--nf-muted);
  font-size: 12px;
}

.analysis-catalog-card__summary {
  margin: 22px 0 0;
  color: var(--nf-ink);
  font-size: 15px;
  font-weight: 750;
  line-height: 1.65;
}

.analysis-catalog-card__use {
  margin: 8px 0 0;
  color: var(--nf-muted);
  font-size: 13px;
  line-height: 1.6;
}

.analysis-catalog-card__contract {
  display: grid;
  gap: 10px;
  margin: 20px 0 0;
  border-top: 1px solid var(--nf-border-soft);
  padding-top: 16px;
}

.analysis-catalog-card__contract div {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr);
  gap: 10px;
}

.analysis-catalog-card__contract dt,
.analysis-catalog-card__contract dd {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
}

.analysis-catalog-card__contract dt {
  color: var(--nf-muted);
  font-weight: 850;
}

.analysis-catalog-card__contract dd {
  overflow-wrap: anywhere;
  color: var(--nf-text);
}

.analysis-catalog-card__footer {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: auto;
  padding-top: 18px;
}

.analysis-catalog__test {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 18px;
  margin-bottom: 34px;
  border: 1px solid color-mix(in srgb, var(--nf-brand) 34%, var(--nf-border));
  border-radius: 18px;
  background: color-mix(in srgb, var(--nf-wash) 58%, var(--nf-panel));
  padding: 20px 22px;
}

.analysis-catalog__test strong,
.analysis-catalog__test span {
  display: block;
}

.analysis-catalog__test strong {
  margin-top: 4px;
  color: var(--nf-ink);
  font-size: 16px;
  font-weight: 900;
}

.analysis-catalog__test div > span {
  margin-top: 5px;
  color: var(--nf-muted);
  font-size: 12px;
  line-height: 1.55;
}

.analysis-catalog__test button {
  display: inline-flex;
  min-height: 44px;
  flex: 0 0 auto;
  align-items: center;
  gap: 9px;
  border: 1px solid var(--nf-action);
  border-radius: 11px;
  background: var(--nf-action);
  padding: 0 17px;
  color: #fff;
  font-size: 13px;
  font-weight: 900;
}

.analysis-catalog__test button:disabled {
  cursor: default;
  opacity: 0.5;
}

/* Analysis workspace: one canonical user task per step. */
.analysis-tabbar.analysis-tabbar--workflow {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-bottom-color: var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 14px 24px 15px;
}

.analysis-tabbar--workflow .analysis-tab {
  min-height: 86px;
}

.analysis-tabbar--workflow .analysis-tab:disabled {
  cursor: wait;
  transform: none;
}

.analysis-tabbar--workflow .analysis-tab__index {
  width: 40px;
  height: 40px;
  border: 3px solid var(--nf-border);
  background: var(--nf-panel);
  box-shadow: 0 0 0 5px var(--nf-panel);
  color: var(--nf-muted);
}

.analysis-tabbar--workflow .analysis-tab.is-ready:not(.is-active) .analysis-tab__index {
  border-color: var(--nf-success-border);
  background: var(--nf-success-soft);
  color: var(--nf-success);
}

.analysis-tabbar--workflow .analysis-tab.is-active .analysis-tab__index {
  border-color: var(--nf-brand-button);
  background: var(--nf-brand-button);
  box-shadow: 0 0 0 5px color-mix(in srgb, var(--nf-brand) 18%, var(--nf-panel));
  color: #fff;
}

.analysis-tabbar--workflow .analysis-tab__label {
  color: var(--nf-ink);
}

.analysis-tabbar--workflow .analysis-tab small {
  color: var(--nf-text);
}

.analysis-tabbar--workflow .analysis-tab em {
  color: var(--nf-muted);
}

.analysis-tabbar--workflow .analysis-tab::before,
.analysis-tabbar--workflow .analysis-tab::after {
  background: var(--nf-border);
}

.analysis-tabbar--workflow .analysis-tab.is-ready::before,
.analysis-tabbar--workflow .analysis-tab.is-ready::after,
.analysis-tabbar--workflow .analysis-tab.is-active::before,
.analysis-tabbar--workflow .analysis-tab.is-active::after {
  background: var(--nf-success-border);
}

.agent-analysis-workspace .analysis-workbench {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 310px);
  grid-template-areas: "stage controls";
  grid-template-rows: minmax(560px, auto);
  align-content: start;
  gap: 16px;
  overflow: auto !important;
  background: var(--nf-page-bg);
}

.analysis-workbench > [hidden] {
  display: none !important;
}

.analysis-workbench > .analysis-model-rail,
.analysis-workbench > .analysis-result-dashboard,
.analysis-workbench > .analysis-step-card {
  grid-area: stage;
  min-height: 560px;
  border-color: var(--nf-border);
  border-radius: 12px;
  background: var(--nf-panel);
  box-shadow: var(--nf-card-shadow);
}

.analysis-workbench > .analysis-model-rail {
  display: flex;
}

.analysis-workbench > .analysis-step-card {
  display: block;
  overflow: auto;
  padding: 22px;
}

.analysis-workbench > .analysis-result-dashboard {
  display: flex;
  overflow: auto;
}

.analysis-workbench .analysis-panel-head {
  border-bottom-color: var(--nf-border-soft);
  padding: 18px 20px;
}

.analysis-workbench .analysis-panel-head p,
.analysis-workbench .analysis-detail-panel__head p {
  color: var(--nf-ink);
  font-size: 15px;
}

.analysis-workbench .analysis-panel-head span,
.analysis-workbench .analysis-detail-panel__head span {
  color: var(--nf-muted);
  line-height: 1.5;
}

.analysis-workbench .analysis-step-kicker {
  color: var(--nf-brand);
}

.analysis-workbench .analysis-model-table__head,
.analysis-workbench .analysis-model-row {
  grid-template-columns: minmax(0, 1fr) 110px 76px;
}

.analysis-workbench .analysis-model-table__head {
  background: var(--nf-panel-soft);
  color: var(--nf-muted);
}

.analysis-workbench .analysis-model-row {
  min-height: 88px;
  border-bottom-color: var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 13px 16px;
}

.analysis-workbench .analysis-model-row:hover,
.analysis-workbench .analysis-model-row.is-selected {
  background: color-mix(in srgb, var(--nf-wash) 58%, var(--nf-panel));
}

.analysis-workbench .analysis-model-row:disabled,
.analysis-workbench .analysis-record-choice:disabled,
.analysis-workbench .analysis-factor:disabled,
.analysis-workbench .analysis-recipe:disabled {
  cursor: wait;
  opacity: 0.7;
}

.analysis-step-card--record .analysis-record-choice-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 18px;
}

.analysis-step-card--record .analysis-record-choice {
  min-height: 82px;
  border-color: var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 12px 14px;
}

.analysis-step-card--record .analysis-record-compact--selected {
  margin-top: 20px;
  border: 1px solid var(--nf-border-soft);
  border-radius: 10px;
  background: var(--nf-panel-soft);
  padding: 18px;
}

.analysis-step-card--record .analysis-record-kpis div {
  border-color: var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 12px;
}

.analysis-step-card--result {
  display: block !important;
}

.analysis-parallel-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 18px;
  border: 1px solid color-mix(in srgb, var(--nf-brand) 28%, var(--nf-border));
  border-radius: 11px;
  background: color-mix(in srgb, var(--nf-wash) 58%, var(--nf-panel));
  padding: 13px 14px;
  color: var(--nf-brand);
}

.analysis-parallel-notice strong,
.analysis-parallel-notice span {
  display: block;
}

.analysis-parallel-notice strong {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 900;
}

.analysis-parallel-notice span {
  margin-top: 3px;
  color: var(--nf-muted);
  font-size: 12px;
  line-height: 1.5;
}

.analysis-parallel-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.analysis-result-branch {
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 12px;
  background: var(--nf-panel);
  padding: 15px;
}

.analysis-result-branch__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.analysis-result-branch__head strong,
.analysis-result-branch__head span {
  display: block;
}

.analysis-result-branch__head strong {
  margin-top: 4px;
  color: var(--nf-ink);
  font-size: 14px;
  font-weight: 900;
}

.analysis-result-branch__head > span {
  border-radius: 999px;
  background: var(--nf-panel-soft);
  padding: 5px 8px;
  color: var(--nf-muted);
  font-size: 12px;
  font-weight: 800;
}

.analysis-result-branch__head > .analysis-vm-status {
  display: block;
  padding: 5px 8px;
}

.analysis-result-branch__hero {
  margin-top: 16px;
  border-radius: 10px;
  background: var(--nf-panel-soft);
  padding: 14px;
}

.analysis-result-branch__hero strong,
.analysis-result-branch__hero span {
  display: block;
}

.analysis-result-branch__hero strong {
  color: var(--nf-ink);
  font-size: 25px;
  font-weight: 900;
}

.analysis-result-branch__hero span {
  margin-top: 3px;
  color: var(--nf-muted);
  font-size: 12px;
}

.analysis-result-branch__metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 10px 0 0;
}

.analysis-result-branch__metrics div {
  border: 1px solid var(--nf-border-soft);
  border-radius: 9px;
  padding: 9px;
}

.analysis-result-branch__metrics dt,
.analysis-result-branch__metrics dd {
  margin: 0;
  font-size: 12px;
}

.analysis-result-branch__metrics dt {
  color: var(--nf-muted);
}

.analysis-result-branch__metrics dd {
  margin-top: 3px;
  color: var(--nf-ink);
  font-weight: 850;
}

.analysis-result-branch > p {
  margin: 12px 0 0;
  color: var(--nf-muted);
  font-size: 12px;
  line-height: 1.55;
}

.analysis-result-branch .analysis-factor-list,
.analysis-result-branch .analysis-recipe-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 12px;
}

.analysis-result-branch .analysis-factor,
.analysis-result-branch .analysis-recipe {
  min-height: 0;
  border-color: var(--nf-border-soft);
  border-radius: 9px;
  background: var(--nf-panel);
  padding: 10px;
}

.analysis-result-branch .analysis-factor p,
.analysis-result-branch .analysis-recipe span,
.analysis-result-branch .analysis-recipe small {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
}

.analysis-result-branch .analysis-recipe small {
  display: block;
  margin-top: 4px;
  color: var(--nf-muted);
  font-size: 12px;
}

.analysis-step-card--rca .analysis-rca-context {
  margin: 18px 0 0;
  border-color: var(--nf-border-soft);
  background: var(--nf-panel-soft);
  padding: 14px 16px;
}

.analysis-step-card--rca .analysis-factor-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.analysis-step-card--rca .analysis-factor {
  min-height: 108px;
  align-content: start;
  border-color: var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 14px;
}

.analysis-step-card--rca .analysis-factor p {
  overflow: visible;
  margin: 5px 0 0;
  line-height: 1.55;
  text-overflow: clip;
  white-space: normal;
}

.analysis-step-card--optimize .analysis-evidence-link {
  margin: 18px 0 0;
  border-color: var(--nf-border-soft);
  background: var(--nf-panel-soft);
  padding: 16px;
}

.analysis-step-card--optimize .analysis-recipe-list {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.analysis-step-card--optimize .analysis-recipe {
  min-height: 104px;
  align-content: start;
  border-color: var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 14px;
}

.analysis-step-card--optimize .analysis-recipe span {
  overflow: visible;
  margin-top: 6px;
  line-height: 1.55;
  text-overflow: clip;
  white-space: normal;
}

.analysis-step-card--answer .analysis-answer-summary {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.analysis-step-card--answer .analysis-answer-row {
  border-color: var(--nf-border-soft);
  background: var(--nf-panel-soft);
  padding: 14px;
}

.analysis-step-card--answer .analysis-answer-row small {
  overflow: visible;
  line-height: 1.5;
  text-overflow: clip;
  white-space: normal;
}

.analysis-step-card--answer .analysis-answer-draft {
  max-height: none;
  margin-top: 16px;
  border-color: color-mix(in srgb, var(--nf-brand) 34%, var(--nf-border));
  background: color-mix(in srgb, var(--nf-wash) 52%, var(--nf-panel));
  color: var(--nf-text);
  padding: 18px;
  font-size: 13px;
  line-height: 1.75;
}

.analysis-step-card--answer .analysis-answer-actions {
  grid-template-columns: repeat(2, minmax(0, 180px));
  justify-content: end;
}

.analysis-workbench .analysis-model-row__name strong,
.analysis-workbench .analysis-record-choice strong,
.analysis-workbench .analysis-record-compact > strong,
.analysis-workbench .analysis-record-kpis strong,
.analysis-workbench .analysis-factor span,
.analysis-workbench .analysis-recipe strong,
.analysis-workbench .analysis-dashboard-head h3,
.analysis-workbench .analysis-vm-status strong,
.analysis-workbench .analysis-vm-conclusion strong,
.analysis-workbench .analysis-kpi-primary strong,
.analysis-workbench .analysis-kpi-grid strong,
.analysis-workbench .analysis-dashboard-chart__meta strong,
.analysis-workbench .analysis-dashboard-selection strong,
.analysis-workbench .analysis-rca-context strong,
.analysis-workbench .analysis-evidence-link strong,
.analysis-workbench .analysis-answer-row strong {
  color: var(--nf-ink);
}

.analysis-workbench .analysis-model-row__name small,
.analysis-workbench .analysis-model-row__type,
.analysis-workbench .analysis-record-choice span,
.analysis-workbench .analysis-record-choice small,
.analysis-workbench .analysis-record-compact > span,
.analysis-workbench .analysis-record-kpis span,
.analysis-workbench .analysis-record-note,
.analysis-workbench .analysis-factor p,
.analysis-workbench .analysis-recipe span,
.analysis-workbench .analysis-dashboard-head span,
.analysis-workbench .analysis-vm-status span,
.analysis-workbench .analysis-vm-conclusion small,
.analysis-workbench .analysis-kpi-primary span,
.analysis-workbench .analysis-kpi-primary small,
.analysis-workbench .analysis-kpi-grid span,
.analysis-workbench .analysis-kpi-grid small,
.analysis-workbench .analysis-dashboard-chart__meta,
.analysis-workbench .analysis-dashboard-chart__bar small,
.analysis-workbench .analysis-dashboard-selection span,
.analysis-workbench .analysis-dashboard-selection small,
.analysis-workbench .analysis-rca-context span,
.analysis-workbench .analysis-rca-context small,
.analysis-workbench .analysis-evidence-link span,
.analysis-workbench .analysis-evidence-link small,
.analysis-workbench .analysis-answer-row span,
.analysis-workbench .analysis-answer-row small {
  color: var(--nf-muted);
}

.analysis-workbench .analysis-model-radio {
  border-color: var(--nf-muted);
  background: var(--nf-panel);
}

.analysis-workbench .analysis-model-row.is-selected .analysis-model-radio {
  border-color: var(--nf-brand);
  background: var(--nf-brand);
}

.analysis-workbench .analysis-record-choice:hover,
.analysis-workbench .analysis-record-choice.is-selected,
.analysis-workbench .analysis-factor:hover,
.analysis-workbench .analysis-factor.is-selected,
.analysis-workbench .analysis-recipe:hover,
.analysis-workbench .analysis-recipe.is-selected {
  border-color: var(--nf-border-strong);
  background: color-mix(in srgb, var(--nf-wash) 62%, var(--nf-panel));
}

.analysis-workbench .analysis-vm-status {
  border-color: var(--nf-border);
  background: var(--nf-panel-soft);
}

.analysis-workbench .analysis-vm-status.is-ok {
  border-color: var(--nf-success-border);
  background: var(--nf-success-soft);
}

.analysis-workbench .analysis-vm-status.is-watch {
  border-color: var(--nf-warning-border);
  background: var(--nf-warning-soft);
}

.analysis-workbench .analysis-vm-status.is-hot {
  border-color: var(--nf-danger-border);
  background: var(--nf-danger-soft);
}

.analysis-workbench .analysis-vm-status.is-ok strong {
  color: var(--nf-success);
}

.analysis-workbench .analysis-vm-status.is-watch strong {
  color: var(--nf-warning);
}

.analysis-workbench .analysis-vm-status.is-hot strong {
  color: var(--nf-danger);
}

.analysis-workbench .analysis-vm-conclusion {
  border-bottom-color: var(--nf-border-soft);
  background: color-mix(in srgb, var(--nf-wash) 54%, var(--nf-panel));
}

.analysis-workbench .analysis-vm-conclusion span,
.analysis-workbench .analysis-stage__eyebrow,
.analysis-workbench .analysis-factor strong {
  color: var(--nf-brand);
}

.analysis-workbench .analysis-kpi-hero,
.analysis-workbench .analysis-kpi-primary,
.analysis-workbench .analysis-kpi-grid div,
.analysis-workbench .analysis-dashboard-chart,
.analysis-workbench .analysis-dashboard-selection,
.analysis-workbench .analysis-dashboard-selection div {
  border-color: var(--nf-border-soft);
}

.analysis-workbench .analysis-dashboard-chart__plot {
  border-bottom-color: var(--nf-border);
}

.analysis-workbench .analysis-dashboard-chart__bar span {
  background: var(--nf-accent);
}

.analysis-workbench .analysis-answer-limitations {
  border-color: var(--nf-warning-border);
  background: var(--nf-warning-soft);
  color: var(--nf-warning);
}

.analysis-workbench .analysis-answer-actions button {
  border-color: var(--nf-border);
  background: var(--nf-panel);
  color: var(--nf-text);
}

.analysis-workbench .analysis-answer-actions button:last-child {
  border-color: var(--nf-action);
  background: var(--nf-action);
  color: #fff;
}

.analysis-workbench > .analysis-control-panel {
  position: sticky;
  top: 0;
  grid-area: controls;
  display: flex;
  min-height: 560px;
  max-height: calc(100vh - 245px);
  align-self: start;
  overflow: auto;
  border-color: var(--nf-border);
  border-radius: 12px;
  background: var(--nf-panel);
  box-shadow: var(--nf-card-shadow);
}

.analysis-workbench .analysis-control-panel label span {
  color: var(--nf-muted);
}

.analysis-workbench .analysis-control-panel textarea,
.analysis-workbench .analysis-control-panel select,
.analysis-workbench .analysis-control-panel input {
  border-color: var(--nf-border);
  background: var(--nf-input);
  color: var(--nf-ink);
}

.analysis-variable-editor {
  margin: 12px 14px 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 10px;
  background: var(--nf-panel-soft);
  padding: 11px;
}

.analysis-variable-editor__head strong,
.analysis-variable-editor__head span {
  display: block;
}

.analysis-variable-editor__head strong {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 900;
}

.analysis-variable-editor__head span {
  margin-top: 3px;
  color: var(--nf-muted);
  font-size: 12px;
  line-height: 1.45;
}

.analysis-variable-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
}

.analysis-variable-grid label {
  min-width: 0;
}

.analysis-variable-grid label span {
  display: block;
  margin-bottom: 4px;
  color: var(--nf-muted);
  font-size: 12px;
  font-weight: 750;
}

.analysis-variable-grid input {
  width: 100%;
  min-height: 36px;
  border-radius: 8px;
  padding: 0 8px;
  font-size: 12px;
}

.analysis-dirty-notice {
  display: grid;
  gap: 3px;
  margin: 12px 14px 0;
  border: 1px solid var(--nf-warning-border);
  border-radius: 9px;
  background: var(--nf-warning-soft);
  padding: 10px 11px;
  color: var(--nf-warning);
  font-size: 12px;
  line-height: 1.5;
}

.analysis-dirty-notice strong,
.analysis-dirty-notice span {
  font-size: 12px;
}

.analysis-dirty-notice--selection {
  border-color: color-mix(in srgb, var(--nf-brand) 34%, var(--nf-border));
  background: color-mix(in srgb, var(--nf-wash) 58%, var(--nf-panel));
  color: var(--nf-brand);
}

.analysis-field-error {
  order: 1;
  margin: 8px 14px 0;
  color: var(--nf-danger);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}

.analysis-workbench .analysis-condition-summary {
  border-top-color: var(--nf-border-soft);
}

.analysis-workbench .analysis-condition-summary div {
  border-color: var(--nf-border-soft);
  background: var(--nf-panel-soft);
}

.analysis-workbench .analysis-condition-summary span,
.analysis-workbench .analysis-condition-summary small {
  color: var(--nf-muted);
}

.analysis-workbench .analysis-condition-summary strong {
  color: var(--nf-ink);
}

.analysis-execution-status {
  margin: 14px;
  border-top: 1px solid var(--nf-border-soft);
  padding-top: 14px;
}

.analysis-execution-status__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.analysis-execution-status__head div {
  min-width: 0;
}

.analysis-execution-status__head strong,
.analysis-execution-status__head span {
  display: block;
}

.analysis-execution-status__head strong {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 850;
}

.analysis-execution-status__head span {
  margin-top: 3px;
  color: var(--nf-muted);
  font-size: 12px;
  line-height: 1.45;
}

.analysis-execution-status__head > small {
  flex: 0 0 auto;
  border-radius: 999px;
  background: var(--nf-panel-soft);
  padding: 4px 7px;
  color: var(--nf-text);
  font-size: 12px;
  font-weight: 800;
}

.analysis-execution-status ol {
  display: grid;
  gap: 0;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.analysis-execution-status li {
  position: relative;
  display: grid;
  min-width: 0;
  grid-template-columns: 12px minmax(0, 1fr) auto;
  align-items: start;
  gap: 8px;
  padding: 7px 0;
}

.analysis-execution-status li::before {
  content: "";
  position: absolute;
  top: 19px;
  bottom: -7px;
  left: 5px;
  width: 1px;
  background: var(--nf-border-soft);
}

.analysis-execution-status li:last-child::before {
  display: none;
}

.analysis-execution-status li > i {
  position: relative;
  z-index: 1;
  width: 11px;
  height: 11px;
  margin-top: 3px;
  border: 2px solid var(--nf-border);
  border-radius: 999px;
  background: var(--nf-panel);
}

.analysis-execution-status li.is-completed > i {
  border-color: var(--nf-success);
  background: var(--nf-success);
}

.analysis-execution-status li.is-running > i {
  border-color: var(--nf-brand);
  background: var(--nf-brand);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--nf-brand) 18%, transparent);
}

.analysis-execution-status li.is-warning > i {
  border-color: var(--nf-warning);
  background: var(--nf-warning);
}

.analysis-execution-status li div {
  min-width: 0;
}

.analysis-execution-status li strong,
.analysis-execution-status li span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-execution-status li strong {
  color: var(--nf-ink);
  font-size: 12px;
  font-weight: 800;
}

.analysis-execution-status li span,
.analysis-execution-status li > small {
  color: var(--nf-muted);
  font-size: 12px;
}

.analysis-execution-status li span {
  margin-top: 2px;
}

.analysis-execution-status li > small {
  white-space: nowrap;
}

.analysis-stage-navigation {
  display: flex;
  gap: 8px;
  order: 2;
  margin-top: 12px;
  border-top: 1px solid var(--nf-border-soft);
  padding: 14px;
}

.analysis-control-panel > .analysis-panel-head {
  order: 0;
}

.analysis-control-panel > label,
.analysis-control-panel > .analysis-control-grid,
.analysis-control-panel > .analysis-variable-editor,
.analysis-control-panel > .analysis-dirty-notice {
  order: 1;
}

.analysis-control-panel > .analysis-condition-summary {
  order: 3;
}

.analysis-control-panel > .analysis-execution-status {
  order: 4;
}

.analysis-stage-navigation button {
  min-height: 40px;
  border: 1px solid var(--nf-border);
  border-radius: 9px;
  padding: 0 13px;
  font-size: 12px;
  font-weight: 850;
}

.analysis-stage-navigation__back {
  flex: 0 0 auto;
  background: var(--nf-panel);
  color: var(--nf-text);
}

.analysis-stage-navigation__next {
  flex: 1 1 auto;
  border-color: var(--nf-action) !important;
  background: var(--nf-action);
  color: #fff;
}

.analysis-stage-navigation button:disabled {
  cursor: default;
  opacity: 0.48;
}

@media (max-width: 1120px) {
  .analysis-tabbar.analysis-tabbar--workflow {
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    overflow-x: auto;
    padding-inline: 18px;
  }
  .agent-analysis-workspace .analysis-workbench {
    grid-template-columns: minmax(0, 1fr) 280px;
  }
  .analysis-step-card--optimize .analysis-recipe-list,
  .analysis-step-card--answer .analysis-answer-summary {
    grid-template-columns: 1fr;
  }
  .analysis-parallel-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 860px) {
  .analysis-catalog__models {
    grid-template-columns: 1fr;
  }
  .analysis-catalog__test {
    align-items: flex-start;
    flex-direction: column;
  }
  .agent-analysis-workspace .analysis-workbench {
    grid-template-columns: 1fr;
    grid-template-areas: "stage" "controls";
    grid-template-rows: auto auto;
    padding: 12px !important;
  }
  .analysis-workbench > .analysis-model-rail,
  .analysis-workbench > .analysis-result-dashboard,
  .analysis-workbench > .analysis-step-card {
    min-height: 0;
  }
  .analysis-workbench > .analysis-control-panel {
    position: static;
    min-height: 0;
    max-height: none;
  }
}
@media (max-width: 639px) {
  .analysis-catalog__header {
    min-height: 0;
    padding: 24px 12px 20px;
  }
  .analysis-catalog__header h2 {
    font-size: 28px;
  }
  .analysis-catalog__header-copy > p {
    font-size: 13px;
  }
  .analysis-tabbar.analysis-tabbar--workflow {
    grid-template-columns: repeat(4, minmax(124px, 1fr));
    padding: 12px 14px;
  }
  .analysis-tabbar--workflow .analysis-tab {
    min-height: 82px;
  }
  .analysis-step-card--record .analysis-record-choice-list,
  .analysis-step-card--rca .analysis-factor-list,
  .analysis-step-card--optimize .analysis-recipe-list,
  .analysis-step-card--answer .analysis-answer-summary {
    grid-template-columns: 1fr;
  }
  .analysis-step-card--optimize .analysis-evidence-link {
    grid-template-columns: 1fr;
  }
  .analysis-step-card--optimize .analysis-evidence-link i {
    transform: rotate(90deg);
  }
  .analysis-step-card--answer .analysis-answer-actions {
    grid-template-columns: 1fr;
  }
  .analysis-catalog__scope,
  .analysis-catalog__models,
  .analysis-catalog__test {
    width: min(100% - 24px, 1120px);
  }
  .analysis-catalog__boundary {
    grid-template-columns: 1fr;
    gap: 5px;
  }
  .analysis-catalog-card {
    min-height: 0;
    padding: 17px;
  }
  .analysis-catalog__test button {
    width: 100%;
    justify-content: center;
  }
  .analysis-variable-grid {
    grid-template-columns: 1fr;
  }
}
.knowledge-manager {
  overflow: hidden;
  border: 1px solid #d9e1ec;
  border-radius: 16px;
  background: #fff;
}

.knowledge-manager__header,
.knowledge-item__summary,
.knowledge-form-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.knowledge-manager__header {
  padding: 16px;
  border-bottom: 1px solid #e8edf5;
}

.knowledge-manager__actions,
.knowledge-item__actions,
.knowledge-item__facts {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.knowledge-archive-toggle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #475569;
  font-size: 12px;
}

.knowledge-archive-toggle input {
  width: 16px;
  height: 16px;
  accent-color: #2563eb;
}

.knowledge-tabs {
  display: flex;
  gap: 4px;
  padding: 8px 16px 0;
  border-bottom: 1px solid #e8edf5;
  background: #f8fafc;
}

.quality-workspace-tabs {
  display: flex;
  gap: 6px;
  margin-top: 14px;
  overflow-x: auto;
}

.quality-workspace-tabs button {
  flex: 0 0 auto;
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.quality-workspace-tabs button.is-active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
}

.knowledge-tabs button {
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid transparent;
  border-bottom: 0;
  border-radius: 10px 10px 0 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 650;
}

.knowledge-tabs button.is-active {
  border-color: #d9e1ec;
  background: #fff;
  color: #1d4ed8;
}

.knowledge-workspace {
  display: grid;
  gap: 16px;
  padding: 16px;
}

.knowledge-policy-note {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  padding: 12px 14px;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  background: #eff6ff;
  color: #475569;
  font-size: 12px;
  line-height: 1.55;
}

.knowledge-policy-note strong {
  color: #1d4ed8;
}

.knowledge-alert {
  padding: 10px 16px;
  border-bottom: 1px solid #fecaca;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 13px;
}

.knowledge-form-grid,
.knowledge-edit-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, minmax(0, 1fr)) auto;
  align-items: end;
}

.knowledge-form-grid label,
.knowledge-dataset-form label {
  display: grid;
  gap: 6px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.knowledge-form-grid input,
.knowledge-form-grid select,
.knowledge-edit-grid input,
.knowledge-edit-grid select,
.knowledge-dataset-form input,
.knowledge-dataset-form select,
.knowledge-dataset-form textarea {
  width: 100%;
  min-height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  padding: 8px 10px;
  color: #0f172a;
  font-size: 13px;
}

.knowledge-dataset-form textarea {
  resize: vertical;
  font-family: inherit;
  line-height: 1.5;
}

.knowledge-dataset-form textarea[name=datasetSchema] {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
}

.knowledge-form-grid input:focus,
.knowledge-form-grid select:focus,
.knowledge-edit-grid input:focus,
.knowledge-edit-grid select:focus,
.knowledge-dataset-form input:focus,
.knowledge-dataset-form select:focus,
.knowledge-dataset-form textarea:focus {
  border-color: #2563eb;
  outline: 3px solid rgba(37, 99, 235, 0.12);
}

.knowledge-primary-button,
.knowledge-secondary-button,
.knowledge-danger-button {
  min-height: 36px;
  border-radius: 999px;
  padding: 0 13px;
  font-size: 12px;
  font-weight: 700;
}

.knowledge-primary-button {
  border: 1px solid #2563eb;
  background: #2563eb;
  color: #fff;
}

.knowledge-secondary-button {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}

.knowledge-danger-button {
  border: 1px solid #fecaca;
  background: #fff;
  color: #b91c1c;
}

.knowledge-primary-button:disabled,
.knowledge-secondary-button:disabled,
.knowledge-danger-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.knowledge-list,
.knowledge-dataset-list {
  display: grid;
  gap: 12px;
}

.knowledge-item,
.knowledge-dataset-form,
.knowledge-detail {
  display: grid;
  gap: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  padding: 14px;
}

.knowledge-item__facts {
  color: #64748b;
  font-size: 12px;
}

.knowledge-item__facts span {
  padding-right: 8px;
  border-right: 1px solid #e2e8f0;
}

.knowledge-item__facts span:last-child {
  border-right: 0;
}

.knowledge-detail {
  background: #f8fafc;
}

.knowledge-chunk {
  display: grid;
  gap: 4px;
  padding: 9px 10px;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;
}

.knowledge-chunk strong {
  color: #334155;
}

.knowledge-empty {
  padding: 28px 16px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  color: #64748b;
  text-align: center;
  font-size: 13px;
}

.knowledge-sample-list {
  display: grid;
  gap: 10px;
}

.knowledge-sample-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px;
  border: 1px solid #fde68a;
  border-radius: 12px;
  background: #fffbeb;
}

.knowledge-dataset-layout {
  display: grid;
  grid-template-columns: minmax(300px, 0.8fr) minmax(0, 1.2fr);
  gap: 16px;
  align-items: start;
}

.knowledge-dataset-form {
  position: sticky;
  top: 0;
}

.knowledge-version-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-top: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 12px;
}

.knowledge-version-row strong {
  color: #334155;
}

.knowledge-row-manager {
  gap: 16px;
  overflow: hidden;
}

.knowledge-row-manager__header,
.knowledge-row-section-title,
.knowledge-row-upload,
.knowledge-row-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.knowledge-row-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.knowledge-row-summary > div {
  display: grid;
  gap: 4px;
  min-width: 0;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #fff;
}

.knowledge-row-summary span,
.knowledge-row-upload__action p {
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.knowledge-row-summary strong {
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-row-notice {
  padding: 10px 12px;
  border: 1px solid #fde68a;
  border-radius: 9px;
  background: #fffbeb;
  color: #92400e;
  font-size: 12px;
  line-height: 1.5;
}

.knowledge-row-notice.is-error {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.knowledge-row-notice.is-success {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.knowledge-row-upload {
  align-items: end;
  padding: 12px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #eff6ff;
}

.knowledge-row-upload__fields {
  display: grid;
  grid-template-columns: minmax(150px, 0.8fr) minmax(150px, 1fr);
  gap: 10px;
  flex: 1 1 360px;
}

.knowledge-row-upload__fields label {
  display: grid;
  gap: 5px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.knowledge-row-upload__fields input,
.knowledge-row-upload__fields select {
  width: 100%;
  min-height: 38px;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  background: #fff;
  padding: 7px 9px;
  color: #0f172a;
  font-size: 13px;
}

.knowledge-row-upload__action {
  display: grid;
  justify-items: end;
  gap: 7px;
  flex: 1 1 280px;
}

.knowledge-row-preview,
.knowledge-row-versions {
  display: grid;
  gap: 10px;
}

.knowledge-row-table-wrap {
  max-width: 100%;
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #fff;
}

.knowledge-row-table {
  width: 100%;
  min-width: 560px;
  border-collapse: collapse;
  table-layout: auto;
  color: #334155;
  font-size: 12px;
}

.knowledge-row-table th,
.knowledge-row-table td {
  max-width: 260px;
  padding: 8px 10px;
  overflow: hidden;
  border-bottom: 1px solid #eef2f7;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-row-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
  color: #475569;
  font-weight: 700;
}

.knowledge-row-table tbody tr:last-child td {
  border-bottom: 0;
}

.knowledge-row-next {
  justify-self: center;
}

.knowledge-row-versions .knowledge-version-row > div {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.knowledge-row-versions .knowledge-version-row > div span {
  color: #64748b;
  font-size: 12px;
}

@media (max-width: 1100px) {
  .knowledge-form-grid,
  .knowledge-edit-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .knowledge-dataset-layout {
    grid-template-columns: 1fr;
  }
  .knowledge-dataset-form {
    position: static;
  }
  .knowledge-row-upload {
    align-items: stretch;
    flex-direction: column;
  }
  .knowledge-row-upload__action {
    justify-items: start;
  }
}
@media (max-width: 680px) {
  .knowledge-manager__header,
  .knowledge-sample-card {
    flex-direction: column;
  }
  .knowledge-manager__actions,
  .knowledge-form-grid,
  .knowledge-edit-grid {
    width: 100%;
    grid-template-columns: 1fr;
  }
  .knowledge-tabs button {
    flex: 1 1 0;
  }
  .knowledge-row-manager__header,
  .knowledge-row-section-title,
  .knowledge-row-notice {
    align-items: flex-start;
    flex-direction: column;
  }
  .knowledge-row-summary,
  .knowledge-row-upload__fields {
    grid-template-columns: 1fr;
  }
}
.agent-shell {
  --nf-agent-background: var(--nf-page-bg, var(--nf-soft));
  background-color: var(--nf-agent-background) !important;
  color: var(--nf-ink);
  font-family: var(--nf-font-sans);
}

.agent-shell * {
  letter-spacing: 0;
}

.agent-shell [class*="text-[9px]"],
.agent-shell [class*="text-[10px]"],
.agent-shell [class*="text-[11px]"] {
  font-size: 12px !important;
  line-height: 1.4 !important;
}

.agent-shell [class*="text-[13px]"] {
  font-size: 13px !important;
  line-height: 1.45 !important;
}

.agent-shell .text-xs {
  font-size: 12px !important;
  line-height: 1.45 !important;
}

.agent-shell .text-sm {
  font-size: 14px !important;
  line-height: 1.5 !important;
}

.agent-shell [class*=rounded-2xl],
.agent-shell [class*=rounded-xl],
.agent-shell [class*=rounded-lg],
.agent-shell [class*="rounded-[12px]"],
.agent-shell [class*="rounded-[14px]"],
.agent-shell [class*="rounded-[16px]"],
.agent-shell [class*="rounded-[18px]"] {
  border-radius: 14px;
}

.agent-shell [class*=border-gray-100],
.agent-shell [class*=border-gray-200],
.agent-shell [class*=border-indigo-200],
.agent-shell [class*="border-[#d9e1ec]"],
.agent-shell [class*="border-[#d9e1ec]"] {
  border-color: var(--nf-border);
}

.agent-shell [class*=bg-gray-50] {
  background-color: var(--nf-soft);
}

.agent-shell [class~="bg-[#f7f9fc]"],
.agent-shell [class~="bg-[#fffaf3]"] {
  background-color: var(--nf-agent-background) !important;
}

.agent-shell [class*=bg-indigo-600] {
  background-color: var(--nf-action);
}

.agent-shell [class*="hover:bg-indigo-700"]:hover {
  background-color: var(--nf-action-hover);
}

.agent-shell [class*=bg-indigo-50] {
  background-color: var(--nf-wash);
}

.agent-shell [class*=text-indigo-700],
.agent-shell [class*=text-indigo-600] {
  color: var(--nf-brand);
}

.agent-shell table {
  border-collapse: separate;
  border-spacing: 0;
}

.agent-shell th {
  background-color: var(--nf-panel-soft);
  font-weight: 400;
  letter-spacing: 0;
}

.agent-shell pre {
  font-family: inherit;
}

.agent-sample-banner {
  position: relative;
  z-index: 35;
  display: inline-flex;
  flex: 0 0 auto;
  align-self: center;
  max-width: min(440px, 100% - 40px);
  align-items: center;
  gap: 7px;
  margin: 6px 0;
  border: 1px solid #f5c46b;
  border-radius: 999px !important;
  background: rgba(255, 251, 235, 0.96);
  padding: 5px 10px;
  color: #92400e;
  box-shadow: 0 4px 12px rgba(146, 64, 14, 0.08);
  font-size: 12px;
  line-height: 1.3;
  white-space: nowrap;
}

.agent-sample-banner strong {
  font-weight: 700;
}

.agent-sample-banner__dot {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #f59e0b;
}

.agent-journey {
  flex: 0 0 auto;
  border-bottom: 1px solid var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 9px 20px 10px;
}

.agent-journey ol {
  display: grid;
  width: min(840px, 100%);
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin: 0 auto;
  padding: 0;
  list-style: none;
}

.agent-journey li {
  position: relative;
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  color: #94a3b8;
}

.agent-journey li::after {
  height: 1px;
  min-width: 10px;
  flex: 1 1 auto;
  margin: 0 8px;
  background: #dbe3ee;
  content: "";
}

.agent-journey li:last-child::after {
  display: none;
}

.agent-journey__number {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  font-size: 12px;
  font-weight: 800;
}

.agent-journey__label {
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-journey li.is-done {
  color: #0f766e;
}

.agent-journey li.is-done .agent-journey__number {
  border-color: #99f6e4;
  background: #ccfbf1;
}

.agent-journey li.is-done::after {
  background: #99f6e4;
}

.agent-journey li.is-active {
  color: #2563eb;
}

.agent-journey li.is-active .agent-journey__number {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
}

.agent-journey li.is-failed {
  color: #be123c;
}

.agent-journey li.is-failed .agent-journey__number {
  border-color: #fda4af;
  background: #fff1f2;
}

.agent-mode-selector {
  min-width: 0;
  margin-inline: auto;
  border: 0;
  padding: 0;
}

.agent-intent-pending-bar {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #c4b5fd;
  border-radius: 12px;
  background: #f5f3ff;
  padding: 10px 14px;
  color: #5b21b6;
}

.agent-intent-pending-bar strong {
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 850;
}

.agent-intent-pending-bar span {
  font-size: 12px;
  line-height: 1.5;
  text-align: right;
}

.agent-mode-selector__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 7px;
}

.agent-mode-selector__head > div {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 8px;
}

.agent-mode-selector__head strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
}

.agent-mode-selector__head span {
  color: #64748b;
  font-size: 12px;
}

.agent-mode-selector__head > span {
  flex: 0 0 auto;
  border-radius: 999px;
  background: #f1f5f9;
  padding: 3px 8px;
  color: #475569;
  font-weight: 700;
}

.agent-mode-selector__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
}

.agent-mode-selector__grid button {
  position: relative;
  display: grid;
  min-width: 0;
  min-height: 54px;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #d9e1ec;
  border-radius: 11px;
  background: #fff;
  padding: 8px 9px;
  color: #475569;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

.agent-mode-selector__grid button:hover:not(:disabled) {
  border-color: #a9b9cc;
  background: #f8fafc;
}

.agent-mode-selector__grid button:focus-visible,
.agent-intent-review button:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.agent-mode-selector__grid button:disabled {
  cursor: default;
  opacity: 0.58;
}

.agent-mode-selector__marker {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #f1f5f9;
  color: #475569;
  font-size: 12px;
  font-weight: 900;
}

.agent-mode-selector__copy {
  display: grid;
  min-width: 0;
  gap: 1px;
}

.agent-mode-selector__copy strong,
.agent-mode-selector__copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-mode-selector__copy strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
}

.agent-mode-selector__copy small {
  color: #64748b;
  font-size: 12px;
}

.agent-mode-selector__check {
  color: currentColor;
  font-size: 12px;
  font-weight: 900;
}

.agent-mode-selector__grid button.is-auto.is-selected {
  border-color: #a78bfa;
  background: #f5f3ff;
  box-shadow: inset 0 0 0 1px rgba(124, 58, 237, 0.08);
  color: #6d28d9;
}

.agent-mode-selector__grid button.is-auto.is-selected .agent-mode-selector__marker {
  background: #ede9fe;
  color: #6d28d9;
}

.agent-mode-selector__grid button.is-simple.is-selected {
  border-color: #86efac;
  background: #f0fdf4;
  color: #15803d;
}

.agent-mode-selector__grid button.is-simple.is-selected .agent-mode-selector__marker {
  background: #dcfce7;
  color: #15803d;
}

.agent-mode-selector__grid button.is-vm.is-selected {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}

.agent-mode-selector__grid button.is-vm.is-selected .agent-mode-selector__marker {
  background: #dbeafe;
  color: #1d4ed8;
}

.agent-mode-selector__grid button.is-anomaly.is-selected {
  border-color: #fdba74;
  background: #fff7ed;
  color: #c2410c;
}

.agent-mode-selector__grid button.is-anomaly.is-selected .agent-mode-selector__marker {
  background: #ffedd5;
  color: #c2410c;
}

.agent-tool-execution-selector {
  display: flex;
  min-width: 0;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-inline: auto;
  border: 1px solid #d9e1ec;
  border-radius: 11px;
  background: #f8fafc;
  padding: 6px 7px 6px 12px;
}

.agent-tool-execution-selector__copy {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 7px;
}

.agent-tool-execution-selector__copy strong {
  flex: 0 0 auto;
  color: #0f172a;
  font-size: 12px;
  font-weight: 850;
}

.agent-tool-execution-selector__copy span {
  overflow: hidden;
  color: #64748b;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-tool-execution-selector__options {
  display: inline-grid;
  flex: 0 0 auto;
  grid-template-columns: repeat(3, minmax(72px, 1fr));
  gap: 3px;
  border: 1px solid #d9e1ec;
  border-radius: 8px;
  background: #fff;
  padding: 3px;
}

.agent-tool-execution-selector__options button {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  padding: 3px 8px;
  color: #64748b;
  font-size: 12px;
  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}

.agent-tool-execution-selector__options button:hover:not(:disabled) {
  background: #f1f5f9;
  color: #334155;
}

.agent-tool-execution-selector__options button:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.agent-tool-execution-selector__options button.is-selected {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.agent-tool-execution-selector__options button.is-parallel.is-selected {
  border-color: #c4b5fd;
  background: #f5f3ff;
  color: #6d28d9;
}

.agent-tool-execution-selector__options button > span {
  font-weight: 900;
}

.agent-tool-execution-selector__options button > strong {
  font-size: 12px;
  font-weight: 800;
}

.agent-message--intent-review {
  width: min(760px, 96%);
  max-width: min(760px, 96%) !important;
  overflow: hidden;
  padding: 0 !important;
}

.agent-intent-review {
  width: 100%;
  background: #fff;
  color: #0f172a;
}

.agent-intent-review__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid #e9d5ff;
  background: linear-gradient(135deg, #faf5ff 0%, #f5f3ff 100%);
  padding: 16px 18px;
}

.agent-intent-review__header > div {
  min-width: 0;
}

.agent-intent-review__eyebrow {
  margin: 0;
  color: #7c3aed;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.agent-intent-review__header h3 {
  margin: 4px 0 0;
  color: #1e1b4b;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.4;
}

.agent-intent-review__header p:last-child {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.55;
}

.agent-intent-review__status {
  flex: 0 0 auto;
  border: 1px solid #c4b5fd;
  border-radius: 999px;
  background: #fff;
  padding: 5px 9px;
  color: #6d28d9;
  font-size: 12px;
  font-weight: 800;
}

.agent-intent-review.is-analyzing .agent-intent-review__status {
  border-color: #93c5fd;
  color: #1d4ed8;
}

.agent-intent-review__summary {
  display: grid;
  gap: 12px;
  padding: 16px 18px 0;
}

.agent-intent-review__request {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  padding: 11px 12px;
}

.agent-intent-review__request > span,
.agent-intent-review__plan > p,
.agent-intent-review dt {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.agent-intent-review__request > strong {
  display: block;
  margin-top: 4px;
  color: #1e293b;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.55;
}

.agent-intent-review__entities {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.agent-intent-review__entities span {
  border-radius: 999px;
  background: #eaf2ff;
  padding: 3px 8px;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.agent-intent-review__feedback-summary {
  display: grid;
  gap: 4px;
  border-left: 3px solid #8b5cf6;
  border-radius: 0 8px 8px 0;
  background: #f5f3ff;
  padding: 9px 11px;
}

.agent-intent-review__feedback-summary span {
  color: #6d28d9;
  font-size: 12px;
  font-weight: 750;
}

.agent-intent-review__feedback-summary strong {
  color: #312e81;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.55;
  white-space: pre-wrap;
}

.agent-intent-review dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  overflow: hidden;
  margin: 0;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #e2e8f0;
}

.agent-intent-review dl > div {
  min-width: 0;
  background: #fff;
  padding: 10px 12px;
}

.agent-intent-review dl > .agent-intent-review__tool-execution {
  grid-column: 1/-1;
}

.agent-intent-review__tool-execution dd span {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
}

.agent-intent-review dd {
  display: grid;
  gap: 2px;
  margin: 4px 0 0;
}

.agent-intent-review dd strong {
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-intent-review dd span {
  overflow: hidden;
  color: #64748b;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-intent-review__plan {
  padding: 14px 18px 0;
}

.agent-intent-review__plan > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 7px;
}

.agent-intent-review__plan span {
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #f8fafc;
  padding: 5px 9px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.agent-intent-review__notice,
.agent-intent-review__error {
  margin: 12px 18px 0;
  border-radius: 9px;
  padding: 9px 11px;
  font-size: 12px;
  line-height: 1.55;
}

.agent-intent-review__notice {
  border: 1px solid #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.agent-intent-review__error {
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.agent-intent-review__actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
  margin-top: 16px;
  border-top: 1px solid #eef2f7;
  padding: 14px 18px 16px;
}

.agent-intent-review__actions button {
  display: flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 10px;
  padding: 0 14px;
  font-size: 12px;
}

.agent-intent-review__actions button span {
  font-weight: 650;
}

.agent-intent-review__actions button strong {
  font-size: 12px;
  font-weight: 850;
}

.agent-intent-review__secondary {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
}

.agent-intent-review__primary {
  border: 1px solid #6d28d9;
  background: #6d28d9;
  color: #fff;
}

.agent-intent-review__actions button:disabled,
.agent-intent-review__revision-actions button:disabled {
  opacity: 0.5;
}

.agent-intent-review__revision {
  display: grid;
  gap: 12px;
  margin-top: 16px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 14px 18px 16px;
}

.agent-intent-review__revision > div:first-child strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
}

.agent-intent-review__revision > div:first-child p {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.agent-intent-review__mode-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
}

.agent-intent-review__mode-grid button {
  display: grid;
  min-width: 0;
  min-height: 54px;
  justify-items: center;
  gap: 3px;
  border: 1px solid #d9e1ec;
  border-radius: 9px;
  background: #fff;
  padding: 7px;
  color: #475569;
}

.agent-intent-review__mode-grid button:disabled {
  cursor: not-allowed;
  opacity: 0.42;
}

.agent-intent-review__mode-grid button > span {
  font-size: 12px;
  font-weight: 900;
}

.agent-intent-review__mode-grid button > strong {
  overflow: hidden;
  max-width: 100%;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-intent-review__mode-grid button.is-auto.is-selected {
  border-color: #a78bfa;
  background: #f5f3ff;
  color: #6d28d9;
}

.agent-intent-review__mode-grid button.is-simple.is-selected {
  border-color: #86efac;
  background: #f0fdf4;
  color: #15803d;
}

.agent-intent-review__mode-grid button.is-vm.is-selected {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}

.agent-intent-review__mode-grid button.is-anomaly.is-selected {
  border-color: #fdba74;
  background: #fff7ed;
  color: #c2410c;
}

.agent-intent-review__feedback-label {
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.agent-intent-review__feedback {
  width: 100%;
  min-height: 64px;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  padding: 9px 11px;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.55;
}

.agent-intent-review__feedback:focus {
  border-color: #2563eb;
  outline: 3px solid rgba(37, 99, 235, 0.14);
}

.agent-intent-review__feedback-help {
  margin: -6px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.agent-intent-review__revision-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.agent-intent-review__revision-actions button {
  min-height: 38px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  padding: 0 12px;
  color: #475569;
  font-size: 12px;
  font-weight: 750;
}

.agent-intent-review__revision-actions button:last-child {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
}

.agent-intent-review__analyzing {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
  border-top: 1px solid #dbeafe;
  background: #eff6ff;
  padding: 14px 18px;
  color: #1d4ed8;
}

.agent-intent-review__analyzing > span {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  border: 2px solid #bfdbfe;
  border-top-color: #2563eb;
  border-radius: 999px;
  animation: agent-intent-spin 0.8s linear infinite;
}

.agent-intent-review__analyzing p {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
}

@keyframes agent-intent-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 900px) {
  .agent-mode-selector__grid,
  .agent-intent-review__mode-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .agent-journey {
    overflow-x: auto;
  }
  .agent-journey ol {
    min-width: 660px;
  }
}
@media (max-width: 640px) {
  .agent-intent-pending-bar {
    display: grid;
  }
  .agent-intent-pending-bar span {
    text-align: left;
  }
  .agent-mode-selector__head > div {
    display: grid;
    gap: 1px;
  }
  .agent-mode-selector__head > span {
    display: none;
  }
  .agent-tool-execution-selector {
    align-items: stretch;
    flex-direction: column;
    gap: 6px;
    padding: 8px;
  }
  .agent-tool-execution-selector__copy span {
    display: none;
  }
  .agent-tool-execution-selector__options {
    width: 100%;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .agent-intent-review__header {
    display: grid;
  }
  .agent-intent-review__status {
    justify-self: start;
  }
  .agent-intent-review dl,
  .agent-intent-review__actions {
    grid-template-columns: 1fr;
  }
  .agent-intent-review__revision-actions {
    display: grid;
    grid-template-columns: 1fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  .agent-mode-selector__grid button,
  .agent-tool-execution-selector__options button,
  .agent-intent-review__analyzing > span {
    animation: none;
    transition: none;
  }
}
.agent-evidence-list {
  display: grid;
  gap: 7px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.agent-evidence-list button {
  display: grid;
  width: 100%;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #d9e1ec;
  border-radius: 10px;
  background: #f8fafc;
  padding: 8px 10px;
  text-align: left;
}

.agent-evidence-list button:hover {
  border-color: #93c5fd;
  background: #eff6ff;
}

.agent-evidence-list button:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.agent-evidence-list span {
  border-radius: 999px;
  background: #eaf2ff;
  padding: 3px 7px;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.agent-evidence-list strong {
  overflow: hidden;
  color: #334155;
  font-size: 13px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-evidence-list small {
  color: #64748b;
  font-size: 12px;
}

.agent-evidence-backdrop {
  position: fixed;
  z-index: 90;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.48);
  padding: 20px;
}

.agent-evidence-viewer {
  display: flex;
  width: min(680px, 100%);
  max-height: min(760px, 100vh - 40px);
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.28);
}

.agent-evidence-viewer > header,
.agent-evidence-viewer > footer {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid #e8edf5;
  padding: 16px 18px;
}

.agent-evidence-viewer > header span,
.agent-evidence-viewer__label {
  color: #2563eb;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.agent-evidence-viewer > header h2 {
  margin: 4px 0 0;
  color: #0f172a;
  font-size: 18px;
  font-weight: 750;
}

.agent-evidence-viewer > header p {
  margin: 3px 0 0;
  color: #64748b;
  font-size: 12px;
}

.agent-evidence-viewer button,
.agent-evidence-viewer footer a {
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #fff;
  padding: 7px 12px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.agent-evidence-viewer__body {
  display: grid;
  gap: 16px;
  overflow: auto;
  padding: 18px;
}

.agent-evidence-viewer__trust {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.agent-evidence-viewer__trust span {
  border-radius: 999px;
  background: #f1f5f9;
  padding: 5px 9px;
  color: #475569;
  font-size: 12px;
  font-weight: 650;
}

.agent-evidence-viewer__supports {
  margin: 4px 0 0;
  color: #334155;
  font-size: 13px;
  line-height: 1.55;
}

.agent-evidence-viewer blockquote {
  margin: 0;
  border-left: 4px solid #60a5fa;
  border-radius: 0 10px 10px 0;
  background: #eff6ff;
  padding: 14px 16px;
  color: #1e3a5f;
  font-size: 14px;
  line-height: 1.7;
}

.agent-evidence-viewer__loading,
.agent-evidence-viewer__error {
  margin: 0;
  border-radius: 9px;
  padding: 9px 11px;
  font-size: 12px;
  line-height: 1.5;
}

.agent-evidence-viewer__loading {
  background: #eff6ff;
  color: #1d4ed8;
}

.agent-evidence-viewer__error {
  background: #fef2f2;
  color: #b91c1c;
}

.agent-evidence-viewer__context {
  display: grid;
  gap: 7px;
}

.agent-evidence-viewer__context article {
  display: grid;
  gap: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  padding: 9px 10px;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;
}

.agent-evidence-viewer__context article.is-selected {
  border-color: #93c5fd;
  background: #eff6ff;
}

.agent-evidence-viewer__context strong,
.agent-evidence-viewer__context p {
  margin: 0;
}

.agent-evidence-viewer dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  margin: 0;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.agent-evidence-viewer dl > div {
  min-width: 0;
  border-right: 1px solid #e8edf5;
  border-bottom: 1px solid #e8edf5;
  padding: 10px 12px;
}

.agent-evidence-viewer dt {
  color: #64748b;
  font-size: 12px;
}

.agent-evidence-viewer dd {
  margin: 4px 0 0;
  overflow-wrap: anywhere;
  color: #0f172a;
  font-size: 13px;
  font-weight: 650;
}

.agent-evidence-viewer__warning {
  margin: 0;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  background: #fff7ed;
  padding: 10px 12px;
  color: #9a3412;
  font-size: 12px;
}

.agent-evidence-viewer > footer {
  justify-content: flex-end;
  border-top: 1px solid #e8edf5;
  border-bottom: 0;
}

.agent-evidence-viewer > footer a {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
}

@media (max-width: 640px) {
  .agent-evidence-list button {
    grid-template-columns: auto minmax(0, 1fr);
  }
  .agent-evidence-list small {
    display: none;
  }
  .agent-evidence-viewer dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.agent-error-notice {
  top: 48px !important;
}

.agent-history-panel {
  transition: width 0.16s ease;
}

.agent-history-save-status {
  color: #64748b;
}

.agent-history-save-status.is-saving {
  color: #2563eb;
}

.agent-history-save-status.is-saved {
  color: #0f766e;
}

.agent-history-save-status.is-error {
  color: #b91c1c;
}

.agent-history-panel--resizing {
  user-select: none;
  transition: none;
}

.agent-history-resize-handle {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 10px;
  height: 100%;
  cursor: col-resize;
  touch-action: none;
}

.agent-history-resize-handle::after {
  content: "";
  position: absolute;
  top: 12px;
  bottom: 12px;
  left: 4px;
  width: 2px;
  border-radius: 999px;
  background: transparent;
}

.agent-history-resize-handle:hover::after,
.agent-history-resize-handle:focus-visible::after {
  background: var(--nf-action);
}

.agent-history-resize-handle:focus-visible {
  outline: 2px solid var(--nf-action);
  outline-offset: -2px;
}

.agent-history-collapsed-label {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.agent-history-delete-button {
  opacity: 0;
  pointer-events: none;
  transform: translateY(-50%);
  transition: opacity 0.14s ease, border-color 0.14s ease, background-color 0.14s ease;
}

.agent-history-item:hover .agent-history-delete-button,
.agent-history-item:focus-within .agent-history-delete-button {
  opacity: 1;
  pointer-events: auto;
}

::ng-deep .nf-floating-chat.is-agent-chat-suppressed,
::ng-deep .nf-floating-chat.is-agent-chat {
  display: none !important;
}

.agent-answer-content {
  min-width: 0;
  font-size: 14px;
  line-height: 1.75;
  overflow-wrap: anywhere;
}

.agent-answer-content > * + * {
  margin-top: 10px;
}

.agent-answer-heading {
  color: #0f172a;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
}

.agent-answer-heading.is-level-1,
.agent-answer-heading.is-level-2 {
  font-size: 16px;
}

.agent-answer-paragraph {
  white-space: pre-wrap;
}

.agent-answer-list {
  display: grid;
  gap: 5px;
  padding-left: 20px;
  list-style: disc;
}

.agent-answer-list--ordered {
  list-style: decimal;
}

.agent-answer-quote {
  border-left: 3px solid #93c5fd;
  background: #f8fbff;
  padding: 8px 10px;
  color: #475569;
}

.agent-answer-code {
  overflow-x: auto;
  border: 1px solid #d9e1ec;
  border-radius: 8px !important;
  background: #f7f9fc;
  padding: 10px 12px;
  color: #334155;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace !important;
  font-size: 12px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.agent-answer-table-wrap {
  max-width: 100%;
  overflow-x: auto;
  border: 1px solid #d9e1ec;
  border-radius: 8px !important;
}

.agent-answer-table {
  min-width: 520px;
  width: 100%;
  font-size: 12px;
}

.agent-answer-table th,
.agent-answer-table td {
  border-bottom: 1px solid #e8edf5;
  padding: 8px 10px;
  text-align: left;
  white-space: nowrap;
}

.agent-answer-table th {
  color: #475569;
  font-weight: 600;
}

.agent-answer-table tbody tr:last-child td {
  border-bottom: 0;
}

.agent-answer-runtime {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(122px, 1fr));
  gap: 1px;
  margin-top: 14px;
  overflow: hidden;
  border: 1px solid #e8edf5;
  border-radius: 9px !important;
  background: #e8edf5;
}

.agent-answer-runtime__item {
  min-width: 0;
  background: #f8fafc;
  padding: 8px 10px;
}

.agent-answer-runtime__item dt {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
}

.agent-answer-runtime__item dd {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
  margin-top: 3px;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.agent-answer-runtime__item dd::before {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #64748b;
  content: "";
}

.agent-answer-runtime__item.is-success dd::before {
  background: #0f766e;
}

.agent-answer-runtime__item.is-warning {
  background: #fffaf0;
}

.agent-answer-runtime__item.is-warning dd {
  color: #9a3412;
}

.agent-answer-runtime__item.is-warning dd::before {
  background: #f97316;
}

.agent-answer-runtime__item.is-muted dd {
  color: #94a3b8;
}

.agent-answer-quality {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  margin-top: 14px;
  overflow: hidden;
  border: 1px solid #bbf7d0;
  border-radius: 12px !important;
  background: #f7fef9;
}

.agent-answer-quality.is-attention {
  border-color: #fed7aa;
  background: #fffaf3;
}

.agent-answer-quality.is-fallback {
  border-color: #bfdbfe;
  background: #f5f9ff;
}

.agent-answer-quality.is-informational {
  border-color: #d9e1ec;
  background: #f8fafc;
}

.agent-answer-quality__head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  padding: 13px;
  cursor: pointer;
  list-style: none;
}

.agent-answer-quality__head::-webkit-details-marker,
.agent-live-flow__header::-webkit-details-marker {
  display: none;
}

.agent-answer-quality__head::after,
.agent-live-flow__header::after {
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  margin-top: 6px;
  content: "";
  justify-self: end;
  transform: rotate(45deg);
  transition: transform 0.16s ease;
}

.agent-answer-quality[open] > .agent-answer-quality__head::after,
.agent-live-flow[open] > .agent-live-flow__header::after {
  transform: rotate(225deg);
}

.agent-answer-quality__body {
  border-top: 1px solid rgba(148, 163, 184, 0.24);
  padding: 0 13px 13px;
}

.agent-answer-quality__summary {
  margin-top: 11px;
  color: #475569;
  font-size: 12px;
  line-height: 1.6;
}

.agent-answer-quality__eyebrow,
.agent-result-handoff__eyebrow {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.agent-answer-quality__head strong,
.agent-result-handoff strong {
  display: block;
  margin-top: 3px;
  color: #0f172a;
  font-size: 14px;
  font-weight: 750;
}

.agent-result-handoff > div > p:last-child {
  margin-top: 4px;
  color: #475569;
  font-size: 12px;
  line-height: 1.6;
}

.agent-answer-quality__status {
  justify-self: center;
  flex: 0 0 auto;
  border: 1px solid #86efac;
  border-radius: 999px !important;
  background: #fff;
  padding: 4px 9px;
  color: #166534;
  font-size: 12px;
  font-weight: 700;
}

.agent-answer-quality.is-attention .agent-answer-quality__status {
  border-color: #fdba74;
  color: #9a3412;
}

.agent-answer-quality.is-fallback .agent-answer-quality__status {
  border-color: #93c5fd;
  color: #1d4ed8;
}

.agent-answer-quality.is-informational .agent-answer-quality__status {
  border-color: #cbd5e1;
  color: #475569;
}

.agent-answer-quality__checks {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 11px;
}

.agent-answer-quality__checks > div {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px !important;
  background: rgba(255, 255, 255, 0.82);
  padding: 8px 9px;
}

.agent-answer-quality__checks dt {
  color: #64748b;
  font-size: 12px;
  font-weight: 650;
}

.agent-answer-quality__checks dd {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 3px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.agent-answer-quality__checks dd::before {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #94a3b8;
  content: "";
}

.agent-answer-quality__checks .is-passed dd::before {
  background: #16a34a;
}

.agent-answer-quality__checks .is-attention dd {
  color: #9a3412;
}

.agent-answer-quality__checks .is-attention dd::before {
  background: #f97316;
}

.agent-answer-quality__limitations {
  display: grid;
  gap: 3px;
  margin-top: 10px;
  padding-left: 18px;
  color: #9a3412;
  font-size: 12px;
  line-height: 1.55;
  list-style: disc;
}

.agent-answer-quality__calibration {
  margin-top: 9px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.agent-inline-visual,
.agent-inline-report {
  margin-top: 12px;
  overflow: hidden;
  border: 1px solid #dbeafe;
  border-radius: 10px !important;
  background: #f8fbff;
}

.agent-inline-visual__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #dbeafe;
  padding: 9px 11px;
}

.agent-inline-visual__head strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 750;
}

.agent-inline-visual__head span {
  color: #64748b;
  font-size: 12px;
}

.agent-inline-table-wrap {
  max-width: 100%;
  overflow-x: auto;
}

.agent-inline-table {
  width: 100%;
  min-width: 580px;
  border-collapse: collapse;
  color: #334155;
  font-size: 12px;
}

.agent-inline-table th,
.agent-inline-table td {
  border-bottom: 1px solid #e8edf5;
  padding: 8px 10px;
  text-align: left;
  white-space: nowrap;
}

.agent-inline-table th {
  background: #eff6ff;
  color: #475569;
  font-weight: 750;
}

.agent-inline-table tbody tr:last-child td {
  border-bottom: 0;
}

.agent-inline-chart {
  display: flex;
  height: 150px;
  align-items: flex-end;
  gap: 7px;
  border-bottom: 1px solid #cbd5e1;
  margin: 14px;
  padding: 0 8px;
}

.agent-inline-chart > span {
  min-width: 8px;
  flex: 1 1 0;
  border-radius: 5px 5px 0 0 !important;
  background: linear-gradient(180deg, #60a5fa, #2563eb);
}

.agent-inline-report > summary {
  cursor: pointer;
  padding: 10px 12px;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 750;
}

.agent-inline-report pre {
  max-height: 320px;
  overflow: auto;
  border-top: 1px solid #dbeafe;
  background: #fff;
  padding: 12px;
  color: #334155;
  font-family: inherit;
  font-size: 12px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.agent-result-handoff {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  margin-top: 12px;
  border: 1px solid #dbeafe;
  border-left: 3px solid #2563eb;
  border-radius: 10px !important;
  background: #f8fbff;
  padding: 12px;
}

.agent-result-handoff__links {
  display: flex;
  max-width: 250px;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.agent-result-handoff__links a {
  border: 1px solid #bfdbfe;
  border-radius: 999px !important;
  background: #fff;
  padding: 6px 10px;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.agent-result-handoff__links a:hover,
.agent-result-handoff__links a:focus-visible {
  border-color: #2563eb;
  background: #eff6ff;
  outline: none;
}

.agent-answer-technical {
  margin-top: 12px;
  border-top: 1px solid #e8edf5;
  padding-top: 9px;
}

.agent-answer-technical > summary {
  width: fit-content;
  cursor: pointer;
  color: #64748b;
  font-size: 12px;
  font-weight: 650;
}

.agent-answer-technical[open] > summary {
  color: #334155;
}

@media (max-width: 680px) {
  .agent-result-handoff {
    align-items: flex-start;
    grid-template-columns: 1fr;
  }
  .agent-answer-quality__checks {
    grid-template-columns: 1fr;
  }
  .agent-result-handoff__links {
    max-width: none;
    justify-content: flex-start;
  }
}
.quality-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
}

.quality-toolbar__field {
  display: grid;
  gap: 4px;
}

.quality-toolbar__field > span {
  padding-left: 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.quality-toolbar__field select,
.quality-toolbar__button {
  height: 40px;
  border-radius: 999px !important;
  font-size: 13px;
}

.quality-toolbar__field select {
  min-width: 154px;
  border: 1px solid #d9e1ec;
  background: #fff;
  padding: 0 34px 0 14px;
  color: #0f172a;
}

.quality-toolbar__field select:focus {
  border-color: #2563eb;
  outline: 2px solid rgba(37, 99, 235, 0.16);
  outline-offset: 1px;
}

.quality-toolbar__button {
  border: 1px solid #d9e1ec;
  padding: 0 16px;
  font-weight: 650;
}

.quality-toolbar__button.is-secondary {
  background: #fff;
  color: #334155;
}

.quality-toolbar__button.is-primary {
  border-color: #0f172a;
  background: #0f172a;
  color: #fff;
}

.quality-toolbar__button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.quality-inline-status,
.quality-validation-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #bfdbfe;
  border-radius: 12px !important;
  background: #eff6ff;
  padding: 12px 14px;
  color: #1e40af;
  font-size: 13px;
}

.quality-schema-hint {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  border: 1px solid #d9e1ec;
  border-radius: 10px !important;
  background: #fff;
  padding: 9px 12px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.quality-schema-hint strong {
  color: #334155;
  font-weight: 700;
}

.quality-schema-hint code {
  border-radius: 6px;
  background: #f4f7fb;
  padding: 2px 6px;
  color: #1d4ed8;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
}

.quality-schema-hint span {
  margin-left: auto;
}

.quality-inline-status__spinner {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  border: 2px solid #bfdbfe;
  border-top-color: #2563eb;
  border-radius: 999px;
  animation: agent-quality-spin 0.8s linear infinite;
}

.admin-model-loading {
  display: flex;
  min-height: 112px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  color: #64748b;
  font-size: 13px;
}

@keyframes agent-quality-spin {
  to {
    transform: rotate(360deg);
  }
}
.quality-validation-summary {
  justify-content: space-between;
  border-color: #d9e1ec;
  background: #fff;
  color: #334155;
}

.quality-status-badge {
  display: inline-flex;
  width: fit-content;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #d9e1ec;
  border-radius: 999px !important;
  background: #f8fafc;
  padding: 4px 9px;
  color: #64748b;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.35;
  text-align: center;
}

.quality-status-badge__dot {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #94a3b8;
}

.quality-status-badge.is-success {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.quality-status-badge.is-success .quality-status-badge__dot {
  background: #16a34a;
}

.quality-status-badge.is-warning {
  border-color: #fed7aa;
  background: #fff7ed;
  color: #9a3412;
}

.quality-status-badge.is-warning .quality-status-badge__dot {
  background: #f97316;
}

.quality-status-badge.is-error {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.quality-status-badge.is-error .quality-status-badge__dot {
  background: #dc2626;
}

.quality-status-badge.is-running {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.quality-status-badge.is-running .quality-status-badge__dot {
  background: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.quality-run-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(130px, 0.55fr) minmax(130px, 0.55fr) minmax(150px, auto);
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
}

.quality-run-row__meta {
  display: grid;
  gap: 3px;
  color: #475569;
  font-size: 12px;
  line-height: 1.45;
}

.quality-run-row__meta strong {
  font-weight: 650;
}

.ingestion-preview-card,
.ingestion-operational-card {
  overflow: hidden;
  border: 1px solid #d9e1ec;
  border-radius: 16px !important;
  background: #fff;
  padding: 16px;
}

.ingestion-preview-card {
  border-color: #fbbf24;
  box-shadow: inset 4px 0 0 #f59e0b;
}

.ingestion-preview-card__header,
.ingestion-operational-card__header,
.ingestion-dataset-card__summary,
.ingestion-version-row,
.ingestion-quarantine-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ingestion-impact-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(90px, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.ingestion-impact-grid > div {
  border: 1px solid #e8edf5;
  border-radius: 10px !important;
  background: #f8fafc;
  padding: 10px;
}

.ingestion-impact-grid span,
.ingestion-impact-grid strong {
  display: block;
}

.ingestion-impact-grid span {
  color: #64748b;
  font-size: 12px;
  font-weight: 650;
}

.ingestion-impact-grid strong {
  margin-top: 3px;
  color: #0f172a;
  font-size: 17px;
  font-weight: 750;
}

.ingestion-preview-card__warning {
  margin-top: 12px;
  border: 1px solid #fecaca;
  border-radius: 9px !important;
  background: #fef2f2;
  padding: 9px 11px;
  color: #b91c1c;
  font-size: 12px;
  line-height: 1.55;
}

.ingestion-approval-check {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 14px;
  color: #334155;
  cursor: pointer;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.45;
}

.ingestion-approval-check input {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  margin-top: 1px;
  accent-color: #0f172a;
}

.ingestion-preview-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}

.ingestion-dataset-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.ingestion-storage-facts {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.ingestion-storage-facts > div {
  display: grid;
  gap: 3px;
  border: 1px solid #e8edf5;
  border-radius: 10px !important;
  background: #f8fafc;
  padding: 10px 12px;
}

.ingestion-storage-facts span {
  color: #64748b;
  font-size: 12px;
}

.ingestion-storage-facts strong {
  color: #0f172a;
  font-size: 14px;
}

.ingestion-storage-facts .ingestion-preview-card__warning {
  grid-column: 1/-1;
  margin-top: 0;
}

.ingestion-version-preview {
  margin-top: 14px;
  border-top: 1px solid #e8edf5;
  padding-top: 14px;
}

.ingestion-version-preview .knowledge-row-table-wrap {
  max-height: 360px;
  margin-top: 12px;
}

.ingestion-dataset-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e8edf5;
  border-radius: 12px !important;
  background: #fbfdff;
}

.ingestion-dataset-card__summary {
  padding: 12px;
}

.ingestion-version-list {
  border-top: 1px solid #e8edf5;
  background: #fff;
}

.ingestion-version-row {
  min-height: 54px;
  border-top: 1px solid #f1f5f9;
  padding: 8px 12px;
}

.ingestion-version-row:first-child {
  border-top: 0;
}

.ingestion-version-row__button {
  min-height: 30px;
  flex: 0 0 auto;
  border: 1px solid #d9e1ec;
  border-radius: 999px !important;
  background: #fff;
  padding: 0 10px;
  color: #334155;
  font-size: 12px;
  font-weight: 650;
}

.ingestion-version-row__button:hover:not(:disabled) {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}

.ingestion-version-row__button.is-danger {
  border-color: #fecaca;
  color: #b91c1c;
}

.ingestion-version-row__button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.ingestion-dataset-card__empty {
  border-top: 1px solid #e8edf5;
  background: #fff;
  padding: 16px 12px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}

.ingestion-operational-card.is-quarantine {
  border-color: #fecaca;
}

.ingestion-quarantine-list {
  overflow: hidden;
  margin-top: 14px;
  border: 1px solid #fee2e2;
  border-radius: 10px !important;
}

.ingestion-quarantine-row {
  border-top: 1px solid #fee2e2;
  padding: 11px 12px;
}

.ingestion-quarantine-row:first-child {
  border-top: 0;
}

.quality-catalog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px;
}

.quality-rule-action {
  flex: 0 0 auto;
  border-radius: 999px !important;
  background: #f4f7fb;
  padding: 4px 9px;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .quality-toolbar {
    width: 100%;
    justify-content: flex-start;
  }
  .quality-run-row {
    grid-template-columns: minmax(0, 1fr) minmax(150px, 0.65fr);
  }
  .ingestion-impact-grid {
    grid-template-columns: repeat(3, minmax(90px, 1fr));
  }
  .ingestion-dataset-grid {
    grid-template-columns: 1fr;
  }
  .ingestion-storage-facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .agent-sample-banner {
    max-width: calc(100% - 24px);
  }
  .agent-sample-banner span:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .quality-toolbar__field,
  .quality-toolbar__field select,
  .quality-toolbar__button {
    width: 100%;
  }
  .quality-run-row {
    grid-template-columns: 1fr;
  }
  .quality-validation-summary {
    align-items: flex-start;
    flex-direction: column;
  }
  .quality-schema-hint span {
    width: 100%;
    margin-left: 0;
  }
  .ingestion-impact-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ingestion-storage-facts {
    grid-template-columns: 1fr;
  }
  .ingestion-preview-card__header,
  .ingestion-operational-card__header,
  .ingestion-quarantine-row {
    align-items: flex-start;
    flex-direction: column;
  }
  .ingestion-preview-card__actions {
    flex-direction: column-reverse;
  }
  .ingestion-preview-card__actions .quality-toolbar__button,
  .ingestion-quarantine-row .ingestion-version-row__button {
    width: 100%;
  }
}
.agent-progress-strip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  border-top: 1px solid var(--nf-border-soft);
  padding-top: 10px;
  color: #64748b;
}

.agent-progress-step {
  display: inline-flex;
  min-width: 0;
  max-width: 160px;
  align-items: center;
  gap: 5px;
  border: 1px solid transparent;
  border-radius: 999px !important;
  background: transparent;
  padding: 2px 0;
  font-size: 12px;
  line-height: 1.2;
}

.agent-progress-dot {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #cbd5e1;
}

.agent-progress-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-progress-link {
  width: 12px;
  height: 1px;
  flex: 0 0 auto;
  background: var(--nf-border);
}

.agent-progress-step.is-done .agent-progress-dot {
  background: #0f766e;
}

.agent-progress-step.is-running .agent-progress-dot {
  background: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.agent-progress-step.is-failed .agent-progress-dot {
  background: #dc2626;
}

.agent-progress-step.is-skipped .agent-progress-dot {
  background: #94a3b8;
}

.agent-live-flow {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  margin-top: 12px;
  border: 1px solid #bfdbfe;
  border-radius: 14px;
  background: linear-gradient(145deg, #f8fbff 0%, #eff6ff 100%);
  color: #0f172a;
}

.agent-live-flow__header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 16px;
  padding: 14px;
  cursor: pointer;
  list-style: none;
}

.agent-live-flow[open] > .agent-live-flow__header {
  border-bottom: 1px solid #dbeafe;
}

.agent-live-flow__header strong {
  display: block;
  margin-top: 2px;
  font-size: 14px;
  line-height: 1.45;
}

.agent-live-flow__header > span {
  justify-self: center;
  flex: 0 0 auto;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #fff;
  padding: 4px 9px;
  color: #2563eb;
  font-size: 12px;
  font-weight: 700;
}

.agent-live-flow__eyebrow {
  color: #2563eb;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.agent-live-flow__steps {
  display: grid;
  gap: 4px;
  margin: 0;
  padding: 12px 14px 14px;
  list-style: none;
}

.agent-live-flow__steps li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 10px;
  align-items: flex-start;
  border-radius: 10px;
  padding: 8px;
  color: #64748b;
  transition: background-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;
}

.agent-live-flow__marker {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.agent-live-flow__copy > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.agent-live-flow__copy strong {
  color: inherit;
  font-size: 13px;
}

.agent-live-flow__copy span,
.agent-live-flow__copy p {
  font-size: 12px;
}

.agent-live-flow__copy span {
  flex: 0 0 auto;
  font-weight: 700;
}

.agent-live-flow__copy p {
  margin: 2px 0 0;
  line-height: 1.5;
}

.agent-live-flow__steps li.is-running {
  background: #dbeafe;
  color: #1d4ed8;
}

.agent-live-flow__steps li.is-running .agent-live-flow__marker {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
  animation: agent-flow-pulse 1.5s ease-in-out infinite;
}

.agent-live-flow__steps li.is-done {
  color: #0f766e;
}

.agent-live-flow__steps li.is-done .agent-live-flow__marker {
  border-color: #99f6e4;
  background: #ccfbf1;
  color: #0f766e;
}

.agent-live-flow__steps li.is-failed {
  background: #fff1f2;
  color: #be123c;
}

.agent-live-flow__steps li.is-skipped {
  opacity: 0.7;
}

@keyframes agent-flow-pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.22);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(37, 99, 235, 0);
  }
}
@media (max-width: 640px) {
  .agent-live-flow {
    width: 100%;
  }
  .agent-live-flow__copy > div {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .agent-live-flow__steps li,
  .agent-live-flow__steps li.is-running .agent-live-flow__marker {
    animation: none;
    transition: none;
  }
}
.agent-chat-trace-bars {
  display: grid;
  height: 108px;
  grid-template-columns: repeat(auto-fit, minmax(12px, 1fr));
  align-items: end;
  gap: 4px;
  border-radius: 8px !important;
  background: #f7f9fc;
  padding: 12px;
}

.agent-chat-trace-bar {
  display: flex;
  min-width: 0;
  height: 84px;
  align-items: end;
  justify-content: center;
  gap: 2px;
}

.agent-chat-trace-bar span {
  width: 45%;
  min-height: 8px;
  border-radius: 4px 4px 0 0;
}

.agent-chat-trace-bar .is-base {
  background: #2563eb;
}

.agent-chat-trace-bar .is-target {
  background: #f97316;
}

.agent-shell ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.agent-shell ::-webkit-scrollbar-thumb {
  background: var(--nf-border-strong);
  border: 3px solid transparent;
  border-radius: 999px;
  background-clip: content-box;
}

.agent-shell ::-webkit-scrollbar-track {
  background: transparent;
}

.agent-flat-section {
  --nf-agent-flat-surface: color-mix(in srgb, var(--nf-panel) 44%, transparent);
  --nf-agent-flat-surface-hover: color-mix(in srgb, var(--nf-panel) 58%, transparent);
}

.agent-flat-metrics {
  gap: 0;
  overflow: hidden;
  border-block: 1px solid var(--nf-border);
  background: color-mix(in srgb, var(--nf-panel) 50%, transparent);
}

.agent-flat-metrics > div {
  border: 0 !important;
  border-left: 1px solid var(--nf-border-soft) !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.agent-flat-metrics > div:first-child {
  border-left: 0 !important;
}

.agent-flat-section > div[class*="rounded-[16px]"][class*=border],
.agent-flat-section > .grid > div[class*="rounded-[16px]"][class*=border],
.agent-flat-section > .grid > .grid > div[class*="rounded-[16px]"][class*=border],
.agent-flat-section > .grid > .space-y-4 > div[class*="rounded-[16px]"][class*=border] {
  border-inline: 0 !important;
  border-radius: 0 !important;
  background: var(--nf-agent-flat-surface) !important;
  box-shadow: none !important;
}

.agent-flat-section > div[class*="rounded-[16px]"][class*=border]:hover,
.agent-flat-section > .grid > div[class*="rounded-[16px]"][class*=border]:hover,
.agent-flat-section > .grid > .grid > div[class*="rounded-[16px]"][class*=border]:hover,
.agent-flat-section > .grid > .space-y-4 > div[class*="rounded-[16px]"][class*=border]:hover {
  background: var(--nf-agent-flat-surface-hover) !important;
}

.agent-flat-section [class*="shadow-[0_"] {
  box-shadow: none !important;
}

.agent-flat-section [class*=ring-] {
  box-shadow: none !important;
}

.agent-flat-section div[class*=rounded-xl][class*=border],
.agent-flat-section div[class*=rounded-lg][class*=border] {
  border-radius: 0 !important;
  box-shadow: none !important;
}

.agent-flat-section div[class*=rounded-lg][class*="bg-[#f4f7fb]"] {
  border-radius: 0 !important;
  background: transparent !important;
}

.workflow-page {
  display: flex;
  flex-direction: column;
}

.workflow-tabbar {
  display: flex;
  gap: 24px;
}

.workflow-summary-strip > div {
  border-left: 1px solid var(--nf-border-soft);
}

.workflow-summary-strip > div:first-child {
  border-left: 0;
}

.workflow-template-card,
.workflow-list-panel,
.workflow-run-panel,
.workflow-result-hero,
.workflow-result-section,
.workflow-empty-state {
  border-radius: 8px;
  box-shadow: none;
}

.workflow-template-card.is-selected {
  box-shadow: inset 3px 0 0 #2563eb;
}

.workflow-list-item {
  background: #fff;
}

.workflow-list-item.is-selected {
  background: #f8fbff;
  box-shadow: inset 3px 0 0 #2563eb;
}

.workflow-list-summary {
  display: grid;
  width: 100%;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  border: 0;
  background: transparent;
  padding: 13px 16px;
  text-align: left;
}

.workflow-list-summary:hover {
  background: #f4f7fb;
}

.workflow-list-summary:focus-visible {
  outline: 2px solid #a9c7ff;
  outline-offset: -2px;
}

.workflow-list-detail {
  border-top: 1px solid var(--nf-border-soft);
  background: #f8fbff;
  padding: 14px 16px 16px;
}

.workflow-node-row,
.workflow-step-row,
.workflow-check-row,
.workflow-output-cell,
.workflow-artifact-cell {
  min-width: 0;
  border-radius: 8px;
  background: #f7f9fc;
}

.workflow-node-row {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
}

.workflow-node-row--compact {
  background: #fff;
}

.workflow-node-index {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #0f172a;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.workflow-section-head {
  display: flex;
  min-height: 44px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--nf-border-soft);
  padding: 0 16px;
}

.workflow-section-head p {
  margin: 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
}

.workflow-section-head span {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.workflow-output-cell,
.workflow-artifact-cell {
  padding: 12px;
}

.workflow-output-cell p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
}

.workflow-output-cell strong {
  display: block;
  margin-top: 5px;
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workflow-check-row {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
}

.workflow-check-row span {
  display: inline-flex;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.workflow-check-row p {
  margin: 0;
  color: #334155;
  font-size: 12px;
  line-height: 1.5;
}

.workflow-step-row {
  display: grid;
  grid-template-columns: 28px minmax(140px, 1fr) 72px minmax(120px, 0.8fr);
  align-items: center;
  gap: 12px;
  border-radius: 0;
  background: #fff;
  padding: 12px 16px;
}

@media (max-width: 900px) {
  .workflow-tabbar {
    gap: 14px;
    overflow-x: auto;
  }
  .workflow-step-row {
    grid-template-columns: 28px minmax(0, 1fr);
  }
  .workflow-step-row > span:nth-child(3),
  .workflow-step-row > div:nth-child(4) {
    grid-column: 2;
  }
  .workflow-list-summary {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }
  .workflow-list-summary > :last-child {
    justify-content: flex-start;
  }
  .workflow-result-hero .border-l {
    border-left: 0 !important;
    border-top: 1px solid var(--nf-border-soft);
    padding-left: 0 !important;
    padding-top: 14px;
  }
}
.agent-analysis-workspace {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.analysis-purpose-strip {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  border-bottom: 1px solid var(--nf-border-soft);
  background: #fbfdff;
  padding: 10px 20px;
}

.analysis-purpose-card {
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  padding: 9px 11px;
}

.analysis-purpose-card span,
.analysis-purpose-card strong,
.analysis-purpose-card small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-purpose-card span {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.analysis-purpose-card strong {
  margin-top: 3px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 850;
}

.analysis-purpose-card small {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-tabbar {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0;
  border-bottom: 1px solid var(--nf-border-soft);
  background: var(--nf-panel);
  padding: 18px 34px 16px;
}

.analysis-tab {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  border: 0;
  background: transparent;
  padding: 0 10px;
  color: #475569;
  cursor: pointer;
  text-align: center;
  transition: color 0.16s ease, transform 0.16s ease;
}

.analysis-tab::before,
.analysis-tab::after {
  content: "";
  position: absolute;
  top: 21px;
  z-index: 0;
  height: 3px;
  border-radius: 999px;
  background: #d8e5ef;
}

.analysis-tab::before {
  left: 0;
  right: calc(50% + 25px);
}

.analysis-tab::after {
  left: calc(50% + 25px);
  right: 0;
}

.analysis-tab:first-child::before,
.analysis-tab:last-child::after {
  display: none;
}

.analysis-tab.is-ready::before,
.analysis-tab.is-ready::after,
.analysis-tab.is-active::before,
.analysis-tab.is-active::after {
  background: #9ee6bd;
}

.analysis-tab:hover {
  color: #0f172a;
  transform: translateY(-1px);
}

.analysis-tab:focus-visible {
  border-radius: 8px;
  outline: 2px solid #93c5fd;
  outline-offset: 4px;
}

.analysis-tab.is-active {
  color: #0f172a;
}

.analysis-tab.is-ready:not(.is-active) {
  color: #166534;
}

.analysis-tab__index {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border: 4px solid #b9f4cf;
  border-radius: 999px;
  background: #f0fdf4;
  color: #166534;
  box-shadow: 0 0 0 5px #fff;
  font-size: 14px;
  font-weight: 800;
  transition: background-color 0.16s ease, border-color 0.16s ease, box-shadow 0.16s ease, color 0.16s ease;
}

.analysis-tab.is-active .analysis-tab__index {
  background: #2563eb;
  border-color: #1d4ed8;
  box-shadow: 0 0 0 5px #dbeafe;
  color: #fff;
}

.analysis-tab.is-ready:not(.is-active) .analysis-tab__index {
  background: #dcfce7;
  border-color: #86efac;
  color: #166534;
}

.analysis-tab__body {
  min-width: 0;
  width: 100%;
}

.analysis-tab__label,
.analysis-tab small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-tab__label {
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
}

.analysis-tab small {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-tab em {
  display: block;
  margin-top: 2px;
  overflow: hidden;
  color: #94a3b8;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-flow-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid var(--nf-border-soft);
  background: #fff;
  padding: 10px 20px;
}

.analysis-flow-summary div {
  min-width: 0;
}

.analysis-flow-summary span,
.analysis-flow-summary strong,
.analysis-flow-summary p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-flow-summary span {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.analysis-flow-summary strong {
  display: block;
  margin-top: 2px;
  color: #0f172a;
  font-size: 12px;
  font-weight: 850;
}

.analysis-flow-summary p {
  max-width: 420px;
  margin: 0;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.analysis-summary-strip {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 8px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--nf-border-soft);
  background: #fbfdff;
}

.analysis-summary-card {
  min-width: 0;
  cursor: pointer;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  padding: 9px 11px;
  text-align: left;
  transition: border-color 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;
}

.analysis-summary-card:hover,
.analysis-summary-card.is-active {
  border-color: #93c5fd;
  background: #f8fbff;
}

.analysis-summary-card.is-active {
  box-shadow: inset 3px 0 0 #2563eb;
}

.analysis-summary-card span,
.analysis-summary-card strong,
.analysis-summary-card small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-summary-card span {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.analysis-summary-card strong {
  margin-top: 3px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
}

.analysis-summary-card small {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-tab-content {
  display: flex;
  min-height: 0;
  flex-direction: column;
}

.analysis-stage {
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--nf-border);
  border-radius: 8px;
  background: var(--nf-panel);
}

.analysis-stage__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--nf-border-soft);
}

.analysis-stage__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.analysis-stage__body--model {
  max-height: none;
}

.analysis-stage__body--record {
  max-height: none;
}

.analysis-stage__body--result {
  max-height: none;
}

.analysis-stage__header h3 {
  margin: 2px 0 0;
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
}

.analysis-stage__eyebrow,
.analysis-stage__hint {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-stage__controls,
.analysis-stage__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.analysis-stage__controls select,
.analysis-stage__controls input {
  height: 34px;
  min-width: 104px;
  border: 1px solid var(--nf-border);
  border-radius: 999px;
  background: #fff;
  padding: 0 12px;
  color: #0f172a;
  font-size: 12px;
}

.analysis-stage__controls input {
  width: 92px;
}

.analysis-stage__actions button {
  height: 34px;
  border: 1px solid var(--nf-border);
  border-radius: 999px;
  background: #fff;
  padding: 0 12px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.analysis-stage__actions button:last-child {
  background: #0f172a;
  color: #fff;
}

.analysis-model-grid,
.analysis-record-grid,
.analysis-result-grid {
  display: grid;
  gap: 0;
}

.analysis-model-grid {
  min-height: 100%;
  grid-template-columns: 1fr;
}

.analysis-record-grid {
  grid-template-columns: 1fr;
}

.analysis-result-grid {
  min-height: 100%;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, minmax(0, 1fr));
}

.analysis-result-grid--single {
  grid-template-rows: minmax(0, 1fr);
}

.analysis-tab-content > .analysis-stage {
  flex: 1 1 auto;
}

.analysis-model-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(152px, 1fr));
  align-content: start;
  gap: 6px;
  padding: 8px;
}

.analysis-model-option {
  min-width: 0;
  cursor: pointer;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  padding: 7px 8px;
  text-align: left;
}

.analysis-model-option:hover,
.analysis-model-option.is-selected {
  border-color: #93c5fd;
  background: #f8fbff;
}

.analysis-model-option.is-selected {
  box-shadow: inset 3px 0 0 #2563eb;
}

.analysis-empty-state {
  display: flex;
  min-height: 96px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  border: 1px dashed var(--nf-border-soft);
  border-radius: 8px;
  background: #f8fafc;
  padding: 14px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}

.analysis-empty-state strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
}

.analysis-empty-state span {
  color: #64748b;
  font-size: 12px;
}

.analysis-empty-state--compact {
  min-height: 0;
  padding: 10px;
  font-size: 12px;
}

.analysis-model-option__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 7px;
}

.analysis-model-option p {
  overflow: hidden;
  margin: 0;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-model-option small {
  display: block;
  margin-top: 2px;
  overflow: hidden;
  color: #64748b;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-model-option__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-top: 5px;
}

.analysis-model-option__meta span,
.analysis-status {
  border-radius: 999px;
  background: #f1f5f9;
  padding: 2px 5px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-status--ready {
  background: #dcfce7;
  color: #166534;
}

.analysis-status--mock {
  background: #fff7ed;
  color: #b45309;
}

.analysis-run-card {
  min-width: 0;
  border-top: 1px solid var(--nf-border-soft);
  padding: 12px;
  background: #fbfdff;
}

.analysis-run-card__head,
.analysis-result-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.analysis-run-card__head p,
.analysis-result-card__head p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-run-card__head strong {
  display: block;
  margin-top: 2px;
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-run-card__head span,
.analysis-result-card__head span {
  border-radius: 999px;
  background: #eef3f8;
  padding: 4px 8px;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
}

.analysis-run-card__summary,
.analysis-muted,
.analysis-record-note {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  color: #475569;
  font-size: 12px;
  line-height: 1.55;
}

.analysis-run-card__summary {
  min-height: 38px;
  margin: 10px 0 0;
  -webkit-line-clamp: 2;
}

.analysis-result-chips {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.analysis-result-chip {
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  padding: 8px 9px;
}

.analysis-result-chip span {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-result-chip strong {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  color: #0f172a;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-mini-chart {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  height: 42px;
  margin-top: 12px;
}

.analysis-mini-chart span {
  flex: 1 1 0;
  min-height: 6px;
  border-radius: 4px 4px 1px 1px;
  background: #0ea5e9;
}

.analysis-record-table {
  overflow: auto;
  max-height: 300px;
}

.analysis-record-table table {
  min-width: 100%;
  font-size: 12px;
}

.analysis-record-table th,
.analysis-record-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--nf-border-soft);
}

.analysis-record-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  color: #64748b;
  text-align: left;
}

.analysis-record-table tr {
  cursor: pointer;
}

.analysis-record-table tbody tr:hover,
.analysis-record-table tbody tr.is-selected {
  background: #f8fbff;
}

.analysis-record-status {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 800;
}

.analysis-record-detail {
  border-top: 1px solid var(--nf-border-soft);
  padding: 14px;
  background: #fbfdff;
}

.analysis-record-detail--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  color: #64748b;
  font-size: 12px;
}

.analysis-record-detail__main h4 {
  margin: 10px 0 2px;
  color: #0f172a;
  font-size: 15px;
  font-weight: 800;
}

.analysis-record-detail__main p {
  color: #64748b;
  font-size: 12px;
}

.analysis-record-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.analysis-record-kpis div {
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  padding: 8px;
}

.analysis-record-kpis span {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-record-kpis strong {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  color: #0f172a;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-record-note {
  margin-top: 12px;
  -webkit-line-clamp: 2;
}

.analysis-result-card {
  min-width: 0;
  overflow: auto;
  padding: 14px;
  border-top: 1px solid var(--nf-border-soft);
}

.analysis-result-card:first-child {
  border-top: 0;
}

.analysis-stage--result .analysis-result-card {
  border-top: 0;
}

.analysis-score {
  display: block;
  margin-top: 12px;
  color: #be123c;
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
}

.analysis-score--blue {
  color: #2563eb;
}

.analysis-score--green {
  color: #047857;
}

.analysis-muted {
  min-height: 38px;
  margin-top: 10px;
  -webkit-line-clamp: 2;
}

.analysis-factor-list,
.analysis-recipe-list {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}

.analysis-factor,
.analysis-recipe {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 4px 8px;
  width: 100%;
  cursor: pointer;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  padding: 8px 9px;
  text-align: left;
  transition: border-color 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;
}

.analysis-factor:hover,
.analysis-recipe:hover,
.analysis-factor.is-selected,
.analysis-recipe.is-selected {
  border-color: #93c5fd;
  background: #f8fbff;
}

.analysis-factor.is-selected,
.analysis-recipe.is-selected {
  box-shadow: inset 3px 0 0 #2563eb;
}

.analysis-factor span,
.analysis-recipe strong {
  overflow: hidden;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-factor strong {
  color: #2563eb;
  font-size: 12px;
}

.analysis-factor p,
.analysis-recipe span {
  grid-column: 1/-1;
  overflow: hidden;
  color: #64748b;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-header-meta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-header-meta span,
.analysis-header-meta strong {
  display: inline-flex;
  min-width: 0;
  max-width: 220px;
  align-items: center;
  overflow: hidden;
  border: 1px solid var(--nf-border-soft);
  border-radius: 999px;
  background: #f8fafc;
  padding: 6px 10px;
  color: #475569;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-header-meta strong {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.analysis-workbench {
  display: grid;
  grid-template-columns: minmax(250px, 300px) minmax(0, 1fr) minmax(270px, 310px);
  grid-template-areas: "model vm controls" "record vm controls" "rca optimize answer";
  grid-template-rows: minmax(176px, auto) minmax(218px, auto) minmax(210px, auto);
  align-content: start;
  gap: 14px;
  overflow: auto !important;
}

.analysis-model-rail,
.analysis-result-dashboard,
.analysis-step-card,
.analysis-control-panel {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--nf-border);
  border-radius: 8px;
  background: #fff;
}

.analysis-model-rail {
  grid-area: model;
}

.analysis-model-rail,
.analysis-control-panel {
  display: flex;
  min-height: 0;
  flex-direction: column;
}

.analysis-step-card--record {
  grid-area: record;
  overflow: auto;
}

.analysis-step-card--rca {
  grid-area: rca;
  overflow: auto;
}

.analysis-step-card--vm,
.analysis-result-dashboard {
  grid-area: vm;
  display: flex;
  min-height: 0;
  flex-direction: column;
  overflow: auto;
}

.analysis-step-card--optimize {
  grid-area: optimize;
  overflow: auto;
}

.analysis-step-card--answer {
  grid-area: answer;
  overflow: auto;
}

.analysis-control-panel {
  grid-area: controls;
}

.analysis-step-card {
  padding: 14px;
}

.analysis-model-rail.is-focused,
.analysis-result-dashboard.is-focused,
.analysis-step-card.is-focused {
  border-color: #93c5fd;
  box-shadow: inset 3px 0 0 #2563eb;
}

.analysis-panel-head,
.analysis-dashboard-head,
.analysis-detail-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.analysis-panel-head {
  border-bottom: 1px solid var(--nf-border-soft);
  padding: 14px;
}

.analysis-panel-head p,
.analysis-detail-panel__head p {
  margin: 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
}

.analysis-step-kicker {
  display: block;
  margin-bottom: 3px;
  color: #2563eb;
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0;
}

.analysis-panel-head span,
.analysis-detail-panel__head span {
  display: block;
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-panel-head button,
.analysis-detail-panel__head button {
  height: 28px;
  border: 1px solid var(--nf-border);
  border-radius: 999px;
  background: #fff;
  padding: 0 9px;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.analysis-panel-head button.is-active,
.analysis-detail-panel.is-focused .analysis-detail-panel__head button,
.analysis-step-card.is-focused .analysis-detail-panel__head button {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
}

.analysis-model-table {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.analysis-model-table__head,
.analysis-model-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 64px 56px;
  align-items: center;
  gap: 8px;
}

.analysis-model-table__head {
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid var(--nf-border-soft);
  background: #f8fafc;
  padding: 8px 12px;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.analysis-model-row {
  width: 100%;
  cursor: pointer;
  border: 0;
  border-bottom: 1px solid var(--nf-border-soft);
  background: #fff;
  padding: 10px 12px;
  text-align: left;
}

.analysis-model-row:hover,
.analysis-model-row.is-selected {
  background: #f8fbff;
}

.analysis-model-row.is-selected {
  box-shadow: inset 3px 0 0 #2563eb;
}

.analysis-model-row__name {
  display: grid;
  min-width: 0;
  grid-template-columns: 12px minmax(0, 1fr);
  gap: 7px;
}

.analysis-model-row__name strong,
.analysis-model-row__name small,
.analysis-model-row__type {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-model-row__name strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
}

.analysis-model-row__name small {
  grid-column: 2;
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-model-row__type {
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.analysis-model-radio {
  width: 10px;
  height: 10px;
  margin-top: 3px;
  border: 1px solid #94a3b8;
  border-radius: 999px;
  background: #fff;
}

.analysis-model-row.is-selected .analysis-model-radio {
  border-color: #2563eb;
  box-shadow: inset 0 0 0 3px #fff;
  background: #2563eb;
}

.analysis-dashboard-head {
  flex: 0 0 auto;
  border-bottom: 1px solid var(--nf-border-soft);
  padding: 18px 20px 16px;
}

.analysis-dashboard-head h3 {
  overflow: hidden;
  margin: 3px 0 0;
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-dashboard-head span {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 6px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #475569;
  font-size: 12px;
  line-height: 1.55;
}

.analysis-vm-status {
  flex: 0 0 auto;
  min-width: 96px;
  border: 1px solid var(--nf-border);
  border-radius: 8px;
  background: #f8fafc;
  padding: 8px 10px;
  text-align: right;
}

.analysis-vm-status strong,
.analysis-vm-status span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-vm-status strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 850;
}

.analysis-vm-status span {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.analysis-vm-status.is-ok {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.analysis-vm-status.is-watch {
  border-color: #fde68a;
  background: #fffbeb;
}

.analysis-vm-status.is-hot {
  border-color: #fecdd3;
  background: #fff1f2;
}

.analysis-vm-status.is-ok strong {
  color: #166534;
}

.analysis-vm-status.is-watch strong {
  color: #92400e;
}

.analysis-vm-status.is-hot strong {
  color: #be123c;
}

.analysis-vm-conclusion {
  flex: 0 0 auto;
  border-bottom: 1px solid var(--nf-border-soft);
  background: #f8fbff;
  padding: 14px 20px;
}

.analysis-vm-conclusion span,
.analysis-vm-conclusion strong,
.analysis-vm-conclusion small {
  display: block;
}

.analysis-vm-conclusion span {
  color: #2563eb;
  font-size: 12px;
  font-weight: 850;
}

.analysis-vm-conclusion strong {
  margin-top: 4px;
  color: #0f172a;
  font-size: 14px;
  font-weight: 850;
  line-height: 1.55;
}

.analysis-vm-conclusion small {
  margin-top: 5px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-kpi-hero {
  display: grid;
  grid-template-columns: minmax(230px, 0.9fr) minmax(0, 1.4fr);
  gap: 0;
  border-bottom: 1px solid var(--nf-border-soft);
}

.analysis-kpi-primary {
  min-width: 0;
  border-right: 1px solid var(--nf-border-soft);
  padding: 22px 20px;
}

.analysis-kpi-primary span,
.analysis-kpi-grid span {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.analysis-kpi-primary strong {
  display: block;
  overflow-wrap: anywhere;
  margin-top: 8px;
  color: #0f172a;
  font-size: 42px;
  font-weight: 850;
  line-height: 1;
}

.analysis-kpi-primary small,
.analysis-kpi-grid small {
  display: block;
  overflow: hidden;
  margin-top: 7px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-kpi-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.analysis-kpi-grid div {
  min-width: 0;
  border-left: 1px solid var(--nf-border-soft);
  border-top: 1px solid var(--nf-border-soft);
  padding: 18px 16px;
}

.analysis-kpi-grid div:nth-child(1),
.analysis-kpi-grid div:nth-child(2) {
  border-top: 0;
}

.analysis-kpi-grid div:nth-child(odd) {
  border-left: 0;
}

.analysis-kpi-grid strong {
  display: block;
  overflow: hidden;
  margin-top: 5px;
  color: #0f172a;
  font-size: 24px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-dashboard-chart {
  flex: 0 0 auto;
  border-bottom: 1px solid var(--nf-border-soft);
  padding: 18px 20px 16px;
}

.analysis-dashboard-chart--empty {
  display: flex;
  min-height: 150px;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-dashboard-chart__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-dashboard-chart__meta strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
}

.analysis-dashboard-chart__plot {
  display: grid;
  height: 160px;
  grid-template-columns: repeat(auto-fit, minmax(48px, 1fr));
  align-items: end;
  gap: 10px;
  margin-top: 14px;
  border-bottom: 1px solid #cbd5e1;
  padding: 0 4px 20px;
}

.analysis-dashboard-chart__bar {
  display: flex;
  min-width: 0;
  height: 100%;
  align-items: end;
  justify-content: center;
  position: relative;
}

.analysis-dashboard-chart__bar span {
  width: 100%;
  min-height: 18%;
  border-radius: 5px 5px 0 0;
  background: #0ea5e9;
}

.analysis-dashboard-chart__bar small {
  position: absolute;
  right: 0;
  bottom: -18px;
  left: 0;
  overflow: hidden;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-dashboard-selection {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid var(--nf-border-soft);
}

.analysis-dashboard-selection div {
  min-width: 0;
  border-left: 1px solid var(--nf-border-soft);
  padding: 14px 16px;
}

.analysis-dashboard-selection div:first-child {
  border-left: 0;
}

.analysis-dashboard-selection span,
.analysis-dashboard-selection strong,
.analysis-dashboard-selection small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-dashboard-selection span {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.analysis-dashboard-selection strong {
  margin-top: 4px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 850;
}

.analysis-dashboard-selection small {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-detail-grid {
  display: grid;
  min-height: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  flex: 1 1 auto;
}

.analysis-detail-panel {
  min-width: 0;
  border-left: 1px solid var(--nf-border-soft);
  padding: 14px;
}

.analysis-detail-panel:first-child {
  border-left: 0;
}

.analysis-detail-panel.is-focused {
  background: #f8fbff;
}

.analysis-detail-panel__head {
  align-items: center;
  margin-bottom: 12px;
}

.analysis-record-compact > strong {
  display: block;
  overflow: hidden;
  color: #0f172a;
  font-size: 15px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-record-compact > span {
  display: block;
  overflow: hidden;
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-record-choice-list {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}

.analysis-record-choice {
  display: grid;
  width: 100%;
  min-width: 0;
  cursor: pointer;
  gap: 3px;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  padding: 8px 9px;
  text-align: left;
  transition: border-color 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;
}

.analysis-record-choice:hover,
.analysis-record-choice.is-selected {
  border-color: #93c5fd;
  background: #f8fbff;
}

.analysis-record-choice.is-selected {
  box-shadow: inset 3px 0 0 #2563eb;
}

.analysis-record-choice strong,
.analysis-record-choice span,
.analysis-record-choice small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-record-choice strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 850;
}

.analysis-record-choice span {
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.analysis-record-choice small {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-record-compact--selected {
  margin-top: 12px;
  border-top: 1px solid var(--nf-border-soft);
  padding-top: 12px;
}

.analysis-rca-context,
.analysis-evidence-link,
.analysis-answer-row {
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #f8fafc;
}

.analysis-rca-context {
  margin-bottom: 10px;
  padding: 9px 10px;
}

.analysis-rca-context span,
.analysis-rca-context strong,
.analysis-rca-context small,
.analysis-answer-row span,
.analysis-answer-row strong,
.analysis-answer-row small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-rca-context span,
.analysis-answer-row span {
  color: #64748b;
  font-size: 12px;
  font-weight: 850;
}

.analysis-rca-context strong,
.analysis-answer-row strong {
  margin-top: 3px;
  color: #0f172a;
  font-size: 12px;
  font-weight: 850;
}

.analysis-rca-context small,
.analysis-answer-row small {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-evidence-link {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding: 9px 10px;
}

.analysis-evidence-link div {
  min-width: 0;
}

.analysis-evidence-link span,
.analysis-evidence-link strong,
.analysis-evidence-link small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-evidence-link span {
  color: #64748b;
  font-size: 12px;
  font-weight: 850;
}

.analysis-evidence-link strong {
  margin-top: 3px;
  color: #0f172a;
  font-size: 12px;
  font-weight: 850;
}

.analysis-evidence-link small {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-evidence-link i {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #eaf2ff;
  color: #2563eb;
  font-size: 12px;
}

.analysis-answer-summary {
  display: grid;
  gap: 8px;
}

.analysis-answer-draft {
  max-height: 220px;
  margin: 10px 0 0;
  overflow: auto;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  background: #eff6ff;
  padding: 10px;
  color: #1e3a5f;
  font-family: inherit;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.65;
  white-space: pre-wrap;
}

.analysis-answer-limitations {
  display: grid;
  gap: 4px;
  margin-top: 8px;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  background: #fff7ed;
  padding: 9px 10px;
  color: #9a3412;
  font-size: 12px;
  line-height: 1.5;
}

.analysis-answer-limitations strong,
.analysis-answer-limitations span {
  font-size: 12px;
}

.analysis-answer-row {
  padding: 8px 9px;
}

.analysis-answer-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 12px;
}

.analysis-answer-actions button {
  height: 36px;
  border: 1px solid var(--nf-border);
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 850;
}

.analysis-answer-actions button:last-child {
  border-color: #0f172a;
  background: #0f172a;
  color: #fff;
}

.analysis-answer-actions button:disabled {
  cursor: default;
  opacity: 0.45;
}

.analysis-control-panel {
  padding: 0;
  overflow: auto;
}

.analysis-control-panel label {
  display: grid;
  gap: 6px;
  padding: 12px 14px 0;
}

.analysis-control-panel label span {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.analysis-control-panel textarea,
.analysis-control-panel select,
.analysis-control-panel input {
  width: 100%;
  min-width: 0;
  border: 1px solid var(--nf-border);
  border-radius: 8px;
  background: #fff;
  padding: 9px 10px;
  color: #0f172a;
  font-size: 12px;
  outline: none;
}

.analysis-control-panel textarea:focus,
.analysis-control-panel select:focus,
.analysis-control-panel input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
}

.analysis-control-panel textarea {
  resize: none;
  line-height: 1.45;
}

.analysis-control-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding-inline: 0;
}

.analysis-control-grid label {
  padding-top: 12px;
}

.analysis-control-latency {
  border-radius: 999px;
  background: #f1f5f9;
  padding: 5px 8px;
  color: #475569 !important;
  font-size: 12px !important;
}

.analysis-condition-summary {
  display: grid;
  gap: 8px;
  margin: 12px 14px 0;
  border-top: 1px solid var(--nf-border-soft);
  padding-top: 12px;
}

.analysis-condition-summary div {
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #f8fafc;
  padding: 8px 9px;
}

.analysis-condition-summary span,
.analysis-condition-summary strong,
.analysis-condition-summary small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.analysis-condition-summary span {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.analysis-condition-summary strong {
  margin-top: 3px;
  color: #0f172a;
  font-size: 12px;
  font-weight: 850;
}

.analysis-condition-summary small {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.analysis-control-run {
  height: 40px;
  margin: 14px;
  border: 0;
  border-radius: 8px;
  background: #0f172a;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
}

.analysis-control-run:disabled {
  opacity: 0.55;
}

.data-explorer-shell {
  --data-viz-blue: #3b82f6;
  --data-viz-blue-soft: #eaf3ff;
  --data-viz-green: #20c997;
  --data-viz-green-soft: #e9fbf4;
  --data-viz-amber: #f4b740;
  --data-viz-amber-soft: #fff4d7;
  --data-viz-rose: #f05d75;
  --data-viz-rose-soft: #fff0f3;
  --data-viz-graphite: #475569;
  --data-viz-graphite-soft: #eef2f6;
  overflow: hidden;
  border: 0 !important;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 22px 54px rgba(19, 34, 56, 0.12);
}

.data-explorer-filters {
  border-bottom: 0;
  background: linear-gradient(180deg, #f7faff 0%, #f2f6fb 100%);
  padding: 16px;
}

.data-explorer-interpretation {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid #dbe7f3;
  background: #f7faff;
  padding: 11px 16px 13px;
  color: #475569;
  font-size: 12px;
}

.data-explorer-interpretation.is-operational {
  border-top-color: #a7f3d0;
  background: #ecfdf5;
}

.data-explorer-interpretation.is-operational > div strong {
  color: #047857;
}

.data-explorer-interpretation.is-sample {
  border-top-color: #fde68a;
  background: #fffbeb;
}

.data-explorer-interpretation > div {
  display: grid;
  flex: 0 0 auto;
  gap: 2px;
}

.data-explorer-interpretation > div strong {
  color: #0f172a;
  font-size: 13px;
}

.data-explorer-interpretation ul {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.data-explorer-interpretation li {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  padding: 5px 9px;
  color: #1d4ed8;
}

.data-explorer-interpretation li small {
  border-left: 1px solid #bfdbfe;
  margin-left: 2px;
  padding-left: 7px;
  color: #64748b;
}

.data-record-table tbody tr[role=button]:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: -2px;
}

.data-explorer-query {
  min-width: 0;
}

.data-explorer-tabbar {
  display: flex;
  flex-wrap: nowrap;
  min-height: 56px;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  overflow-x: auto;
  border-bottom: 0;
  background: #fff;
  padding: 0 20px;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06);
}

.data-explorer-tab {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  min-width: 0;
  height: 56px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  border-radius: 0 !important;
  background: transparent;
  color: #64748b;
  font-size: 15px;
  font-weight: 750;
  line-height: 1;
  text-shadow: none;
  box-shadow: none;
  transition: color 0.14s ease;
}

.data-explorer-tab:hover {
  background: transparent;
  color: #17324d;
  filter: none;
}

.data-explorer-tab.is-active {
  border-left-color: transparent;
  background: transparent;
  color: #17324d;
  text-shadow: none;
  filter: none;
  box-shadow: none;
}

.data-explorer-tab.is-active::before {
  content: "";
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #2e6fae;
}

.data-explorer-tab.is-active::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  border-radius: 999px 999px 0 0;
  background: #2e6fae;
}

.data-explorer-tab span {
  border-radius: 999px;
  background: #eef4fb;
  padding: 2px 7px;
  font-size: 12px;
  font-weight: 700;
  opacity: 1;
}

.data-explorer-tab.is-active span {
  color: #5f6f84;
  opacity: 0.76;
}

.data-explorer-body {
  padding: 16px;
}

.data-summary-panel {
  display: grid;
  grid-template-columns: minmax(0, 0.94fr) minmax(360px, 1.06fr);
  gap: 16px;
}

.data-summary-panel > .data-hub-overview {
  display: contents;
}

.data-hub-intro,
.data-hub-catalog,
.data-tab-explain,
.trace-timeline-viz {
  min-width: 0;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(19, 34, 56, 0.08);
}

.data-hub-intro {
  background: linear-gradient(135deg, #ffffff 0%, #f5f9ff 58%, #eef7f4 100%);
  padding: 18px 20px;
}

.data-summary-panel > .data-hub-overview > .data-hub-intro {
  grid-column: 1/-1;
}

.data-hub-label {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: var(--data-viz-blue-soft);
  padding: 4px 9px;
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
}

.data-hub-intro h3 {
  max-width: 860px;
  margin: 9px 0 0;
  color: #0f172a;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.28;
}

.data-hub-intro > p {
  max-width: 980px;
  margin: 5px 0 0;
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
}

.data-hub-action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.data-hub-action {
  display: inline-flex;
  min-width: 116px;
  height: 34px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.78);
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  transition: border-color 0.14s ease, background 0.14s ease, color 0.14s ease;
}

.data-hub-action i {
  color: var(--data-viz-blue);
  font-size: 12px;
}

.data-hub-action:hover {
  border-color: rgba(59, 130, 246, 0.38);
  background: #fff;
  color: #17324d;
}

.data-hub-action:disabled {
  cursor: not-allowed;
  opacity: 0.52;
}

.data-hub-action:disabled:hover {
  border-color: rgba(59, 130, 246, 0.2);
  background: rgba(255, 255, 255, 0.78);
  color: #334155;
}

.data-hub-action--primary {
  border-color: rgba(46, 111, 174, 0.32);
  background: #eef4fb;
  color: #17324d;
}

.data-hub-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.data-hub-kpi {
  position: relative;
  display: grid;
  min-height: 66px;
  min-width: 0;
  border: 0;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.88);
  padding: 8px 11px 9px;
  box-shadow: 0 12px 26px rgba(19, 34, 56, 0.1);
  gap: 4px;
}

.data-hub-kpi::before {
  content: "";
  position: absolute;
  inset: auto 11px 9px auto;
  width: 30px;
  height: 3px;
  border-radius: 999px;
  background: var(--data-viz-blue);
  opacity: 0.72;
}

.data-hub-kpi--emerald::before {
  background: var(--data-viz-green);
}

.data-hub-kpi--amber::before {
  background: var(--data-viz-amber);
}

.data-hub-kpi--rose::before {
  background: var(--data-viz-rose);
}

.data-hub-kpi__top,
.data-hub-kpi__value {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.data-hub-kpi__label,
.data-hub-kpi__state,
.data-hub-kpi__value small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-hub-kpi__label {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 5px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.data-hub-kpi__label i {
  color: var(--data-viz-blue);
  font-size: 12px;
}

.data-hub-kpi--emerald .data-hub-kpi__label i {
  color: var(--data-viz-green);
}

.data-hub-kpi--amber .data-hub-kpi__label i {
  color: var(--data-viz-amber);
}

.data-hub-kpi--rose .data-hub-kpi__label i {
  color: var(--data-viz-rose);
}

.data-hub-kpi__state {
  max-width: 50%;
  color: #738195;
  font-size: 12px;
  font-weight: 650;
}

.data-hub-kpi__state.is-muted {
  color: #98a4b3;
}

.data-hub-kpi__value strong {
  display: block;
  min-width: max-content;
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.05;
}

.data-hub-kpi__value small {
  max-width: 58%;
  padding-right: 36px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.data-hub-catalog {
  padding: 16px;
}

.data-hub-catalog .data-section-header p {
  font-weight: 600;
}

.data-hub-catalog .data-section-header span {
  font-weight: 500;
}

.data-summary-panel > .data-hub-overview > .data-hub-source-map {
  grid-column: 1;
  grid-row: 2/4;
  min-height: 242px;
}

.data-summary-panel > .data-search-summary-header {
  grid-column: 2;
  grid-row: 2;
  align-self: end;
}

.data-summary-panel > .data-search-summary-grid {
  grid-column: 2;
  grid-row: 3;
}

.data-summary-panel > .data-explorer-divider,
.data-summary-panel > .data-visual-grid,
.data-summary-panel > .data-chart-lab {
  grid-column: 1/-1;
}

.data-source-map-body {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: center;
  gap: 16px;
  margin-top: 14px;
}

.data-source-donut {
  display: flex;
  width: 150px;
  height: 150px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);
}

.data-source-donut-core {
  display: flex;
  width: 88px;
  height: 88px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 0 0 1px var(--nf-border-soft);
}

.data-source-donut-core strong {
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.data-source-donut-core span {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.data-source-legend {
  display: grid;
  min-width: 0;
  gap: 8px;
}

.data-source-legend-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 3px 10px;
  min-width: 0;
}

.data-source-legend-item span {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  overflow: hidden;
  color: #0f172a;
  font-size: 12px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-source-legend-item i {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: var(--data-viz-blue);
}

.data-source-legend-item strong {
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

.data-source-legend-item small {
  grid-column: 1/-1;
  overflow: hidden;
  color: #94a3b8;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-source-legend-item--emerald i {
  background: var(--data-viz-green);
}

.data-source-legend-item--amber i {
  background: var(--data-viz-amber);
}

.data-source-legend-item--rose i {
  background: var(--data-viz-rose);
}

.data-source-legend-item--graphite i {
  background: var(--data-viz-graphite);
}

.data-catalog-list {
  display: grid;
  gap: 9px;
  margin-top: 12px;
}

.data-catalog-item {
  min-width: 0;
}

.data-catalog-item__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.data-catalog-item__head p {
  overflow: hidden;
  margin: 0;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-catalog-item__head span {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.data-catalog-track,
.data-rank-row div,
.data-quality-row > div:nth-child(2),
.trace-contribution-row div,
.trace-status-strip div div {
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #eef3f8;
}

.data-catalog-track i,
.data-rank-row i,
.data-quality-row i,
.trace-contribution-row i,
.trace-status-strip div i {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: var(--data-viz-blue);
}

.data-catalog-item small {
  display: block;
  overflow: hidden;
  margin-top: 4px;
  color: #94a3b8;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-catalog-item--emerald i {
  background: var(--data-viz-green);
}

.data-catalog-item--amber i {
  background: var(--data-viz-amber);
}

.data-catalog-item--rose i {
  background: var(--data-viz-rose);
}

.data-catalog-item--graphite i {
  background: var(--data-viz-graphite);
}

.data-section-header {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px 14px;
}

.data-section-header > div {
  min-width: 0;
}

.data-section-header p {
  margin: 0;
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
}

.data-section-header small {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.data-section-header span {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: #f4f7fb;
  padding: 4px 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.data-section-header--compact {
  align-items: center;
}

.data-section-header--compact span {
  background: transparent;
  padding: 0;
  font-weight: 600;
}

.data-summary-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 16px;
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(19, 34, 56, 0.08);
}

.data-search-summary-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 0;
}

.data-summary-metric {
  min-width: 0;
  border-left: 1px solid rgba(226, 232, 240, 0.72);
  background: color-mix(in srgb, var(--nf-panel) 72%, #f8fafc);
  padding: 12px 14px;
}

.data-search-summary-grid .data-summary-metric {
  border-left: 1px solid rgba(226, 232, 240, 0.72);
  padding: 13px 14px;
}

.data-summary-metric:first-child {
  border-left: 0;
}

.data-search-summary-grid .data-summary-metric:nth-child(odd) {
  border-left: 0;
}

.data-search-summary-grid .data-summary-metric:nth-child(n+3) {
  border-top: 1px solid rgba(226, 232, 240, 0.72);
}

.data-summary-metric--graphite .data-summary-bar {
  background: var(--data-viz-graphite);
}

.data-summary-metric--oxide .data-summary-bar {
  background: var(--data-viz-blue);
}

.data-summary-metric--emerald .data-summary-bar {
  background: var(--data-viz-green);
}

.data-summary-metric--rose .data-summary-bar {
  background: var(--data-viz-rose);
}

.data-status-ok,
.data-process-bar,
.data-lot-dot {
  background: var(--data-viz-blue) !important;
}

.data-status-watch {
  background: var(--data-viz-amber) !important;
}

.data-status-hot {
  background: var(--data-viz-rose) !important;
}

.data-explorer-divider {
  height: 1px;
  margin: 16px 0;
  background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.24), transparent);
}

.data-insight-grid {
  display: grid;
  grid-template-columns: 0.95fr 1.05fr;
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(19, 34, 56, 0.08);
}

.data-visual-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.data-chart-lab {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.data-chart-card {
  min-width: 0;
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  background: #fff;
  padding: 16px;
  box-shadow: 0 14px 32px rgba(19, 34, 56, 0.08);
}

.data-donut-wrap {
  display: grid;
  grid-template-columns: 116px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  margin-top: 16px;
}

.data-donut {
  display: flex;
  width: 116px;
  height: 116px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
}

.data-donut > div {
  display: flex;
  width: 72px;
  height: 72px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 999px;
  background: #fff;
}

.data-donut strong {
  color: #0f172a;
  font-size: 17px;
  font-weight: 800;
}

.data-donut span {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 700;
}

.data-donut-legend {
  display: grid;
  gap: 7px;
}

.data-donut-legend span {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.data-donut-legend i {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 999px;
}

.data-scatter-plot {
  position: relative;
  height: 152px;
  margin-top: 16px;
  border-left: 1px solid #cbd5e1;
  border-bottom: 1px solid #cbd5e1;
  background: linear-gradient(#eef3f8 1px, transparent 1px), linear-gradient(90deg, #eef3f8 1px, transparent 1px);
  background-size: 25% 25%;
}

.data-scatter-dot {
  position: absolute;
  border: 2px solid #fff;
  border-radius: 999px;
  background: var(--data-viz-blue);
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.34);
}

.data-scatter-dot.is-watch {
  background: var(--data-viz-amber);
  box-shadow: 0 0 0 1px rgba(244, 183, 64, 0.38);
}

.data-scatter-dot.is-hot {
  background: var(--data-viz-rose);
  box-shadow: 0 0 0 1px rgba(240, 93, 117, 0.4);
}

.data-scatter-axis {
  position: absolute;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 800;
}

.data-scatter-axis--x {
  right: 0;
  bottom: -17px;
}

.data-scatter-axis--y {
  top: -15px;
  left: 0;
}

.data-heatmap {
  display: grid;
  gap: 7px;
  margin-top: 16px;
}

.data-heatmap-row {
  display: grid;
  grid-template-columns: minmax(76px, 0.8fr) minmax(0, 1fr);
  align-items: center;
  gap: 9px;
}

.data-heatmap-row span {
  overflow: hidden;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-heatmap-row div {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 5px;
}

.data-heatmap-row i {
  height: 18px;
  border-radius: 4px;
  background: var(--data-viz-blue);
}

.data-heatmap-row i.is-watch {
  background: var(--data-viz-amber);
}

.data-heatmap-row i.is-hot {
  background: var(--data-viz-rose);
}

.data-sparkline {
  width: 100%;
  height: 106px;
  margin-top: 15px;
  overflow: visible;
  border-bottom: 1px solid #cbd5e1;
  border-left: 1px solid #cbd5e1;
  background: linear-gradient(#eef3f8 1px, transparent 1px), linear-gradient(90deg, #eef3f8 1px, transparent 1px);
  background-size: 25% 25%;
}

.data-sparkline polyline {
  fill: none;
  stroke: var(--data-viz-green);
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 3;
}

.data-histogram {
  display: grid;
  height: 54px;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  align-items: end;
  gap: 5px;
  margin-top: 12px;
}

.data-histogram div {
  display: flex;
  min-width: 0;
  height: 100%;
  align-items: end;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
}

.data-histogram i {
  display: block;
  width: 100%;
  min-height: 5px;
  border-radius: 5px 5px 1px 1px;
  background: var(--data-viz-rose);
}

.data-histogram span {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 700;
}

.data-insight-block {
  min-width: 0;
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  background: #fff;
  padding: 16px;
  box-shadow: 0 14px 32px rgba(19, 34, 56, 0.08);
}

.data-insight-block + .data-insight-block {
  border-left: 0;
}

.data-visual-grid .data-insight-block + .data-insight-block {
  border-left: 0;
}

.data-rank-row,
.data-quality-row,
.trace-contribution-row,
.trace-status-strip div {
  display: grid;
  grid-template-columns: minmax(72px, 1fr) minmax(96px, 1.4fr) 34px;
  align-items: center;
  gap: 9px;
}

.data-rank-row span,
.trace-contribution-row span,
.trace-status-strip div span {
  overflow: hidden;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-rank-row strong,
.data-quality-row strong,
.trace-contribution-row strong,
.trace-status-strip div strong {
  color: #64748b;
  font-size: 12px;
  text-align: right;
}

.data-coverage-cloud {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
}

.data-coverage-chip {
  min-width: 0;
}

.data-coverage-chip span {
  display: block;
  overflow: hidden;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-coverage-chip i {
  display: block;
  height: 5px;
  margin-top: 5px;
  border-radius: 999px;
  background: var(--data-viz-blue);
}

.data-quality-row {
  grid-template-columns: minmax(68px, 0.9fr) minmax(82px, 1fr) 40px;
  border: 0;
  border-radius: 9px;
  background: #fff;
  padding: 9px;
  box-shadow: 0 10px 22px rgba(19, 34, 56, 0.07);
}

.data-quality-row p,
.data-quality-row small {
  display: block;
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-quality-row p {
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
}

.data-quality-row small {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 12px;
}

.data-record-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(320px, 0.75fr);
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(19, 34, 56, 0.08);
}

.data-section-block,
.data-record-table {
  min-width: 0;
  overflow: hidden;
}

.data-record-table .data-section-header {
  border-bottom: 1px solid rgba(226, 232, 240, 0.72);
  padding: 14px 16px;
}

.data-table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid rgba(226, 232, 240, 0.72);
  padding: 12px 16px;
  color: #64748b;
  font-size: 12px;
}

.data-tab-explain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  padding: 14px 16px;
}

.data-tab-explain p {
  margin: 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
}

.data-tab-explain small {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.data-tab-explain__stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.data-tab-explain__stats span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  border-radius: 999px;
  background: #eef4fb;
  padding: 5px 9px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.data-tab-explain__stats i {
  width: 7px;
  height: 7px;
  border-radius: 999px;
}

.data-record-side {
  min-width: 0;
  border-left: 0;
  background: #f7faff;
}

.data-side-section {
  min-width: 0;
  border-top: 1px solid rgba(226, 232, 240, 0.72);
  padding: 16px;
}

.data-side-section:first-child {
  border-top: 0;
}

.data-trace-layout {
  display: grid;
  gap: 16px;
}

.data-trace-layout > .data-section-block,
.data-trace-split {
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(19, 34, 56, 0.08);
}

.data-trace-split {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.data-trace-split > .data-side-section {
  border-top: 0;
}

.data-trace-split > .data-side-section + .data-side-section {
  border-left: 1px solid rgba(226, 232, 240, 0.72);
}

.trace-timeline-viz {
  padding: 16px;
}

.trace-timeline-viz__rail {
  display: grid;
  position: relative;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  min-height: 118px;
  margin-top: 18px;
  border-radius: 8px;
  background: #f8fafc;
  padding: 14px;
  overflow: hidden;
}

.trace-timeline-node {
  display: grid;
  position: relative;
  min-width: 0;
  grid-template-columns: 32px minmax(0, 1fr);
  gap: 9px;
  border: 1px solid #dbe7f3;
  border-radius: 8px !important;
  background: #fff;
  padding: 10px;
  text-align: left;
}

.trace-timeline-node:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 25px;
  right: -11px;
  z-index: 1;
  width: 11px;
  height: 2px;
  background: #cbd5e1;
}

.trace-timeline-node__marker {
  display: flex;
  justify-content: center;
}

.trace-timeline-node i {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border: 3px solid #fff;
  border-radius: 999px;
  background: var(--data-viz-blue);
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.32);
}

.trace-timeline-node__body {
  min-width: 0;
}

.trace-timeline-node__topline {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.trace-timeline-node strong,
.trace-timeline-node small,
.trace-timeline-node span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trace-timeline-node strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
}

.trace-timeline-node em {
  flex: 0 0 auto;
  border-radius: 999px;
  background: var(--data-viz-blue-soft);
  padding: 2px 7px;
  color: #2563eb;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.25;
}

.trace-timeline-node small {
  margin-top: 5px;
  color: #64748b;
  font-size: 12px;
}

.trace-timeline-node span {
  margin-top: 4px;
  color: #94a3b8;
  font-size: 12px;
}

.trace-timeline-node.is-watch {
  border-color: rgba(244, 183, 64, 0.34);
  background: var(--data-viz-amber-soft);
}

.trace-timeline-node.is-watch i {
  background: var(--data-viz-amber);
  box-shadow: 0 0 0 1px rgba(244, 183, 64, 0.4);
}

.trace-timeline-node.is-watch em {
  background: #fff8ec;
  color: #b7791f;
}

.trace-timeline-node.is-hot {
  border-color: rgba(240, 93, 117, 0.36);
  background: var(--data-viz-rose-soft);
}

.trace-timeline-node.is-hot i {
  background: var(--data-viz-rose);
  box-shadow: 0 0 0 1px rgba(240, 93, 117, 0.42);
}

.trace-timeline-node.is-hot em {
  background: #fff3f5;
  color: #c93452;
}

.trace-status-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.trace-metrology-panel {
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  background: #fff;
  padding: 16px;
  box-shadow: 0 14px 32px rgba(19, 34, 56, 0.08);
}

.trace-metrology-ladder {
  display: grid;
  gap: 9px;
  margin-top: 14px;
}

.trace-metrology-ladder__row {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(140px, 2fr) 64px;
  align-items: center;
  gap: 10px;
}

.trace-metrology-ladder__row span {
  overflow: hidden;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trace-metrology-ladder__row div {
  height: 9px;
  overflow: hidden;
  border-radius: 999px;
  background: #eef3f8;
}

.trace-metrology-ladder__row i {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: var(--data-viz-blue);
}

.trace-metrology-ladder__row.is-watch i {
  background: var(--data-viz-amber);
}

.trace-metrology-ladder__row.is-hot i {
  background: var(--data-viz-rose);
}

.trace-metrology-ladder__row strong {
  color: #64748b;
  font-size: 12px;
  text-align: right;
}

.trace-contribution-list {
  display: grid;
  gap: 8px;
  margin-top: 14px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--nf-border-soft);
  padding-bottom: 14px;
}

.data-empty-state {
  border: 1px dashed var(--nf-border);
  border-radius: 8px;
  background: #fbfdff;
  padding: 54px 16px;
  color: #64748b;
  font-size: 14px;
  text-align: center;
}

.sensor-mini-bars {
  display: flex;
  width: 76px;
  height: 30px;
  align-items: flex-end;
  gap: 3px;
}

.sensor-mini-bars span {
  width: 8px;
  min-height: 6px;
  border-radius: 4px 4px 1px 1px;
  background: linear-gradient(180deg, #7dd3fc, var(--data-viz-blue));
}

.metrology-delta__track {
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #eef3f8;
}

.metrology-delta__track span {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: var(--data-viz-amber);
}

.insight-workspace {
  display: grid;
  gap: 14px;
  align-content: start;
  color: #0f172a;
}

.insight-kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--nf-border);
  border-radius: 8px;
  background: #fff;
}

.insight-kpi {
  min-width: 0;
  padding: 13px 16px;
  border-left: 1px solid var(--nf-border-soft);
}

.insight-kpi:first-child {
  border-left: 0;
}

.insight-kpi span,
.insight-selection span,
.insight-eyebrow {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.insight-kpi strong {
  display: block;
  overflow: hidden;
  margin-top: 4px;
  color: #0f172a;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.05;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.insight-main-grid,
.insight-bottom-grid {
  display: grid;
  gap: 14px;
}

.insight-main-grid {
  grid-template-columns: minmax(0, 1.05fr) minmax(360px, 0.95fr);
}

.insight-bottom-grid {
  grid-template-columns: minmax(0, 0.95fr) minmax(360px, 1.05fr);
}

.insight-side-stack {
  display: grid;
  gap: 14px;
  align-content: start;
}

.insight-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--nf-border);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}

.insight-card--visual {
  display: flex;
  min-height: 510px;
  flex-direction: column;
}

.insight-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--nf-border-soft);
}

.insight-card__head h3 {
  margin: 2px 0 0;
  font-size: 14px;
  font-weight: 800;
}

.insight-head-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
}

.insight-head-actions button,
.insight-rec-card button,
.insight-report-toolbar button,
.insight-answer-bar button {
  min-width: 0;
  border: 1px solid var(--nf-border);
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.insight-head-actions button {
  height: 30px;
  border-radius: 999px;
  padding: 0 10px;
}

.insight-head-actions button:hover,
.insight-rec-card button:hover,
.insight-report-toolbar button:hover {
  border-color: #93c5fd;
  background: #f8fbff;
}

.insight-head-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.insight-pill {
  display: inline-flex;
  max-width: 170px;
  align-items: center;
  border-radius: 999px;
  background: #eaf2ff;
  padding: 4px 9px;
  color: #2563eb;
  font-size: 12px;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.insight-chart-shell {
  display: flex;
  flex: 1 1 auto;
  min-height: 320px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 18px;
  background: linear-gradient(#edf2f7 1px, transparent 1px), linear-gradient(90deg, #edf2f7 1px, transparent 1px), radial-gradient(circle at 20% 20%, rgba(37, 99, 235, 0.08), transparent 32%), #f8fafc;
  background-size: 28px 28px, 28px 28px, 100% 100%, 100% 100%;
}

.insight-chart-stage {
  position: relative;
  width: min(100%, 520px);
  height: 300px;
  transform-origin: center;
  transition: transform 0.18s ease;
}

.insight-wafer {
  position: relative;
  width: min(300px, 82vw);
  height: min(300px, 82vw);
  margin: 0 auto;
  border: 2px solid #cbd5e1;
  border-radius: 999px;
  background: radial-gradient(circle at 50% 48%, rgba(255, 255, 255, 0.95) 0 58%, rgba(226, 232, 240, 0.9) 59% 61%, transparent 62%), conic-gradient(from 210deg, rgba(37, 99, 235, 0.14), rgba(5, 150, 105, 0.12), rgba(217, 119, 6, 0.16), rgba(190, 18, 60, 0.12), rgba(37, 99, 235, 0.14));
  box-shadow: inset 0 0 0 18px rgba(255, 255, 255, 0.65), inset 0 0 34px rgba(15, 23, 42, 0.08);
}

.insight-wafer::before,
.insight-wafer::after {
  content: "";
  position: absolute;
  background: rgba(148, 163, 184, 0.24);
}

.insight-wafer::before {
  top: 50%;
  left: 14%;
  right: 14%;
  height: 1px;
}

.insight-wafer::after {
  top: 14%;
  bottom: 14%;
  left: 50%;
  width: 1px;
}

.insight-wafer-die {
  position: absolute;
  z-index: 1;
  display: flex;
  width: 38px;
  height: 28px;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 12px;
  font-weight: 800;
  box-shadow: 0 5px 12px rgba(15, 23, 42, 0.12);
}

.insight-bar-chart,
.insight-trend-chart {
  display: flex;
  height: 100%;
  align-items: flex-end;
  gap: 9px;
  padding: 34px 20px 30px;
}

.insight-bar,
.insight-trend-point {
  position: relative;
  flex: 1 1 0;
  min-width: 24px;
  min-height: 16px;
  border: 0;
  border-radius: 7px 7px 2px 2px;
  color: transparent;
  box-shadow: inset 0 -10px 18px rgba(255, 255, 255, 0.18);
}

.insight-bar span,
.insight-trend-point span {
  position: absolute;
  left: 50%;
  bottom: -22px;
  max-width: 56px;
  transform: translateX(-50%);
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.insight-scatter-chart {
  position: relative;
  height: 100%;
  border-left: 1px solid #cbd5e1;
  border-bottom: 1px solid #cbd5e1;
  background: linear-gradient(#e2e8f0 1px, transparent 1px), linear-gradient(90deg, #e2e8f0 1px, transparent 1px);
  background-size: 52px 52px;
}

.insight-scatter-point {
  position: absolute;
  width: 22px;
  height: 22px;
  transform: translate(-50%, -50%);
  border: 2px solid #fff;
  border-radius: 999px;
  color: transparent;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.16);
}

.insight-wafer-die,
.insight-bar,
.insight-trend-point,
.insight-scatter-point {
  cursor: pointer;
  transition: opacity 0.14s ease, outline-color 0.14s ease, transform 0.14s ease;
}

.insight-wafer-die.is-ok,
.insight-bar.is-ok,
.insight-trend-point.is-ok,
.insight-scatter-point.is-ok {
  background: #2563eb;
}

.insight-wafer-die.is-watch,
.insight-bar.is-watch,
.insight-trend-point.is-watch,
.insight-scatter-point.is-watch {
  background: #d97706;
}

.insight-wafer-die.is-hot,
.insight-bar.is-hot,
.insight-trend-point.is-hot,
.insight-scatter-point.is-hot {
  background: #be123c;
}

.insight-wafer-die.is-idle,
.insight-bar.is-idle,
.insight-trend-point.is-idle,
.insight-scatter-point.is-idle {
  background: #94a3b8;
}

.insight-wafer-die.is-selected,
.insight-bar.is-selected,
.insight-trend-point.is-selected,
.insight-scatter-point.is-selected {
  outline: 3px solid rgba(15, 23, 42, 0.22);
  outline-offset: 2px;
}

.insight-wafer-die.is-muted,
.insight-bar.is-muted,
.insight-trend-point.is-muted,
.insight-scatter-point.is-muted {
  opacity: 0.3;
}

.insight-caption {
  padding: 13px 16px 0;
}

.insight-caption p {
  color: #475569;
  font-size: 12px;
  line-height: 1.55;
}

.insight-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.insight-chip-row span {
  border-radius: 999px;
  background: #f1f5f9;
  padding: 4px 8px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.insight-selection {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
  margin: 14px 16px 16px;
  overflow: hidden;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
}

.insight-selection div {
  min-width: 0;
  padding: 10px;
  border-left: 1px solid var(--nf-border-soft);
  background: #fbfdff;
}

.insight-selection div:first-child {
  border-left: 0;
}

.insight-selection strong {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.insight-recommend-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 14px;
}

.insight-rec-card {
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  padding: 10px;
  background: #fbfdff;
}

.insight-rec-card.is-selected {
  border-color: #93c5fd;
  background: #f0f7ff;
  box-shadow: inset 3px 0 0 #2563eb;
}

.insight-rec-card p {
  overflow: hidden;
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.insight-rec-card div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.insight-rec-card button,
.insight-report-toolbar button {
  min-height: 28px;
  border-radius: 999px;
  padding: 0 9px;
}

.insight-rec-card button.is-active,
.insight-report-toolbar button.is-active {
  border-color: #2563eb;
  background: #eaf2ff;
  color: #2563eb;
}

.insight-action-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 14px;
}

.insight-action-button {
  display: flex;
  min-height: 44px;
  min-width: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.insight-action-button:hover,
.insight-action-button.is-active {
  border-color: #93c5fd;
  background: #f0f7ff;
  color: #2563eb;
}

.insight-trace-bars {
  display: flex;
  height: 140px;
  align-items: flex-end;
  gap: 7px;
  padding: 18px 16px 6px;
}

.insight-trace-bars div {
  display: flex;
  flex: 1 1 0;
  min-width: 8px;
  align-items: flex-end;
  gap: 2px;
}

.insight-trace-bars span {
  display: block;
  flex: 1 1 0;
  min-height: 8px;
  border-radius: 4px 4px 1px 1px;
}

.insight-trace-bars .is-base {
  background: #94a3b8;
}

.insight-trace-bars .is-target {
  background: #2563eb;
}

.insight-record-list {
  display: grid;
  gap: 8px;
  padding: 14px 16px 16px;
}

.insight-record-list button {
  display: grid;
  grid-template-columns: minmax(92px, 0.8fr) minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fbfdff;
  padding: 9px 10px;
  text-align: left;
}

.insight-record-list span,
.insight-record-list strong,
.insight-record-list em {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.insight-record-list span {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.insight-record-list strong {
  color: #0f172a;
  font-size: 12px;
}

.insight-record-list em {
  color: #2563eb;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
}

.insight-report-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  padding: 14px 16px 0;
}

.insight-report-preview {
  margin: 14px 16px 16px;
  overflow: hidden;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fbfdff;
}

.insight-report-preview pre {
  max-height: 250px;
  margin: 0;
  overflow: auto;
  padding: 14px;
  color: #334155;
  font-family: inherit;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-wrap;
}

.insight-answer-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border: 1px solid var(--nf-border);
  border-radius: 8px;
  background: #0f172a;
  padding: 14px 16px;
  color: #fff;
}

.insight-answer-bar p {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
}

.insight-answer-bar span {
  display: block;
  margin-top: 3px;
  color: #cbd5e1;
  font-size: 12px;
}

.insight-answer-bar button {
  height: 34px;
  border-color: rgba(255, 255, 255, 0.28);
  background: #fff;
  color: #0f172a;
  border-radius: 999px;
  padding: 0 14px;
}

.trace-tabs {
  display: flex;
  flex-wrap: nowrap;
  min-height: 56px;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  overflow-x: auto;
  border-radius: 0 !important;
  background: #fff;
  padding: 0 20px;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06);
}

.trace-compare-shell {
  overflow: hidden;
  border-radius: 8px;
}

.trace-compare-filters {
  display: grid;
  grid-template-columns: minmax(180px, 1.2fr) repeat(4, minmax(112px, 0.8fr)) minmax(120px, 0.7fr) auto;
  align-items: end;
  gap: 10px;
  border-bottom: 1px solid var(--nf-border-soft);
  background: #fbfdff;
  padding: 12px 16px 10px;
}

.trace-compare-filters button {
  min-width: 86px;
}

.trace-filter-field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
}

.trace-filter-field span {
  overflow: hidden;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trace-filter-field select,
.trace-filter-field input {
  width: 100%;
}

.trace-filter-summary {
  display: flex;
  min-height: 38px;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid var(--nf-border-soft);
  background: #fff;
  padding: 0 16px;
  color: #64748b;
  font-size: 12px;
}

.trace-filter-summary span,
.trace-filter-summary em {
  flex: 0 0 auto;
}

.trace-filter-summary strong {
  min-width: 0;
  overflow: hidden;
  color: #0f172a;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trace-filter-summary em {
  margin-left: auto;
  font-style: normal;
}

.trace-tab-button {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  height: 56px;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  border-radius: 0 !important;
  background: transparent;
  color: #64748b;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  text-shadow: none;
  box-shadow: none;
  transition: color 0.14s ease;
}

.trace-tab-button:hover {
  background: transparent;
  color: #17324d;
  filter: none;
}

.trace-tab-button.is-active {
  background: transparent;
  color: #17324d;
  text-shadow: none;
  filter: none;
  box-shadow: none;
}

.trace-tab-button.is-active::before {
  content: "";
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #2e6fae;
}

.trace-tab-button.is-active::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  border-radius: 999px 999px 0 0;
  background: #2e6fae;
}

.trace-tab-button span {
  border-radius: 999px;
  background: #eef4fb;
  padding: 2px 7px;
  color: #5f6f84;
  font-size: 12px;
  font-weight: 500;
  opacity: 1;
}

.trace-visual-card {
  overflow: hidden;
}

.trace-risk-pill {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border-radius: 999px !important;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.trace-risk-ok {
  background: #ecfdf5;
  color: #047857;
}

.trace-risk-watch {
  background: #fff7ed;
  color: #b45309;
}

.trace-risk-hot {
  background: #fff1f2;
  color: #be123c;
}

.trace-wave-stage {
  border: 1px solid var(--nf-border-soft);
  border-radius: 12px !important;
  background: linear-gradient(180deg, #fbfdff 0%, #f8fafc 100%);
  padding: 10px 12px 12px;
}

.trace-focus-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;
}

.trace-focus-card {
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  padding: 10px 12px;
  box-shadow: inset 3px 0 0 #2563eb;
}

.trace-focus-card.is-watch {
  box-shadow: inset 3px 0 0 #f59e0b;
}

.trace-focus-card.is-hot,
.trace-focus-card.is-high,
.trace-focus-card.is-critical {
  box-shadow: inset 3px 0 0 #e11d48;
}

.trace-focus-card span,
.trace-focus-card strong,
.trace-focus-card p {
  display: block;
  min-width: 0;
}

.trace-focus-card span {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.trace-focus-card strong {
  overflow: hidden;
  margin-top: 3px;
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trace-focus-card p {
  display: -webkit-box;
  overflow: hidden;
  min-height: 31px;
  margin-top: 5px;
  color: #475569;
  font-size: 12px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.trace-wave-grid {
  display: grid;
  grid-template-columns: minmax(0, 900px) minmax(210px, 1fr);
  align-items: center;
  gap: 16px;
}

.trace-wave-chart {
  width: min(100%, 900px);
  aspect-ratio: 720/260;
  justify-self: center;
}

.trace-wave-svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.trace-wave-notes {
  display: grid;
  gap: 8px;
  min-width: 0;
  border-left: 1px solid var(--nf-border-soft);
  padding-left: 14px;
}

.trace-wave-note {
  min-width: 0;
  border-bottom: 1px solid var(--nf-border-soft);
  padding-bottom: 8px;
}

.trace-wave-note:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.trace-wave-note span,
.trace-wave-note strong,
.trace-wave-note p {
  display: block;
  min-width: 0;
}

.trace-wave-note span {
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.trace-wave-note strong {
  overflow: hidden;
  margin-top: 3px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trace-wave-note p {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.trace-grid line {
  stroke: #e2e8f0;
  stroke-width: 1;
}

.trace-grid text,
.trace-axis-label {
  fill: #94a3b8;
  font-size: 12px;
  font-weight: 400;
}

.trace-deviation-band {
  fill: #fb7185;
}

.trace-line {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 3.2;
}

.trace-line.is-baseline {
  stroke: #2563eb;
  stroke-width: 4.2;
}

.trace-line.is-target {
  stroke: #f97316;
  stroke-width: 3.4;
}

.trace-node.is-baseline circle {
  fill: #2563eb;
}

.trace-node.is-target circle {
  fill: #f97316;
}

.trace-node circle {
  stroke: #fff;
  stroke-width: 2;
}

.trace-series-label text {
  font-size: 12px;
  font-weight: 800;
  paint-order: stroke;
  stroke: #fff;
  stroke-width: 4px;
}

.trace-series-label.is-baseline text {
  fill: #1d4ed8;
}

.trace-series-label.is-target text {
  fill: #ea580c;
}

.trace-deviation-marker {
  cursor: pointer;
}

.trace-deviation-marker line {
  stroke: #be123c;
  stroke-linecap: round;
  stroke-width: 1.4;
}

.trace-deviation-marker circle {
  fill: #be123c;
  stroke: #fff;
  stroke-width: 2.4;
}

.trace-deviation-marker text {
  fill: #be123c;
  font-size: 12px;
  font-weight: 500;
  paint-order: stroke;
  stroke: #fff;
  stroke-width: 3px;
}

.trace-deviation-marker.is-selected circle {
  fill: #0f172a;
}

.trace-deviation-marker.is-selected line,
.trace-deviation-marker.is-selected text {
  stroke: #0f172a;
}

.trace-timeline {
  display: grid;
  min-height: 58px;
  grid-template-columns: repeat(auto-fit, minmax(22px, 1fr));
  gap: 4px;
  margin-top: 8px;
}

.trace-timeline-step {
  position: relative;
  min-width: 0;
  height: 58px;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px !important;
  background: #fff;
}

.trace-timeline-step:hover,
.trace-timeline-step.is-selected {
  border-color: #93c5fd;
  box-shadow: inset 0 0 0 1px #93c5fd;
}

.trace-timeline-bar {
  position: absolute;
  bottom: 17px;
  left: 50%;
  width: 8px;
  min-height: 7px;
  transform: translateX(-50%);
  border-radius: 999px 999px 2px 2px;
  background: #cbd5e1;
}

.trace-timeline-step.is-watch .trace-timeline-bar {
  background: #f59e0b;
}

.trace-timeline-step.is-hot .trace-timeline-bar {
  background: #e11d48;
}

.trace-timeline-step em {
  position: absolute;
  right: 0;
  bottom: 3px;
  left: 0;
  color: #94a3b8;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  text-align: center;
}

.trace-reading-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)) minmax(260px, 2fr);
  gap: 0;
  margin-top: 10px;
  overflow: hidden;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px !important;
  background: #fff;
}

.trace-reading-row div {
  min-width: 0;
  border-left: 1px solid var(--nf-border-soft);
  padding: 10px 12px;
}

.trace-reading-row div:first-child {
  border-left: 0;
}

.trace-reading-row span {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.trace-reading-row strong {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  color: #0f172a;
  font-size: 15px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trace-reading-row p {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 3px;
  color: #334155;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.trace-detail-grid {
  display: grid;
  grid-template-columns: minmax(260px, 0.9fr) minmax(260px, 1fr) minmax(320px, 1.35fr);
  gap: 10px;
  margin-top: 10px;
}

.trace-detail-panel {
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fff;
  padding: 12px;
}

.trace-detail-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.trace-detail-panel__head p {
  margin: 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
}

.trace-detail-panel__head span {
  flex: 0 0 auto;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.trace-segment-detail {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
}

.trace-segment-detail div {
  min-width: 0;
  border-left: 1px solid var(--nf-border-soft);
  padding: 8px 9px;
}

.trace-segment-detail div:first-child {
  border-left: 0;
}

.trace-segment-detail span,
.trace-segment-detail strong,
.trace-metric-detail-list span,
.trace-metric-detail-list strong,
.trace-metric-detail-list small {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trace-segment-detail span,
.trace-metric-detail-list span {
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.trace-segment-detail strong {
  margin-top: 3px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
}

.trace-segment-detail div:nth-child(3) strong {
  color: #be123c;
}

.trace-detail-copy {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 9px;
  color: #475569;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.trace-metric-detail-list {
  display: grid;
  gap: 7px;
}

.trace-metric-detail-list div {
  display: grid;
  grid-template-columns: minmax(92px, 1fr) minmax(82px, auto);
  gap: 2px 10px;
  min-width: 0;
  border-bottom: 1px solid var(--nf-border-soft);
  padding-bottom: 7px;
}

.trace-metric-detail-list div:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.trace-metric-detail-list strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
}

.trace-metric-detail-list small {
  grid-column: 1/-1;
  color: #94a3b8;
  font-size: 12px;
}

.trace-evidence-list {
  display: grid;
  gap: 7px;
}

.trace-evidence-item {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  gap: 9px;
  min-width: 0;
  border: 1px solid var(--nf-border-soft);
  border-radius: 8px;
  background: #fbfdff;
  padding: 8px 9px;
}

.trace-evidence-item > span {
  align-self: start;
  border-radius: 999px;
  background: #eaf2ff;
  padding: 3px 7px;
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

.trace-evidence-item.is-watch > span {
  background: #fff7ed;
  color: #b45309;
}

.trace-evidence-item.is-hot > span {
  background: #fff1f2;
  color: #be123c;
}

.trace-evidence-item div,
.trace-evidence-item strong,
.trace-evidence-item small,
.trace-evidence-item p {
  min-width: 0;
}

.trace-evidence-item strong,
.trace-evidence-item small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trace-evidence-item strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 600;
}

.trace-evidence-item small {
  margin-top: 1px;
  color: #64748b;
  font-size: 12px;
}

.trace-evidence-item p {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 3px;
  color: #475569;
  font-size: 12px;
  line-height: 1.4;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.trace-evidence-empty {
  border: 1px dashed var(--nf-border);
  border-radius: 8px;
  padding: 18px 10px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}

.trace-chart-empty {
  border: 1px dashed var(--nf-border);
  border-radius: 12px !important;
  background: #f8fafc;
  padding: 44px 16px;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}

:host-context([data-theme=dark]) .agent-shell {
  --nf-agent-card-surface: color-mix(in srgb, var(--nf-panel) 88%, #06111e);
  --nf-agent-card-raised: color-mix(in srgb, var(--nf-panel-elevated) 88%, #06111e);
  --nf-agent-card-soft: color-mix(in srgb, var(--nf-panel-soft) 84%, #06111e);
  --nf-agent-card-hover: color-mix(in srgb, var(--nf-wash) 70%, var(--nf-panel));
}

:host-context([data-theme=dark]) .agent-shell [class~=bg-white],
:host-context([data-theme=dark]) .agent-shell [class~="bg-[#ffffff]"] {
  background-color: var(--nf-agent-card-surface) !important;
}

:host-context([data-theme=dark]) .agent-shell [class~="bg-[#f7f9fc]"],
:host-context([data-theme=dark]) .agent-shell [class~="bg-[#f4f7fb]"],
:host-context([data-theme=dark]) .agent-shell [class~="bg-[#f1f5f9]"] {
  background-color: var(--nf-agent-card-soft) !important;
}

:host-context([data-theme=dark]) .agent-shell [class~="hover:bg-[#f4f7fb]"]:hover,
:host-context([data-theme=dark]) .agent-shell [class~="hover:bg-[#f1f5f9]"]:hover {
  background-color: var(--nf-agent-card-hover) !important;
}

:host-context([data-theme=dark]) .trace-tabs {
  background: #101927;
  border: 1px solid var(--nf-border);
  border-bottom: 0;
}

:host-context([data-theme=dark]) .trace-compare-shell,
:host-context([data-theme=dark]) .trace-visual-card,
:host-context([data-theme=dark]) .trace-reading-row,
:host-context([data-theme=dark]) .trace-detail-panel {
  background: linear-gradient(145deg, rgba(20, 40, 61, 0.82), rgba(9, 24, 40, 0.92)), var(--nf-agent-card-surface) !important;
  border-color: color-mix(in srgb, var(--nf-border-strong) 30%, var(--nf-border)) !important;
  box-shadow: inset 0 1px 0 rgba(135, 215, 255, 0.07);
}

:host-context([data-theme=dark]) .trace-compare-filters,
:host-context([data-theme=dark]) .trace-filter-summary,
:host-context([data-theme=dark]) .trace-wave-stage {
  background: linear-gradient(180deg, rgba(20, 40, 61, 0.76), rgba(7, 19, 33, 0.9)), var(--nf-agent-card-soft);
  border-color: var(--nf-border-soft);
}

:host-context([data-theme=dark]) .trace-tab-button {
  border-left-color: rgba(135, 215, 255, 0.12);
  background: linear-gradient(180deg, #24384f 0%, #18283a 100%);
  color: var(--nf-muted);
  text-shadow: none;
}

:host-context([data-theme=dark]) .trace-tab-button:hover {
  background: linear-gradient(180deg, #2a435e 0%, #1c3148 100%);
  color: var(--nf-ink);
  filter: none;
}

:host-context([data-theme=dark]) .trace-tab-button.is-active {
  background: var(--nf-agent-card-surface);
  color: var(--nf-ink);
  box-shadow: inset 0 3px 0 var(--nf-brand);
}

:host-context([data-theme=dark]) .trace-risk-ok {
  background: var(--nf-success-pill);
  color: var(--nf-success);
}

:host-context([data-theme=dark]) .trace-risk-watch {
  background: var(--nf-warning-pill);
  color: var(--nf-warning);
}

:host-context([data-theme=dark]) .trace-risk-hot {
  background: var(--nf-danger-pill);
  color: var(--nf-danger);
}

:host-context([data-theme=dark]) .trace-wave-note span,
:host-context([data-theme=dark]) .trace-filter-field span,
:host-context([data-theme=dark]) .trace-filter-summary,
:host-context([data-theme=dark]) .trace-focus-card span,
:host-context([data-theme=dark]) .trace-reading-row span,
:host-context([data-theme=dark]) .trace-detail-panel__head span,
:host-context([data-theme=dark]) .trace-segment-detail span,
:host-context([data-theme=dark]) .trace-metric-detail-list span,
:host-context([data-theme=dark]) .trace-metric-detail-list small,
:host-context([data-theme=dark]) .trace-evidence-item small,
:host-context([data-theme=dark]) .trace-timeline-step em,
:host-context([data-theme=dark]) .trace-chart-empty,
:host-context([data-theme=dark]) .trace-evidence-empty {
  color: var(--nf-muted);
}

:host-context([data-theme=dark]) .trace-wave-note strong,
:host-context([data-theme=dark]) .trace-filter-summary strong,
:host-context([data-theme=dark]) .trace-focus-card strong,
:host-context([data-theme=dark]) .trace-reading-row strong,
:host-context([data-theme=dark]) .trace-detail-panel__head p,
:host-context([data-theme=dark]) .trace-segment-detail strong,
:host-context([data-theme=dark]) .trace-metric-detail-list strong,
:host-context([data-theme=dark]) .trace-evidence-item strong {
  color: var(--nf-ink);
}

:host-context([data-theme=dark]) .trace-wave-note p,
:host-context([data-theme=dark]) .trace-focus-card p,
:host-context([data-theme=dark]) .trace-reading-row p,
:host-context([data-theme=dark]) .trace-detail-copy,
:host-context([data-theme=dark]) .trace-evidence-item p {
  color: var(--nf-text);
}

:host-context([data-theme=dark]) .trace-grid line {
  stroke: color-mix(in srgb, var(--nf-border) 84%, #ffffff 4%);
}

:host-context([data-theme=dark]) .trace-grid text,
:host-context([data-theme=dark]) .trace-axis-label {
  fill: var(--nf-muted);
}

:host-context([data-theme=dark]) .trace-node circle,
:host-context([data-theme=dark]) .trace-deviation-marker circle {
  stroke: var(--nf-agent-card-surface);
}

:host-context([data-theme=dark]) .trace-deviation-marker text {
  stroke: var(--nf-agent-card-surface);
}

:host-context([data-theme=dark]) .trace-series-label text {
  stroke: var(--nf-agent-card-surface);
}

:host-context([data-theme=dark]) .trace-deviation-marker.is-selected circle {
  fill: var(--nf-ink);
}

:host-context([data-theme=dark]) .trace-deviation-marker.is-selected line,
:host-context([data-theme=dark]) .trace-deviation-marker.is-selected text {
  stroke: var(--nf-ink);
}

:host-context([data-theme=dark]) .trace-timeline-step,
:host-context([data-theme=dark]) .trace-focus-card,
:host-context([data-theme=dark]) .trace-segment-detail,
:host-context([data-theme=dark]) .trace-evidence-item,
:host-context([data-theme=dark]) .trace-chart-empty {
  background: var(--nf-agent-card-raised);
  border-color: var(--nf-border-soft);
}

:host-context([data-theme=dark]) .trace-timeline-step:hover,
:host-context([data-theme=dark]) .trace-timeline-step.is-selected {
  border-color: var(--nf-brand);
  background: color-mix(in srgb, var(--nf-wash) 58%, var(--nf-agent-card-raised));
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--nf-brand) 70%, transparent);
}

:host-context([data-theme=dark]) .trace-reading-row div,
:host-context([data-theme=dark]) .trace-segment-detail div,
:host-context([data-theme=dark]) .trace-metric-detail-list div,
:host-context([data-theme=dark]) .trace-wave-notes,
:host-context([data-theme=dark]) .trace-wave-note,
:host-context([data-theme=dark]) .trace-filter-summary {
  border-color: var(--nf-border-soft);
}

:host-context([data-theme=dark]) .trace-evidence-item > span {
  background: var(--nf-wash);
  color: var(--nf-brand);
}

:host-context([data-theme=dark]) .trace-evidence-item.is-watch > span {
  background: var(--nf-warning-pill);
  color: var(--nf-warning);
}

:host-context([data-theme=dark]) .trace-evidence-item.is-hot > span {
  background: var(--nf-danger-pill);
  color: var(--nf-danger);
}

@media (max-width: 1180px) {
  .analysis-workbench {
    grid-template-columns: minmax(220px, 280px) minmax(0, 1fr);
    grid-template-areas: "model controls" "record controls" "vm vm" "rca optimize" "answer answer";
    grid-template-rows: auto auto auto auto auto;
    overflow: auto !important;
  }
  .analysis-control-panel {
    grid-area: controls;
  }
}
@media (max-width: 1023px) {
  .agent-analysis-workspace {
    display: flex;
    flex-direction: column;
  }
  .analysis-tabbar {
    grid-template-columns: repeat(5, minmax(132px, 1fr));
    overflow-x: auto;
    padding-inline: 18px;
  }
  .analysis-purpose-strip {
    grid-template-columns: repeat(5, minmax(180px, 1fr));
    overflow-x: auto;
    padding-inline: 14px;
  }
  .analysis-flow-summary {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
    padding-inline: 14px;
  }
  .analysis-flow-summary p {
    max-width: none;
    text-align: left;
  }
  .analysis-summary-strip {
    grid-template-columns: repeat(6, minmax(132px, 1fr));
    overflow-x: auto;
    padding-inline: 14px;
  }
  .analysis-kpi-hero,
  .analysis-detail-grid {
    grid-template-columns: 1fr;
  }
  .analysis-kpi-primary,
  .analysis-detail-panel {
    border-left: 0;
    border-right: 0;
    border-top: 1px solid var(--nf-border-soft);
  }
  .analysis-kpi-primary {
    border-top: 0;
  }
  .analysis-detail-panel:first-child {
    border-top: 0;
  }
  .agent-analysis-workspace > .analysis-flowbar,
  .agent-analysis-workspace > .analysis-stage--model,
  .agent-analysis-workspace > .analysis-stage:nth-of-type(2),
  .agent-analysis-workspace > .analysis-stage:nth-of-type(3) {
    grid-column: auto;
    grid-row: auto;
  }
  .analysis-flowbar {
    grid-template-columns: repeat(6, minmax(72px, 1fr));
    overflow-x: auto;
  }
  .analysis-model-grid,
  .analysis-record-grid,
  .analysis-result-grid {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
  .analysis-run-card,
  .analysis-record-detail,
  .analysis-result-card {
    border-left: 0;
    border-top: 1px solid var(--nf-border-soft);
  }
  .analysis-result-card:first-child {
    border-top: 0;
  }
  .agent-flat-metrics > div:nth-child(odd) {
    border-left: 0 !important;
  }
  .data-summary-panel {
    grid-template-columns: 1fr;
  }
  .data-summary-panel > .data-hub-overview > .data-hub-intro,
  .data-summary-panel > .data-hub-overview > .data-hub-source-map,
  .data-summary-panel > .data-search-summary-header,
  .data-summary-panel > .data-search-summary-grid {
    grid-column: 1;
    grid-row: auto;
  }
  .data-summary-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .data-summary-metric:nth-child(odd) {
    border-left: 0;
  }
  .data-summary-metric:nth-child(n+3) {
    border-top: 1px solid rgba(226, 232, 240, 0.72);
  }
  .data-explorer-tabbar {
    justify-content: flex-start;
  }
  .data-hub-overview,
  .data-insight-grid,
  .data-visual-grid,
  .data-record-layout,
  .data-trace-split {
    grid-template-columns: 1fr;
  }
  .data-chart-lab {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .data-hub-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .data-insight-block + .data-insight-block,
  .data-record-side,
  .data-trace-split > .data-side-section + .data-side-section {
    border-left: 0;
    border-top: 1px solid rgba(226, 232, 240, 0.72);
  }
  .insight-main-grid,
  .insight-bottom-grid {
    grid-template-columns: 1fr;
  }
  .insight-card--visual {
    min-height: auto;
  }
  .insight-kpi-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .insight-kpi:nth-child(odd) {
    border-left: 0;
  }
  .insight-kpi:nth-child(n+3) {
    border-top: 1px solid var(--nf-border-soft);
  }
  .trace-tabs {
    min-height: 62px;
    padding: 10px 12px 0;
  }
  .trace-tab-button {
    flex-basis: 162px;
    height: 52px;
    font-size: 15px;
  }
  .trace-compare-filters {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .trace-compare-filters button {
    grid-column: 1/-1;
  }
  .trace-filter-field--base {
    grid-column: span 2;
  }
  .trace-focus-strip {
    grid-template-columns: 1fr;
  }
  .trace-wave-grid {
    grid-template-columns: 1fr;
  }
  .trace-wave-notes {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    border-left: 0;
    border-top: 1px solid var(--nf-border-soft);
    padding-top: 10px;
    padding-left: 0;
  }
  .trace-wave-note {
    border-bottom: 0;
    border-left: 1px solid var(--nf-border-soft);
    padding-bottom: 0;
    padding-left: 10px;
  }
  .trace-wave-note:first-child {
    border-left: 0;
    padding-left: 0;
  }
  .trace-reading-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .trace-reading-row .trace-reading-judgement {
    grid-column: 1/-1;
  }
  .trace-reading-row div:nth-child(odd) {
    border-left: 0;
  }
  .trace-reading-row div:nth-child(n+3) {
    border-top: 1px solid var(--nf-border-soft);
  }
  .trace-detail-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 639px) {
  .analysis-workbench {
    grid-template-columns: 1fr;
    grid-template-areas: "model" "record" "vm" "rca" "optimize" "answer" "controls";
    padding: 10px !important;
  }
  .analysis-kpi-grid,
  .analysis-control-grid,
  .analysis-dashboard-selection,
  .analysis-model-table__head,
  .analysis-model-row {
    grid-template-columns: 1fr;
  }
  .analysis-dashboard-selection div {
    border-left: 0;
    border-top: 1px solid var(--nf-border-soft);
  }
  .analysis-dashboard-selection div:first-child {
    border-top: 0;
  }
  .analysis-model-table__head span:nth-child(n+2) {
    display: none;
  }
  .analysis-dashboard-head {
    align-items: stretch;
    flex-direction: column;
  }
  .analysis-kpi-primary strong {
    font-size: 34px;
  }
  .analysis-tabbar {
    grid-template-columns: repeat(5, minmax(108px, 1fr));
    padding: 14px 16px 12px;
  }
  .analysis-purpose-strip {
    grid-template-columns: 1fr;
    gap: 6px;
    padding: 10px;
  }
  .analysis-summary-strip {
    grid-template-columns: repeat(6, minmax(118px, 1fr));
    gap: 6px;
    padding: 10px;
  }
  .analysis-tab {
    gap: 8px;
    padding: 0 6px;
  }
  .analysis-tab::before,
  .analysis-tab::after {
    top: 18px;
  }
  .analysis-tab::before {
    right: calc(50% + 22px);
  }
  .analysis-tab::after {
    left: calc(50% + 22px);
  }
  .analysis-tab__index {
    width: 38px;
    height: 38px;
    border-width: 3px;
    box-shadow: 0 0 0 4px #fff;
    font-size: 12px;
  }
  .analysis-tab.is-active .analysis-tab__index {
    box-shadow: 0 0 0 4px #dbeafe;
  }
  .analysis-tab__label {
    font-size: 12px;
  }
  .analysis-tab small {
    font-size: 12px;
  }
  .analysis-tab em {
    font-size: 12px;
  }
  .analysis-flowbar {
    grid-template-columns: repeat(6, minmax(64px, 1fr));
    padding-inline: 2px;
  }
  .analysis-flowbar__item {
    border: 0;
  }
  .analysis-flowbar__item::after {
    left: calc(50% + 24px);
    right: calc(-50% + 24px);
  }
  .analysis-flowbar__circle {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    font-size: 13px;
  }
  .analysis-flowbar__item p {
    max-width: 64px;
    font-size: 12px;
  }
  .analysis-stage__header {
    align-items: stretch;
    flex-direction: column;
  }
  .analysis-stage__controls,
  .analysis-stage__actions {
    justify-content: stretch;
  }
  .analysis-stage__controls select,
  .analysis-stage__controls input,
  .analysis-stage__actions button {
    flex: 1 1 130px;
  }
  .analysis-record-kpis,
  .analysis-result-chips {
    grid-template-columns: 1fr;
  }
  .agent-flat-metrics > div {
    border-left: 0 !important;
    border-top: 1px solid var(--nf-border-soft) !important;
  }
  .agent-flat-metrics > div:first-child {
    border-top: 0 !important;
  }
  .data-summary-strip {
    grid-template-columns: 1fr;
  }
  .data-hub-kpi-grid,
  .data-chart-lab,
  .data-coverage-cloud,
  .trace-status-strip {
    grid-template-columns: 1fr;
  }
  .data-hub-intro,
  .data-hub-catalog,
  .data-tab-explain,
  .trace-timeline-viz {
    padding: 12px;
  }
  .data-hub-intro h3 {
    font-size: 17px;
  }
  .data-source-map-body {
    grid-template-columns: 1fr;
    justify-items: center;
  }
  .data-source-legend {
    width: 100%;
  }
  .data-summary-metric {
    border-left: 0;
    border-top: 1px solid var(--nf-border-soft);
  }
  .data-summary-metric:first-child {
    border-top: 0;
  }
  .data-explorer-filters,
  .data-explorer-body {
    padding: 12px;
  }
  .data-explorer-interpretation {
    align-items: stretch;
    flex-direction: column;
    padding: 11px 12px;
  }
  .data-explorer-interpretation ul {
    justify-content: flex-start;
  }
  .data-explorer-interpretation li small {
    display: none;
  }
  .data-explorer-tabbar {
    min-height: 54px;
    gap: 18px;
    padding: 0 14px;
  }
  .data-explorer-tab {
    flex: 0 0 auto;
    height: 54px;
    font-size: 13px;
  }
  .data-tab-explain {
    align-items: stretch;
    flex-direction: column;
  }
  .data-tab-explain__stats {
    justify-content: flex-start;
  }
  .data-donut-wrap,
  .trace-metrology-ladder__row {
    grid-template-columns: 1fr;
  }
  .data-donut-wrap {
    justify-items: center;
  }
  .trace-timeline-viz__rail {
    height: auto;
    min-height: 0;
    background: #f8fafc;
    padding: 10px;
  }
  .trace-timeline-node {
    position: static;
    display: grid;
    width: auto;
    grid-template-columns: 34px minmax(0, 1fr);
    align-items: center;
    gap: 8px;
    transform: none;
    text-align: left;
  }
  .trace-timeline-node:not(:last-child)::after {
    display: none;
  }
  .trace-timeline-node + .trace-timeline-node {
    margin-top: 8px;
  }
  .trace-timeline-node strong,
  .trace-timeline-node small {
    grid-column: 2;
  }
  .trace-timeline-node strong {
    margin-top: 0;
  }
  .data-table-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .insight-kpi-strip,
  .insight-recommend-grid,
  .insight-selection,
  .insight-action-grid {
    grid-template-columns: 1fr;
  }
  .insight-kpi,
  .insight-selection div {
    border-left: 0;
    border-top: 1px solid var(--nf-border-soft);
  }
  .insight-kpi:first-child,
  .insight-selection div:first-child {
    border-top: 0;
  }
  .insight-chart-stage {
    height: 260px;
  }
  .insight-wafer {
    width: min(250px, 78vw);
    height: min(250px, 78vw);
  }
  .insight-record-list button {
    grid-template-columns: 1fr;
    gap: 3px;
  }
  .insight-answer-bar {
    align-items: stretch;
    flex-direction: column;
  }
  .trace-wave-svg {
    height: 100%;
  }
  .trace-tabs {
    min-height: 58px;
    padding: 8px 10px 0;
  }
  .trace-tab-button {
    flex-basis: 132px;
    height: 50px;
    font-size: 14px;
  }
  .trace-compare-filters,
  .trace-segment-detail {
    grid-template-columns: 1fr;
  }
  .trace-filter-field--base {
    grid-column: auto;
  }
  .trace-filter-summary {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
    padding: 8px 12px;
  }
  .trace-filter-summary em {
    margin-left: 0;
  }
  .trace-segment-detail div {
    border-left: 0;
    border-top: 1px solid var(--nf-border-soft);
  }
  .trace-segment-detail div:first-child {
    border-top: 0;
  }
  .trace-wave-notes {
    grid-template-columns: 1fr;
  }
  .trace-wave-note,
  .trace-wave-note:first-child {
    border-left: 0;
    border-bottom: 1px solid var(--nf-border-soft);
    padding-left: 0;
    padding-bottom: 8px;
  }
  .trace-wave-note:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
  .trace-timeline {
    grid-template-columns: repeat(8, minmax(20px, 1fr));
  }
  .trace-reading-row {
    grid-template-columns: 1fr;
  }
  .trace-reading-row div {
    border-left: 0;
    border-top: 1px solid var(--nf-border-soft);
  }
  .trace-reading-row div:first-child {
    border-top: 0;
  }
}`],
})
export class PageAgentComponent implements OnInit, OnDestroy {
    public overviewLoading: boolean = false;
    public asking: boolean = false;
    public input: string = '';
    public waferMapFile: File | null = null;
    public waferMapError: string = '';
    public waferMapNotice: string = '';
    public readonly waferMapMaxBytes: number = 5 * 1024 * 1024;
    public selectedAgentMode: string = 'auto';
    public readonly agentModes: any[] = [
        {
            id: 'auto',
            label: '자동 선택',
            shortLabel: 'Orchestrator',
            description: '질문과 첨부 데이터의 사전검증 결과로 적합한 Agent를 연결합니다.',
            marker: 'AI'
        },
        {
            id: 'simple',
            label: '단순 질의',
            shortLabel: 'RAG Agent',
            description: '문서·지식 검색을 바탕으로 근거 있는 답변을 만듭니다.',
            marker: 'Q'
        },
        {
            id: 'virtual_metrology',
            label: '가상 계측',
            shortLabel: 'VM Agent',
            description: '공정 데이터와 모델로 계측값을 예측하고 비교합니다.',
            marker: 'VM'
        },
        {
            id: 'anomaly',
            label: '이상 탐지',
            shortLabel: 'Anomaly Agent',
            description: '이상 점수와 영향 요인을 분석해 원인 후보를 찾습니다.',
            marker: '!'
        }
    ];
    public selectedToolExecutionMode: string = 'auto';
    public readonly toolExecutionModes: any[] = [
        {
            id: 'auto',
            label: '자동',
            description: 'Tool 의존성을 분석해 순차 또는 병렬 실행을 결정합니다.'
        },
        {
            id: 'sequential',
            label: '순차',
            description: '앞선 Tool 결과를 다음 Tool에 전달하며 한 단계씩 실행합니다.'
        },
        {
            id: 'parallel',
            label: '병렬',
            description: '서로 독립적인 Tool을 같은 Wave에서 동시에 실행합니다.'
        }
    ];
    private lastQuestionHadWaferMap: boolean = false;
    private pendingAgentRequest: any = null;
    public section: string = 'chat';
    public stats: any[] = [];
    public requirements: any[] = [];
    public tools: any[] = [];
    public workflows: any[] = [];
    public suggestions: string[] = [];
    public metrics: any[] = [];
    public capabilityModules: any[] = [];
    public modelServing: any = {};
    public processPreview: any[] = [];
    public chartPreview: any = {};
    public messages: any[] = [];
    public historyItems: any[] = [];
    public historySearch: string = '';
    public showHistory: boolean = false;
    public historyKey: string = 'fab.agent.history';
    public historyBackendLoaded: boolean = false;
    public conversationHistoryLoading: boolean = false;
    public historyPagination: any = { page: 1, dump: 10, total: 0, totalPages: 1 };
    private historyRequestSeq: number = 0;
    public historySaveState: 'idle' | 'saving' | 'saved' | 'error' = 'idle';
    public historySaveStatus: string = '';
    private historySaveSeq: number = 0;
    private historySaveTimer: any = null;
    public historyHealth: any = { status: 'unknown', healthy: true, backups: [] };
    public historyRecoveryBusy: boolean = false;
    public historyPanelCollapsed: boolean = false;
    public historyPanelWidth: number = 288;
    public historyPanelMinWidth: number = 240;
    public historyPanelMaxWidth: number = 520;
    public historyPanelResizing: boolean = false;
    private historyPanelPrefsKey: string = 'fab.agent.history.panel';
    private historyResizeStart: any = null;
    private historyResizeRenderQueued: boolean = false;
    public lastQuestion: string = '';
    public askSeq: number = 0;
    public askElapsedSeconds: number = 0;
    private activeAskController: AbortController | null = null;
    private activeAskStartedAt: number = 0;
    private askElapsedTimer: any = null;
    private routerSub: any;
    private floatingChatObserver: MutationObserver | null = null;
    private readonly dashboardQuestionKey: string = 'nanofab.agent.pending-question';
    // Sub-section data
    public workflowData: any = { templates: [], history: [], stats: {} };
    public statsData: any = { summary: {}, toolStats: [], intentBreakdown: [], trend: [] };
    public explorerData: any = { process: {}, semiconductorData: { summary: {}, catalog: [] }, search: { records: [], statistics: {}, facets: {} }, domainData: {}, documentAI: {}, quality: {} };
    public processTraceData: any = { traces: [], sensors: [], metrology: [], lot: '' };
    public documentHubData: any = { summary: {}, categories: [], types: [], languages: [], pipeline: [], documents: [] };
    public documentHubQuery: string = '';
    public documentHubFilters: any = { category: 'all', type: 'all', language: 'all', sort: 'updated' };
    public showDocumentHubDetailedFilters: boolean = false;
    public readonly documentHubSortOptions: any[] = [
        { id: 'updated', label: '최근 업데이트순' },
        { id: 'title', label: '문서명순' },
        { id: 'pages', label: '페이지 많은순' },
        { id: 'chunks', label: '청크 많은순' },
    ];
    public selectedHubDocument: any = null;
    public selectedHubPage: number = 1;
    private documentHubStateHydrated: boolean = false;
    private requestedHubDocumentId: string = '';
    private hubModalReturnFocus: HTMLElement | null = null;
    public lotSearch: string = '';
    public explorerFilters: any = { source_scope: 'sample', lot: '', process: '', equipment: '', status: '', sort: 'date', order: 'desc', page: 1, dump: 20 };
    public activeExplorerTab: string = 'summary';
    public selectedRecordId: string = '';
    public selectedRecord: any = null;
    public detailLoading: boolean = false;
    public operationalAnalysisModelId: string = '';
    public operationalAnalysisBusy: boolean = false;
    public operationalAnalysisResult: any = null;
    public operationalAnalysisError: string = '';
    private explorerStateHydrated: boolean = false;
    private explorerRequestSeq: number = 0;
    private explorerDetailSeq: number = 0;
    public analysisData: any = { modelRegistry: { registry: [] }, selectedModel: {}, modelRun: {}, analytics: {}, optimization: {}, trace: {}, workflow: {} };
    public analysisCatalogData: any = { modelRegistry: { registry: [] } };
    public traceData: any = { similarity: 0, deviationSegments: [], overlaySeries: [] };
    public visualizationReportData: any = { visualization: {}, rendered: {}, trace: {}, report: {} };
    public dataQualityData: any = { semiconductorData: { summary: {}, catalog: [] }, ingestion: {}, quality: {} };
    public knowledgeCatalogData: any = { documents: [], datasets: [], sampleDatasets: [], summary: {}, policy: {}, audit: [] };
    public activeQualityWorkspace: string = 'files';
    public knowledgeLoading: boolean = false;
    public knowledgeBusy: boolean = false;
    public showArchivedKnowledge: boolean = false;
    public documentUploadProgress: number = 0;
    public documentForm: any = { title: '', owner: '', tags: '', visibility: 'project' };
    public selectedDocumentDetail: any = null;
    public selectedDocumentPage: any = null;
    public documentPageLoading: boolean = false;
    private requestedKnowledgeDocumentId: string = '';
    public datasetForm: any = {
        id: '', name: '', description: '', owner: '', visibility: 'project',
        readers: 'researcher, admin', editors: 'admin',
        schemaText: '[\n  {"name": "id", "type": "string", "required": true}\n]',
        lineageDocuments: '', lineageDatasets: ''
    };
    public selectedDatasetDetail: any = null;
    public datasetRowMode: string = 'append';
    public datasetRowKeyField: string = 'id';
    public datasetRowBusy: boolean = false;
    public datasetRowUploadStatus: any = { uploading: false, percent: 0, filename: '' };
    public datasetMaintenanceBusy: string = '';
    public datasetMaintenanceData: any = null;
    public datasetMaintenancePreview: any = null;
    public uploadDatasetType: string = 'process';
    public uploadSource: string = 'manual-upload';
    public uploadMode: string = 'validate-only';
    public uploadStatus: any = { uploading: false, percent: 0, filename: '' };
    public ingestionRuns: any[] = [];
    public pendingIngestionPreview: any = null;
    public ingestionApprovalChecked: boolean = false;
    public ingestionApplying: boolean = false;
    public ingestionOperation: string = '';
    public ingestionRollbackId: string = '';
    public ingestionDiscardId: string = '';
    public operationalMaintenanceBusy: string = '';
    public selectedOperationalVersionPage: any = null;
    public adminConsoleData: any = { operations: {}, semiconductorData: { summary: {}, catalog: [] }, ingestion: {}, quality: {}, accessAudit: {}, securityBackup: {}, performance: {}, serving: {}, mcp: {}, workflow: {} };
    public functionalMapData: any = { summary: [], principles: [], groups: [], navigationDecision: {}, interfaceFlow: [], dataDomains: [], responseModes: [], innovationLoops: [], menu: [], journeys: [], platformLayers: [], requirementMap: [], currentScreens: [], uxDevices: [], nextDesign: [] };
    public trainingData: any = { scenarios: [], audiences: [] };
    public trainingRole: string = 'trainee';
    public sectionLoading: any = {};
    public sectionErrors: any = {};
    public historyLoading: boolean = false;
    public runningWorkflow: string = '';
    public workflowSearch: string = '';
    public workflowFilter: string = 'all';
    public workflowRunInput: string = 'Lot A13 이상 원인 분석';
    public selectedWorkflowId: string = '';
    public selectedWorkflow: any = null;
    public selectedWorkflowRun: any = null;
    public activeWorkflowTab: string = 'templates';
    public analysisQuery: string = 'Lot A13 두께 이상 원인 분석';
    public analysisModelId: string = '';
    public analysisMetric: string = 'thickness';
    public analysisTarget: number = 120;
    public analysisMode: string = 'auto';
    public analysisWorkspaceOpen: boolean = false;
    public activeAnalysisTab: string = 'model';
    public selectedAnalysisRecordId: string = '';
    public selectedAnalysisRecord: any = null;
    public selectedRcaFactorName: string = '';
    public selectedOptimizationRecipeId: string = '';
    public analysisRunning: boolean = false;
    public analysisInputsDirty: boolean = false;
    public analysisSelectionsDirty: boolean = false;
    public analysisVariables: any = { temperature: null, pressure: null, power: null, time: null };
    public readonly analysisVariableFieldDefinitions: any[] = [
        { key: 'temperature', label: '온도', unit: '°C', min: 0, max: 1000, step: 1 },
        { key: 'pressure', label: '압력', unit: 'Torr', min: 0, max: 100, step: 0.01 },
        { key: 'power', label: 'RF 전력', unit: 'W', min: 0, max: 100000, step: 1 },
        { key: 'time', label: '공정 시간', unit: 's', min: 0.001, max: 100000, step: 0.1 }
    ];
    public traceBase: string = 'baseline';
    public traceTarget: string = 'Lot A13';
    public traceMetric: string = 'pressure';
    public traceMode: string = 'lot';
    public traceFilters: any = { lot: 'Lot A13', process: '', equipment: '', status: '' };
    public traceActiveTab: string = 'waveform';
    public selectedTraceSegment: any = null;
    public traceRunning: boolean = false;
    public chartType: string = 'wafermap';
    public visualizationDataset: string = 'Lot A13';
    public visualizationMetric: string = 'thickness';
    public selectedVisualizationRecommendation: any = null;
    public selectedVisualizationChart: string = '';
    public visualizationRunning: boolean = false;
    public activeVisualizationInteraction: string = 'hover';
    public selectedVisualizationPoint: any = null;
    public visualizationZoom: number = 1;
    public visualizationPan: number = 0;
    public visualizationBrushActive: boolean = false;
    public linkedVisualizationStatus: string = '';
    public visualizationActionMessage: string = '';
    public reportTemplate: string = 'process-analysis';
    public reportPreview: any = null;
    public reportGenerating: boolean = false;
    public qualityChecking: boolean = false;
    public adminRefreshing: boolean = false;
    public adminSettingsWorkspace: string = 'llm';
    public llmSettingsData: any = { models: [], downloadedModels: [], settings: {}, params: {}, status: {}, selectedModel: {} };
    public llmSettingsForm: any = { model: '', provider: 'ollama', temperature: 0.2, top_p: 0.9, max_tokens: 1024, ollama_base_url: '' };
    public llmSettingsSaving: boolean = false;
    public llmSettingsSyncing: boolean = false;
    public llmSettingsTesting: boolean = false;
    public llmSettingsLoading: boolean = false;
    public llmTestPrompt: string = '식각 공정 endpoint 이상 원인을 근거와 함께 요약해줘';
    public llmTestResult: any = null;
    public documentPipelineData: any = { settings: {}, capabilities: {}, stages: [], servingModels: [], qdrant: {} };
    public readonly documentPipelineFormatOptions: any[] = [
        { id: 'pdf', label: 'PDF' },
        { id: 'docx', label: 'DOCX' },
        { id: 'hwp', label: 'HWP' },
        { id: 'hwpx', label: 'HWPX' },
        { id: 'txt', label: 'TXT' },
        { id: 'md', label: 'Markdown' }
    ];
    public documentPipelineForm: any = {
        formats: ['pdf', 'docx', 'hwp', 'hwpx', 'txt', 'md'],
        ocr_enabled: true,
        ocr_language: 'kor+eng',
        extract_text: true,
        extract_table: true,
        extract_formula: true,
        chunk_size: 900,
        chunk_overlap: 120,
        metadata_model: '',
        category_min: 1,
        category_max: 4,
        embedding_model: '',
        qdrant_enabled: false,
        qdrant_url: 'http://127.0.0.1:6333',
        qdrant_collection: 'nanofab_documents',
        qdrant_distance: 'Cosine'
    };
    public documentPipelineLoading: boolean = false;
    public documentPipelineSaving: boolean = false;
    public documentPipelineTesting: boolean = false;
    public documentPipelineTestResult: any = null;
    public actionResult: any = null;

    // 답변 토큰은 한 번에 받고, 실제 문맥/의도/Skill 계획 단계만 먼저 표시합니다.
    public streamMode: boolean = false;
    public glossaryCache: any = null;
    public glossaryTooltip: any = null;
    public showGlossaryPanel: boolean = false;
    public selectedEvidence: any = null;
    private evidenceRequestSeq: number = 0;
    private agentStateHydrated: any = {};

    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public payload(data: any) {
        if (data && data.data) return data.data;
        return data || {};
    }

    public errorText(error: any, fallback: string = '요청 처리 중 오류가 발생했습니다.') {
        if (!error) return fallback;
        if (typeof error === 'string') return error;
        return error?.data?.message
            || error?.error?.message
            || error.message
            || (typeof error.error === 'string' ? error.error : '')
            || fallback;
    }

    private isLotQuery(value: string) {
        return /^lot\s+[a-z]\d{1,4}$/i.test(String(value || '').trim());
    }

    private normalizeLotQuery(value: string) {
        const text = String(value || '').trim().replace(/\s+/g, ' ');
        const match = text.match(/^lot\s+([a-z]\d{1,4})$/i);
        return match ? `Lot ${match[1].toUpperCase()}` : text;
    }

    public async callApi(action: string, params: any = {}, fallback: string = '요청 처리 중 오류가 발생했습니다.') {
        try {
            const result = await wiz.call(action, params);
            if (Number(result.code) === 200) return this.payload(result.data);
            const errorPayload = this.payload(result.data);
            const apiError = errorPayload?.error || result?.data?.error || {};
            const traceId = apiError.traceId || errorPayload?.traceId || result?.data?.traceId || '';
            const message = apiError.message || errorPayload?.message || result?.data?.message || result.message || fallback;
            throw new Error(traceId ? `${message} (추적 ID: ${traceId})` : message);
        } catch (error: any) {
            throw new Error(this.errorText(error, fallback));
        }
    }

    public currentSectionError() {
        return this.sectionErrors[this.section] || '';
    }

    public async retryCurrentSection() {
        if (this.overviewLoading || this.sectionLoading[this.section]) return;
        this.sectionErrors[this.section] = '';
        if (this.section === 'chat') {
            await Promise.all([
                this.load(),
                this.loadSection('chat', true)
            ]);
            return;
        }
        await this.loadSection(this.section, true);
    }

    private observeFloatingChat() {
        if (typeof MutationObserver === 'undefined' || !document?.body) return;
        this.floatingChatObserver = new MutationObserver(() => this.applyFloatingChatSuppression(this.section === 'chat'));
        this.floatingChatObserver.observe(document.body, { childList: true, subtree: true });
    }

    private syncFloatingChatVisibility() {
        this.setFloatingChatSuppressed(this.section === 'chat');
    }

    private setFloatingChatSuppressed(suppressed: boolean) {
        if (typeof document === 'undefined') return;
        document.documentElement.classList.toggle('agent-chat-active', suppressed);
        this.applyFloatingChatSuppression(suppressed);
        if (typeof window !== 'undefined' && typeof CustomEvent !== 'undefined') {
            window.dispatchEvent(new CustomEvent('nanofab-floating-chat-visibility', {
                detail: { hidden: suppressed, source: 'agent-chat' }
            }));
        }
    }

    private applyFloatingChatSuppression(suppressed: boolean) {
        if (typeof document === 'undefined') return;
        document.querySelectorAll('.nf-floating-chat').forEach((element: Element) => {
            element.classList.toggle('is-agent-chat-suppressed', suppressed);
            if (suppressed) element.setAttribute('aria-hidden', 'true');
            else if (element.classList.contains('nf-floating-chat')) element.removeAttribute('aria-hidden');
        });
    }

    public async ngOnInit() {
        const requestedSection = WizRoute.segment.section || 'chat';
        this.section = this.normalizeSection(requestedSection);
        this.primeInitialView();
        await this.service.init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        this.loadHistoryPanelPrefs();
        this.observeFloatingChat();
        this.syncFloatingChatVisibility();
        if (!WizRoute.segment.section || requestedSection !== this.section) {
            this.service.href('/agent/chat');
        }
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                const requested = WizRoute.segment.section || 'chat';
                const newSection = this.normalizeSection(requested);
                if (requested !== newSection) {
                    this.service.href(`/agent/${newSection}`);
                    return;
                }
                if (newSection !== this.section) {
                    this.section = newSection;
                    this.syncFloatingChatVisibility();
                    if (newSection === 'analysis') this.agentStateHydrated.analysis = false;
                    await this.loadSection(this.section, newSection === 'analysis');
                    await this.service.render();
                } else if (newSection === 'analysis') {
                    this.agentStateHydrated.analysis = false;
                    await this.loadSection('analysis', true);
                    await this.service.render();
                } else if (newSection === 'admin') {
                    this.agentStateHydrated.admin = false;
                    await this.loadSection('admin');
                } else {
                    this.syncFloatingChatVisibility();
                }
            }
        });
        await Promise.all([
            this.load(),
            this.loadSection(this.section)
        ]);
        await this.consumeDashboardQuestion();
    }

    private async consumeDashboardQuestion() {
        if (this.section !== 'chat' || typeof sessionStorage === 'undefined') return;
        let question = '';
        try {
            question = String(sessionStorage.getItem(this.dashboardQuestionKey) || '').trim().slice(0, 2000);
            if (question) sessionStorage.removeItem(this.dashboardQuestionKey);
        } catch (_error) {
            return;
        }
        if (!question || this.asking) return;
        this.input = question;
        await this.ask();
    }

    public ngOnDestroy() {
        if (this.activeAskController) this.activeAskController.abort();
        this.explorerRequestSeq += 1;
        this.explorerDetailSeq += 1;
        this.historyRequestSeq += 1;
        this.historySaveSeq += 1;
        if (this.historySaveTimer) clearTimeout(this.historySaveTimer);
        this.stopAskTimer();
        this.endHistoryResize();
        if (this.floatingChatObserver) this.floatingChatObserver.disconnect();
        this.setFloatingChatSuppressed(false);
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private primeInitialView() {
        this.stats = this.defaultStats();
        this.requirements = this.defaultRequirements();
        this.tools = this.defaultTools();
        this.workflows = this.defaultWorkflows();
        this.suggestions = this.defaultSuggestions();
        this.metrics = this.defaultMetrics();
        this.capabilityModules = this.defaultCapabilityModules();
        this.modelServing = this.defaultModelServing();
        this.processPreview = this.defaultProcessPreview();
        this.chartPreview = this.defaultChartPreview();
        if (!this.messages.length) {
            this.messages = [this.initialAssistantMessage()];
        }
        this.loadHistory();
    }

    private initialAssistantMessage() {
        return {
            role: 'assistant',
            content: '반도체 공정 데이터 검색, AI 모델 분석, Trace 비교, 참고 문서 확인을 한 화면에서 이어서 볼 수 있습니다.\n\n질문과 첨부 데이터의 형식·구조를 사전 확인한 뒤 이해한 의도를 먼저 보여드리며, 확인 후에만 Agent를 실행합니다.',
            intro: true
        };
    }

    public async load() {
        if (this.overviewLoading) return;
        this.overviewLoading = true;
        await this.service.render();

        try {
            const result = await this.callApi('overview', {}, 'Agent 개요를 불러오지 못했습니다.');
            this.stats = this.normalizeStats(result.stats || []);
            this.requirements = this.normalizeRequirements(result.requirements || []);
            this.tools = this.normalizeTools(result.tools || []);
            this.workflows = this.normalizeWorkflows(result.workflows || []);
            this.suggestions = (result.suggestions || []).length ? result.suggestions : this.defaultSuggestions();
            this.metrics = (result.metrics || []).length ? result.metrics : this.defaultMetrics();
            this.capabilityModules = (result.capabilities || []).length ? result.capabilities : this.defaultCapabilityModules();
            this.modelServing = result.modelServing || this.defaultModelServing();
            this.functionalMapData = result.functionalMap || this.functionalMapData;
            this.processPreview = (result.processPreview || []).length ? result.processPreview : this.defaultProcessPreview();
            this.chartPreview = result.chartPreview || this.defaultChartPreview();
            if (!this.messages.length) this.messages = [this.initialAssistantMessage()];
        } catch (error: any) {
            this.sectionErrors.chat = this.errorText(error, 'Agent 개요를 불러오지 못했습니다.');
        } finally {
            this.overviewLoading = false;
            await this.service.render();
        }
    }

    public defaultStats() {
        return [
            { label: 'Requirements', value: 29, change: 100, tone: 'blue' },
            { label: 'MCP Tools', value: 12, change: 60, tone: 'emerald' },
            { label: 'Workflows', value: 8, change: 50, tone: 'amber' },
            { label: '기능군', value: 25, change: 100, tone: 'rose' }
        ];
    }

    public normalizeStats(stats: any[]) {
        if (!stats.length) return this.defaultStats();
        const capability = stats.find((item: any) => item.label === '기능군');
        if (!capability || Number(capability.value || 0) < 25) return this.defaultStats();
        return stats;
    }

    public defaultRequirements() {
        return [
            { code: 'SFR-001', title: '자연어 채팅 인터페이스', status: 'implemented', owner: 'UI' },
            { code: 'SFR-003', title: 'RAG 기반 문서 검색', status: 'mock', owner: 'Data' },
            { code: 'SFR-005', title: 'MCP 서버 및 도구 레지스트리', status: 'contract', owner: 'Backend' },
            { code: 'SFR-006', title: '공정 데이터 검색 도구', status: 'mock', owner: 'Data' },
            { code: 'SFR-007', title: 'AI 모델 서비스 호출', status: 'mock', owner: 'AI' },
            { code: 'SFR-008', title: '시각화/차트 자동 생성', status: 'contract', owner: 'UI' },
            { code: 'SFR-010', title: '온프레미스 LLM 서빙', status: 'blocked', owner: 'Infra' },
            { code: 'SFR-011', title: '워크플로 템플릿 관리', status: 'implemented', owner: 'Backend' },
            { code: 'SFR-012', title: '공정 이력 추적', status: 'mock', owner: 'Data' },
            { code: 'SFR-014', title: 'RCA 원인 분석', status: 'mock', owner: 'AI' },
            { code: 'SFR-015', title: '가상계측 예측', status: 'mock', owner: 'AI' },
            { code: 'SFR-017', title: 'Trace 파형 비교', status: 'mock', owner: 'AI' },
            { code: 'SFR-018', title: '파라미터 최적화/SPC', status: 'mock', owner: 'AI' },
            { code: 'SFR-019', title: '보고서 자동 생성', status: 'contract', owner: 'Backend' }
        ];
    }

    public normalizeRequirements(requirements: any[]) {
        return requirements.length >= 10 ? requirements : this.defaultRequirements();
    }

    public defaultTools() {
        return [
            { name: 'process.search', label: '공정 데이터 검색', status: 'ready', latency: '0.42s', success: 98, permission: 'researcher' },
            { name: 'rag.search', label: '근거 문서 검색', status: 'ready', latency: '0.31s', success: 96, permission: 'researcher' },
            { name: 'model.predict', label: 'AI 모델 호출', status: 'ready', latency: '0.88s', success: 94, permission: 'researcher' },
            { name: 'chart.render', label: '시각화 생성', status: 'ready', latency: '0.21s', success: 99, permission: 'researcher' },
            { name: 'trace.compare', label: 'Trace 분석', status: 'ready', latency: '0.64s', success: 91, permission: 'engineer' },
            { name: 'optimize.recommend', label: '조건 최적화', status: 'ready', latency: '0.55s', success: 92, permission: 'researcher' },
            { name: 'report.compose', label: '보고서 초안 생성', status: 'draft_only', latency: '0.39s', success: 90, permission: 'researcher' },
            { name: 'quality.validate', label: '품질 검증', status: 'ready', latency: '0.18s', success: 97, permission: 'researcher' },
            { name: 'ingestion.monitor', label: '수집 모니터링', status: 'ready', latency: '0.22s', success: 95, permission: 'operator' },
            { name: 'access.audit', label: '감사 기록', status: 'ready', latency: '0.16s', success: 99, permission: 'admin' },
            { name: 'operations.metrics', label: '운영 지표', status: 'ready', latency: '0.24s', success: 98, permission: 'operator' },
            { name: 'demo.run', label: '시나리오 데모', status: 'mock', latency: '0.33s', success: 94, permission: 'guest' }
        ];
    }

    public normalizeTools(tools: any[]) {
        const hasQuality = tools.some((item: any) => item.name === 'quality.validate');
        return hasQuality && tools.length >= 12 ? tools : this.defaultTools();
    }

    public defaultWorkflows() {
        return [
            { title: '공정 데이터 탐색', steps: ['Intent 분석', '공정 검색', '요약 통계', '차트 생성', 'Citation 표시'] },
            { title: '공정 이상 진단', steps: ['이상탐지', '유사 사례 검색', 'RCA', '대응 방안', '보고서 초안'] },
            { title: '최적 조건 탐색', steps: ['유사 실험 검색', '민감도 분석', '예측 모델', '추천', '근거 정리'] },
            { title: '기술 문서 조사', steps: ['RAG 검색', 'Re-rank', '요약', '동향 분석', '출처 정리'] },
            { title: 'Trace 파형 비교', steps: ['기준 파형 정렬', 'DTW 유사도', '편차 구간', '원인 후보'] },
            { title: '보고서 자동 생성', steps: ['대화 선택', '템플릿 적용', '차트 삽입', '공유 링크'] },
            { title: '데이터 수집/품질 점검', steps: ['수집 모니터링', '스키마 검증', '품질 지표', '재처리'] },
            { title: '데모/검증 실행', steps: ['시나리오 선택', '도구 실행', '채점', '결과서'] }
        ];
    }

    public normalizeWorkflows(workflows: any[]) {
        return workflows.length >= 8 ? workflows : this.defaultWorkflows();
    }

    public defaultSuggestions() {
        return [
            'Lot A13 CMP 공정의 센서 이상과 계측 편차 원인을 RCA 관점으로 분석해줘',
            'Lot A13 수율 하락 원인을 trace와 recipe 기준으로 비교해줘',
            '목표 두께 120nm에 가까운 Recipe 조건을 추천해줘',
            '지난달 이온주입 공정 중 균일도 95% 미만인 실험을 보여줘',
            '이번 주 식각 공정 이상 현황을 표, 차트, 근거 포함 보고서로 만들어줘',
            '5개 필수 Agent 시나리오를 실행하고 요구사항별 증거를 묶어 검수 결과로 정리해줘',
            '공정/장비/센서/계측 더미 데이터 구축 현황을 요약해줘'
        ];
    }

    public defaultMetrics() {
        return [
            { label: 'tool accuracy', value: '90%+' },
            { label: 'unit score', value: '90점+' },
            { label: 'long run', value: 'progress' },
            { label: 'deploy', value: 'no restart' }
        ];
    }

    public defaultCapabilityModules() {
        return [
            { fn: 'FN-20260430-0005', title: 'LLM Serving', module: 'serving', status: 'implemented', surface: 'Ollama model catalog + non-streaming infer' },
            { fn: 'FN-20260430-0006', title: 'RAG Pipeline', module: 'rag', status: 'mock', surface: 'hybrid search + prompt policy' },
            { fn: 'FN-20260430-0007', title: 'MCP Tools', module: 'mcp', status: 'contract', surface: 'registry + call logs' },
            { fn: 'FN-20260430-0008', title: 'Workflow', module: 'workflow', status: 'contract', surface: 'templates + run history' },
            { fn: 'FN-20260430-0009', title: 'Process Search', module: 'process', status: 'mock', surface: 'filters + stats + trace' },
            { fn: 'FN-20260430-0010', title: 'AI Model Service', module: 'model_service', status: 'mock', surface: 'registry + adapters' },
            { fn: 'FN-20260430-0011', title: 'Anomaly/RCA/VM', module: 'analytics', status: 'mock', surface: 'score + RCA + VM' },
            { fn: 'FN-20260430-0012', title: 'Trace Compare', module: 'trace', status: 'mock', surface: 'overlay + deviation' },
            { fn: 'FN-20260430-0013', title: 'Optimize/SPC', module: 'optimize', status: 'mock', surface: 'recommend + control chart' },
            { fn: 'FN-20260430-0014', title: 'Visualization', module: 'visualization', status: 'contract', surface: 'chart recommendation + export contract' },
            { fn: 'FN-20260430-0015', title: 'Research Dashboard', module: 'research_env', status: 'implemented', surface: 'widget IA + agent context bridge' },
            { fn: 'FN-20260430-0016', title: 'Report Generation', module: 'report', status: 'draft_only', surface: 'templates + markdown draft' },
            { fn: 'FN-20260430-0017', title: 'Domain Data', module: 'domain_data', status: 'implemented', surface: 'instruction schema + review' },
            { fn: 'FN-20260430-0018', title: 'Ingestion Pipeline', module: 'ingestion', status: 'implemented', surface: 'sources + retry + lineage' },
            { fn: 'FN-20260430-0019', title: 'Quality Management', module: 'quality', status: 'implemented', surface: 'metrics + validation' },
            { fn: 'FN-20260430-0020', title: 'Document/OCR Data', module: 'document_ai', status: 'implemented', surface: 'parsers + privacy + approval' },
            { fn: 'FN-20260430-0021', title: 'Access/Audit', module: 'access_audit', status: 'implemented', surface: 'RBAC + audit schema' },
            { fn: 'FN-20260430-0022', title: 'Security/Backup', module: 'security_backup', status: 'implemented', surface: 'encryption + backup policy' },
            { fn: 'FN-20260430-0023', title: 'Operations Monitoring', module: 'operations', status: 'implemented', surface: 'metrics + alerts + trace' },
            { fn: 'FN-20260430-0024', title: 'Performance/A11y', module: 'performance', status: 'implemented', surface: 'targets + async + a11y' },
            { fn: 'FN-20260430-0025', title: 'Training', module: 'training', status: 'implemented', surface: 'learning mode + manuals' },
            { fn: 'FN-20260430-0026', title: 'Showcase', module: 'showcase', status: 'implemented', surface: 'demo scenarios + fallback' },
            { fn: 'FN-20260430-0027', title: 'Verification', module: 'verification', status: 'implemented', surface: 'tests + scoring + defects' },
            { fn: 'FN-20260430-0028', title: 'Deliverables', module: 'deliverables', status: 'implemented', surface: 'artifact catalog + final report' },
            { fn: 'FN-20260430-0029', title: 'MVP Selection', module: 'mvp', status: 'implemented', surface: 'scope + completion criteria' }
        ];
    }

    public defaultModelServing() {
        return { activeModel: 'nanofab-llm-8b-q4' };
    }

    public agentRuntimeLabel() {
        const model = this.modelServing?.activeModel || 'configured LLM';
        return `AI Agent · ${model}`;
    }

    public defaultProcessPreview() {
        return [
            { id: 'PR-ETCH-2401', process: 'etch', status: 'watch' },
            { id: 'PR-CMP-2402', process: 'cmp', status: 'hot' },
            { id: 'PR-ALD-2403', process: 'deposition', status: 'ok' }
        ];
    }

    public defaultChartPreview() {
        return { type: 'wafermap', title: 'Process Visualization' };
    }

    public selectAgentMode(mode: string) {
        if (this.asking || this.hasPendingIntentReview()) return;
        if (!this.agentModes.some((item: any) => item.id === mode)) return;
        if (!this.agentModeSupportsWaferMap(mode)) return;
        this.selectedAgentMode = mode;
        this.service.render();
    }

    public agentModeSupportsWaferMap(mode: string) {
        return !this.waferMapFile || ['auto', 'anomaly'].includes(mode);
    }

    public selectToolExecutionMode(mode: string) {
        if (this.asking || this.hasPendingIntentReview()) return;
        if (!this.toolExecutionModes.some((item: any) => item.id === mode)) return;
        this.selectedToolExecutionMode = mode;
        this.service.render();
    }

    public async handleToolExecutionModeKeydown(event: KeyboardEvent, currentMode: string) {
        const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        const modes = this.toolExecutionModes.map((item: any) => item.id);
        const selectedMode = String(this.selectedToolExecutionMode || currentMode);
        const currentIndex = Math.max(0, modes.indexOf(selectedMode));
        let nextIndex = currentIndex;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = modes.length - 1;
        if (['ArrowLeft', 'ArrowUp'].includes(event.key)) nextIndex = (currentIndex - 1 + modes.length) % modes.length;
        if (['ArrowRight', 'ArrowDown'].includes(event.key)) nextIndex = (currentIndex + 1) % modes.length;
        const nextMode = modes[nextIndex];
        this.selectToolExecutionMode(nextMode);
        await this.service.render();
        if (typeof document === 'undefined') return;
        await new Promise<void>((resolve) => {
            requestAnimationFrame(() => {
                const target = document.querySelector(
                    `[data-tool-execution-mode="${nextMode}"]`
                ) as HTMLElement | null;
                target?.focus();
                resolve();
            });
        });
    }

    public toolExecutionModeClass(mode: string) {
        return `is-${mode}${this.selectedToolExecutionMode === mode ? ' is-selected' : ''}`;
    }

    public toolExecutionModeLabel(mode: string) {
        const normalized = String(mode || '').toLowerCase();
        if (normalized === 'sequential') return '순차 실행';
        if (normalized === 'parallel') return '병렬 실행';
        return '자동 결정';
    }

    public toolExecutionModeSourceLabel(message: any) {
        const requested = String(
            message?.intentReview?.requestedToolExecutionMode || 'auto'
        ).toLowerCase();
        const resolved = String(
            message?.intentReview?.toolExecutionMode || ''
        ).toLowerCase();
        if (requested === 'parallel' && resolved === 'sequential') {
            return '병렬 요청 · 병렬화 가능한 Wave가 없어 순차 확정';
        }
        if (requested === 'parallel') return '사용자 병렬 선택으로 확정';
        if (requested === 'sequential') return '사용자 순차 선택으로 확정';
        return '서버 의존성 분석으로 확정';
    }

    public toolExecutionWaveSummary(message: any) {
        const review = message?.intentReview || {};
        const waves = Array.isArray(review.executionWaves) ? review.executionWaves : [];
        const skills = Array.isArray(review.skills) ? review.skills : [];
        if (!waves.length) {
            if (review.toolExecutionMode === 'parallel' && skills.length > 1) {
                return `${skills.length}개 Tool을 의존성 기준으로 병렬 배치`;
            }
            if (review.toolExecutionMode === 'sequential') {
                return `${skills.length}개 Tool을 계획 순서대로 실행`;
            }
            return '서버가 Tool 의존성을 분석해 실행 방식을 결정';
        }
        const parallelWaves = waves.filter((wave: any) => {
            const waveSkills = Array.isArray(wave)
                ? wave
                : (wave?.skills || wave?.tools || wave?.toolNames || []);
            return String(wave?.mode || wave?.executionMode || '').toLowerCase() === 'parallel'
                || waveSkills.length > 1;
        }).length;
        const parts = [`${waves.length}개 실행 Wave`];
        if (parallelWaves) parts.push(`${parallelWaves}개 병렬 Wave`);
        parts.push(`${skills.length}개 Tool`);
        return parts.join(' · ');
    }

    public async handleAgentModeKeydown(event: KeyboardEvent, currentMode: string, scope: string, message: any = null) {
        const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        const modes = this.agentModes
            .map((item: any) => item.id)
            .filter((mode: string) => this.agentModeSupportsWaferMap(mode));
        const selectedMode = scope === 'intent-review'
            ? String(message?.intentReview?.correctionAgentMode || currentMode)
            : String(this.selectedAgentMode || currentMode);
        const currentIndex = Math.max(0, modes.indexOf(selectedMode));
        let nextIndex = currentIndex;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = modes.length - 1;
        if (['ArrowLeft', 'ArrowUp'].includes(event.key)) nextIndex = (currentIndex - 1 + modes.length) % modes.length;
        if (['ArrowRight', 'ArrowDown'].includes(event.key)) nextIndex = (currentIndex + 1) % modes.length;
        const nextMode = modes[nextIndex];
        if (scope === 'intent-review') await this.selectIntentCorrection(message, nextMode);
        else this.selectAgentMode(nextMode);
        await this.focusAgentMode(scope, nextMode);
    }

    private async focusAgentMode(scope: string, mode: string) {
        await this.service.render();
        if (typeof document === 'undefined') return;
        await new Promise<void>((resolve) => {
            requestAnimationFrame(() => {
                const target = document.querySelector(
                    `[data-agent-mode-scope="${scope}"][data-agent-mode="${mode}"]`
                ) as HTMLElement | null;
                target?.focus();
                resolve();
            });
        });
    }

    private async focusIntentReview(selector: string = '.agent-intent-review__title') {
        await this.service.render();
        if (typeof document === 'undefined') return;
        await new Promise<void>((resolve) => {
            requestAnimationFrame(() => {
                const cards = document.querySelectorAll('.agent-intent-review');
                const card = cards.item(cards.length - 1) as HTMLElement | null;
                if (card) {
                    const target = card.querySelector(selector) as HTMLElement | null;
                    (target || card).scrollIntoView({ block: 'center', behavior: 'auto' });
                    target?.focus({ preventScroll: true });
                }
                resolve();
            });
        });
    }

    public agentModeButtonClass(mode: string) {
        const tone = mode === 'virtual_metrology' ? 'is-vm' : `is-${mode}`;
        return `${tone}${this.selectedAgentMode === mode ? ' is-selected' : ''}`;
    }

    public intentCorrectionModeClass(message: any, mode: string) {
        const tone = mode === 'virtual_metrology' ? 'is-vm' : `is-${mode}`;
        return `${tone}${message?.intentReview?.correctionAgentMode === mode ? ' is-selected' : ''}`;
    }

    public agentModeLabel(mode: string) {
        return this.agentModes.find((item: any) => item.id === mode)?.label || '자동 선택';
    }

    public agentModeShortLabel(mode: string) {
        return this.agentModes.find((item: any) => item.id === mode)?.shortLabel || 'Orchestrator';
    }

    public inferredAgentMode(intent: string) {
        const normalized = String(intent || '').toLowerCase();
        if (['predict', 'optimize'].includes(normalized)) return 'virtual_metrology';
        if (['anomaly', 'compare', 'spc'].includes(normalized)) return 'anomaly';
        return 'simple';
    }

    public hasPendingIntentReview() {
        const status = String(this.pendingAgentRequest?.progressMessage?.intentReview?.status || '');
        return Boolean(this.pendingAgentRequest && ['awaiting', 'editing', 'analyzing'].includes(status));
    }

    public showIntentReview(message: any) {
        return Boolean(message?.intentReview && ['awaiting', 'editing', 'analyzing'].includes(message.intentReview.status));
    }

    public intentReviewStatusLabel(message: any) {
        const status = String(message?.intentReview?.status || 'awaiting');
        if (status === 'editing') return '수정할 Agent 선택';
        if (status === 'analyzing') return '의도 다시 분석 중';
        return '사용자 확인 대기';
    }

    public intentEntityChips(message: any) {
        const entities = message?.intentReview?.entities || {};
        const values: string[] = [];
        const append = (items: any[]) => (items || []).forEach((item: any) => {
            const value = typeof item === 'string' ? item : (item?.label || item?.value || '');
            const text = String(value || '').trim();
            if (text && values.indexOf(text) < 0) values.push(text);
        });
        append(entities.lots);
        append(entities.processes);
        append(entities.equipment);
        append(entities.parameters);
        return values.slice(0, 8);
    }

    public intentSkillLabel(skill: string) {
        const labels: any = {
            'rag.search': '문서·RAG 검색',
            'process.search': '공정 데이터 조회',
            'model.predict': 'AI 모델 예측',
            'analytics.analyze': '결과 해석·RCA',
            'trace.compare': 'Trace 비교',
            'chart.render': '시각화 생성',
            'report.compose': '보고서 구성',
            'optimize.recommend': '조건 최적화'
        };
        return labels[skill] || skill;
    }

    public intentSecondaryLabels(message: any) {
        const labels: any = {
            search: '공정 검색',
            research: '문서·RAG',
            predict: '가상 계측',
            anomaly: '이상 탐지',
            compare: 'Trace 비교',
            spc: 'SPC 분석',
            optimize: '조건 최적화',
            report: '보고서 생성',
            explain: '개념 설명'
        };
        return (message?.analysis?.secondaryIntents || [])
            .map((intent: string) => labels[intent] || intent)
            .filter(Boolean)
            .slice(0, 5);
    }

    public intentAttachmentSummary(message: any) {
        const attachment = message?.intentReview?.attachment || {};
        if (!message?.intentReview?.hasUserData) return '질문 기반 데이터 선택';
        if (attachment.validationStatus !== 'validated') return '첨부 파일 존재만 확인 · 실행 전 검증 필요';
        const parts: string[] = ['사전 검증 완료'];
        const format = String(attachment.format || attachment.extension || '').replace(/^\./, '').toUpperCase();
        if (format) parts.push(format);
        if (Array.isArray(attachment.shape) && attachment.shape.length) parts.push(attachment.shape.join('×'));
        if (Number(attachment.sizeBytes) > 0) {
            const bytes = Number(attachment.sizeBytes);
            parts.push(bytes < 1024 ? `${bytes} B` : `${Math.ceil(bytes / 1024)} KiB`);
        }
        return parts.join(' · ');
    }

    public chatJourneySteps() {
        const latest = [...(this.messages || [])].reverse().find((item: any) => item?.role !== 'user' && !item?.intro);
        const hasQuestion = (this.messages || []).some((item: any) => item?.role === 'user');
        const reviewStatus = String(latest?.intentReview?.status || '');
        const failed = latest?.role === 'error';
        const cancelled = Boolean(latest?.cancelled || latest?.answerFlow?.currentStep === 'cancelled');
        const completed = Boolean(latest && !cancelled && this.responseComplete(latest) && latest?.content);
        const current = String(latest?.answerFlow?.currentStep || '');
        const isExecuting = Boolean(latest?.processing && current === 'execute');
        const reviewReady = ['awaiting', 'editing', 'analyzing', 'confirmed'].includes(reviewStatus);
        return [
            {
                id: 'input', number: 1, label: '질문·데이터',
                status: hasQuestion ? 'done' : 'active'
            },
            {
                id: 'intent', number: 2, label: '문맥·의도 분석',
                status: (failed || cancelled) && !reviewReady ? 'failed' : reviewReady || isExecuting || completed ? 'done' : hasQuestion ? 'active' : 'waiting'
            },
            {
                id: 'review', number: 3, label: '사용자 검토',
                status: reviewStatus === 'confirmed' || isExecuting || completed ? 'done' : cancelled && reviewReady ? 'failed' : reviewReady ? 'active' : 'waiting'
            },
            {
                id: 'agents', number: 4, label: 'Multi Agent 실행',
                status: (failed || cancelled) && reviewStatus === 'confirmed' ? 'failed' : completed ? 'done' : isExecuting ? 'active' : 'waiting'
            },
            {
                id: 'answer', number: 5, label: '해석·답변',
                status: failed ? 'failed' : completed ? 'done' : latest?.processing && current === 'answer' ? 'active' : 'waiting'
            }
        ];
    }

    public journeyStepClass(status: string) {
        return `is-${status || 'waiting'}`;
    }

    public async requestIntentRevision(message: any) {
        if (this.asking || !this.showIntentReview(message)) return;
        message.intentReview.status = 'editing';
        message.intentReview.error = '';
        message.intentReview.correctionAgentMode = String(message.intentReview.requestedAgentMode || 'auto');
        message.intentReview.correctionNote = String(message.intentReview.correctionNote || '');
        await this.focusIntentReview('.agent-intent-review__feedback');
    }

    public async cancelIntentRevision(message: any) {
        if (this.asking || message?.intentReview?.status !== 'editing') return;
        const pending = this.pendingAgentRequest;
        const committedFeedback = pending?.progressMessage === message
            ? String(pending.intentFeedback || '')
            : '';
        message.intentReview.status = 'awaiting';
        message.intentReview.error = '';
        message.intentReview.correctionNote = committedFeedback;
        await this.focusIntentReview('.agent-intent-review__secondary');
    }

    public async selectIntentCorrection(message: any, mode: string) {
        if (this.asking || message?.intentReview?.status !== 'editing') return;
        if (!this.agentModes.some((item: any) => item.id === mode)) return;
        if (!this.agentModeSupportsWaferMap(mode)) return;
        message.intentReview.correctionAgentMode = mode;
        message.intentReview.error = '';
        await this.service.render();
    }

    public canReanalyzeIntent(message: any) {
        const review = message?.intentReview || {};
        const note = String(review.correctionNote || '').trim();
        const modeChanged = String(review.correctionAgentMode || '') !== String(review.requestedAgentMode || 'auto');
        return Boolean(note || modeChanged);
    }

    private buildIntentReview(
        plan: any,
        requestedAgentMode: string,
        requestedToolExecutionMode: string,
        waferMap: File | null,
        prior: any = null
    ) {
        const analysis = plan?.analysis || {};
        const attachment = plan?.attachment || analysis?.attachment || null;
        const executionContract = plan?.toolExecution
            || analysis?.toolExecution
            || plan?.executionPlan
            || analysis?.executionPlan
            || {};
        const resolvedMode = String(
            plan?.agentMode
            || analysis?.agentMode
            || (requestedAgentMode === 'auto' ? this.inferredAgentMode(plan?.intent || analysis?.intent) : requestedAgentMode)
        );
        const resolvedToolExecutionMode = String(
            plan?.resolvedToolExecutionMode
            || plan?.toolExecutionMode
            || analysis?.resolvedToolExecutionMode
            || analysis?.toolExecutionMode
            || executionContract?.resolvedMode
            || executionContract?.mode
            || requestedToolExecutionMode
            || 'auto'
        ).toLowerCase();
        const executionWaves = plan?.executionWaves
            || analysis?.executionWaves
            || executionContract?.waves
            || [];
        const skills = plan?.skillPlan || analysis?.tools || [];
        const dataSource = waferMap
            ? `사용자 첨부 데이터 · ${waferMap.name}`
            : resolvedMode === 'simple' ? '승인된 문서·도메인 지식' : '등록된 공정·모델 데이터';
        let executionMode = 'Orchestrator가 질문에 맞는 Agent를 연결';
        if (resolvedMode === 'simple') executionMode = waferMap ? '첨부 문맥 확인 후 RAG 답변' : 'RAG 검색·Instruction 응답';
        if (resolvedMode === 'virtual_metrology') executionMode = waferMap ? '첨부 데이터 검증 후 모델 추론' : '등록된 모델로 가상 계측 예측';
        if (resolvedMode === 'anomaly') executionMode = waferMap ? '첨부 데이터 검증 후 이상 분석' : '등록된 모델로 이상 점수·원인 분석';
        return {
            status: 'awaiting',
            requestedAgentMode,
            correctionAgentMode: requestedAgentMode === 'auto' ? resolvedMode : requestedAgentMode,
            agentMode: resolvedMode,
            agentModeLabel: plan?.agentModeLabel || analysis?.agentModeLabel || this.agentModeLabel(resolvedMode),
            agentModeSource: plan?.agentModeSource || analysis?.agentModeSource || (requestedAgentMode === 'auto' ? 'automatic' : 'user'),
            intent: plan?.intent || analysis?.intent || 'general',
            intentLabel: plan?.intentLabel || analysis?.intentLabel || '질문 분석',
            taskTypeLabel: plan?.taskTypeLabel || analysis?.taskTypeLabel || '질문 유형',
            understoodRequest: analysis?.resolvedQuery || analysis?.normalizedQuery || plan?.question || '',
            entities: analysis?.entities || {},
            skills,
            hasUserData: Boolean(waferMap),
            attachment,
            dataSource,
            executionMode,
            requestedToolExecutionMode,
            toolExecutionMode: ['sequential', 'parallel'].includes(resolvedToolExecutionMode)
                ? resolvedToolExecutionMode
                : 'auto',
            executionWaves: Array.isArray(executionWaves) ? executionWaves : [],
            requiresVisualization: Boolean(plan?.requiresVisualization || analysis?.requiresVisualization),
            planFallback: Boolean(plan?.planFallback),
            error: '',
            correctionNote: String(prior?.correctionNote || ''),
            revisionCount: Number(prior?.revisionCount || 0)
        };
    }

    private holdAnswerFlowForReview(answerFlow: any) {
        if (!answerFlow?.steps?.length) return answerFlow;
        return {
            ...answerFlow,
            currentStep: 'review',
            reviewStatus: 'awaiting_confirmation',
            steps: answerFlow.steps.map((step: any) => ({
                ...step,
                status: ['context', 'intent', 'skill'].includes(step.id) ? 'completed' : 'pending'
            }))
        };
    }

    private resumeAnswerFlowAfterReview(answerFlow: any) {
        if (!answerFlow?.steps?.length) return answerFlow;
        return {
            ...answerFlow,
            currentStep: 'execute',
            reviewStatus: 'confirmed',
            steps: answerFlow.steps.map((step: any) => ({
                ...step,
                status: ['context', 'intent', 'skill'].includes(step.id)
                    ? 'completed'
                    : step.id === 'execute' ? 'running' : 'pending'
            }))
        };
    }

    public capabilityClass(status: string) {
        if (status === 'implemented') return 'border-[#0ea5e9]/50 bg-[#0ea5e9]/10 text-[#0ea5e9]';
        if (status === 'contract') return 'border-[#38bdf8]/40 bg-[#38bdf8]/10 text-[#38bdf8]';
        if (status === 'mock' || status === 'draft_only') return 'border-[#f59e0b]/40 bg-[#f59e0b]/10 text-[#f59e0b]';
        if (status === 'blocked') return 'border-red-300/50 bg-red-500/10 text-red-300';
        return 'border-white/10 bg-white/5 text-[#94a3b8]';
    }

    public capabilityStatusClass(status: string) {
        if (status === 'implemented') return 'border border-green-200 bg-green-50 text-green-700';
        if (status === 'contract') return 'border border-[#8fb0d6] bg-[#e3eefb] text-[#2e6fae]';
        if (status === 'mock' || status === 'draft_only') return 'border border-[#fed7aa] bg-[#fff7ed] text-[#b45309]';
        if (status === 'blocked') return 'border border-red-200 bg-red-50 text-red-700';
        if (status === 'planned') return 'border border-[#fed7aa] bg-[#fff7ed] text-[#b45309]';
        return 'border border-[#d9e1ec] bg-[#f4f7fb] text-[#475569]';
    }

    public capabilityStatusLabel(status: string) {
        const labels: any = {
            implemented: '구현',
            contract: '계약',
            mock: 'Mock',
            draft_only: '초안',
            planned: '계획',
            blocked: '차단',
            missing: '미구현'
        };
        return labels[status] || status || '-';
    }

    public capabilityGroups() {
        const groups = [
            { title: 'AI 실행 기반', subtitle: 'LLM, RAG, MCP, Workflow, 공정 검색', start: 5, end: 14 },
            { title: '운영 데이터 거버넌스', subtitle: 'Dashboard, Report, Ingestion, 품질, 보안/운영', start: 15, end: 24 },
            { title: '전달과 검증', subtitle: 'Training, Showcase, Verification, Deliverables, MVP', start: 25, end: 29 }
        ];
        return groups.map((group: any) => {
            const items = this.capabilityModules.filter((item: any) => {
                const number = Number(String(item.fn || '').split('-').pop() || 0);
                return number >= group.start && number <= group.end;
            });
            return { ...group, items };
        });
    }

    public async selectSuggestion(text: string) {
        this.input = text;
        await this.ask();
    }

    public handleChatInputKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' || (event as any).isComposing) return;
        if (event.shiftKey) return;
        event.preventDefault();
        void this.ask();
    }

    public selectWaferMap(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input?.files?.item(0) || null;
        this.waferMapError = '';
        this.waferMapNotice = '';
        this.waferMapFile = null;
        if (!file) {
            void this.service.render();
            return;
        }

        const extension = this.waferMapExtension(file.name);
        if (!['.png', '.jpg', '.jpeg', '.npz'].includes(extension)) {
            this.waferMapError = 'PNG, JPG, JPEG 또는 NPZ 웨이퍼 맵 파일만 첨부할 수 있습니다.';
            input.value = '';
            void this.service.render();
            return;
        }
        if (file.size === 0) {
            this.waferMapError = '빈 웨이퍼 맵 파일은 첨부할 수 없습니다.';
            input.value = '';
            void this.service.render();
            return;
        }
        if (file.size > this.waferMapMaxBytes) {
            this.waferMapError = '웨이퍼 맵 파일 크기는 5MiB 이하여야 합니다.';
            input.value = '';
            void this.service.render();
            return;
        }
        this.waferMapFile = file;
        if (!this.agentModeSupportsWaferMap(this.selectedAgentMode)) {
            this.selectedAgentMode = 'auto';
            this.waferMapNotice = '웨이퍼맵은 이상 탐지 전용 데이터입니다. Agent를 자동 선택으로 변경했습니다.';
        }
        void this.service.render();
    }

    public clearWaferMap(input: HTMLInputElement | null = null) {
        this.waferMapFile = null;
        this.waferMapError = '';
        this.waferMapNotice = '';
        const target = input || (
            typeof document !== 'undefined'
                ? document.getElementById('agent-wafer-map-input') as HTMLInputElement | null
                : null
        );
        if (target) target.value = '';
        void this.service.render();
    }

    public waferMapFileSize() {
        const bytes = Number(this.waferMapFile?.size || 0);
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${Math.ceil(bytes / 1024)} KiB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MiB`;
    }

    private waferMapExtension(filename: string) {
        const normalized = String(filename || '').trim().toLowerCase();
        const index = normalized.lastIndexOf('.');
        return index >= 0 ? normalized.slice(index) : '';
    }

    public async ask() {
        const message = (this.input || '').trim();
        if (!message || this.asking || this.hasPendingIntentReview()) return;

        const waferMap = this.waferMapFile;
        const requestedAgentMode = this.selectedAgentMode;
        const requestedToolExecutionMode = this.selectedToolExecutionMode;
        this.lastQuestionHadWaferMap = Boolean(waferMap);
        const seq = ++this.askSeq;
        const controller = this.beginAskRequest();
        const context = this.conversationContext();
        const progressMessage: any = this.createAnswerProgressMessage(message);
        this.lastQuestion = message;
        this.messages.push({
            role: 'user',
            content: message,
            attachment: waferMap ? {
                kind: 'wafer_map',
                name: waferMap.name,
                size: waferMap.size
            } : null,
            agentMode: requestedAgentMode,
            toolExecutionMode: requestedToolExecutionMode
        }, progressMessage);
        this.input = '';
        this.asking = true;
        this.syncFloatingChatVisibility();
        await this.service.render();

        const plan = await this.prepareAnswerFlow(
            message,
            context,
            progressMessage,
            seq,
            controller,
            waferMap,
            requestedAgentMode,
            requestedToolExecutionMode
        );
        if (seq !== this.askSeq || controller.signal.aborted) return;
        if (!plan) {
            const planError = progressMessage.planBlockingError || {
                code: 'INTENT_PLAN_UNAVAILABLE',
                message: '의도 분석을 완료하지 못해 Agent를 실행하지 않았습니다.'
            };
            this.failAnswerFlow(progressMessage, planError.message);
            Object.assign(progressMessage, {
                role: 'error',
                content: planError.message,
                question: message,
                retryable: true,
                processing: false
            });
            this.finishAskRequest(seq, controller);
            await this.service.render();
            return;
        }
        const reviewPlan = plan;
        progressMessage.answerFlow = this.holdAnswerFlowForReview(
            reviewPlan.answerFlow || progressMessage.answerFlow
        );
        progressMessage.processing = false;
        progressMessage.intentReview = this.buildIntentReview(
            reviewPlan,
            requestedAgentMode,
            requestedToolExecutionMode,
            waferMap
        );
        this.pendingAgentRequest = {
            message,
            context,
            progressMessage,
            waferMap,
            requestedAgentMode,
            reviewedAgentMode: progressMessage.intentReview.agentMode,
            requestedToolExecutionMode,
            reviewedToolExecutionMode: progressMessage.intentReview.toolExecutionMode,
            intentFeedback: ''
        };
        this.finishAskRequest(seq, controller);
        await this.focusIntentReview();
    }

    public async confirmIntent(message: any) {
        const pending = this.pendingAgentRequest;
        if (
            this.asking
            || !pending
            || pending.progressMessage !== message
            || message?.intentReview?.status !== 'awaiting'
        ) return;

        message.intentReview.status = 'confirmed';
        message.intentReview.confirmedAt = new Date().toISOString();
        message.answerFlow = this.resumeAnswerFlowAfterReview(message.answerFlow);
        message.processing = true;
        const seq = ++this.askSeq;
        const controller = this.beginAskRequest();
        const confirmedAgentMode = String(message.intentReview.agentMode || pending.reviewedAgentMode || pending.requestedAgentMode || 'auto');
        const confirmedToolExecutionMode = String(
            message.intentReview.toolExecutionMode
            || pending.reviewedToolExecutionMode
            || pending.requestedToolExecutionMode
            || 'auto'
        );
        const confirmedReview = {
            intent: message.intentReview.intent,
            intentLabel: message.intentReview.intentLabel,
            agentMode: confirmedAgentMode,
            agentModeLabel: message.intentReview.agentModeLabel,
            toolExecutionMode: confirmedToolExecutionMode,
            resolvedQuery: message.intentReview.understoodRequest,
            secondaryIntents: (message.analysis?.secondaryIntents || []).slice(0, 10),
            skills: (message.intentReview.skills || []).slice(0, 20),
            revisionCount: Number(message.intentReview.revisionCount || 0),
            feedback: String(pending.intentFeedback || '').trim()
        };
        this.asking = true;
        this.pendingAgentRequest = null;
        this.syncFloatingChatVisibility();
        await this.service.render();
        await this.askNormal(
            pending.message,
            seq,
            controller,
            message,
            pending.context,
            pending.waferMap,
            confirmedAgentMode,
            String(pending.requestedToolExecutionMode || 'auto'),
            confirmedReview
        );
    }

    public async reanalyzeIntent(message: any) {
        const pending = this.pendingAgentRequest;
        if (
            this.asking
            || !pending
            || pending.progressMessage !== message
            || message?.intentReview?.status !== 'editing'
        ) return;
        const requestedAgentMode = String(message.intentReview.correctionAgentMode || 'auto');
        const intentFeedback = String(message.intentReview.correctionNote || '').trim().slice(0, 1000);
        if (!this.agentModes.some((item: any) => item.id === requestedAgentMode)) return;
        if (!this.canReanalyzeIntent(message)) return;

        const priorReview = { ...message.intentReview };
        const seq = ++this.askSeq;
        const controller = this.beginAskRequest();
        this.asking = true;
        message.processing = true;
        message.intentReview.status = 'analyzing';
        message.intentReview.error = '';
        message.planBlockingError = null;
        await this.service.render();

        const plan = await this.prepareAnswerFlow(
            pending.message,
            pending.context,
            message,
            seq,
            controller,
            pending.waferMap,
            requestedAgentMode,
            pending.requestedToolExecutionMode,
            intentFeedback
        );
        if (seq !== this.askSeq || controller.signal.aborted) return;
        message.processing = false;
        if (!plan) {
            message.intentReview = {
                ...priorReview,
                status: 'editing',
                correctionAgentMode: requestedAgentMode,
                error: message?.planBlockingError?.message
                    || message?.planFallback?.reason
                    || '의도를 다시 분석하지 못했습니다. 잠시 후 재시도해 주세요.'
            };
            message.answerFlow = this.holdAnswerFlowForReview(message.answerFlow);
            this.finishAskRequest(seq, controller);
            await this.focusIntentReview('.agent-intent-review__feedback');
            return;
        }

        message.answerFlow = this.holdAnswerFlowForReview(plan.answerFlow || message.answerFlow);
        message.intent = plan.intent;
        message.analysis = plan.analysis;
        message.intentReview = {
            ...this.buildIntentReview(
                plan,
                requestedAgentMode,
                pending.requestedToolExecutionMode,
                pending.waferMap,
                priorReview
            ),
            revisionCount: Number(priorReview.revisionCount || 0) + 1
        };
        pending.requestedAgentMode = requestedAgentMode;
        pending.reviewedAgentMode = message.intentReview.agentMode;
        pending.reviewedToolExecutionMode = message.intentReview.toolExecutionMode;
        pending.intentFeedback = intentFeedback;
        this.selectedAgentMode = requestedAgentMode;
        this.finishAskRequest(seq, controller);
        await this.focusIntentReview();
    }

    private conversationContext() {
        const candidates = (this.messages || [])
            .filter((item: any) => ['user', 'assistant'].includes(item?.role) && !item?.processing && !item?.streaming)
            .map((item: any) => ({
                role: item.role,
                content: String(item.content || '').replace(/\s+/g, ' ').trim().slice(0, 1200)
            }))
            .filter((item: any) => Boolean(item.content))
            .slice(-8);
        const messages: any[] = [];
        let remaining = 6000;
        for (let index = candidates.length - 1; index >= 0 && remaining > 0; index--) {
            const item = candidates[index];
            const content = item.content.slice(0, remaining);
            if (!content) continue;
            messages.unshift({ ...item, content });
            remaining -= content.length;
        }
        return { messages };
    }

    private createAnswerProgressMessage(question: string) {
        return {
            role: 'assistant',
            content: '',
            question,
            processing: true,
            answerFlow: {
                version: 'answer-flow-v1',
                currentStep: 'context',
                steps: [
                    { id: 'context', order: 1, label: '문맥 파악', status: 'running', detail: '최근 대화와 현재 질문의 분석 범위를 확인하고 있습니다.' },
                    { id: 'intent', order: 2, label: '의도 분류', status: 'pending', detail: '단순 질문·예측·분석·비교 중 질문 유형을 판별합니다.' },
                    { id: 'skill', order: 3, label: 'Skill 선택', status: 'pending', detail: '질문에 필요한 데이터·모델·분석 Skill만 선택합니다.' },
                    { id: 'execute', order: 4, label: '답변 전략 실행', status: 'pending', detail: '모델, 일반 반도체 지식, 시각화 필요 여부에 맞춰 실행합니다.' },
                    { id: 'answer', order: 5, label: '최종 답변 요약', status: 'pending', detail: '확인된 근거와 결과를 질문에 맞는 형식으로 요약합니다.' }
                ]
            }
        };
    }

    private async prepareAnswerFlow(
        message: string,
        context: any,
        progressMessage: any,
        seq: number,
        controller: AbortController,
        waferMap: File | null = null,
        requestedAgentMode: string = 'auto',
        requestedToolExecutionMode: string = 'auto',
        intentFeedback: string = ''
    ) {
        try {
            const formData = new FormData();
            formData.append('message', message);
            formData.append('context', JSON.stringify(context || { messages: [] }));
            if (waferMap) formData.append('wafer_map', waferMap, waferMap.name);
            formData.append('agent_mode', requestedAgentMode || 'auto');
            formData.append('tool_execution_mode', requestedToolExecutionMode || 'auto');
            if (intentFeedback) formData.append('intent_feedback', intentFeedback);
            const response = await fetch(wiz.url('plan_answer'), {
                method: 'POST',
                body: formData,
                signal: controller.signal
            });
            let envelope: any = null;
            try {
                envelope = await response.json();
            } catch (_error) {
                const parseError: any = new Error(
                    response.ok
                        ? '사전 분석 응답을 해석하지 못했습니다.'
                        : `첨부 데이터 사전 검증에 실패했습니다. (${response.status})`
                );
                parseError.blocking = response.status >= 400 && response.status < 500;
                throw parseError;
            }
            if (!response.ok || Number(envelope?.code) !== 200) {
                const requestError: any = new Error(
                    envelope?.data?.message || envelope?.message || '답변 계획을 만들지 못했습니다.'
                );
                requestError.code = envelope?.data?.error?.code || envelope?.data?.code || '';
                requestError.blocking = [400, 401, 403, 409, 413, 415, 422].includes(response.status);
                throw requestError;
            }
            if (seq !== this.askSeq || controller.signal.aborted || !progressMessage?.processing) return;
            const plan = this.payload(envelope.data);
            progressMessage.intent = plan.intent;
            progressMessage.analysis = plan.analysis;
            await this.revealPreparedAnswerFlow(progressMessage, plan.answerFlow, seq, controller);
            return plan;
        } catch (error: any) {
            if (this.isAbortError(error) || seq !== this.askSeq || !progressMessage?.processing) return;
            if (error?.blocking) {
                progressMessage.planBlockingError = {
                    code: String(error.code || 'INTENT_PREFLIGHT_FAILED'),
                    message: this.errorText(error, '첨부 데이터와 Agent 경로를 확인해 주세요.')
                };
                return null;
            }
            const failureReason = this.errorText(error, '사전 의도 분석 요청에 실패했습니다.');
            progressMessage.planBlockingError = {
                code: 'INTENT_PLAN_UNAVAILABLE',
                message: `의도 분석을 완료하지 못해 Agent를 실행하지 않았습니다. ${failureReason}`
            };
            console.warn('[AI Agent] plan_answer blocked before review:', failureReason);
            await this.service.render();
            return null;
        }
    }

    private fallbackPreparedAnswerFlow(answerFlow: any) {
        const details: any = {
            context: '최근 대화와 현재 질문에서 답변 범위를 순서대로 확인합니다.',
            intent: '확인한 문맥을 기준으로 단순·예측·분석·비교 질문을 분류합니다.',
            skill: '분류된 의도에 맞춰 필요한 데이터·모델·분석 Skill을 선택합니다.',
            execute: '선택한 답변 전략과 Skill을 실행하고 있습니다.',
            answer: '실행 결과를 질문에 맞는 최종 답변으로 요약합니다.'
        };
        return {
            ...(answerFlow || {}),
            mode: 'sequential-fallback',
            currentStep: 'execute',
            steps: (answerFlow?.steps || []).map((step: any) => ({
                ...step,
                status: ['context', 'intent', 'skill'].includes(step.id)
                    ? 'completed'
                    : step.id === 'execute' ? 'running' : 'pending',
                detail: details[step.id] || step.detail
            }))
        };
    }

    private async revealPreparedAnswerFlow(progressMessage: any, preparedFlow: any, seq: number, controller: AbortController) {
        const preparedSteps = preparedFlow?.steps || [];
        if (!preparedSteps.length) return;
        const stages = ['context', 'intent', 'skill'];
        for (let index = 0; index < stages.length; index++) {
            if (seq !== this.askSeq || controller.signal.aborted || !progressMessage?.processing) return;
            const activeId = stages[index];
            const visibleSteps = preparedSteps.map((step: any) => {
                if (stages.indexOf(step.id) < index) return { ...step, status: 'completed' };
                if (step.id === activeId) return { ...step, status: index === 0 ? 'completed' : 'running' };
                return { ...step, status: 'pending' };
            });
            if (index > 0) {
                const previous = visibleSteps.find((step: any) => step.id === stages[index - 1]);
                if (previous) previous.status = 'completed';
            }
            progressMessage.answerFlow = { ...preparedFlow, currentStep: activeId, steps: visibleSteps };
            await this.service.render();
            await this.progressPause(index < stages.length - 1 ? 280 : 220, controller);
        }
        if (seq !== this.askSeq || controller.signal.aborted || !progressMessage?.processing) return;
        progressMessage.answerFlow = preparedFlow;
        await this.service.render();
    }

    private progressPause(milliseconds: number, controller: AbortController) {
        return new Promise<void>((resolve) => {
            if (controller.signal.aborted) return resolve();
            const finish = () => {
                clearTimeout(timer);
                controller.signal.removeEventListener('abort', finish);
                resolve();
            };
            const timer = setTimeout(finish, milliseconds);
            controller.signal.addEventListener('abort', finish, { once: true });
        });
    }

    private beginAskRequest() {
        if (this.activeAskController) this.activeAskController.abort();
        this.activeAskController = new AbortController();
        this.activeAskStartedAt = this.nowMs();
        this.askElapsedSeconds = 0;
        this.stopAskTimer();
        this.askElapsedTimer = setInterval(() => {
            if (!this.asking) return;
            this.askElapsedSeconds = Math.max(0, Math.floor((this.nowMs() - this.activeAskStartedAt) / 1000));
            void this.service.render();
        }, 1000);
        return this.activeAskController;
    }

    private nowMs() {
        return typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
    }

    private activeAskElapsedMs() {
        return Math.max(0, Math.round(this.nowMs() - this.activeAskStartedAt));
    }

    private stopAskTimer() {
        if (this.askElapsedTimer) clearInterval(this.askElapsedTimer);
        this.askElapsedTimer = null;
    }

    private finishAskRequest(seq: number, controller: AbortController) {
        if (seq !== this.askSeq || this.activeAskController !== controller) return;
        this.stopAskTimer();
        this.activeAskController = null;
        this.asking = false;
    }

    private isAbortError(error: any) {
        return error?.name === 'AbortError' || String(error?.message || error || '').toLowerCase().indexOf('aborted') >= 0;
    }

    private async askNormal(
        message: string,
        seq: number,
        controller: AbortController,
        progressMessage: any,
        context: any,
        waferMap: File | null = null,
        requestedAgentMode: string = 'auto',
        requestedToolExecutionMode: string = 'auto',
        confirmedReview: any = null
    ) {
        try {
            const formData = new FormData();
            formData.append('message', message);
            formData.append('context', JSON.stringify(context || { messages: [] }));
            formData.append('agent_mode', requestedAgentMode || 'auto');
            formData.append('tool_execution_mode', requestedToolExecutionMode || 'auto');
            if (confirmedReview) formData.append('confirmed_review', JSON.stringify(confirmedReview));
            if (confirmedReview?.feedback) formData.append('intent_feedback', confirmedReview.feedback);
            if (waferMap) formData.append('wafer_map', waferMap, waferMap.name);
            const request = fetch(wiz.url('ask'), {
                method: 'POST',
                body: formData,
                signal: controller.signal
            }).then(
                (response: Response) => ({ response, error: null }),
                (error: any) => ({ response: null, error })
            );
            if (progressMessage?.answerFlow?.mode === 'sequential-fallback') {
                const fallbackFlow = this.fallbackPreparedAnswerFlow(progressMessage.answerFlow);
                await this.revealPreparedAnswerFlow(progressMessage, fallbackFlow, seq, controller);
                if (seq !== this.askSeq || controller.signal.aborted) return;
            }
            const outcome = await request;
            if (outcome.error) throw outcome.error;
            const response: Response = outcome.response as Response;
            let envelope: any = null;
            try {
                envelope = await response.json();
            } catch (error) {
                throw new Error('서버 응답을 해석하지 못했습니다. 잠시 후 다시 시도해 주세요.');
            }
            if (!response.ok || Number(envelope?.code) !== 200) {
                throw new Error(envelope?.data?.message || envelope?.message || `질의를 처리하지 못했습니다. (${response.status})`);
            }
            const result = this.payload(envelope.data);
            if (seq !== this.askSeq) return;
            result.answerFlow = result.answerFlow || this.completeFallbackAnswerFlow(progressMessage.answerFlow);
            await this.revealFinalAnswerStage(progressMessage, result.answerFlow, seq, controller);
            if (seq !== this.askSeq || controller.signal.aborted) return;
            const completedMessage = this.assistantMessageFromMeta(
                result,
                result.answer || '답변을 생성하지 못했습니다.',
                message,
                this.activeAskElapsedMs()
            );
            Object.assign(progressMessage, completedMessage, { processing: false });
            if (waferMap) this.clearWaferMap();
            await this.saveHistory(message);
        } catch (error: any) {
            if (seq === this.askSeq && !this.isAbortError(error)) {
                this.failAnswerFlow(progressMessage, '답변 요청을 완료하지 못했습니다. 질문을 확인한 뒤 다시 시도해 주세요.');
                Object.assign(progressMessage, {
                    role: 'error',
                    content: this.errorText(error, '질의를 처리하지 못했습니다. 입력값을 확인해주세요.'),
                    question: message,
                    retryable: true,
                    processing: false
                });
            }
        } finally {
            this.finishAskRequest(seq, controller);
            await this.service.render();
        }
    }

    private async revealFinalAnswerStage(progressMessage: any, finalFlow: any, seq: number, controller: AbortController) {
        if (seq !== this.askSeq || controller.signal.aborted || !progressMessage?.processing) return;
        const steps = (finalFlow?.steps?.length ? finalFlow.steps : progressMessage.answerFlow?.steps || []).map((step: any) => {
            if (step.id === 'answer') {
                return { ...step, status: 'running', detail: '완성된 근거와 결과를 읽기 쉬운 최종 답변으로 정리하고 있습니다.' };
            }
            if (step.id === 'execute' && ['running', 'pending'].includes(step.status)) {
                return { ...step, status: 'completed' };
            }
            return step;
        });
        if (!steps.length) return;
        progressMessage.answerFlow = { ...(finalFlow || progressMessage.answerFlow), currentStep: 'answer', steps };
        await this.service.render();
        await this.progressPause(140, controller);
    }

    private failAnswerFlow(progressMessage: any, detail: string) {
        const currentStep = progressMessage?.answerFlow?.currentStep;
        const steps = (progressMessage?.answerFlow?.steps || []).map((step: any) => {
            if (step.id === currentStep || step.status === 'running') {
                return { ...step, status: 'failed', detail };
            }
            if (step.status === 'pending') return { ...step, status: 'skipped' };
            return step;
        });
        if (steps.length) {
            progressMessage.answerFlow = { ...progressMessage.answerFlow, currentStep: 'failed', steps };
        }
    }

    private completeFallbackAnswerFlow(answerFlow: any) {
        if (!answerFlow?.steps?.length) return null;
        return {
            ...answerFlow,
            mode: answerFlow.mode || 'sequential-fallback',
            currentStep: 'answer',
            steps: answerFlow.steps.map((step: any) => ({
                ...step,
                status: ['failed', 'cancelled', 'skipped'].includes(step.status) ? step.status : 'completed'
            }))
        };
    }

    private assistantMessageFromMeta(meta: any, content: string = '', question: string = '', clientLatencyMs: number = 0) {
        const message: any = {
            role: 'assistant',
            content,
            question: question || meta?.question || '',
            clientLatencyMs
        };
        this.applyAssistantMeta(message, meta || {});
        return message;
    }

    private applyAssistantMeta(message: any, meta: any) {
        if (!message || !meta) return;
        const policy = meta.artifactPolicy || this.fallbackArtifactPolicy(meta);
        Object.assign(message, {
            question: meta.question || message.question || '',
            intent: meta.intent,
            analysis: meta.analysis,
            trace: meta.trace,
            traceCompare: meta.traceCompare,
            stages: meta.stages || [],
            tools: meta.toolPlan || [],
            citations: meta.citations || [],
            evidence: meta.evidence || [],
            deepLinks: meta.deepLinks || [],
            tokens: meta.tokens || [],
            table: meta.table,
            markdown: meta.markdown,
            chart: meta.chart,
            actions: meta.actions || [],
            followups: meta.followups || [],
            glossaryHits: meta.glossaryHits || [],
            interpretation: meta.interpretation || '',
            orchestration: meta.orchestration,
            answerFlow: meta.answerFlow || message.answerFlow || null,
            answerQuality: meta.answerQuality || message.answerQuality || null,
            llm: meta.llm || message.llm || null,
            domainModel: meta.domainModel || message.domainModel || null,
            backendMeta: meta.meta || meta.responseMeta || message.backendMeta || null,
            dataScope: meta.dataScope || message.dataScope || '',
            artifactPolicy: policy
        });
        this.pruneHiddenArtifacts(message);
    }

    private fallbackArtifactPolicy(meta: any) {
        const intent = String(meta?.intent || '').toLowerCase();
        const dataIntents = ['search', 'anomaly', 'optimize', 'research', 'report', 'predict', 'compare', 'spc'];
        const dataRelated = dataIntents.indexOf(intent) >= 0;
        const actionNames = (meta?.actions || []).map((action: any) => action?.name);
        return {
            progress: dataRelated && Boolean((meta?.stages || []).length),
            execution: dataRelated && Boolean((meta?.actions || []).length || meta?.table || meta?.markdown),
            traceCompare: dataRelated && actionNames.indexOf('trace.compare') >= 0 && Boolean(meta?.traceCompare?.overlaySeries?.length),
            chart: dataRelated && Boolean(meta?.chart) && actionNames.indexOf('chart.render') >= 0
        };
    }

    private pruneHiddenArtifacts(message: any) {
        if (!this.artifactAllowed(message, 'progress')) message.stages = [];
        if (!this.artifactAllowed(message, 'execution')) {
            message.actions = [];
            message.table = null;
            message.markdown = null;
        }
        if (!this.artifactAllowed(message, 'traceCompare')) message.traceCompare = null;
        if (!this.artifactAllowed(message, 'chart')) message.chart = null;
    }

    private finishStreamMessage(streamMsg: any, meta: any = null, runtime: any = {}) {
        if (!streamMsg) return;
        if (meta) this.applyAssistantMeta(streamMsg, meta);
        const hasRuntime = runtime && Object.keys(runtime).length > 0;
        if (hasRuntime) {
            const runtimeModel = runtime.model && typeof runtime.model === 'string'
                ? { id: runtime.model, name: runtime.model }
                : runtime.model;
            streamMsg.llm = {
                ...(streamMsg.llm || {}),
                ...(runtime || {}),
                ...(runtimeModel ? { model: runtimeModel } : {})
            };
        }
        streamMsg.streaming = false;
    }

    private async askStream(message: string, seq: number, controller: AbortController) {
        const url = wiz.url('ask_stream');
        const formData = new FormData();
        formData.append('message', message);
        let streamMsg: any = null;
        let meta: any = null;
        let runtime: any = {};
        let completed = false;
        let failed = false;

        try {
            streamMsg = { role: 'assistant', content: '', streaming: true, question: message };
            this.messages.push(streamMsg);
            await this.service.render();

            const response = await fetch(url, { method: 'POST', body: formData, signal: controller.signal });
            if (!response.ok) throw new Error('SSE 연결 실패');
            if (!response.body) throw new Error('스트리밍 응답 본문이 없습니다.');
            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                if (seq !== this.askSeq || controller.signal.aborted) {
                    await reader.cancel();
                    return;
                }
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';
                for (const line of lines) {
                    if (!line.startsWith('data: ')) continue;
                    let event: any;
                    try { event = JSON.parse(line.slice(6)); } catch { continue; }
                    if (event.type === 'meta') {
                        meta = event.data;
                    } else if (event.type === 'token' && streamMsg) {
                        streamMsg.content += event.content;
                        await this.service.render();
                    } else if (event.type === 'done' && streamMsg) {
                        runtime = {
                            ...runtime,
                            ...(event.model ? { model: event.model } : {}),
                            ...(typeof event.fallback === 'boolean' ? { fallback: event.fallback } : {}),
                            ...(typeof event.degraded === 'boolean' ? { degraded: event.degraded } : {}),
                            ...(Number.isFinite(Number(event.latencyMs)) ? { latencyMs: Number(event.latencyMs) } : {}),
                            ...(event.status ? { status: event.status } : {})
                        };
                        completed = true;
                        this.finishStreamMessage(streamMsg, meta, runtime);
                        await this.service.render();
                    } else if (event.type === 'error') {
                        failed = true;
                        const streamError = event.traceId
                            ? `${event.message || 'SSE 오류'} (추적 ID: ${event.traceId})`
                            : (event.message || 'SSE 오류');
                        if (!streamMsg) {
                            this.messages.push({ role: 'error', content: streamError, question: message, retryable: true });
                        } else {
                            streamMsg.role = 'error';
                            const partial = this.readableMarkdown(streamMsg.content);
                            streamMsg.content = partial ? `${partial}\n\n${streamError}` : streamError;
                            streamMsg.retryable = true;
                            streamMsg.streaming = false;
                        }
                    }
                }
            }
            if (streamMsg && !failed) {
                runtime = {
                    ...runtime,
                    latencyMs: runtime.latencyMs ?? this.activeAskElapsedMs()
                };
                this.finishStreamMessage(streamMsg, meta, runtime);
                completed = completed || Boolean(streamMsg.content);
            }
            if (streamMsg && completed && !failed) {
                await this.saveHistory(message);
            }
        } catch (e: any) {
            if (seq === this.askSeq && !this.isAbortError(e)) {
                if (streamMsg) {
                    streamMsg.role = 'error';
                    streamMsg.content = this.readableMarkdown(streamMsg.content) || `스트리밍 실패: ${e.message || e}`;
                    streamMsg.retryable = true;
                    streamMsg.streaming = false;
                } else {
                    this.messages.push({ role: 'error', content: `스트리밍 실패: ${e.message || e}`, question: message, retryable: true });
                }
            }
        } finally {
            this.finishAskRequest(seq, controller);
            await this.service.render();
        }
    }

    public async cancelAsk() {
        if (!this.asking) return;
        this.askSeq++;
        const controller = this.activeAskController;
        this.activeAskController = null;
        if (controller) controller.abort();
        this.stopAskTimer();
        this.asking = false;
        const pendingReviewMessage = this.pendingAgentRequest?.progressMessage;
        if (pendingReviewMessage?.intentReview?.status === 'analyzing') {
            pendingReviewMessage.processing = false;
            pendingReviewMessage.intentReview.status = 'editing';
            pendingReviewMessage.intentReview.error = '의도 재분석을 중단했습니다. Agent를 선택해 다시 분석할 수 있습니다.';
            pendingReviewMessage.answerFlow = this.holdAnswerFlowForReview(pendingReviewMessage.answerFlow);
            await this.focusIntentReview('.agent-intent-review__feedback');
            return;
        }
        const activeMessage = [...this.messages].reverse().find((item: any) => item?.streaming || item?.processing);
        if (activeMessage) {
            activeMessage.streaming = false;
            activeMessage.processing = false;
            activeMessage.cancelled = true;
            activeMessage.role = 'status';
            const partial = this.readableMarkdown(activeMessage.content);
            activeMessage.content = partial
                ? `요청을 중단했습니다.\n\n${partial}`
                : '요청을 중단했습니다. 질문을 수정하거나 재시도할 수 있습니다.';
            const steps = activeMessage.answerFlow?.steps || [];
            activeMessage.answerFlow = {
                ...(activeMessage.answerFlow || {}),
                currentStep: 'cancelled',
                steps: steps.map((step: any) => ({
                    ...step,
                    status: ['running', 'pending'].includes(step.status) ? 'cancelled' : step.status
                }))
            };
        } else {
            this.messages.push({
                role: 'status',
                content: '요청을 중단했습니다. 질문을 수정하거나 재시도할 수 있습니다.',
                cancelled: true
            });
        }
        await this.service.render();
    }

    public async retryLast() {
        if (!this.lastQuestion || this.asking) return;
        this.input = this.lastQuestion;
        if (this.lastQuestionHadWaferMap && !this.waferMapFile) {
            this.waferMapError = '이 질문은 웨이퍼 맵 첨부가 필요합니다. 파일을 다시 선택한 뒤 실행해 주세요.';
            await this.service.render();
            return;
        }
        await this.ask();
    }

    public async retryMessage(message: any) {
        if (this.asking) return;
        this.input = String(message?.question || this.lastQuestion || '').trim();
        if (!this.input) return;
        const requiresWaferMap = message?.attachment?.kind === 'wafer_map'
            || message?.analysis?.entities?.attachment?.kind === 'wafer_map';
        if (requiresWaferMap && !this.waferMapFile) {
            this.lastQuestionHadWaferMap = true;
            this.waferMapError = '이 질문은 웨이퍼 맵 첨부가 필요합니다. 파일을 다시 선택한 뒤 실행해 주세요.';
            await this.service.render();
            return;
        }
        await this.ask();
    }

    public statClass(tone: string) {
        const map: any = {
            blue: 'bg-[#e3eefb] text-[#2e6fae] border-[#8fb0d6]',
            emerald: 'bg-green-50 text-green-700 border-green-200',
            amber: 'bg-amber-50 text-amber-900 border-amber-200',
            rose: 'bg-rose-50 text-rose-900 border-rose-200'
        };
        return map[tone] || map.blue;
    }

    public toolClass(status: string) {
        const map: any = {
            ready: 'border border-[#8fb0d6] bg-[#e3eefb] text-[#2e6fae]',
            mock: 'border border-green-200 bg-green-50 text-green-700',
            planned: 'border border-[#d9e1ec] bg-[#f4f7fb] text-[#64748b]'
        };
        return map[status] || map.planned;
    }

    public stageClass(status: string) {
        return status === 'done' ? 'bg-[#0f766e]' : 'bg-amber-400';
    }

    public showOrchestration(message: any) {
        return this.responseComplete(message) && Boolean(message?.orchestration?.agentRuns?.length);
    }

    public compactOrchestrationAgents(message: any) {
        const runs = message?.orchestration?.agentRuns || [];
        return runs.filter((run: any) => run && run.name).slice(0, 10);
    }

    public orchestrationStatusClass(status: string) {
        if (['completed', 'done'].includes(status)) return 'border-[#bbf7d0] bg-[#f0fdf4] text-[#15803d]';
        if (status === 'partial_success' || status === 'partial') return 'border-[#fed7aa] bg-[#fff7ed] text-[#b45309]';
        if (status === 'failed') return 'border-[#fecdd3] bg-[#fff1f2] text-[#be123c]';
        if (status === 'planned') return 'border-[#bfdbfe] bg-[#eff6ff] text-[#2563eb]';
        return 'border-[#d9e1ec] bg-[#f7f9fc] text-[#64748b]';
    }

    public compactProgress(message: any) {
        const stages = (message?.stages || []).filter((stage: any) => stage && stage.name);
        return stages.map((stage: any) => ({
            name: String(stage.name || ''),
            status: stage.status || 'planned'
        }));
    }

    public progressItemClass(status: string) {
        if (['done', 'ready', 'completed'].includes(status)) return 'is-done';
        if (status === 'failed') return 'is-failed';
        if (status === 'skipped' || status === 'cancelled') return 'is-skipped';
        if (status === 'running') return 'is-running';
        return 'is-pending';
    }

    public showLiveAnswerFlow(message: any) {
        return Boolean(
            message?.role !== 'user'
            && message?.answerFlow?.steps?.length
            && !this.showIntentReview(message)
        );
    }

    public answerFlowHeader(message: any) {
        if (message?.processing) return '질문에 맞는 분석 경로를 실행하고 있습니다';
        if (message?.cancelled) return '답변 생성 요청을 중단했습니다';
        if (message?.role === 'error') return '답변 생성 과정에서 오류가 발생했습니다';
        return '질문에 맞는 답변 생성 과정을 완료했습니다';
    }

    public answerFlowTerminalLabel(message: any) {
        if (message?.cancelled) return '중단';
        if (message?.role === 'error') return '실패';
        return '완료';
    }

    public liveAnswerFlowSteps(message: any) {
        return (message?.answerFlow?.steps || []).filter((step: any) => step?.id && step?.label);
    }

    public answerFlowStatusLabel(status: string) {
        const labels: any = {
            completed: '완료', running: '진행 중', pending: '대기',
            failed: '실패', skipped: '생략', cancelled: '중단'
        };
        return labels[status] || status || '대기';
    }

    public responseComplete(message: any) {
        return Boolean(message)
            && !message.streaming
            && !message.processing
            && !this.showIntentReview(message);
    }

    public artifactAllowed(message: any, key: string) {
        const policy = message?.artifactPolicy;
        if (policy && typeof policy[key] === 'boolean') return policy[key];
        const intent = String(message?.intent || '').toLowerCase();
        if (['general', 'explain'].indexOf(intent) >= 0) return false;
        return true;
    }

    public showMessageProgress(message: any) {
        return this.responseComplete(message) && this.artifactAllowed(message, 'progress') && this.compactProgress(message).length > 0;
    }

    public showMessageMeta(message: any) {
        return this.responseComplete(message) && this.artifactAllowed(message, 'progress') && Boolean(message?.intent);
    }

    public hasExecutionResult(message: any) {
        if (!message) return false;
        if (!this.responseComplete(message) || !this.artifactAllowed(message, 'execution')) return false;
        if ((message.actions || []).length) return true;
        if (message.table || message.markdown) return true;
        return Boolean(message.chart && !message.traceCompare?.overlaySeries?.length);
    }

    public showInlineTable(message: any) {
        return this.responseComplete(message)
            && this.artifactAllowed(message, 'execution')
            && Boolean(message?.table?.columns?.length && message?.table?.rows?.length);
    }

    public showInlineChart(message: any) {
        return this.responseComplete(message)
            && this.artifactAllowed(message, 'chart')
            && Boolean(message?.chart?.points?.length);
    }

    public showInlineReport(message: any) {
        return this.responseComplete(message)
            && message?.intent === 'report'
            && this.artifactAllowed(message, 'execution')
            && Boolean(message?.markdown);
    }

    public inlineChartHeight(value: any, points: any[]) {
        const values = (points || []).map((item: any) => Number(item)).filter((item: number) => Number.isFinite(item));
        const numeric = Number(value);
        if (!Number.isFinite(numeric) || !values.length) return '12%';
        const minimum = Math.min(...values);
        const maximum = Math.max(...values);
        if (maximum === minimum) return '64%';
        const ratio = (numeric - minimum) / (maximum - minimum);
        return `${Math.round(18 + Math.max(0, Math.min(1, ratio)) * 76)}%`;
    }

    public inlineChartPointLabel(value: any, index: number) {
        return `${index + 1}번째 값: ${value}`;
    }

    public showTraceCompare(message: any) {
        return this.responseComplete(message) && this.artifactAllowed(message, 'traceCompare') && Boolean(message.traceCompare?.overlaySeries?.length);
    }

    public referenceCitations(message: any) {
        const citations = message?.citations || [];
        return citations.filter((citation: any) => {
            const text = String(citation || '').trim();
            if (!text) return false;
            if (/^[a-z][a-z0-9_]*\.[a-z0-9_.-]+\s*(?:·|:|$)/i.test(text)) return false;
            return !this.isProjectMaterialSource(text);
        });
    }

    public messageEvidence(message: any) {
        const structured = (message?.evidence || []).filter((item: any) => (
            item
            && item.id
            && item.title
            && !this.isProjectMaterialSource([item.title, item.source, item.subtitle].join(' '))
        ));
        if (structured.length) return structured;
        return this.referenceCitations(message).map((citation: any, index: number) => ({
            id: `citation-${index + 1}`,
            type: 'citation',
            typeLabel: '분석 근거',
            title: String(citation || ''),
            subtitle: '상세 원문 연결 정보 없음',
            excerpt: '이 출처는 이전 응답 계약에서 문자열로 제공되어 원문 위치를 자동으로 열 수 없습니다.',
            supports: '응답 참고 자료',
            source: String(citation || ''),
            fields: {},
        }));
    }

    private isProjectMaterialSource(value: any) {
        const text = String(value || '').replace(/\s+/g, '');
        return /(제안요청서|제안서|목표시스템구성도|성과지표정의서|요구사항매트릭스|MVP범위문서|기능구조도|SFR-\d+)/i.test(text);
    }

    public messageAnalysisEvidence(message: any) {
        return this.messageEvidence(message).filter((item: any) => !this.isReferenceEvidence(item));
    }

    public messageReferences(message: any) {
        return this.messageEvidence(message).filter((item: any) => this.isReferenceEvidence(item));
    }

    private isReferenceEvidence(item: any) {
        const scope = String(item?.dataScope || '');
        return item?.type === 'document_chunk'
            && item?.referenceEligible === true
            && ['user-document', 'public', 'internal'].includes(scope);
    }

    public async openEvidenceViewer(item: any) {
        if (!item) return;
        const requestSeq = ++this.evidenceRequestSeq;
        this.selectedEvidence = { ...item, detailLoading: Boolean(item.detailApi), detailError: '' };
        await this.service.render();
        if (item.detailApi !== 'knowledge_document_evidence' || !item.documentId || !item.chunkId) return;
        try {
            const detail = await this.callApi('knowledge_document_evidence', {
                document_id: item.documentId,
                chunk_id: item.chunkId
            }, '문서 근거 원문을 불러오지 못했습니다.');
            if (requestSeq !== this.evidenceRequestSeq || !this.selectedEvidence) return;
            this.selectedEvidence = {
                ...this.selectedEvidence,
                excerpt: detail.chunk?.text || this.selectedEvidence.excerpt,
                source: `사용자 승인 문서 · ${detail.document?.id || item.documentId}`,
                fields: {
                    ...(this.selectedEvidence.fields || {}),
                    documentId: detail.document?.id || item.documentId,
                    page: detail.chunk?.page,
                    security: detail.document?.visibility,
                    indexType: detail.indexType,
                    updatedAt: detail.document?.updatedAt,
                },
                adjacent: detail.adjacent || [],
                detailLoading: false,
                detailError: '',
            };
        } catch (error: any) {
            if (requestSeq !== this.evidenceRequestSeq || !this.selectedEvidence) return;
            this.selectedEvidence = {
                ...this.selectedEvidence,
                detailLoading: false,
                detailError: this.errorText(error, '문서 근거 원문을 불러오지 못했습니다.'),
            };
        }
        await this.service.render();
    }

    public closeEvidenceViewer() {
        this.evidenceRequestSeq += 1;
        this.selectedEvidence = null;
        this.service.render();
    }

    public evidenceFieldRows(item: any) {
        const labels: any = {
            lot: 'Lot', wafer: 'Wafer', date: '측정일', process: '공정', equipment: '장비',
            status: '상태', thickness: '두께', uniformity: '균일도', defect: '결함률',
            documentId: '문서 ID', page: '페이지', section: '문서 구간', security: '공개 범위',
            indexType: '색인 방식', updatedAt: '문서 갱신일',
            revision: '모델 revision', artifactSha256: '모델 SHA-256',
            inputSha256: '입력 SHA-256', license: '모델 라이선스',
            productionValidated: '생산 검증',
        };
        return Object.keys(item?.fields || [])
            .filter((key: string) => item.fields[key] !== null && item.fields[key] !== undefined && item.fields[key] !== '')
            .map((key: string) => ({
                label: labels[key] || key,
                value: key === 'productionValidated'
                    ? (item.fields[key] ? '완료' : '미완료')
                    : item.fields[key]
            }));
    }

    public evidenceScopeLabel(item: any) {
        const labels: any = {
            sample: '시스템 샘플', operational: '운영 데이터',
            'user-document': '사용자 승인 문서', internal: '내부 문서', public: '공개 문서',
            'user-uploaded-wafer-map': '사용자 첨부 웨이퍼맵'
        };
        return labels[String(item?.dataScope || '')] || item?.dataScope || '범위 정보 없음';
    }

    public showAnswerRuntimeMeta(message: any) {
        return message?.role === 'assistant'
            && this.responseComplete(message)
            && Boolean(message?.question || message?.llm || message?.orchestration || message?.backendMeta);
    }

    public showAnswerQuality(message: any) {
        return message?.role === 'assistant'
            && !message?.intro
            && this.responseComplete(message)
            && Boolean(message?.question || message?.intent || message?.answerQuality || message?.orchestration);
    }

    public answerQuality(message: any) {
        if (message?.answerQuality?.label) {
            const quality = {
                ...message.answerQuality,
                limitations: [...(message.answerQuality.limitations || [])]
            };
            const runtimeFallback = Boolean(message?.llm?.fallback)
                || ['fallback', 'degraded'].includes(String(message?.llm?.status || ''));
            if (runtimeFallback && quality.status === 'grounded') {
                quality.status = 'grounded_fallback';
                quality.label = '근거 기반 대체 응답';
                quality.summary = 'LLM 생성 답변 대신 검증된 도구·도메인 모델 결과 초안을 사용했습니다. 연결된 근거를 확인해 주세요.';
                if (!quality.limitations.includes('구성된 LLM 응답 대신 근거 기반 대체 초안을 사용했습니다.')) {
                    quality.limitations.push('구성된 LLM 응답 대신 근거 기반 대체 초안을 사용했습니다.');
                }
            }
            return quality;
        }
        const evidenceCount = this.messageEvidence(message).length;
        const verification = String(message?.orchestration?.verification?.status || '').toLowerCase();
        const failedTools = (message?.actions || []).filter((item: any) => item?.status === 'failed').length;
        const fallback = Boolean(message?.llm?.fallback) || ['fallback', 'degraded'].includes(String(message?.llm?.status || ''));
        const informational = ['general', 'site', 'explain'].includes(String(message?.intent || '')) && !(message?.actions || []).length;
        let status = 'review_needed';
        let label = '근거 확인 필요';
        let summary = '응답은 생성됐지만 확인 가능한 근거와 검증 상태를 함께 살펴봐야 합니다.';
        if (verification === 'needs_clarification') {
            status = 'needs_input';
            label = '질문 보완 필요';
            summary = '분석 범위를 확정할 입력이 부족해 데이터 도구와 모델 실행을 멈췄습니다.';
        } else if (this.answerDataScopeValue(message) === 'no_data') {
            status = 'no_data';
            label = '판단 보류';
            summary = '일치하는 데이터 근거가 없어 예측이나 원인 판단을 생성하지 않았습니다.';
        } else if (informational) {
            status = 'informational';
            label = '안내 응답';
            summary = '데이터 분석 없이 화면·기능 안내 범위에서 답했습니다.';
        } else if (!failedTools && evidenceCount && fallback) {
            status = 'grounded_fallback';
            label = '근거 기반 대체 응답';
            summary = 'LLM 생성 답변 대신 검증된 도구·도메인 모델 결과 초안을 사용했습니다.';
        } else if (!failedTools && evidenceCount && verification === 'completed') {
            status = 'grounded';
            label = '근거 검증 완료';
            summary = '완료된 도구 결과와 연결 근거를 기준으로 답변 경계를 확인했습니다.';
        }
        return {
            status,
            label,
            summary,
            checks: [
                { label: '근거 연결', status: evidenceCount ? 'passed' : (informational ? 'not_applicable' : 'attention'), detail: evidenceCount ? `${evidenceCount}건 연결` : (informational ? '데이터 근거 미사용' : '연결 근거 없음') },
                { label: '도구 실행', status: failedTools ? 'attention' : 'not_applicable', detail: failedTools ? `${failedTools}건 실패` : ((message?.actions || []).length ? `${(message.actions || []).length}건 확인` : '실행 없음') },
                { label: '응답 경계', status: verification === 'completed' ? 'passed' : 'attention', detail: verification === 'completed' ? '검증 완료' : '확인 필요' },
            ],
            limitations: this.answerDataScopeValue(message) === 'sample'
                ? ['샘플 데이터 범위이며 실제 생산 판정용이 아닙니다.']
                : this.answerDataScopeValue(message) === 'user-uploaded-wafer-map'
                    ? ['사용자 첨부 웨이퍼맵을 연구용 공개 모델로 분석했으며 실제 생산 판정용이 아닙니다.']
                    : [],
            calibrationNote: '검증 상태는 정답 확률이 아니라 근거·도구·응답 경계의 확인 결과입니다.'
        };
    }

    public answerQualityChecks(message: any) {
        return (this.answerQuality(message).checks || []).slice(0, 3);
    }

    public answerQualityLimitations(message: any) {
        return (this.answerQuality(message).limitations || []).slice(0, 3);
    }

    public answerQualityClass(message: any) {
        const status = this.answerQuality(message).status;
        if (status === 'grounded') return 'is-grounded';
        if (status === 'informational') return 'is-informational';
        if (status === 'grounded_fallback') return 'is-fallback';
        return 'is-attention';
    }

    public answerQualityCheckClass(status: string) {
        if (status === 'passed') return 'is-passed';
        if (status === 'attention') return 'is-attention';
        return 'is-neutral';
    }

    private answerDataScopeValue(message: any) {
        return String(message?.dataScope || message?.backendMeta?.dataScope || message?.analysis?.safety?.dataScope || '');
    }

    public answerTechnicalItems(message: any) {
        return this.answerRuntimeItems(message).filter((item: any) => ['model', 'latency', 'fallback', 'degraded', 'scope'].includes(item.key));
    }

    public hasSpecializedResult(message: any) {
        if (['general', 'site', 'explain'].includes(String(message?.intent || '')) && !(message?.actions || []).length) return false;
        if (this.answerDataScopeValue(message) === 'user-uploaded-wafer-map') return false;
        return this.hasExecutionResult(message) || this.showTraceCompare(message) || Boolean(message?.deepLinks?.length);
    }

    public specializedResultTitle(message: any) {
        if (this.showTraceCompare(message)) return 'Trace 파형·편차 비교';
        if (message?.chart || message?.markdown) return '시각화·보고서 결과';
        if (['anomaly', 'predict', 'optimize', 'spc'].includes(String(message?.intent || ''))) return '모델 예측·원인 분석';
        return '조회 데이터와 상세 조건';
    }

    public specializedResultSummary(message: any) {
        if (this.showTraceCompare(message)) return '채팅에는 결론만 유지하고, 파형 오버레이·이탈 구간·원인 후보는 Trace 비교 화면에서 확인합니다.';
        if (message?.chart || message?.markdown) return '채팅에는 핵심 해석만 유지하고, 차트 탐색·보고서 미리보기·내보내기는 시각화 화면에서 이어갑니다.';
        if (['anomaly', 'predict', 'optimize', 'spc'].includes(String(message?.intent || ''))) return '채팅에는 판단 요약만 유지하고, 모델 출력·불확실성·RCA·추천 조건은 예측·추론 화면에서 검토합니다.';
        return '채팅에는 답변에 필요한 요약만 유지하고, 원본 레코드·필터·Lot 상세는 데이터 허브에서 확인합니다.';
    }

    public specializedResultLinks(message: any) {
        const labels: any = {
            '/agent/history': '데이터 허브에서 원본 확인',
            '/agent/trace': 'Trace 비교 열기',
            '/agent/analysis': '예측·추론에서 검토',
            '/agent/visualization': '시각화·보고서 열기',
            '/agent/workflows': '워크플로에서 반복 실행',
            '/posts': '승인 문서 확인',
        };
        const links: any[] = [];
        const add = (href: string) => {
            if (!labels[href] || links.some((item: any) => item.href === href)) return;
            links.push({ href, label: labels[href] });
        };
        if (this.showTraceCompare(message)) add('/agent/trace');
        if (['anomaly', 'predict', 'optimize', 'spc'].includes(String(message?.intent || ''))) add('/agent/analysis');
        if (message?.chart || message?.markdown || message?.intent === 'report') add('/agent/visualization');
        if (message?.table || message?.actions?.length) add('/agent/history');
        (message?.deepLinks || []).forEach((link: any) => add(String(link?.href || '')));
        return links.slice(0, 3);
    }

    public answerRuntimeItems(message: any) {
        const llm = message?.llm || message?.backendMeta?.llm || {};
        const fallback = this.booleanRuntimeState(llm.fallback, llm.status === 'fallback');
        const degraded = this.booleanRuntimeState(llm.degraded, llm.status === 'fallback' || llm.status === 'degraded');
        return [
            {
                key: 'model',
                label: '모델 / 실행 방식',
                value: this.answerModelLabel(message),
                tone: degraded === true ? 'warning' : 'neutral'
            },
            {
                key: 'latency',
                label: '응답 시간',
                value: this.answerLatencyLabel(message),
                tone: 'neutral'
            },
            {
                key: 'fallback',
                label: 'Fallback',
                value: fallback === true ? '대체 응답 사용' : fallback === false ? '사용 안 함' : '정보 없음',
                tone: fallback === true ? 'warning' : fallback === false ? 'success' : 'muted'
            },
            {
                key: 'degraded',
                label: '서비스 상태',
                value: degraded === true ? '저하됨' : degraded === false ? '정상' : this.runtimeStatusLabel(llm.status),
                tone: degraded === true ? 'warning' : degraded === false ? 'success' : 'muted'
            },
            {
                key: 'scope',
                label: '데이터 범위',
                value: this.answerDataScopeLabel(message),
                tone: 'neutral'
            },
            {
                key: 'evidence',
                label: '근거 수준',
                value: this.answerEvidenceLabel(message),
                tone: this.answerEvidenceTone(message)
            }
        ];
    }

    public answerRuntimeItemClass(tone: string) {
        if (tone === 'warning') return 'is-warning';
        if (tone === 'success') return 'is-success';
        if (tone === 'muted') return 'is-muted';
        return 'is-neutral';
    }

    private booleanRuntimeState(value: any, inferredTrue: boolean = false): boolean | null {
        if (typeof value === 'boolean') return value;
        if (inferredTrue) return true;
        return null;
    }

    private answerModelLabel(message: any) {
        const llm = message?.llm || message?.backendMeta?.llm || {};
        const status = String(llm.status || '').toLowerCase();
        if (llm.summaryUsedInAnswer === false && message?.domainModel) {
            const domainModel = message.domainModel;
            const name = domainModel.name || domainModel.id || 'WaferGuard CNN';
            return `${name} · 검증형 Agent 요약 (LLM 미호출)`;
        }
        if (status === 'skipped') return 'LLM 미사용 · 규칙 응답';
        if (status === 'clarification') return 'LLM 미사용 · 확인 질문';
        const model = llm.model || message?.orchestration?.responseGeneration?.model;
        if (typeof model === 'string') return model;
        return model?.name || model?.id || model?.model || '모델 정보 없음';
    }

    private answerLatencyLabel(message: any) {
        const llm = message?.llm || message?.backendMeta?.llm || {};
        const value = llm.latencyMs ?? message?.backendMeta?.latencyMs ?? message?.clientLatencyMs;
        if (value === undefined || value === null || !Number.isFinite(Number(value))) return '-';
        const ms = Math.max(0, Math.round(Number(value)));
        return ms >= 1000 ? `${(ms / 1000).toFixed(ms >= 10000 ? 0 : 1)}초` : `${ms}ms`;
    }

    private runtimeStatusLabel(status: any) {
        const labels: any = {
            ok: '정상',
            healthy: '정상',
            fallback: '대체 응답',
            degraded: '저하됨',
            skipped: '해당 없음',
            clarification: '해당 없음'
        };
        return labels[String(status || '').toLowerCase()] || '정보 없음';
    }

    private answerDataScopeLabel(message: any) {
        const scope = message?.dataScope
            || message?.backendMeta?.dataScope
            || message?.analysis?.safety?.dataScope
            || message?.orchestration?.profile?.scope;
        const labels: any = {
            authorized_dataset_only: '권한이 허용된 데이터셋',
            current_dataset: '현재 데이터셋',
            sample: '샘플 데이터',
            sample_only: '샘플 데이터만',
            operational: '운영 데이터',
            no_data: '데이터 미조회'
        };
        if (scope) return labels[String(scope)] || String(scope).replace(/_/g, ' ');
        if (!(message?.actions || []).length && ['general', 'site', 'clarification'].includes(String(message?.intent || ''))) {
            return '데이터 미조회';
        }
        return '범위 정보 없음';
    }

    private answerEvidenceLabel(message: any) {
        const count = this.messageEvidence(message).length;
        const verification = String(message?.orchestration?.verification?.status || '').toLowerCase();
        if (verification === 'needs_clarification') return '질문 보완 필요';
        if (!count) return (message?.actions || []).length ? '표시된 출처 없음' : '데이터 근거 미사용';
        if (verification === 'completed') return `검증 단계 완료 · 참고 ${count}건`;
        if (verification === 'partial_success') return `일부 확인 필요 · 참고 ${count}건`;
        return `참고 근거 ${count}건`;
    }

    private answerEvidenceTone(message: any) {
        const count = this.messageEvidence(message).length;
        const verification = String(message?.orchestration?.verification?.status || '').toLowerCase();
        if (verification === 'needs_clarification' || verification === 'partial_success') return 'warning';
        if (!count && (message?.actions || []).length) return 'warning';
        return count ? 'success' : 'muted';
    }

    public messageContentBlocks(message: any) {
        return this.markdownContentBlocks(message?.content || '');
    }

    public markdownContentBlocks(value: any) {
        const lines = String(value || '').replace(/\r\n?/g, '\n').split('\n');
        const blocks: any[] = [];
        let paragraph: string[] = [];
        let code: string[] | null = null;

        const flushParagraph = () => {
            if (!paragraph.length) return;
            const text = this.cleanInlineMarkdown(paragraph.join(' '));
            if (text) blocks.push({ type: 'paragraph', text });
            paragraph = [];
        };

        for (let index = 0; index < lines.length; index++) {
            const raw = lines[index] || '';
            const trimmed = raw.trim();
            if (/^```/.test(trimmed)) {
                flushParagraph();
                if (code === null) code = [];
                else {
                    blocks.push({ type: 'code', text: code.join('\n') });
                    code = null;
                }
                continue;
            }
            if (code !== null) {
                code.push(raw);
                continue;
            }
            if (!trimmed) {
                flushParagraph();
                continue;
            }

            const heading = trimmed.match(/^(#{1,6})\s+(.+)$/);
            const emphasizedHeading = trimmed.match(/^(?:\*\*([^*]+)\*\*|__([^_]+)__)\s*$/);
            if (heading || emphasizedHeading) {
                flushParagraph();
                blocks.push({
                    type: 'heading',
                    level: heading ? Math.min(4, heading[1].length) : 4,
                    text: this.cleanInlineMarkdown(heading ? heading[2] : (emphasizedHeading?.[1] || emphasizedHeading?.[2] || ''))
                });
                continue;
            }

            if (raw.indexOf('|') >= 0 && index + 1 < lines.length && this.isMarkdownTableDivider(lines[index + 1])) {
                flushParagraph();
                const headers = this.markdownTableCells(raw);
                const rows: string[][] = [];
                index += 2;
                while (index < lines.length && lines[index].indexOf('|') >= 0 && lines[index].trim()) {
                    rows.push(this.markdownTableCells(lines[index]));
                    index++;
                }
                index--;
                blocks.push({ type: 'table', headers, rows });
                continue;
            }

            const bullet = trimmed.match(/^[-*+]\s+(.+)$/);
            const ordered = trimmed.match(/^\d+[.)]\s+(.+)$/);
            if (bullet || ordered) {
                flushParagraph();
                const type = bullet ? 'unordered-list' : 'ordered-list';
                const text = this.cleanInlineMarkdown((bullet || ordered)?.[1] || '');
                const previous = blocks[blocks.length - 1];
                if (previous?.type === type) previous.items.push(text);
                else blocks.push({ type, items: [text] });
                continue;
            }

            const quote = trimmed.match(/^>\s?(.*)$/);
            if (quote) {
                flushParagraph();
                blocks.push({ type: 'quote', text: this.cleanInlineMarkdown(quote[1]) });
                continue;
            }
            if (/^([-*_])\1{2,}$/.test(trimmed)) {
                flushParagraph();
                continue;
            }
            paragraph.push(trimmed);
        }

        flushParagraph();
        if (code !== null && code.length) blocks.push({ type: 'code', text: code.join('\n') });
        return blocks;
    }

    public readableMarkdown(value: any) {
        return this.markdownContentBlocks(value).map((block: any) => {
            if (block.type === 'unordered-list') return block.items.map((item: string) => `• ${item}`).join('\n');
            if (block.type === 'ordered-list') return block.items.map((item: string, index: number) => `${index + 1}. ${item}`).join('\n');
            if (block.type === 'table') {
                return [block.headers, ...block.rows].map((row: string[]) => row.join(' · ')).join('\n');
            }
            return block.text || '';
        }).filter(Boolean).join('\n\n');
    }

    private cleanInlineMarkdown(value: any) {
        return String(value || '')
            .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1')
            .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
            .replace(/\*\*([^*]+)\*\*/g, '$1')
            .replace(/__([^_]+)__/g, '$1')
            .replace(/`([^`]+)`/g, '$1')
            .replace(/\*([^*\n]+)\*/g, '$1')
            .replace(/_([^_\n]+)_/g, '$1')
            .replace(/<[^>]+>/g, '')
            .replace(/\\([`*_{}\[\]()#+\-.!])/g, '$1')
            .trim();
    }

    private markdownTableCells(line: string) {
        return String(line || '').trim().replace(/^\|/, '').replace(/\|$/, '').split('|')
            .map((cell: string) => this.cleanInlineMarkdown(cell.trim()));
    }

    private isMarkdownTableDivider(line: string) {
        const cells = String(line || '').trim().replace(/^\|/, '').replace(/\|$/, '').split('|');
        return cells.length > 0 && cells.every((cell: string) => /^\s*:?-{3,}:?\s*$/.test(cell));
    }

    public chartHeight(value: number) {
        return `${Math.max(18, Math.min(96, value))}%`;
    }

    public autocompleteSuggestions() {
        const text = (this.input || '').trim().toLowerCase();
        if (!text) return this.suggestions.slice(0, 3);
        return this.suggestions.filter((item: string) => item.toLowerCase().indexOf(text) >= 0).slice(0, 4);
    }

    public filteredHistory() {
        const text = (this.historySearch || '').trim().toLowerCase();
        if (!text) return this.historyItems;
        return this.historyItems.filter((item: any) => {
            return item.title.toLowerCase().indexOf(text) >= 0 || item.preview.toLowerCase().indexOf(text) >= 0;
        });
    }

    public loadHistory() {
        try {
            this.historyItems = JSON.parse(localStorage.getItem(this.historyKey) || '[]');
        } catch (e) {
            this.historyItems = [];
        }
    }

    public loadHistoryPanelPrefs() {
        try {
            const prefs = JSON.parse(localStorage.getItem(this.historyPanelPrefsKey) || '{}');
            if (typeof prefs.collapsed === 'boolean') this.historyPanelCollapsed = prefs.collapsed;
            if (Number.isFinite(Number(prefs.width))) {
                this.historyPanelWidth = this.clampHistoryPanelWidth(Number(prefs.width));
            }
        } catch (e) {
            this.historyPanelCollapsed = false;
            this.historyPanelWidth = this.clampHistoryPanelWidth(this.historyPanelWidth);
        }
    }

    private saveHistoryPanelPrefs() {
        try {
            localStorage.setItem(this.historyPanelPrefsKey, JSON.stringify({
                collapsed: this.historyPanelCollapsed,
                width: this.clampHistoryPanelWidth(this.historyPanelWidth)
            }));
        } catch (e) {
            // 브라우저 저장소가 막힌 경우에도 패널 조작은 현재 세션에서 계속 동작합니다.
        }
    }

    private clampHistoryPanelWidth(width: number) {
        return Math.max(this.historyPanelMinWidth, Math.min(this.historyPanelMaxWidth, Math.round(width || this.historyPanelWidth)));
    }

    public async toggleHistoryPanel() {
        this.historyPanelCollapsed = !this.historyPanelCollapsed;
        if (this.historyPanelCollapsed) this.endHistoryResize();
        this.saveHistoryPanelPrefs();
        await this.service.render();
    }

    public startHistoryResize(event: MouseEvent | TouchEvent) {
        if (this.historyPanelCollapsed) return;
        event.preventDefault();
        if (this.historyResizeStart) this.endHistoryResize();
        this.historyResizeStart = {
            clientX: this.historyPointerClientX(event),
            width: this.historyPanelWidth
        };
        this.historyPanelResizing = true;
        document.addEventListener('mousemove', this.onHistoryResize);
        document.addEventListener('mouseup', this.endHistoryResize);
        document.addEventListener('touchmove', this.onHistoryResize, { passive: false });
        document.addEventListener('touchend', this.endHistoryResize);
    }

    private onHistoryResize = (event: MouseEvent | TouchEvent) => {
        if (!this.historyResizeStart) return;
        event.preventDefault();
        const delta = this.historyResizeStart.clientX - this.historyPointerClientX(event);
        this.historyPanelWidth = this.clampHistoryPanelWidth(this.historyResizeStart.width + delta);
        this.queueHistoryPanelRender();
    };

    private endHistoryResize = () => {
        if (!this.historyResizeStart && !this.historyPanelResizing) return;
        this.historyResizeStart = null;
        this.historyPanelResizing = false;
        document.removeEventListener('mousemove', this.onHistoryResize);
        document.removeEventListener('mouseup', this.endHistoryResize);
        document.removeEventListener('touchmove', this.onHistoryResize);
        document.removeEventListener('touchend', this.endHistoryResize);
        this.saveHistoryPanelPrefs();
        this.queueHistoryPanelRender();
    };

    private historyPointerClientX(event: MouseEvent | TouchEvent) {
        const touch = (event as TouchEvent).touches?.[0] || (event as TouchEvent).changedTouches?.[0];
        return touch ? touch.clientX : (event as MouseEvent).clientX;
    }

    private queueHistoryPanelRender() {
        if (this.historyResizeRenderQueued) return;
        this.historyResizeRenderQueued = true;
        requestAnimationFrame(async () => {
            this.historyResizeRenderQueued = false;
            await this.service.render();
        });
    }

    public async handleHistoryResizeKey(event: KeyboardEvent) {
        if (this.historyPanelCollapsed) return;
        const key = event.key;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;
        event.preventDefault();
        if (key === 'ArrowLeft') this.historyPanelWidth = this.clampHistoryPanelWidth(this.historyPanelWidth + 24);
        if (key === 'ArrowRight') this.historyPanelWidth = this.clampHistoryPanelWidth(this.historyPanelWidth - 24);
        if (key === 'Home') this.historyPanelWidth = this.historyPanelMinWidth;
        if (key === 'End') this.historyPanelWidth = this.historyPanelMaxWidth;
        this.saveHistoryPanelPrefs();
        await this.service.render();
    }

    private persistentHistoryMessages() {
        return (this.messages || []).map((message: any) => {
            const projected = { ...message };
            if (message?.attachment?.kind === 'wafer_map') {
                projected.attachment = {
                    kind: 'wafer_map',
                    size: Math.max(0, Math.floor(Number(message.attachment.size) || 0))
                };
            }
            const reviewDataSource = String(projected.intentReview?.dataSource || '');
            if (
                projected.intentReview
                && (projected.intentReview.hasUserData || reviewDataSource.startsWith('사용자 첨부 데이터'))
            ) {
                projected.intentReview = {
                    ...projected.intentReview,
                    dataSource: '사용자 첨부 데이터'
                };
            }
            return projected;
        });
    }

    public async saveHistory(title: string) {
        const saveSeq = ++this.historySaveSeq;
        const item = {
            id: `conv-${Date.now()}`,
            title: String(title || '제목 없는 대화').slice(0, 160),
            preview: String(this.messages[this.messages.length - 1]?.content || '').slice(0, 240),
            created: new Date().toLocaleString(),
            messages: this.persistentHistoryMessages()
        };
        this.historyItems = [item, ...this.historyItems].slice(0, 20);
        this.persistHistoryItems();
        this.historySaveState = 'saving';
        this.historySaveStatus = '대화 이력 저장 중...';
        try { await this.service.render(); } catch (e) { /* 저장 상태 렌더 실패는 AI 답변을 실패로 바꾸지 않습니다. */ }
        try {
            await this.callApi('save_history', { item: JSON.stringify(item) }, '대화 이력을 저장하지 못했습니다.');
            if (saveSeq !== this.historySaveSeq) return true;
            this.historySaveState = 'saved';
            this.historySaveStatus = '대화 이력 저장 완료';
        } catch (error: any) {
            if (saveSeq !== this.historySaveSeq) return false;
            // The AI answer itself succeeded. A persistence failure is shown as
            // a separate status and must not turn that answer into an error.
            this.historySaveState = 'error';
            this.historySaveStatus = `${this.errorText(error, '서버 저장에 실패했습니다.')} 브라우저에만 보관됩니다.`;
        } finally {
            if (saveSeq === this.historySaveSeq) {
                try { await this.service.render(); } catch (e) { /* 동일한 비치명 상태 표시 실패 */ }
                if (this.historySaveTimer) clearTimeout(this.historySaveTimer);
                this.historySaveTimer = setTimeout(async () => {
                    if (saveSeq !== this.historySaveSeq) return;
                    this.historySaveState = 'idle';
                    this.historySaveStatus = '';
                    try { await this.service.render(); } catch (e) { /* 상태 초기화 렌더 실패 */ }
                }, this.historySaveState === 'error' ? 8000 : 4000);
            }
        }
        return this.historySaveState === 'saved';
    }

    private persistHistoryItems() {
        try {
            const localItems = this.historyItems.filter((item: any) => Array.isArray(item.messages)).slice(0, 20);
            localStorage.setItem(this.historyKey, JSON.stringify(localItems));
        } catch (e) {
            // 저장소 권한 문제는 현재 화면 상태까지 막지 않습니다.
        }
    }

    public async deleteHistoryItem(item: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const itemId = item?.id;
        if (!itemId) return;

        const previousItems = this.historyItems.slice();
        this.historyItems = this.historyItems.filter((entry: any) => String(entry.id) !== String(itemId));
        this.persistHistoryItems();
        await this.service.render();

        try {
            await this.callApi('delete_history_item', { id: itemId }, '대화 이력을 삭제하지 못했습니다.');
        } catch (error: any) {
            this.historyItems = previousItems;
            this.persistHistoryItems();
            this.sectionErrors.chat = this.errorText(error, '대화 이력을 삭제하지 못했습니다.');
            await this.service.render();
        }
    }

    public async openHistory(item: any) {
        if (!item?.id) return;
        if (this.asking) await this.cancelAsk();
        this.pendingAgentRequest = null;
        this.clearWaferMap();
        let fullItem = item;
        if (!Array.isArray(item.messages)) {
            this.conversationHistoryLoading = true;
            await this.service.render();
            try {
                const result = await this.callApi('load_history_item', { id: item.id }, '대화 내용을 불러오지 못했습니다.');
                fullItem = result.item || item;
                this.historyItems = this.historyItems.map((entry: any) => entry.id === item.id ? fullItem : entry);
            } catch (error: any) {
                this.sectionErrors.chat = this.errorText(error, '대화 내용을 불러오지 못했습니다.');
                return;
            } finally {
                this.conversationHistoryLoading = false;
                await this.service.render();
            }
        }
        this.messages = JSON.parse(JSON.stringify(fullItem.messages || []));
        const latestUser = [...this.messages].reverse().find((message: any) => message?.role === 'user');
        this.lastQuestion = String(latestUser?.content || '').trim();
        this.lastQuestionHadWaferMap = latestUser?.attachment?.kind === 'wafer_map';
        await this.service.render();
    }

    public async newChat() {
        if (this.asking) await this.cancelAsk();
        this.pendingAgentRequest = null;
        this.clearWaferMap();
        this.lastQuestionHadWaferMap = false;
        this.lastQuestion = '';
        this.selectedAgentMode = 'auto';
        this.selectedToolExecutionMode = 'auto';
        this.messages = [this.initialAssistantMessage()];
        this.navTo('chat');
        await this.service.render();
    }

    public async clearHistory() {
        const ok = await this.service.modal.show({
            title: '대화 이력 삭제',
            message: '서버 이력은 검증 백업을 남긴 뒤 비우고, 브라우저에 저장된 Agent 대화도 삭제합니다.',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!ok) return;
        try {
            await this.callApi('delete_history', {}, '대화 이력을 삭제하지 못했습니다.');
            this.historyItems = [];
            this.historyBackendLoaded = false;
            localStorage.removeItem(this.historyKey);
            await this.loadHistoryHealth(false);
            this.sectionErrors.chat = '';
        } catch (error: any) {
            this.sectionErrors.chat = this.errorText(error, '대화 이력을 삭제하지 못했습니다.');
        }
        await this.service.render();
    }

    public async copyShareText() {
        const text = this.messages.map((message: any) => `${message.role}: ${message.content}`).join('\n\n');
        try {
            await navigator.clipboard.writeText(text);
            await this.service.modal.success('공유용 대화 텍스트를 복사했습니다.');
        } catch (e) {
            await this.service.modal.error('브라우저 권한 때문에 복사하지 못했습니다.');
        }
    }

    public async loadGlossary() {
        if (this.glossaryCache) return;
        try {
            this.glossaryCache = await this.callApi('glossary', {}, '용어사전을 불러오지 못했습니다.');
        } catch (error: any) {
            this.sectionErrors.chat = this.errorText(error);
        }
    }

    public async toggleGlossaryPanel() {
        await this.loadGlossary();
        if (this.historyPanelCollapsed) {
            this.historyPanelCollapsed = false;
            this.saveHistoryPanelPrefs();
        }
        this.showGlossaryPanel = !this.showGlossaryPanel;
        await this.service.render();
    }

    public glossaryEntries() {
        if (!this.glossaryCache) return [];
        return Object.entries(this.glossaryCache).map(([term, desc]: [string, any]) => ({ term, description: desc }));
    }

    public showGlossaryTooltip(term: string, desc: string) {
        this.glossaryTooltip = { term, description: desc };
    }

    public hideGlossaryTooltip() {
        this.glossaryTooltip = null;
    }

    public toggleStreamMode() {
        this.streamMode = !this.streamMode;
    }

    // ── Section navigation (sub-page routing) ─────────────────────────
    public navTo(sectionId: string) {
        this.service.href(`/agent/${this.normalizeSection(sectionId)}`);
    }

    public goDataHubOverview() {
        this.activeExplorerTab = 'summary';
        this.service.href('/agent/history');
    }

    public goLotHistoryFromExplorer() {
        const params = new URLSearchParams();
        const lot = this.explorerTargetLot();
        if (lot) params.set('lot', lot);
        if (this.explorerFilters.source_scope === 'operational') params.set('source_scope', 'operational');
        if (this.selectedRecordId) params.set('record', this.selectedRecordId);
        const query = params.toString();
        this.service.href(`/agent/lot-history${query ? '?' + query : ''}`);
    }

    public normalizeSection(sectionId: string) {
        if (sectionId === 'llm-settings') return this.service.auth.session?.role === 'admin' ? 'admin' : 'chat';
        const baseSections = ['chat', 'history', 'lot-history', 'analysis', 'workflows', 'visualization', 'trace'];
        const roleSections = this.service.auth.session?.role === 'admin' ? ['admin', 'quality', 'stats'] : ['training'];
        const allowed = [...baseSections, ...roleSections];
        return allowed.indexOf(sectionId || 'chat') >= 0 ? (sectionId || 'chat') : 'chat';
    }

    public hydrateDocumentHubState() {
        if (this.documentHubStateHydrated || typeof location === 'undefined') return;
        const params = new URLSearchParams(location.search || '');
        this.documentHubQuery = params.get('q') || '';
        this.documentHubFilters.category = params.get('category') || 'all';
        this.documentHubFilters.type = params.get('type') || 'all';
        this.documentHubFilters.language = params.get('language') || 'all';
        this.documentHubFilters.sort = params.get('sort') || 'updated';
        this.requestedHubDocumentId = params.get('document') || '';
        this.selectedHubPage = Math.max(1, Number(params.get('page') || 1) || 1);
        this.documentHubStateHydrated = true;
    }

    private restoreHubDocumentSelection() {
        const categoryIds = (this.documentHubData.categories || []).map((item: any) => String(item.id));
        const typeIds = (this.documentHubData.types || []).map((item: any) => String(item.id));
        const languageIds = (this.documentHubData.languages || []).map((item: any) => String(item.id));
        if (this.documentHubFilters.category !== 'all' && !categoryIds.includes(this.documentHubFilters.category)) {
            this.documentHubFilters.category = 'all';
        }
        if (this.documentHubFilters.type !== 'all' && !typeIds.includes(this.documentHubFilters.type)) {
            this.documentHubFilters.type = 'all';
        }
        if (this.documentHubFilters.language !== 'all' && !languageIds.includes(this.documentHubFilters.language)) {
            this.documentHubFilters.language = 'all';
        }
        if (!['updated', 'title', 'pages', 'chunks'].includes(this.documentHubFilters.sort)) {
            this.documentHubFilters.sort = 'updated';
        }

        const requested = (this.documentHubData.documents || [])
            .find((item: any) => item.id === this.requestedHubDocumentId);
        this.selectedHubDocument = requested || null;
        if (requested) {
            const pages = requested.pages || [];
            if (!pages.some((page: any) => Number(page.number) === this.selectedHubPage)) {
                this.selectedHubPage = Number(pages[0]?.number || 1);
            }
        } else {
            this.selectedHubPage = 1;
        }
        this.syncDocumentHubState();
    }

    public syncDocumentHubState() {
        if (this.section !== 'history' || typeof window === 'undefined') return;
        const params = new URLSearchParams();
        const query = String(this.documentHubQuery || '').trim();
        if (query) params.set('q', query);
        ['category', 'type', 'language'].forEach((key: string) => {
            const value = String(this.documentHubFilters[key] || 'all');
            if (value && value !== 'all') params.set(key, value);
        });
        if (this.documentHubFilters.sort && this.documentHubFilters.sort !== 'updated') {
            params.set('sort', this.documentHubFilters.sort);
        }
        if (this.selectedHubDocument?.id) {
            params.set('document', this.selectedHubDocument.id);
            if (this.selectedHubPage > 1) params.set('page', String(this.selectedHubPage));
        }
        const encoded = params.toString();
        window.history.replaceState(null, '', `/agent/history${encoded ? '?' + encoded : ''}`);
    }

    public async updateDocumentHubQuery(value: string) {
        this.documentHubQuery = String(value || '').slice(0, 200);
        this.syncDocumentHubState();
        await this.service.render();
    }

    public async setDocumentHubFilter(key: string, value: string) {
        if (!['category', 'type', 'language', 'sort'].includes(key)) return;
        this.documentHubFilters[key] = String(value || (key === 'sort' ? 'updated' : 'all'));
        this.syncDocumentHubState();
        await this.service.render();
    }

    public async toggleDocumentHubDetailedFilters() {
        this.showDocumentHubDetailedFilters = !this.showDocumentHubDetailedFilters;
        await this.service.render();
    }

    public async setDocumentHubCategory(categoryId: string) {
        await this.setDocumentHubFilter('category', categoryId || 'all');
    }

    public async resetDocumentHubFilters() {
        const sort = String(this.documentHubFilters.sort || 'updated');
        this.documentHubQuery = '';
        this.documentHubFilters = { category: 'all', type: 'all', language: 'all', sort };
        this.syncDocumentHubState();
        await this.service.render();
    }

    public documentHubDocuments() {
        const query = String(this.documentHubQuery || '').trim().toLocaleLowerCase();
        const tokens = query.split(/\s+/).filter(Boolean);
        const category = String(this.documentHubFilters.category || 'all');
        const type = String(this.documentHubFilters.type || 'all');
        const language = String(this.documentHubFilters.language || 'all');
        const rows = (this.documentHubData.documents || []).filter((item: any) => {
            if (category !== 'all' && !this.documentHubDocumentHasCategory(item, category)) return false;
            if (type !== 'all' && item.typeKey !== type && item.typeLabel !== type) return false;
            if (language !== 'all' && item.languageKey !== language && item.languageLabel !== language) return false;
            if (!tokens.length) return true;
            const categoryLabels = (item.aiCategories || []).map((value: string) => this.documentHubCategoryLabel(value));
            const haystack = [
                item.title, item.subtitle, item.typeLabel, item.languageLabel, item.source,
                item.organization, item.aiSummary, item.detailedDescription,
                ...(item.authors || []), ...(item.keywords || []), ...categoryLabels,
            ].filter(Boolean).join(' ').toLocaleLowerCase();
            return tokens.every((token: string) => haystack.includes(token));
        });
        const sort = String(this.documentHubFilters.sort || 'updated');
        return [...rows].sort((left: any, right: any) => {
            if (sort === 'title') return String(left.title || '').localeCompare(String(right.title || ''), 'ko');
            if (sort === 'pages') return Number(right.pageCount || 0) - Number(left.pageCount || 0);
            if (sort === 'chunks') return Number(right.pipeline?.chunkCount || 0) - Number(left.pipeline?.chunkCount || 0);
            return String(right.updatedAt || right.publishedAt || '').localeCompare(String(left.updatedAt || left.publishedAt || ''));
        });
    }

    public documentHubDocumentHasCategory(item: any, categoryId: string) {
        const option = (this.documentHubData.categories || [])
            .find((category: any) => category.id === categoryId || category.label === categoryId);
        const candidates = [categoryId, option?.label].filter(Boolean);
        return (item?.aiCategories || []).some((value: string) => candidates.includes(value));
    }

    public documentHubCategoryLabel(value: string) {
        const option = (this.documentHubData.categories || [])
            .find((item: any) => item.id === value || item.label === value);
        return option?.label || value || '미분류';
    }

    public documentHubCategoryCount(categoryId: string) {
        const documents = this.documentHubData.documents || [];
        if (categoryId === 'all') return documents.length;
        return documents.filter((item: any) => this.documentHubDocumentHasCategory(item, categoryId)).length;
    }

    public documentHubCategories() {
        return [...(this.documentHubData.categories || [])].sort((left: any, right: any) =>
            String(left?.label || '').localeCompare(String(right?.label || ''), 'ko', {
                numeric: true,
                sensitivity: 'base',
            })
        );
    }

    public documentHubActiveCategoryLabel() {
        const categoryId = String(this.documentHubFilters.category || 'all');
        return categoryId === 'all' ? '전체 문서' : this.documentHubCategoryLabel(categoryId);
    }

    public documentHubActiveCategoryTone() {
        const categoryId = String(this.documentHubFilters.category || 'all');
        return categoryId === 'all' ? 'is-all' : this.documentHubCategoryTone(categoryId);
    }

    public documentHubActiveFilterCount() {
        return ['category', 'type', 'language']
            .filter((key: string) => this.documentHubFilters[key] && this.documentHubFilters[key] !== 'all')
            .length;
    }

    public documentHubCategoryTone(value: string) {
        const categories = this.documentHubCategories();
        const index = categories.findIndex((item: any) => item.id === value || item.label === value);
        return `tone-${(Math.max(0, index) % 12) + 1}`;
    }

    public documentHubMetricCards() {
        const documents = this.documentHubData.documents || [];
        const summary = this.documentHubData.summary || {};
        const totalDocuments = Number(summary.totalDocuments ?? documents.length);
        const totalPages = Number(summary.totalPages ?? documents.reduce((sum: number, item: any) => sum + Number(item.pageCount || 0), 0));
        const totalChunks = Number(summary.totalChunks ?? documents.reduce((sum: number, item: any) => sum + Number(item.pipeline?.chunkCount || 0), 0));
        const vectorized = Number(summary.vectorizedDocuments ?? documents.filter((item: any) => ['ready', 'completed', 'indexed'].includes(String(item.pipeline?.vectorStatus || ''))).length);
        const rate = totalDocuments ? Math.round((vectorized / totalDocuments) * 100) : 0;
        return [
            { label: '전체 문서', value: totalDocuments, unit: '건', note: 'Agent 검색 대상', icon: 'fa-solid fa-folder-open', tone: 'blue' },
            { label: '전체 페이지', value: totalPages, unit: 'p', note: '전체 페이지 미리보기', icon: 'fa-regular fa-file-lines', tone: 'violet' },
            { label: '생성 청크', value: totalChunks, unit: '개', note: '검색용 문맥 단위', icon: 'fa-solid fa-cubes-stacked', tone: 'cyan' },
            { label: '벡터화 완료', value: `${vectorized}/${totalDocuments}`, unit: '', note: `${rate}% 색인 완료`, icon: 'fa-solid fa-diagram-project', tone: 'green' },
        ];
    }

    public documentHubPipelineStages() {
        if (Array.isArray(this.documentHubData.pipeline) && this.documentHubData.pipeline.length) {
            return this.documentHubData.pipeline;
        }
        const pipeline = this.documentHubData.pipeline || {};
        if (pipeline.parser || pipeline.chunking || pipeline.metadata || pipeline.embedding || pipeline.vector) {
            return [
                { id: 'parse', label: 'Parsing', detail: pipeline.parser?.name || '문서 구조·본문 추출', status: pipeline.parser?.status },
                { id: 'chunk', label: 'Chunking', detail: pipeline.chunking?.name || '의미 단위 분할', status: pipeline.chunking?.status },
                { id: 'metadata', label: 'AI Metadata', detail: pipeline.metadata?.name || '요약·카테고리 생성', status: pipeline.metadata?.status },
                { id: 'embedding', label: 'Embedding', detail: pipeline.embedding?.name || '다국어 임베딩', status: pipeline.embedding?.status },
                { id: 'vector', label: 'Vector Index', detail: pipeline.vector?.index || 'Agent 검색 색인', status: pipeline.vector?.status },
            ];
        }
        return [
            { id: 'parse', label: 'Parsing', detail: '문서 구조·표·본문 추출', status: 'completed' },
            { id: 'chunk', label: 'Chunking', detail: '의미 단위 분할', status: 'completed' },
            { id: 'metadata', label: 'AI Metadata', detail: '요약·카테고리 생성', status: 'completed' },
            { id: 'embedding', label: 'Embedding', detail: '다국어 임베딩', status: 'completed' },
            { id: 'vector', label: 'Vector Index', detail: 'Agent 검색 색인', status: 'completed' },
        ];
    }

    public documentHubTypeIcon(typeKey: string) {
        const icons: any = {
            paper: 'fa-solid fa-scroll',
            technical: 'fa-solid fa-file-code',
            manual: 'fa-solid fa-book-open',
            glossary: 'fa-solid fa-spell-check',
        };
        return icons[typeKey] || 'fa-regular fa-file-lines';
    }

    public documentHubHasActiveFilters() {
        return Boolean(String(this.documentHubQuery || '').trim())
            || ['category', 'type', 'language'].some((key: string) => this.documentHubFilters[key] && this.documentHubFilters[key] !== 'all');
    }

    public hubDocumentAuthors(documentItem: any) {
        return (documentItem?.authors || []).join(', ') || documentItem?.organization || '데모 문서 편집팀';
    }

    public currentHubDocumentPage() {
        const pages = this.selectedHubDocument?.pages || [];
        return pages.find((page: any) => Number(page.number) === Number(this.selectedHubPage)) || pages[0] || null;
    }

    public hubDocumentPageNumbers() {
        return (this.selectedHubDocument?.pages || []).map((page: any) => Number(page.number));
    }

    public async openHubDocument(documentItem: any) {
        if (!documentItem?.id) return;
        if (typeof document !== 'undefined') this.hubModalReturnFocus = document.activeElement as HTMLElement;
        this.selectedHubDocument = documentItem;
        this.requestedHubDocumentId = documentItem.id;
        this.selectedHubPage = Number(documentItem.pages?.[0]?.number || 1);
        this.syncDocumentHubState();
        await this.service.render();
        if (typeof document !== 'undefined') {
            setTimeout(() => (document.querySelector('.agent-document-modal') as HTMLElement)?.focus(), 0);
        }
    }

    public async closeHubDocument() {
        const returnFocus = this.hubModalReturnFocus;
        this.selectedHubDocument = null;
        this.requestedHubDocumentId = '';
        this.selectedHubPage = 1;
        this.hubModalReturnFocus = null;
        this.syncDocumentHubState();
        await this.service.render();
        if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
    }

    public async setHubDocumentPage(pageNumber: number) {
        const pages = this.hubDocumentPageNumbers();
        const next = Number(pageNumber);
        if (!pages.includes(next)) return;
        this.selectedHubPage = next;
        this.syncDocumentHubState();
        await this.service.render();
        if (typeof document !== 'undefined') {
            const scroller = document.querySelector('.agent-document-page-scroll') as HTMLElement;
            if (scroller) scroller.scrollTop = 0;
        }
    }

    public async stepHubDocumentPage(direction: number) {
        const pages = this.hubDocumentPageNumbers();
        const index = pages.indexOf(Number(this.selectedHubPage));
        const nextIndex = index + Number(direction || 0);
        if (index < 0 || nextIndex < 0 || nextIndex >= pages.length) return;
        await this.setHubDocumentPage(pages[nextIndex]);
    }

    public handleHubDialogKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeHubDocument();
            return;
        }
        if (event.key !== 'Tab' || typeof document === 'undefined') return;
        const dialog = document.querySelector('.agent-document-modal');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
            .filter((element: HTMLElement) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public async downloadDocumentHubCatalog() {
        const payload = {
            exportedAt: new Date().toISOString(),
            sample: true,
            filters: { query: this.documentHubQuery, ...this.documentHubFilters },
            summary: this.documentHubData.summary,
            documents: this.documentHubDocuments(),
        };
        await this.service.file.download(payload, 'agent-document-hub-sample.json');
    }

    public async loadSection(sectionId: string, force: boolean = false) {
        sectionId = this.normalizeSection(sectionId);
        this.hydrateAgentSectionState(sectionId);
        if (sectionId !== 'chat' || !this.sectionErrors.chat) this.sectionErrors[sectionId] = '';
        this.sectionLoading[sectionId] = true;
        await this.service.render();

        try {
            if (sectionId === 'chat' && force) this.historyBackendLoaded = false;
            if (sectionId === 'chat' && !this.historyBackendLoaded) {
                await this.loadBackendHistory();
            }
            if (sectionId === 'workflows' && (force || !this.workflowData.templates?.length)) {
                this.workflowData = await this.callApi('workflow_detail', {}, '워크플로 데이터를 불러오지 못했습니다.');
            }
            if (sectionId === 'workflows') {
                this.ensureWorkflowSelection();
                this.syncAgentSectionState('workflows');
            }
            if (sectionId === 'stats') {
                this.statsData = await this.callApi('usage_stats', {}, '사용 통계를 불러오지 못했습니다.');
            }
            if (sectionId === 'history' && (force || !this.documentHubData.documents?.length)) {
                this.hydrateDocumentHubState();
                this.documentHubData = await this.callApi('document_hub', {}, 'Agent 문서 허브를 불러오지 못했습니다.');
                this.restoreHubDocumentSelection();
            }
            if (sectionId === 'lot-history' && (force || !this.processTraceData.traces?.length)) {
                await this.loadProcessTrace(false);
            }
            if (sectionId === 'analysis' && (force || !this.analysisCatalogData.modelRegistry?.registry?.length)) {
                this.analysisCatalogData = await this.callApi('analysis_catalog', {}, '분석 모델 안내를 불러오지 못했습니다.');
            }
            if (sectionId === 'analysis' && this.analysisWorkspaceOpen && (force || !this.analysisData.modelRegistry?.registry?.length)) {
                this.analysisData = await this.callApi('analysis_hub', this.analysisRequestParams(), 'AI 분석 데이터를 불러오지 못했습니다.');
                this.analysisInputsDirty = false;
                this.analysisSelectionsDirty = false;
            }
            if (sectionId === 'analysis' && this.analysisWorkspaceOpen && this.analysisData.modelRegistry?.registry?.length) {
                this.applyAnalysisResponseState();
            }
            if (sectionId === 'analysis') this.syncAgentSectionState('analysis');
            if (sectionId === 'trace' && (force || !this.traceData.similarity)) {
                this.traceData = await this.callApi('trace_panel', this.traceRequestParams(), 'Trace 데이터를 불러오지 못했습니다.');
            }
            if (sectionId === 'trace') {
                this.applyTraceResponseState();
                this.ensureTraceSegment();
                this.syncAgentSectionState('trace');
            }
            if (sectionId === 'visualization' && (force || !this.visualizationReportData.visualization?.module)) {
                this.visualizationReportData = await this.callApi('visualization_report', this.visualizationRequestParams(), '시각화 데이터를 불러오지 못했습니다.');
            }
            if (sectionId === 'visualization') {
                this.ensureVisualizationSelection();
                this.syncAgentSectionState('visualization');
            }
            if (sectionId === 'quality' && (force || !this.dataQualityData.ingestion?.module)) {
                this.dataQualityData = await this.callApi('ingestion_quality', {}, '품질 데이터를 불러오지 못했습니다.');
                this.ingestionRuns = this.dataQualityData.ingestion?.uploadRuns || [];
            }
            if (sectionId === 'quality' && (force || !this.knowledgeCatalogData.policy?.documentFormats)) {
                try {
                    this.sectionErrors.knowledge = '';
                    this.knowledgeCatalogData = await this.callApi('knowledge_catalog', {}, '문서·데이터셋 카탈로그를 불러오지 못했습니다.');
                    this.prepareKnowledgeCatalog();
                } catch (error: any) {
                    this.sectionErrors.knowledge = this.errorText(error, '문서·데이터셋 카탈로그를 불러오지 못했습니다.');
                }
            }
            if (sectionId === 'quality' && this.requestedKnowledgeDocumentId) {
                const requested = (this.knowledgeCatalogData.documents || [])
                    .find((item: any) => item.id === this.requestedKnowledgeDocumentId);
                if (requested) {
                    await this.openKnowledgeDocument(requested);
                    this.requestedKnowledgeDocumentId = '';
                } else if (!this.sectionErrors.knowledge) {
                    this.sectionErrors.knowledge = '연결된 문서를 현재 권한으로 열 수 없습니다. 보관 상태와 공개 범위를 확인해주세요.';
                }
            }
            if (sectionId === 'admin' && this.adminSettingsWorkspace === 'operations' && (force || !this.adminConsoleData.operations?.module)) {
                this.adminConsoleData = await this.callApi('admin_console', {}, '관리자 데이터를 불러오지 못했습니다.');
            }
            if (sectionId === 'admin' && this.adminSettingsWorkspace === 'llm' && (force || !this.llmSettingsData.models?.length)) {
                await this.loadLlmSettings(false);
            }
            if (sectionId === 'admin' && this.adminSettingsWorkspace === 'document-ai' && (force || !this.documentPipelineData.stages?.length)) {
                await this.loadDocumentPipelineSettings(false);
            }
            if (sectionId === 'admin') this.syncAgentSectionState('admin');
            if (sectionId === 'training' && (force || !this.trainingData.scenarios?.length)) {
                this.trainingData = await this.callApi('training_scenarios', {}, '학습 시나리오를 불러오지 못했습니다.');
            }
        } catch (error: any) {
            this.sectionErrors[sectionId] = this.errorText(error);
        }

        this.sectionLoading[sectionId] = false;
        await this.service.render();
    }

    public async loadProcessTrace(render: boolean = true) {
        this.hydrateExplorerState();
        const errorSection = this.section === 'lot-history' ? 'lot-history' : 'history';
        const requestSeq = ++this.explorerRequestSeq;
        this.explorerDetailSeq += 1;
        this.detailLoading = false;
        const requestParams = { ...this.explorerRequestParams() };
        this.historyLoading = true;
        this.sectionErrors[errorSection] = '';
        if (render) await this.service.render();
        try {
            const nextExplorerData = await this.callApi('data_explorer', requestParams, '데이터 탐색 결과를 불러오지 못했습니다.');
            if (requestSeq !== this.explorerRequestSeq) return;

            const records = nextExplorerData.search?.records || [];
            const operationalVersionId = String(nextExplorerData?.meta?.version?.id || '');
            const selectedId = records.some((record: any) => record.id === requestParams.record_id)
                ? requestParams.record_id
                : (records[0]?.id || '');
            const targetRecord = records.find((record: any) => record.id === selectedId) || null;
            const embeddedDetail = nextExplorerData.selectedRecord?.record?.id === selectedId
                ? nextExplorerData.selectedRecord
                : null;
            const detailPromise = selectedId && !embeddedDetail
                ? this.callApi('process_detail', {
                    record_id: selectedId,
                    source_scope: requestParams.source_scope,
                    version_id: operationalVersionId,
                }, '상세 정보를 불러오지 못했습니다.')
                : Promise.resolve(embeddedDetail);
            const traceKey = targetRecord?.lot || this.explorerFilters.lot || '';
            const tracePromise = traceKey
                ? this.callApi('process_trace', {
                    lot_id: traceKey,
                    source_scope: requestParams.source_scope,
                    version_id: operationalVersionId,
                }, 'Lot 이력을 불러오지 못했습니다.')
                : Promise.resolve({ traces: [], sensors: [], metrology: [], lot: '' });
            const [nextSelectedRecord, nextTraceData] = await Promise.all([detailPromise, tracePromise]);
            if (requestSeq !== this.explorerRequestSeq) return;

            this.explorerData = nextExplorerData;
            this.ensureOperationalAnalysisModel();
            this.operationalAnalysisResult = null;
            this.operationalAnalysisError = '';
            this.explorerFilters.page = Number(nextExplorerData.search?.pagination?.page || 1);
            this.selectedRecordId = selectedId;
            this.selectedRecord = nextSelectedRecord;
            this.processTraceData = nextTraceData;
            this.syncExplorerState();
        } catch (error: any) {
            if (requestSeq === this.explorerRequestSeq) {
                this.sectionErrors[errorSection] = this.errorText(error);
            }
        } finally {
            if (requestSeq === this.explorerRequestSeq) {
                this.historyLoading = false;
                await this.service.render();
            }
        }
    }

    public hydrateExplorerState() {
        if (this.explorerStateHydrated) return;
        const params = new URLSearchParams(location.search || '');
        const query = params.get('q') || '';
        const lot = params.get('lot') || '';
        if (lot) {
            this.explorerFilters.lot = lot;
            this.lotSearch = query;
        } else if (this.isLotQuery(query)) {
            this.explorerFilters.lot = this.normalizeLotQuery(query);
            this.lotSearch = '';
        } else {
            this.lotSearch = query || this.lotSearch;
        }
        this.explorerFilters.process = params.get('process') || this.explorerFilters.process;
        this.explorerFilters.equipment = params.get('equipment') || this.explorerFilters.equipment;
        this.explorerFilters.status = params.get('status') || this.explorerFilters.status;
        const requestedSource = params.get('source_scope') || 'sample';
        this.explorerFilters.source_scope = (
            requestedSource === 'operational' && this.service.auth.session?.role === 'admin'
        ) ? 'operational' : 'sample';
        this.explorerFilters.sort = params.get('sort') || this.explorerFilters.sort;
        this.explorerFilters.order = params.get('order') || this.explorerFilters.order;
        this.explorerFilters.page = Number(params.get('page') || this.explorerFilters.page) || 1;
        this.explorerFilters.dump = [10, 20, 50].includes(Number(params.get('dump')))
            ? Number(params.get('dump'))
            : this.explorerFilters.dump;
        this.selectedRecordId = params.get('record') || this.selectedRecordId;
        this.activeExplorerTab = this.normalizeExplorerTab(params.get('tab') || this.activeExplorerTab);
        this.explorerStateHydrated = true;
    }

    public explorerRequestParams() {
        return {
            source_scope: this.explorerFilters.source_scope || 'sample',
            query: this.lotSearch || '',
            lot: this.explorerFilters.lot || '',
            process: this.explorerFilters.process || '',
            equipment: this.explorerFilters.equipment || '',
            status: this.explorerFilters.status || '',
            sort: this.explorerFilters.sort || 'date',
            order: this.explorerFilters.order || 'desc',
            page: this.explorerFilters.page || 1,
            dump: this.explorerFilters.dump || 20,
            record_id: this.selectedRecordId || ''
        };
    }

    public syncExplorerState() {
        if (this.section !== 'history' && this.section !== 'lot-history') return;
        const params = new URLSearchParams();
        const state: any = this.explorerRequestParams();
        if (state.query && !this.isLotQuery(state.query)) params.set('q', state.query);
        ['lot', 'process', 'equipment', 'status', 'sort', 'order'].forEach((key: string) => {
            if (state[key]) params.set(key, state[key]);
        });
        if (state.source_scope === 'operational') params.set('source_scope', 'operational');
        if (state.page && Number(state.page) > 1) params.set('page', String(state.page));
        if (state.dump && Number(state.dump) !== 20) params.set('dump', String(state.dump));
        if (this.selectedRecordId) params.set('record', this.selectedRecordId);
        if (this.section === 'history' && this.activeExplorerTab && this.activeExplorerTab !== 'summary') {
            params.set('tab', this.activeExplorerTab);
        }
        const query = params.toString();
        const path = this.section === 'lot-history' ? '/agent/lot-history' : '/agent/history';
        history.replaceState(null, '', `${path}${query ? '?' + query : ''}`);
    }

    public hydrateAgentSectionState(sectionId: string) {
        if (this.agentStateHydrated[sectionId] || sectionId === 'history' || sectionId === 'lot-history') return;
        const params = new URLSearchParams(location.search || '');
        if (sectionId === 'workflows') {
            this.workflowSearch = params.get('q') || this.workflowSearch;
            this.workflowFilter = params.get('filter') || this.workflowFilter;
            this.workflowRunInput = params.get('input') || this.workflowRunInput;
            this.selectedWorkflowId = params.get('workflow') || this.selectedWorkflowId;
            this.activeWorkflowTab = this.normalizeWorkflowTab(params.get('tab') || this.activeWorkflowTab);
        }
        if (sectionId === 'analysis') {
            const legacyTestParams = ['q', 'model', 'metric', 'target', 'mode', 'record', 'rca', 'recipe', 'tab'];
            const requestedView = params.get('view') || '';
            this.analysisWorkspaceOpen = requestedView === 'test' || (
                requestedView !== 'catalog'
                && legacyTestParams.some((key: string) => params.has(key))
            );
            this.analysisQuery = params.get('q') || 'Lot A13 두께 이상 원인 분석';
            this.analysisModelId = params.get('model') || '';
            this.analysisMetric = params.get('metric') || 'thickness';
            this.analysisMode = params.get('mode') || 'auto';
            this.selectedAnalysisRecordId = params.get('record') || '';
            this.selectedRcaFactorName = params.get('rca') || '';
            this.selectedOptimizationRecipeId = params.get('recipe') || '';
            const target = Number(params.get('target') || 120);
            this.analysisTarget = Number.isFinite(target) ? target : 120;
            ['temperature', 'pressure', 'power', 'time'].forEach((key: string) => {
                const raw = params.get(key);
                const value = raw === null || raw === '' ? null : Number(raw);
                this.analysisVariables[key] = value !== null && Number.isFinite(value) ? value : null;
            });
            this.activeAnalysisTab = this.normalizeAnalysisTab(params.get('tab') || this.analysisModeToTab(this.analysisMode) || 'model');
        }
        if (sectionId === 'trace') {
            this.traceBase = params.get('base') || this.traceBase;
            this.traceTarget = params.get('target') || this.traceTarget;
            this.traceMetric = params.get('metric') || this.traceMetric;
            this.traceMode = params.get('mode') || this.traceMode;
            this.traceFilters = {
                lot: params.get('lot') || this.traceFilters.lot || '',
                process: params.get('process') || this.traceFilters.process || '',
                equipment: params.get('equipment') || this.traceFilters.equipment || '',
                status: params.get('status') || this.traceFilters.status || '',
            };
            if (!params.get('lot') && this.traceTargetIsLot(this.traceTarget)) {
                this.traceFilters.lot = this.traceTarget;
            }
            if (!params.get('equipment') && !this.traceFilters.lot && this.traceTargetIsEquipment(this.traceTarget)) {
                this.traceFilters.equipment = this.traceTarget;
            }
            this.traceActiveTab = this.normalizeTraceTab(params.get('tab') || this.traceActiveTab);
        }
        if (sectionId === 'visualization') {
            this.chartType = params.get('chart') || this.chartType;
            this.visualizationDataset = params.get('dataset') || this.visualizationDataset;
            this.visualizationMetric = params.get('metric') || this.visualizationMetric;
        }
        if (sectionId === 'quality') {
            const workspace = params.get('workspace') || '';
            if (['files', 'documents', 'datasets'].includes(workspace)) {
                this.activeQualityWorkspace = workspace;
            }
            this.requestedKnowledgeDocumentId = params.get('document') || '';
            if (this.requestedKnowledgeDocumentId) this.activeQualityWorkspace = 'documents';
        }
        if (sectionId === 'admin') {
            const workspace = params.get('workspace') || 'llm';
            this.adminSettingsWorkspace = ['llm', 'document-ai', 'operations'].includes(workspace)
                ? workspace
                : 'llm';
        }
        this.agentStateHydrated[sectionId] = true;
    }

    public syncAgentSectionState(sectionId: string) {
        if (this.section !== sectionId) return;
        const params = new URLSearchParams();
        if (sectionId === 'workflows') {
            if (this.workflowSearch) params.set('q', this.workflowSearch);
            if (this.workflowFilter && this.workflowFilter !== 'all') params.set('filter', this.workflowFilter);
            if (this.selectedWorkflowId) params.set('workflow', this.selectedWorkflowId);
            if (this.workflowRunInput) params.set('input', this.workflowRunInput);
            if (this.activeWorkflowTab && this.activeWorkflowTab !== 'templates') params.set('tab', this.activeWorkflowTab);
        }
        if (sectionId === 'analysis') {
            if (this.analysisWorkspaceOpen) {
                params.set('view', 'test');
                if (this.analysisQuery) params.set('q', this.analysisQuery);
                if (this.analysisModelId) params.set('model', this.analysisModelId);
                if (this.analysisMetric) params.set('metric', this.analysisMetric);
                if (this.analysisTarget) params.set('target', String(this.analysisTarget));
                if (this.analysisMode && this.analysisMode !== 'auto') params.set('mode', this.analysisMode);
                if (this.selectedAnalysisRecordId) params.set('record', this.selectedAnalysisRecordId);
                if (this.selectedRcaFactorName) params.set('rca', this.selectedRcaFactorName);
                if (this.selectedOptimizationRecipeId) params.set('recipe', this.selectedOptimizationRecipeId);
                Object.keys(this.analysisInputOverrides()).forEach((key: string) => {
                    params.set(key, String(this.analysisInputOverrides()[key]));
                });
                if (this.activeAnalysisTab && this.activeAnalysisTab !== 'model') params.set('tab', this.activeAnalysisTab);
            }
        }
        if (sectionId === 'trace') {
            if (this.traceBase) params.set('base', this.traceBase);
            if (this.traceTarget) params.set('target', this.traceTarget);
            if (this.traceMetric) params.set('metric', this.traceMetric);
            if (this.traceFilters.lot) params.set('lot', this.traceFilters.lot);
            if (this.traceFilters.process) params.set('process', this.traceFilters.process);
            if (this.traceFilters.equipment) params.set('equipment', this.traceFilters.equipment);
            if (this.traceFilters.status) params.set('status', this.traceFilters.status);
            if (this.traceMode && this.traceMode !== 'lot') params.set('mode', this.traceMode);
            if (this.traceActiveTab && this.traceActiveTab !== 'waveform') params.set('tab', this.traceActiveTab);
        }
        if (sectionId === 'visualization') {
            if (this.chartType) params.set('chart', this.chartType);
            if (this.visualizationDataset) params.set('dataset', this.visualizationDataset);
            if (this.visualizationMetric) params.set('metric', this.visualizationMetric);
        }
        if (sectionId === 'admin' && this.adminSettingsWorkspace !== 'llm') {
            params.set('workspace', this.adminSettingsWorkspace);
        }
        const query = params.toString();
        history.replaceState(null, '', `/agent/${sectionId}${query ? '?' + query : ''}`);
    }

    public async applyExplorerFilters() {
        this.explorerFilters.page = 1;
        this.selectedRecordId = '';
        await this.loadProcessTrace();
    }

    public async changeExplorerSource(value: any) {
        const requested = String(value || '') === 'operational' && this.service.auth.session?.role === 'admin'
            ? 'operational'
            : 'sample';
        // Invalidate both the list and detail requests before exposing the new
        // source selection. This prevents a late operational response from
        // being rendered or treated as sample data while the next query runs.
        this.explorerRequestSeq += 1;
        this.explorerDetailSeq += 1;
        this.historyLoading = false;
        this.detailLoading = false;
        this.lotSearch = '';
        this.explorerFilters = { source_scope: requested, lot: '', process: '', equipment: '', status: '', sort: 'date', order: 'desc', page: 1, dump: 20 };
        this.selectedRecordId = '';
        this.selectedRecord = null;
        this.operationalAnalysisModelId = '';
        this.operationalAnalysisResult = null;
        this.operationalAnalysisError = '';
        this.processTraceData = { traces: [], sensors: [], metrology: [], lot: '', dataScope: requested, sampleDataMixed: false };
        this.explorerData = {
            dataScope: requested,
            sampleDataMixed: false,
            process: {},
            semiconductorData: { summary: {}, catalog: [] },
            search: { records: [], statistics: {}, facets: {}, pagination: { page: 1, dump: 20, total: 0, totalPages: 1 } },
            domainData: {},
            documentAI: {},
            quality: {},
            meta: {},
        };
        this.sectionErrors[this.section === 'lot-history' ? 'lot-history' : 'history'] = '';
        await this.loadProcessTrace();
    }

    public async resetExplorerFilters() {
        this.lotSearch = '';
        const sourceScope = this.explorerFilters.source_scope || 'sample';
        this.explorerFilters = { source_scope: sourceScope, lot: '', process: '', equipment: '', status: '', sort: 'date', order: 'desc', page: 1, dump: 20 };
        this.selectedRecordId = '';
        await this.loadProcessTrace();
    }

    public async setExplorerSort(field: string) {
        if (this.explorerFilters.sort === field) {
            this.explorerFilters.order = this.explorerFilters.order === 'asc' ? 'desc' : 'asc';
        } else {
            this.explorerFilters.sort = field;
            this.explorerFilters.order = field === 'date' ? 'desc' : 'asc';
        }
        await this.loadProcessTrace();
    }

    public sortIndicator(field: string) {
        if (this.explorerFilters.sort !== field) return '';
        return this.explorerFilters.order === 'asc' ? ' ↑' : ' ↓';
    }

    public explorerInterpretedFilters() {
        const labels: any = {
            temperature: '온도',
            pressure: '압력',
            power: '전력',
            time: '시간',
            thickness: '두께',
            uniformity: '균일도',
            defect: '결함률',
            cpk: 'Cpk',
            yieldScore: '수율',
            date: '날짜',
        };
        const operators: any = {
            lt: '<',
            lte: '≤',
            gt: '>',
            gte: '≥',
            eq: '=',
            neq: '≠',
        };
        const interpreted = this.explorerData.search?.appliedFilters?.query || [];
        if (!Array.isArray(interpreted)) return [];
        return interpreted.map((item: any) => ({
            label: labels[item.field] || item.field,
            operator: operators[item.operator] || item.operator,
            value: item.value,
            source: item.source || '',
        }));
    }

    public setExplorerTab(tab: string) {
        this.activeExplorerTab = this.normalizeExplorerTab(tab);
        this.syncExplorerState();
    }

    public normalizeExplorerTab(tab: string) {
        return ['summary', 'records'].indexOf(tab || '') >= 0 ? tab : 'summary';
    }

    public explorerTargetRecord() {
        return this.selectedRecord?.record || (this.explorerData.search?.records || [])[0] || null;
    }

    public explorerTargetLot() {
        const record = this.explorerTargetRecord();
        if (record?.lot) return record.lot;
        if (this.explorerFilters.lot) return this.explorerFilters.lot;
        const match = String(this.lotSearch || '').match(/lot\s*([a-z]\d{1,4})/i);
        return match ? `Lot ${match[1].toUpperCase()}` : 'Lot A13';
    }

    public explorerUsesOperationalData() {
        return this.explorerFilters.source_scope === 'operational'
            || this.explorerData?.dataScope === 'operational'
            || this.selectedRecord?.provenance?.dataScope === 'operational'
            || this.processTraceData?.dataScope === 'operational';
    }

    public explorerOperationalAnalysis() {
        return this.explorerData?.meta?.operationalAnalysis || {};
    }

    public explorerOperationalAnalysisReady() {
        return this.explorerUsesOperationalData() && this.explorerOperationalAnalysis()?.ready === true;
    }

    public explorerOperationalModels() {
        const models = this.explorerOperationalAnalysis()?.models;
        return Array.isArray(models) ? models : [];
    }

    public selectedOperationalAnalysisModel() {
        return this.explorerOperationalModels().find((item: any) => item?.id === this.operationalAnalysisModelId)
            || this.explorerOperationalModels()[0]
            || null;
    }

    private ensureOperationalAnalysisModel() {
        const models = this.explorerOperationalModels();
        if (!models.some((item: any) => item?.id === this.operationalAnalysisModelId)) {
            this.operationalAnalysisModelId = String(models[0]?.id || '');
        }
    }

    public explorerOperationalVersionId() {
        return String(this.explorerData?.meta?.version?.id || this.explorerData?.sourceMeta?.versionId || '');
    }

    public explorerFacetsApproximate() {
        return this.explorerUsesOperationalData() && this.explorerData.search?.facets?.approximate === true;
    }

    public operationalTraceTruncated() {
        if (this.processTraceData?.dataScope !== 'operational') return false;
        const pagination = this.processTraceData?.pagination || {};
        const returned = (this.processTraceData?.traces || []).length;
        return pagination.hasNext === true || Number(pagination.total || 0) > returned;
    }

    public explorerSourceLabel() {
        return this.explorerUsesOperationalData() ? '운영 적재 데이터' : '시스템 샘플 데이터';
    }

    public explorerSourceNotice() {
        if (this.explorerUsesOperationalData()) {
            const version = this.explorerData?.sourceMeta?.versionId || this.explorerData?.meta?.version?.id || '활성 버전 없음';
            const analysis = this.explorerOperationalAnalysisReady()
                ? '승인 운영 AI 경계 사용 가능'
                : '운영 AI는 준비 전까지 차단';
            return `${version} · 샘플과 혼합하지 않는 읽기 전용 조회 · ${analysis}`;
        }
        return '화면·AI 흐름 검증용 샘플이며 실제 생산 판단용 데이터가 아닙니다.';
    }

    public explorerQueryPlaceholder() {
        return this.explorerUsesOperationalData()
            ? '운영 자유어 AND 검색: "Lot A13" etch (비교식·OR/NOT 미지원)'
            : '자연어/키워드 검색: Lot A13 두께 이상, 식각 endpoint';
    }

    public async goExplorerAnalysis() {
        if (this.explorerUsesOperationalData()) {
            await this.runOperationalAnalysis(this.explorerTargetRecord());
            return;
        }
        const record = this.explorerTargetRecord();
        const query = record
            ? `${record.lot} ${record.process} ${record.id} 원인 분석 및 예측`
            : (this.lotSearch || `${this.explorerTargetLot()} 이상 원인 분석 및 예측`);
        const params = new URLSearchParams();
        params.set('q', query);
        params.set('metric', 'thickness');
        params.set('mode', 'auto');
        if (record?.id) params.set('record', record.id);
        this.service.href(`/agent/analysis?${params.toString()}`);
    }

    public operationalAnalysisOutput(item: any) {
        const output = item?.output || {};
        return Object.keys(output).map((key: string) => `${key}: ${String(output[key])}`).join(' · ');
    }

    public operationalAnalysisProvenance(item: any) {
        const provenance = item?.provenance || {};
        const contentHash = String(provenance.operationalContentHash || '').slice(0, 12);
        const inputHash = String(provenance.inputSha256 || '').slice(0, 12);
        return `데이터 ${contentHash || '-'} · 입력 ${inputHash || '-'} · 모델 ${provenance.modelVersion || '-'}`;
    }

    public async runOperationalAnalysis(record: any = null) {
        if (!this.explorerUsesOperationalData()) return;
        const readiness = this.explorerOperationalAnalysis();
        if (readiness?.ready !== true) {
            await this.service.modal.error(readiness?.reason || '승인 운영 AI 경계가 준비되지 않아 실행을 차단했습니다.');
            return;
        }
        record = record || this.explorerTargetRecord();
        if (!record?.id) {
            await this.service.modal.error('분석할 운영 레코드를 먼저 선택해주세요.');
            return;
        }
        this.ensureOperationalAnalysisModel();
        if (!this.operationalAnalysisModelId) {
            await this.service.modal.error('실행 가능한 승인 모델이 없습니다. 관리자 설정을 확인해주세요.');
            return;
        }

        this.operationalAnalysisBusy = true;
        this.operationalAnalysisError = '';
        this.operationalAnalysisResult = null;
        await this.service.render();
        try {
            const status = await this.callApi(
                'operational_analysis_status', {}, '운영 AI 준비 상태를 확인하지 못했습니다.'
            );
            if (status?.ready !== true || !status?.csrfToken) {
                throw new Error(status?.reason || '운영 AI 경계가 실행 준비 상태가 아닙니다.');
            }
            const models = Array.isArray(status.models) ? status.models : [];
            if (!models.some((item: any) => item?.id === this.operationalAnalysisModelId)) {
                throw new Error('선택한 모델이 더 이상 승인 목록에 없습니다. 화면을 새로고침해주세요.');
            }
            const randomPart = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
                ? crypto.randomUUID()
                : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
            this.operationalAnalysisResult = await this.callApi('operational_analysis_run', {
                model_id: this.operationalAnalysisModelId,
                record_id: String(record.id),
                version_id: this.explorerOperationalVersionId(),
                csrf_token: status.csrfToken,
                idempotency_key: `ui-${randomPart}`,
            }, '운영 AI 분석을 실행하지 못했습니다.');
        } catch (error: any) {
            this.operationalAnalysisError = this.errorText(error, '운영 AI 분석을 실행하지 못했습니다.');
        }
        this.operationalAnalysisBusy = false;
        await this.service.render();
    }

    public async goTraceCompareFromExplorer() {
        if (this.explorerUsesOperationalData()) {
            await this.service.modal.error('운영 센서/Trace adapter가 연결되지 않아 샘플 파형 비교로 전환하지 않았습니다.');
            return;
        }
        const params = new URLSearchParams();
        params.set('base', 'baseline');
        params.set('target', this.explorerTargetLot());
        params.set('metric', 'pressure');
        params.set('tab', 'waveform');
        this.service.href(`/agent/trace?${params.toString()}`);
    }

    public totalExplorerPages() {
        const pagination = this.explorerData.search?.pagination || {};
        return Math.max(1, Number(pagination.totalPages || Math.ceil((pagination.total || 0) / (pagination.dump || 20))));
    }

    public explorerPageNumbers() {
        const total = this.totalExplorerPages();
        const current = Math.max(1, Number(this.explorerData.search?.pagination?.page || this.explorerFilters.page || 1));
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        return Array.from({ length: Math.max(0, end - start + 1) }, (_: any, index: number) => start + index);
    }

    public canNextExplorerPage() {
        const pagination = this.explorerData.search?.pagination || {};
        return (pagination.page || 1) * (pagination.dump || 20) < (pagination.total || 0);
    }

    public dataHubVizColor(tone: string) {
        const colors: any = {
            oxide: '#3b82f6',
            emerald: '#20c997',
            amber: '#f4b740',
            rose: '#f05d75',
            graphite: '#475569',
            ok: '#3b82f6',
            watch: '#f4b740',
            hot: '#f05d75',
            idle: '#94a3b8',
        };
        return colors[tone] || colors.oxide;
    }

    public explorerSummaryMetrics() {
        const search = this.explorerData.search || {};
        const stats = search.statistics || {};
        const basics = stats.basics || {};
        const thicknessAvailable = this.hasMetricValue(basics.thicknessAvg);
        const uniformityAvailable = this.hasMetricValue(basics.uniformityAvg);
        const defectAvailable = this.hasMetricValue(basics.defectAvg);
        return [
            {
                label: '검색 결과',
                value: search.pagination?.total || stats.count || 0,
                unit: '건',
                note: stats.summary || '검색 대기',
                tone: 'graphite',
                width: this.metricRatio(search.pagination?.total || stats.count || 0, 20),
            },
            {
                label: '평균 두께',
                value: thicknessAvailable ? basics.thicknessAvg : '-',
                unit: thicknessAvailable ? 'nm' : '',
                note: thicknessAvailable ? 'target 120nm' : '필드 미제공',
                tone: 'oxide',
                width: thicknessAvailable ? this.metricRatio(basics.thicknessAvg, 124) : 0,
            },
            {
                label: '평균 균일도',
                value: uniformityAvailable ? basics.uniformityAvg : '-',
                unit: uniformityAvailable ? '%' : '',
                note: uniformityAvailable ? 'goal 95%+' : '필드 미제공',
                tone: 'emerald',
                width: uniformityAvailable ? this.metricRatio(basics.uniformityAvg, 100) : 0,
            },
            {
                label: '평균 결함률',
                value: defectAvailable ? basics.defectAvg : '-',
                unit: '',
                note: defectAvailable ? 'limit 0.30' : '필드 미제공',
                tone: 'rose',
                width: defectAvailable ? this.metricRatio(0.7 - Math.min(Number(basics.defectAvg), 0.7), 0.7) : 0,
            },
        ];
    }

    public hasMetricValue(value: any) {
        if (value === null || value === undefined || value === '' || typeof value === 'boolean') return false;
        return Number.isFinite(Number(value));
    }

    public recordMetricLabel(value: any, unit: string = '') {
        return this.hasMetricValue(value) ? `${value}${unit}` : '-';
    }

    public valueOrDash(value: any) {
        return value === null || value === undefined || String(value).trim() === '' ? '-' : value;
    }

    public explorerStatusItems() {
        const status = this.explorerData.search?.statistics?.status || {};
        return [
            { key: 'ok', label: '정상', value: status.ok || 0, className: 'data-status-ok' },
            { key: 'watch', label: '관찰', value: status.watch || 0, className: 'data-status-watch' },
            { key: 'hot', label: '긴급', value: status.hot || 0, className: 'data-status-hot' },
        ];
    }

    public explorerProcessDistribution() {
        const distribution = this.explorerData.search?.statistics?.distributions?.process || {};
        return Object.keys(distribution).map((key: string) => ({ key, value: distribution[key] }));
    }

    public dataHubPrimaryMetrics() {
        const search = this.explorerData.search || {};
        const stats = search.statistics || {};
        const searchTotal = search.pagination?.total || stats.count || 0;
        const traceLot = this.processTraceData.lot || this.explorerFilters.lot || this.lotSearch || '';
        const linkedSignals = this.filteredSensorReadings().length + this.filteredMetrologyRows().length;
        return [
            {
                label: '검색 결과',
                value: searchTotal,
                unit: '건',
                note: 'Lot·레시피 매칭',
                state: '현재 조건 기준',
                tone: 'oxide',
                icon: 'fa-solid fa-magnifying-glass',
            },
            {
                label: 'Trace 단계',
                value: this.processTraceData.traces?.length || 0,
                unit: '단계',
                note: '공정 흐름',
                state: traceLot ? `${traceLot} 기준` : 'Lot 선택 대기',
                stateTone: traceLot ? 'neutral' : 'muted',
                tone: 'emerald',
                icon: 'fa-solid fa-route',
            },
            {
                label: '연결 신호',
                value: linkedSignals,
                unit: '개',
                note: 'RCA 근거 연결',
                state: '센서·계측 매칭',
                tone: 'amber',
                icon: 'fa-solid fa-link',
            },
            {
                label: '연결 데이터',
                value: this.dataHubCatalogTotal(),
                unit: '건',
                note: '공정·장비·품질 신호',
                state: '데이터 소스 합산',
                tone: 'rose',
                icon: 'fa-solid fa-database',
            },
        ];
    }

    public dataHubCatalogCards() {
        const catalog = this.filteredDataCatalog();
        const max = Math.max(1, ...catalog.map((item: any) => Number(item.count || 0)));
        const tones = ['oxide', 'emerald', 'amber', 'rose', 'graphite'];
        return catalog.slice(0, 8).map((item: any, index: number) => ({
            ...item,
            pct: this.metricRatio(Number(item.count || 0), max),
            tone: tones[index % tones.length],
            examplesText: (item.examples || []).slice(0, 3).join(' · '),
        }));
    }

    public dataHubCatalogTotal() {
        return this.dataHubCatalogCards().reduce((total: number, item: any) => total + Number(item.count || 0), 0);
    }

    public dataHubCatalogDonutStyle() {
        const catalog = this.dataHubCatalogCards();
        const total = Math.max(1, this.dataHubCatalogTotal());
        let cursor = 0;
        const stops = catalog.map((item: any) => {
            const start = cursor;
            const end = cursor + (Number(item.count || 0) / total) * 100;
            cursor = end;
            return `${this.dataHubVizColor(item.tone)} ${start}% ${end}%`;
        });
        return stops.length ? `conic-gradient(${stops.join(', ')})` : 'conic-gradient(#e2e8f0 0 100%)';
    }

    public dataHubSourceMapDate() {
        const records = this.explorerData.search?.records || [];
        const dates = records.map((record: any) => record.date).filter(Boolean).sort();
        if (dates.length) return dates[dates.length - 1];
        return this.explorerData.semiconductorData?.summary?.latestDate || 'latest';
    }

    public filteredDataCatalog() {
        const dictCatalog = (key: string, label: string, count: number, usage: string, examples: any[]) => ({
            key,
            label,
            count,
            freshness: 'current filter',
            quality: '',
            usage,
            examples: Array.from(new Set((examples || []).filter(Boolean))).slice(0, 4),
        });
        const processCount = this.filteredProcessTotal();
        const equipmentRows = this.filteredEquipmentRows();
        const sensorRows = this.filteredSensorReadings();
        const metrologyRows = this.filteredMetrologyRows();
        const lotRows = this.filteredLotRows();
        const recipeRows = this.filteredRecipeRows();
        return [
            dictCatalog('process', '공정 이력', processCount, 'process.search / LOT trace', ['recipe', 'thickness', 'uniformity']),
            dictCatalog('equipment', '연결 장비', equipmentRows.length, 'equipment health / queue', equipmentRows.map((item: any) => item.id)),
            dictCatalog('sensor', '센서 시계열', sensorRows.length, 'anomaly / RCA / trace', sensorRows.map((item: any) => item.sensor)),
            dictCatalog('metrology', '계측 결과', metrologyRows.length, 'virtual metrology / SPC', metrologyRows.map((item: any) => item.metric)),
            dictCatalog('lot', 'Lot 운영', lotRows.length, 'dashboard / priority', lotRows.map((item: any) => item.id)),
            dictCatalog('recipe', 'Recipe 조건', recipeRows.length, 'optimization', recipeRows.map((item: any) => item.id)),
        ].filter((item: any) => Number(item.count || 0) > 0);
    }

    public filteredProcessTotal() {
        const search = this.explorerData.search || {};
        return search.pagination?.total || search.statistics?.count || (search.records || []).length || 0;
    }

    public filteredEquipmentRows() {
        const ids = this.explorerDistributionSet('equipment');
        const processes = this.explorerDistributionSet('process');
        const equipment = this.explorerData.semiconductorData?.equipment || [];
        if (!this.hasExplorerScope()) return equipment;
        if (this.filteredProcessTotal() <= 0) return [];
        return equipment.filter((item: any) => this.matchesSet(item.id, ids) && this.matchesSet(item.process, processes));
    }

    public filteredSensorReadings() {
        const rows = this.explorerData.semiconductorData?.sensorReadings || [];
        if (!this.hasExplorerScope()) return rows;
        if (this.filteredProcessTotal() <= 0) return [];
        return rows.filter((item: any) => this.matchesExplorerScope(item));
    }

    public filteredMetrologyRows() {
        const rows = this.explorerData.semiconductorData?.metrology || [];
        if (!this.hasExplorerScope()) return rows;
        if (this.filteredProcessTotal() <= 0) return [];
        return rows.filter((item: any) => this.matchesExplorerScope(item));
    }

    public filteredLotRows() {
        const lots = this.explorerDistributionSet('lot');
        const rows = this.explorerData.semiconductorData?.lots || [];
        if (!this.hasExplorerScope()) return rows;
        if (this.filteredProcessTotal() <= 0) return [];
        return rows.filter((item: any) => this.matchesSet(item.id, lots));
    }

    public filteredRecipeRows() {
        const processes = this.explorerDistributionSet('process');
        const records = this.explorerData.search?.records || [];
        const recipeIds = new Set(records.map((record: any) => record.recipe).filter(Boolean));
        const rows = this.explorerData.semiconductorData?.recipes || [];
        if (!this.hasExplorerScope()) return rows;
        if (this.filteredProcessTotal() <= 0) return [];
        return rows.filter((item: any) => this.matchesSet(item.process, processes) || recipeIds.has(item.id));
    }

    private matchesExplorerScope(item: any) {
        const lots = this.explorerDistributionSet('lot');
        const processes = this.explorerDistributionSet('process');
        const equipment = this.explorerDistributionSet('equipment');
        const statuses = this.explorerDistributionSet('status');
        return this.matchesSet(item.lot, lots)
            && (!processes.size || !item.process || processes.has(String(item.process)))
            && this.matchesSet(item.equipment, equipment)
            && this.matchesSet(item.status, statuses);
    }

    private explorerDistributionSet(name: string) {
        const distribution = this.explorerData.search?.statistics?.distributions?.[name] || {};
        return new Set(Object.keys(distribution).filter(Boolean));
    }

    private matchesSet(value: any, allowed: Set<string>) {
        if (!allowed.size) return true;
        return allowed.has(String(value || ''));
    }

    private hasExplorerScope() {
        return this.filteredProcessTotal() > 0
            || !!this.explorerFilters.lot
            || !!this.explorerFilters.process
            || !!this.explorerFilters.equipment
            || !!this.explorerFilters.status
            || !!this.lotSearch;
    }

    public dataHubCoverageItems() {
        const summary = this.explorerData.semiconductorData?.summary || {};
        const search = this.explorerData.search?.statistics?.distributions?.process || {};
        const overall = this.explorerData.process?.statistics?.distributions?.process || {};
        const keys = Object.keys(search).length ? Object.keys(search) : (summary.coverage?.length ? summary.coverage : Object.keys(overall));
        const rows = keys.map((key: string) => ({
            key,
            value: search[key] || overall[key] || 0,
        }));
        const max = Math.max(1, ...rows.map((row: any) => Number(row.value || 0)));
        return rows.slice(0, 14).map((row: any) => ({
            ...row,
            pct: this.metricRatio(Number(row.value || 0), max),
        }));
    }

    public explorerEquipmentDistribution() {
        const distribution = this.explorerData.search?.statistics?.distributions?.equipment || {};
        return Object.keys(distribution).map((key: string) => ({ key, value: distribution[key] }));
    }

    public explorerLotDistribution() {
        const distribution = this.explorerData.search?.statistics?.distributions?.lot || {};
        return Object.keys(distribution).map((key: string) => ({ key, value: distribution[key] }));
    }

    public dataQualityMetrics() {
        const rows = this.explorerData.semiconductorData?.dashboard?.qualityMetrics || [];
        return rows.map((item: any) => ({
            ...item,
            width: this.metricRatio(this.percentNumber(item.value), 100),
        }));
    }

    public statusDonutStyle() {
        if (this.statusTotal() <= 0) return 'conic-gradient(#cbd5e1 0 100%)';
        const items = this.explorerStatusItems();
        const total = Math.max(1, this.statusTotal());
        const ok = (Number(items[0]?.value || 0) / total) * 100;
        const watch = ok + (Number(items[1]?.value || 0) / total) * 100;
        return `conic-gradient(${this.dataHubVizColor('ok')} 0 ${ok}%, ${this.dataHubVizColor('watch')} ${ok}% ${watch}%, ${this.dataHubVizColor('hot')} ${watch}% 100%)`;
    }

    public statusDonutCenter() {
        const ok = this.explorerStatusItems()[0]?.value || 0;
        const total = Math.max(1, this.statusTotal());
        return Math.round((Number(ok) / total) * 100);
    }

    public statusDonutCenterLabel() {
        return this.statusTotal() > 0 ? `${this.statusDonutCenter()}%` : '-';
    }

    public explorerScatterPoints() {
        const records = (this.explorerData.search?.records || [])
            .filter((record: any) => this.hasMetricValue(record.thickness) && this.hasMetricValue(record.uniformity));
        const thickness = this.numericRange(records.map((record: any) => Number(record.thickness || 0)).filter((value: number) => value > 0));
        const uniformity = this.numericRange(records.map((record: any) => Number(record.uniformity || 0)).filter((value: number) => value > 0));
        return records.slice(0, 24).map((record: any) => {
            const defect = Number(record.defect || 0);
            return {
                x: this.scaleToPercent(Number(record.thickness || thickness.min), thickness.min, thickness.max, 8, 92),
                y: this.scaleToPercent(Number(record.uniformity || uniformity.min), uniformity.min, uniformity.max, 10, 88),
                size: Math.max(8, Math.min(18, Math.round(8 + defect * 16))),
                className: this.traceTimelineStatusClass(record.status),
                label: `${this.valueOrDash(record.id)} · ${this.valueOrDash(record.process)} · ${this.recordMetricLabel(record.thickness, 'nm')} · ${this.recordMetricLabel(record.uniformity, '%')}`,
            };
        });
    }

    public processStatusHeatmap() {
        const records = this.explorerData.search?.records || [];
        const processes = Array.from(new Set(records.map((record: any) => record.process))).filter(Boolean).slice(0, 8);
        const statusKeys = [
            { key: 'ok', label: '정상', className: 'is-ok' },
            { key: 'watch', label: '관찰', className: 'is-watch' },
            { key: 'hot', label: '긴급', className: 'is-hot' },
        ];
        return processes.map((process: any) => {
            const scoped = records.filter((record: any) => record.process === process);
            const total = Math.max(1, scoped.length);
            return {
                process,
                cells: statusKeys.map((status: any) => {
                    const value = scoped.filter((record: any) => record.status === status.key).length;
                    return {
                        ...status,
                        value,
                        opacity: Math.max(0.18, Math.min(1, value / total)),
                        title: `${process} ${status.label} ${value}건`,
                    };
                }),
            };
        });
    }

    public explorerTrendPolyline(metric: string) {
        const records = [...(this.explorerData.search?.records || [])]
            .filter((record: any) => Number(record[metric] || 0) > 0)
            .sort((a: any, b: any) => String(a.date || '').localeCompare(String(b.date || '')));
        if (!records.length) return '';
        const values = records.map((record: any) => Number(record[metric] || 0));
        const range = this.numericRange(values);
        const last = Math.max(1, records.length - 1);
        return records.map((record: any, index: number) => {
            const x = Math.round((index / last) * 100);
            const y = 100 - this.scaleToPercent(Number(record[metric] || range.min), range.min, range.max, 8, 92);
            return `${x},${Math.round(y)}`;
        }).join(' ');
    }

    public metricHistogram(metric: string, bins: number = 6) {
        const values = (this.explorerData.search?.records || [])
            .map((record: any) => Number(record[metric] || 0))
            .filter((value: number) => value > 0);
        if (!values.length) return [];
        const range = this.numericRange(values);
        const step = Math.max(1, (range.max - range.min) / bins);
        const buckets = Array.from({ length: bins }).map((_: any, index: number) => ({
            label: `${Math.round(range.min + step * index)}`,
            value: 0,
        }));
        values.forEach((value: number) => {
            const index = Math.min(bins - 1, Math.floor((value - range.min) / step));
            buckets[index].value += 1;
        });
        const max = Math.max(1, ...buckets.map((bucket: any) => bucket.value));
        return buckets.map((bucket: any) => ({
            ...bucket,
            height: this.metricRatio(bucket.value, max),
        }));
    }

    public distributionWidth(value: number, rows: any[] = []) {
        const max = Math.max(1, ...rows.map((row: any) => Number(row.value || 0)));
        return this.metricRatio(Number(value || 0), max);
    }

    public statusTotal() {
        return this.explorerStatusItems().reduce((sum: number, item: any) => sum + Number(item.value || 0), 0);
    }

    public traceTimelineItems() {
        const rows = [...(this.processTraceData.traces || [])].sort((a: any, b: any) => String(a.date || '').localeCompare(String(b.date || '')));
        const total = Math.max(1, rows.length - 1);
        return rows.map((row: any, index: number) => ({
            ...row,
            index: index + 1,
            pct: rows.length <= 1 ? 50 : Math.round((index / total) * 100),
            className: this.traceTimelineStatusClass(row.status),
        }));
    }

    public traceStatusItems() {
        const rows = this.processTraceData.traces || [];
        const status = {
            ok: rows.filter((row: any) => row.status === 'ok').length,
            watch: rows.filter((row: any) => row.status === 'watch').length,
            hot: rows.filter((row: any) => row.status === 'hot').length,
        };
        return [
            { label: '정상', value: status.ok, className: 'data-status-ok' },
            { label: '관찰', value: status.watch, className: 'data-status-watch' },
            { label: '긴급', value: status.hot, className: 'data-status-hot' },
        ];
    }

    public traceStatusTotal() {
        return this.traceStatusItems().reduce((sum: number, item: any) => sum + Number(item.value || 0), 0);
    }

    public traceUnknownStatusCount() {
        return (this.processTraceData.traces || [])
            .filter((row: any) => !['ok', 'watch', 'hot'].includes(String(row.status || ''))).length;
    }

    public traceSensorContributors() {
        const rows = [...(this.processTraceData.sensors || [])].sort((a: any, b: any) => Number(b.contribution || 0) - Number(a.contribution || 0));
        return rows.slice(0, 6).map((sensor: any) => ({
            ...sensor,
            width: this.metricRatio(Number(sensor.contribution || 0), 0.6),
        }));
    }

    public traceTimelineStatusClass(status: string) {
        if (status === 'ok') return 'is-ok';
        if (status === 'watch') return 'is-watch';
        if (status === 'hot') return 'is-hot';
        return '';
    }

    public traceStatusLabel(status: string) {
        if (status === 'ok') return '정상';
        if (status === 'watch') return '관찰';
        if (status === 'hot') return '긴급';
        return '상태 미제공';
    }

    public traceMetrologyDeltaItems() {
        return [...(this.processTraceData.metrology || [])].slice(0, 8).map((met: any) => {
            const target = Number(met.target || 0);
            const value = Number(met.value || 0);
            const sigma = Math.max(Number(met.sigma || 1), 1);
            const delta = value - target;
            return {
                ...met,
                deltaText: `${delta >= 0 ? '+' : ''}${delta.toFixed(2)}${met.unit || ''}`,
                width: this.metricRatio(Math.min(Math.abs(delta), sigma * 3), sigma * 3),
                className: this.traceTimelineStatusClass(met.status),
            };
        });
    }

    public sensorTrendBars(sensor: any) {
        const min = Number(sensor?.min || 0);
        const avg = Number(sensor?.avg || 0);
        const max = Number(sensor?.max || avg || min || 1);
        const baseline = Number(sensor?.baseline || avg || min);
        const range = Math.max(1, max - Math.min(min, baseline));
        return [min, baseline, avg, max, avg].map((value: number) => {
            const height = 28 + ((value - Math.min(min, baseline)) / range) * 62;
            return Math.max(22, Math.min(92, Math.round(height)));
        });
    }

    public metrologyDeltaWidth(met: any) {
        const target = Number(met?.target || 0);
        const value = Number(met?.value || 0);
        const sigma = Math.max(Number(met?.sigma || 1), 1);
        const delta = Math.min(Math.abs(value - target), sigma * 3);
        return Math.max(12, Math.min(100, Math.round((delta / (sigma * 3)) * 100)));
    }

    public metricRatio(value: number, max: number) {
        if (!max || max <= 0) return 0;
        return Math.max(4, Math.min(100, Math.round((Number(value || 0) / max) * 100)));
    }

    private percentNumber(value: any) {
        const parsed = Number(String(value || '').replace('%', ''));
        return Number.isFinite(parsed) ? parsed : 0;
    }

    private numericRange(values: number[]) {
        const cleaned = values.filter((value: number) => Number.isFinite(value));
        if (!cleaned.length) return { min: 0, max: 1 };
        const min = Math.min(...cleaned);
        const max = Math.max(...cleaned);
        return min === max ? { min: min - 1, max: max + 1 } : { min, max };
    }

    private scaleToPercent(value: number, min: number, max: number, floor: number = 0, ceiling: number = 100) {
        if (!Number.isFinite(value) || max <= min) return Math.round((floor + ceiling) / 2);
        const ratio = (value - min) / (max - min);
        return Math.max(floor, Math.min(ceiling, Math.round(floor + ratio * (ceiling - floor))));
    }

    public async previousExplorerPage() {
        await this.goExplorerPage((this.explorerFilters.page || 1) - 1);
    }

    public async nextExplorerPage() {
        if (!this.canNextExplorerPage()) return;
        await this.goExplorerPage((this.explorerFilters.page || 1) + 1);
    }

    public async goExplorerPage(page: number) {
        const next = Math.max(1, Math.min(this.totalExplorerPages(), Number(page || 1)));
        if (next === Number(this.explorerFilters.page || 1) && this.explorerData.search?.records?.length) return;
        this.explorerFilters.page = next;
        await this.loadProcessTrace();
    }

    public async changeExplorerPageSize(value: any) {
        const size = Number(value);
        this.explorerFilters.dump = [10, 20, 50].includes(size) ? size : 20;
        this.explorerFilters.page = 1;
        this.selectedRecordId = '';
        await this.loadProcessTrace();
    }

    public async selectExplorerRecord(record: any) {
        if (!record?.id || this.historyLoading) return;
        if (!(this.explorerData.search?.records || []).some((item: any) => item.id === record.id)) return;
        const detailSeq = ++this.explorerDetailSeq;
        this.selectedRecordId = record.id;
        this.operationalAnalysisResult = null;
        this.operationalAnalysisError = '';
        this.detailLoading = true;
        await this.service.render();
        try {
            const sourceScope = this.explorerData?.dataScope || this.explorerFilters.source_scope || 'sample';
            const operationalVersionId = this.explorerOperationalVersionId();
            const [nextSelectedRecord, nextTraceData] = await Promise.all([
                this.callApi('process_detail', {
                    record_id: record.id,
                    source_scope: sourceScope,
                    version_id: operationalVersionId,
                }, '상세 정보를 불러오지 못했습니다.'),
                this.callApi('process_trace', {
                    lot_id: record.lot,
                    source_scope: sourceScope,
                    version_id: operationalVersionId,
                }, 'Lot 이력을 불러오지 못했습니다.'),
            ]);
            if (detailSeq !== this.explorerDetailSeq) return;
            this.selectedRecord = nextSelectedRecord;
            this.processTraceData = nextTraceData;
            this.syncExplorerState();
        } catch (error: any) {
            if (detailSeq === this.explorerDetailSeq) {
                this.sectionErrors.history = this.errorText(error);
            }
        } finally {
            if (detailSeq === this.explorerDetailSeq) {
                this.detailLoading = false;
                await this.service.render();
            }
        }
    }

    public async askSelectedRecord() {
        const record = this.selectedRecord?.record;
        if (!record) return;
        if (this.explorerUsesOperationalData()) {
            await this.runOperationalAnalysis(record);
            return;
        }
        this.input = `${record.lot} ${record.process} ${record.id}의 ${record.status} 상태 원인을 센서, 계측, recipe 기준으로 분석해줘`;
        this.section = 'chat';
        this.service.href('/agent/chat');
        await this.ask();
    }

    public async downloadExplorerJson() {
        const exportObj = {
            provenance: this.sampleExportContext(),
            filters: this.explorerRequestParams(),
            selectedRecord: this.selectedRecord,
            search: this.explorerData.search,
            trace: this.processTraceData,
        };
        await this.service.file.download(exportObj, 'nanofab-data-explorer.json');
    }

    public sampleExportContext() {
        const operational = this.explorerData?.dataScope === 'operational';
        return {
            dataScope: this.explorerData?.dataScope || 'sample',
            dataAsOf: this.explorerData?.dataAsOf || '2026-05-18',
            source: this.explorerData?.source || 'NanoFab Studio sample semiconductor dataset',
            sourceMeta: this.explorerData?.sourceMeta || null,
            version: this.explorerData?.meta?.version || null,
            warning: operational
                ? '운영 적재 버전의 읽기 전용 조회 결과입니다. AI/Trace 모델 분석에는 연결되지 않았습니다.'
                : '샘플 데이터 기반 결과이며 실제 생산 판단용이 아닙니다.',
            exportedAt: new Date().toISOString(),
        };
    }

    public recordStatusClass(status: string) {
        if (status === 'ok') return 'bg-[#eaf2ff] text-[#2563eb]';
        if (status === 'watch') return 'bg-[#fff7ed] text-[#b45309]';
        if (status === 'hot') return 'bg-red-50 text-red-700';
        return 'bg-[#f1f5f9] text-[#64748b]';
    }

    public recordStatusLabel(status: any) {
        const labels: any = { ok: '정상', watch: '관찰', hot: '긴급' };
        return labels[String(status || '')] || '상태 미제공';
    }

    public async uploadDataset() {
        if (this.uploadStatus.uploading) return;
        this.sectionErrors.quality = '';
        let files: any = null;
        try {
            files = await this.service.file.select({ accept: '.csv,.json,.xlsx', multiple: false });
        } catch (error) {
            files = null;
        }
        if (!files || files.length === 0) return;

        const file = files[0];
        const fd = new FormData();
        fd.append('file', file);
        fd.append('dataset_type', this.uploadDatasetType);
        fd.append('source', this.uploadSource);
        fd.append('mode', this.uploadMode);
        fd.append('filename', file.name || 'dataset.csv');
        this.uploadStatus = { uploading: true, percent: 0, filename: file.name || 'dataset.csv' };
        await this.service.render();

        try {
            const response: any = await this.service.file.upload(wiz.url('ingestion_upload'), fd, this.uploadProgress.bind(this));
            if (!response || Number(response.code) !== 200) {
                throw new Error(response?.data?.message || response?.message || '파일 검증에 실패했습니다.');
            }
            const run = this.payload(response.data || response);
            if (!run?.id || !['validated', 'validated-with-warnings', 'preview-ready', 'quarantined'].includes(String(run?.status || ''))) {
                throw new Error('파일 검증 결과를 확인하지 못했습니다. 다시 시도해 주세요.');
            }
            this.ingestionRuns = [run, ...this.ingestionRuns].slice(0, 8);
            this.pendingIngestionPreview = run?.status === 'preview-ready' ? run.preview : null;
            this.ingestionApprovalChecked = false;
            this.dataQualityData.ingestion = {
                ...(this.dataQualityData.ingestion || {}),
                uploadRuns: this.ingestionRuns
            };
            if (run?.status === 'quarantined') {
                const refreshed = await this.callApi('ingestion_quality', {}, '격리 목록을 새로고치지 못했습니다.');
                this.dataQualityData = refreshed;
                this.ingestionRuns = refreshed.ingestion?.uploadRuns || this.ingestionRuns;
            }
            this.actionResult = { type: 'ingestion', result: run };
        } catch (error: any) {
            this.sectionErrors.quality = this.errorText(error, '파일 검증에 실패했습니다.');
        }

        this.uploadStatus.uploading = false;
        this.uploadStatus.percent = 0;
        await this.service.render();
    }

    public uploadActionLabel() {
        if (this.uploadMode === 'append') return '추가 적재 미리보기';
        if (this.uploadMode === 'replace') return '교체 적재 미리보기';
        return '파일 검증';
    }

    public async commitIngestionPreview() {
        const preview = this.pendingIngestionPreview;
        if (!preview?.id || !preview?.confirmationToken || this.ingestionApplying) return;
        if (!this.ingestionApprovalChecked) {
            this.sectionErrors.quality = '영향 행 수와 운영 데이터 변경 내용을 확인한 뒤 승인 체크박스를 선택해주세요.';
            await this.service.render();
            return;
        }
        const impact = preview.impact || {};
        const isRollback = preview.kind === 'rollback';
        const confirmed = await this.service.modal.show({
            title: isRollback ? '운영 데이터 롤백 승인' : '운영 데이터 반영 승인',
            message: `${this.datasetTypeLabel(preview.datasetType)}에 ${impact.insertedRows || 0}행 추가, ${impact.updatedRows || 0}행 변경, ${impact.removedRows || 0}행 제거 후 총 ${impact.resultRows || 0}행이 됩니다. ${isRollback ? '기존 버전을 보존하고 롤백 결과를 새 버전으로' : '새 버전을'} 생성하고 활성화하시겠습니까?`,
            action: isRollback ? '새 롤백 버전 생성' : '버전 생성 및 반영',
            cancel: '취소',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;

        this.ingestionApplying = true;
        this.ingestionOperation = 'apply';
        this.sectionErrors.quality = '';
        await this.service.render();
        try {
            const result = isRollback
                ? await this.callApi('ingestion_rollback', {
                    phase: 'commit',
                    dataset_type: preview.datasetType,
                    preview_id: preview.id,
                    confirmation_token: preview.confirmationToken,
                    confirmation: preview.confirmationPhrase
                }, '운영 데이터 롤백에 실패했습니다.')
                : await this.callApi('ingestion_commit', {
                    preview_id: preview.id,
                    confirmation_token: preview.confirmationToken,
                    confirmation: preview.confirmationPhrase
                }, '운영 데이터 반영에 실패했습니다.');
            const run = result.run;
            this.pendingIngestionPreview = null;
            this.ingestionApprovalChecked = false;
            this.ingestionRuns = run ? [run, ...this.ingestionRuns.filter((item: any) => item?.id !== preview.id)].slice(0, 8) : this.ingestionRuns;
            this.dataQualityData.ingestion = {
                ...(this.dataQualityData.ingestion || {}),
                uploadRuns: this.ingestionRuns,
                operationalStore: result.operationalStore || this.dataQualityData.ingestion?.operationalStore
            };
            this.actionResult = { type: 'ingestion', result: run };
        } catch (error: any) {
            this.sectionErrors.quality = this.errorText(error, '운영 데이터 반영에 실패했습니다.');
        }
        this.ingestionApplying = false;
        this.ingestionOperation = '';
        await this.service.render();
    }

    public async cancelIngestionPreview() {
        const preview = this.pendingIngestionPreview;
        if (!preview?.id || !preview?.confirmationToken || this.ingestionApplying) return;
        this.ingestionApplying = true;
        this.ingestionOperation = 'cancel';
        this.sectionErrors.quality = '';
        await this.service.render();
        try {
            await this.callApi('ingestion_preview_cancel', {
                preview_id: preview.id,
                confirmation_token: preview.confirmationToken
            }, '적재 미리보기 취소에 실패했습니다.');
            this.pendingIngestionPreview = null;
            this.ingestionApprovalChecked = false;
            this.ingestionRuns = this.ingestionRuns.map((item: any) => item?.id === preview.id ? {
                ...item,
                status: 'cancelled',
                applied: false,
                message: '관리자가 미리보기를 취소하여 운영 데이터에는 반영하지 않았습니다.'
            } : item);
        } catch (error: any) {
            this.sectionErrors.quality = this.errorText(error, '적재 미리보기 취소에 실패했습니다.');
        }
        this.ingestionApplying = false;
        this.ingestionOperation = '';
        await this.service.render();
    }

    public operationalDatasets() {
        return this.dataQualityData.ingestion?.operationalStore?.datasets || [];
    }

    public operationalMaintenance() {
        return this.dataQualityData.ingestion?.operationalStore?.maintenance || {};
    }

    public formatStorageBytes(value: any) {
        let size = Number(value || 0);
        if (!Number.isFinite(size) || size <= 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let index = 0;
        while (size >= 1024 && index < units.length - 1) {
            size /= 1024;
            index += 1;
        }
        return `${size >= 10 || index === 0 ? size.toFixed(0) : size.toFixed(1)} ${units[index]}`;
    }

    public operationalVersionFields() {
        const page = this.selectedOperationalVersionPage;
        const declared = page?.version?.columnNames || [];
        if (declared.length) return declared.slice(0, 20);
        const first = (page?.rows || [])[0] || {};
        return Object.keys(first).slice(0, 20);
    }

    public operationalCellValue(row: any, field: string) {
        const value = row?.[field];
        if (value === null || value === undefined || value === '') return '-';
        return String(value);
    }

    public async openOperationalVersion(dataset: any, version: any, offset: number = 0) {
        if (!dataset?.datasetType || !version?.id || this.operationalMaintenanceBusy) return;
        this.operationalMaintenanceBusy = 'page';
        this.sectionErrors.quality = '';
        await this.service.render();
        try {
            const page = await this.callApi('ingestion_version_page', {
                dataset_type: dataset.datasetType,
                version_id: version.id,
                offset,
                limit: 100,
            }, '운영 버전 행을 불러오지 못했습니다.');
            this.selectedOperationalVersionPage = { ...page, datasetType: dataset.datasetType };
        } catch (error: any) {
            this.sectionErrors.quality = this.errorText(error, '운영 버전 행을 불러오지 못했습니다.');
        }
        this.operationalMaintenanceBusy = '';
        await this.service.render();
    }

    public async nextOperationalVersionPage() {
        const page = this.selectedOperationalVersionPage;
        if (!page?.pagination?.hasMore || !page?.version?.id) return;
        await this.openOperationalVersion(
            { datasetType: page.datasetType },
            page.version,
            Number(page.pagination.offset || 0) + Number(page.pagination.returned || 0),
        );
    }

    public async runOperationalMaintenance(action: string) {
        if (this.operationalMaintenanceBusy) return;
        const confirmations: any = {
            backup: 'CREATE OPERATIONAL BACKUP',
            gc: 'RUN OPERATIONAL GC',
        };
        if (confirmations[action]) {
            const confirmed = await this.service.modal.show({
                title: action === 'backup' ? '운영 저장소 백업' : '운영 저장소 보존 정리',
                message: action === 'backup'
                    ? '현재 SQLite 운영 버전을 체크섬 매니페스트와 함께 전용 백업 디렉터리에 저장합니다.'
                    : '현재 버전과 최근 50개/30일 이내 버전은 보존하고 오래된 고아 청크와 백업을 정리합니다.',
                action: action === 'backup' ? '검증 백업 생성' : '보존 정책 실행',
                cancel: '취소',
                actionBtn: action === 'backup' ? 'success' : 'warning',
                status: action === 'backup' ? 'success' : 'warning',
            });
            if (!confirmed) return;
        }
        this.operationalMaintenanceBusy = action;
        this.sectionErrors.quality = '';
        await this.service.render();
        try {
            const response = await this.callApi('ingestion_store_maintenance', {
                action,
                confirmation: confirmations[action] || '',
            }, '운영 저장소 유지보수에 실패했습니다.');
            this.dataQualityData.ingestion.operationalStore = {
                ...(this.dataQualityData.ingestion.operationalStore || {}),
                maintenance: response.maintenance,
                status: response.maintenance?.status || this.dataQualityData.ingestion.operationalStore?.status,
            };
            if (response.maintenance?.status === 'error' || response.result?.ok === false) {
                throw new Error('유지보수 결과에서 운영 저장소 오류가 확인되었습니다. 무결성 상세를 확인한 뒤 다시 시도해주세요.');
            }
            if (action !== 'status') {
                await this.service.modal.success(action === 'backup' ? '운영 저장소 검증 백업을 생성했습니다.' : (action === 'gc' ? '보존 정책 정리를 완료했습니다.' : '운영 저장소 무결성 검증을 완료했습니다.'));
            }
        } catch (error: any) {
            this.sectionErrors.quality = this.errorText(error, '운영 저장소 유지보수에 실패했습니다.');
        }
        this.operationalMaintenanceBusy = '';
        await this.service.render();
    }

    public operationalQuarantine() {
        return this.dataQualityData.ingestion?.operationalStore?.quarantine || [];
    }

    public pendingOperationalPreviews() {
        return this.dataQualityData.ingestion?.operationalStore?.pendingPreviews || [];
    }

    public async resumeIngestionPreview(item: any) {
        if (!item?.id || this.ingestionApplying) return;
        this.ingestionApplying = true;
        this.ingestionOperation = 'resume';
        this.sectionErrors.quality = '';
        await this.service.render();
        try {
            this.pendingIngestionPreview = await this.callApi('ingestion_preview_resume', {
                preview_id: item.id
            }, '승인 대기 미리보기를 재개하지 못했습니다.');
            this.ingestionApprovalChecked = false;
            this.dataQualityData.ingestion.operationalStore.pendingPreviews = this.pendingOperationalPreviews()
                .filter((preview: any) => preview.id !== item.id);
        } catch (error: any) {
            this.sectionErrors.quality = this.errorText(error, '승인 대기 미리보기를 재개하지 못했습니다.');
        }
        this.ingestionApplying = false;
        this.ingestionOperation = '';
        await this.service.render();
    }

    public async rollbackIngestionVersion(dataset: any, version: any) {
        if (!dataset?.datasetType || !version?.id || version?.current || this.ingestionRollbackId) return;
        this.ingestionRollbackId = version.id;
        this.sectionErrors.quality = '';
        await this.service.render();
        try {
            const preview = await this.callApi('ingestion_rollback', {
                phase: 'preview',
                dataset_type: dataset.datasetType,
                version_id: version.id
            }, '롤백 영향도를 계산하지 못했습니다.');
            const impact = preview.impact || {};
            const confirmed = await this.service.modal.show({
                title: '운영 데이터 버전 롤백',
                message: `${version.id} 스냅샷으로 되돌리면 ${impact.insertedRows || 0}행 추가, ${impact.updatedRows || 0}행 변경, ${impact.removedRows || 0}행 제거됩니다. 기존 버전은 보존하고 롤백 결과를 새 버전으로 생성합니다. 계속하시겠습니까?`,
                action: '새 롤백 버전 생성',
                cancel: '취소',
                actionBtn: 'warning',
                status: 'warning'
            });
            if (confirmed) {
                const result = await this.callApi('ingestion_rollback', {
                    phase: 'commit',
                    dataset_type: dataset.datasetType,
                    preview_id: preview.id,
                    confirmation_token: preview.confirmationToken,
                    confirmation: preview.confirmationPhrase
                }, '운영 데이터 롤백에 실패했습니다.');
                const run = result.run;
                this.ingestionRuns = run ? [run, ...this.ingestionRuns].slice(0, 8) : this.ingestionRuns;
                this.dataQualityData.ingestion = {
                    ...(this.dataQualityData.ingestion || {}),
                    uploadRuns: this.ingestionRuns,
                    operationalStore: result.operationalStore || this.dataQualityData.ingestion?.operationalStore
                };
                this.actionResult = { type: 'ingestion', result: run };
            } else {
                await this.callApi('ingestion_preview_cancel', {
                    preview_id: preview.id,
                    confirmation_token: preview.confirmationToken
                }, '롤백 미리보기를 취소하지 못했습니다.');
            }
        } catch (error: any) {
            this.sectionErrors.quality = this.errorText(error, '운영 데이터 롤백에 실패했습니다.');
        }
        this.ingestionRollbackId = '';
        await this.service.render();
    }

    public async discardQuarantine(item: any) {
        if (!item?.id || this.ingestionDiscardId) return;
        const confirmed = await this.service.modal.show({
            title: '격리 데이터 폐기',
            message: `${item.filename || item.id}의 격리 사본을 폐기합니다. 운영 데이터에는 영향이 없습니다. 계속하시겠습니까?`,
            action: '격리 사본 폐기',
            cancel: '취소',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        this.ingestionDiscardId = item.id;
        this.sectionErrors.quality = '';
        await this.service.render();
        try {
            const result = await this.callApi('ingestion_quarantine_discard', {
                quarantine_id: item.id,
                confirmation: `DISCARD ${item.id}`
            }, '격리 데이터 폐기에 실패했습니다.');
            this.dataQualityData.ingestion = {
                ...(this.dataQualityData.ingestion || {}),
                operationalStore: result.operationalStore || this.dataQualityData.ingestion?.operationalStore
            };
            this.ingestionRuns = this.ingestionRuns.map((run: any) => run?.id === item.id ? {
                ...run,
                status: 'discarded',
                applied: false,
                message: '관리자가 격리 사본을 폐기했습니다. 운영 데이터에는 영향이 없습니다.'
            } : run);
        } catch (error: any) {
            this.sectionErrors.quality = this.errorText(error, '격리 데이터 폐기에 실패했습니다.');
        }
        this.ingestionDiscardId = '';
        await this.service.render();
    }

    public async uploadProgress(percent: number) {
        this.uploadStatus.percent = Math.round(percent || 0);
        await this.service.render();
    }

    public ingestionRunItems() {
        return this.ingestionRuns.length ? this.ingestionRuns : (this.dataQualityData.ingestion?.uploadRuns || []);
    }

    public uploadModeLabel(mode: any) {
        const labels: any = {
            'validate-only': '검증만 (운영 미반영)',
            append: '추가 적재',
            replace: '교체 적재'
        };
        return labels[String(mode || '')] || String(mode || '-');
    }

    public datasetTypeLabel(type: any) {
        const labels: any = {
            process: '공정 이력',
            sensor: '센서 시계열',
            metrology: '계측 결과',
            equipment: '장비 마스터'
        };
        return labels[String(type || '')] || String(type || '-');
    }

    public uploadRequiredColumnsLabel() {
        const fallback: any = {
            process: ['id', 'lot', 'process', 'equipment', 'date'],
            sensor: ['id', 'lot', 'equipment', 'sensor', 'window'],
            metrology: ['id', 'lot', 'metric', 'value', 'date'],
            equipment: ['id', 'name', 'process', 'status']
        };
        const schemas = this.dataQualityData.ingestion?.uploadPolicy?.schemas || {};
        const columns = schemas[this.uploadDatasetType] || fallback[this.uploadDatasetType] || [];
        return (columns || []).join(', ') || '스키마 정보 확인 필요';
    }

    public ingestionRunStatusLabel(run: any) {
        const status = String(run?.status || '');
        const labels: any = {
            validated: '검증 통과',
            'validated-with-warnings': '경고와 함께 검증',
            'preview-ready': '승인 대기',
            committed: '승인·반영 완료',
            cancelled: '미리보기 취소',
            expired: '승인 만료',
            discarded: '격리 사본 폐기',
            'legacy-sample': '과거 샘플 이력',
            completed: run?.applied === false ? '검증 완료 · 미반영' : '적재 완료',
            running: '처리 중',
            queued: '대기 중',
            failed: '실패',
            rejected: '거부됨',
            quarantined: '격리됨'
        };
        return labels[status] || status || '상태 확인 필요';
    }

    public ingestionRunStatusClass(run: any) {
        const status = String(run?.status || '');
        if (status === 'validated' || status === 'committed') return 'is-success';
        if (status === 'validated-with-warnings' || status === 'preview-ready' || status === 'legacy-sample' || status === 'expired' || (status === 'completed' && run?.applied === false)) return 'is-warning';
        if (status === 'cancelled' || status === 'discarded') return 'is-neutral';
        if (['failed', 'rejected', 'quarantined'].includes(status)) return 'is-error';
        if (['running', 'queued'].includes(status)) return 'is-running';
        if (status === 'completed' && run?.applied === true) return 'is-success';
        return 'is-neutral';
    }

    public ingestionSourceStatusLabel(status: any) {
        const labels: any = {
            ready: '수집 준비',
            running: '수집 중',
            planned: '연결 준비 중',
            failed: '수집 실패',
            degraded: '일부 지연',
            stopped: '중지'
        };
        return labels[String(status || '')] || String(status || '상태 확인 필요');
    }

    public ingestionSourceStatusClass(status: any) {
        status = String(status || '');
        if (status === 'running') return 'is-running';
        if (status === 'ready') return 'is-success';
        if (status === 'planned') return 'is-neutral';
        if (status === 'degraded') return 'is-warning';
        if (['failed', 'stopped'].includes(status)) return 'is-error';
        return 'is-neutral';
    }

    public ingestionSourceTypeLabel(type: any) {
        const labels: any = {
            batch: '일괄 수집',
            stream: '실시간 수집',
            master: '기준정보',
            file: '파일 연계',
            rest: 'API 연계'
        };
        return labels[String(type || '')] || String(type || '-');
    }

    public qualityValidationStatusLabel(status: any) {
        const labels: any = {
            passed: '품질 기준 통과',
            warning: '확인 필요',
            failed: '품질 기준 미달'
        };
        return labels[String(status || '')] || String(status || '검증 전');
    }

    public qualityValidationStatusClass(status: any) {
        if (status === 'passed') return 'is-success';
        if (status === 'warning') return 'is-warning';
        if (status === 'failed') return 'is-error';
        return 'is-neutral';
    }

    public qualityMetricLabel(metric: any) {
        const labels: any = {
            missingRate: '결측률',
            outlierRate: '이상치 비율',
            duplicateRate: '중복률',
            unitConsistency: '단위 일관성',
            timestampSync: '시간 정합률',
            timestampIntegrity: '시간값 무결성'
        };
        return labels[String(metric || '')] || String(metric || '-');
    }

    public qualityThresholdLabel(rule: any) {
        const value = Number(rule?.threshold);
        if (!Number.isFinite(value)) return String(rule?.threshold ?? '-');
        const metric = String(rule?.metric || '');
        if (/(Rate|Consistency|Sync|Integrity)$/i.test(metric) && value <= 1) return `${Math.round(value * 100)}%`;
        return String(value);
    }

    public qualityActionLabel(action: any) {
        const labels: any = {
            interpolate_or_recollect: '보간 또는 재수집',
            review_or_exclude: '검토 후 제외',
            convert_standard_unit: '표준 단위로 변환',
            resample_and_align: '시간축 재정렬',
            deduplicate: '중복 제거'
        };
        return labels[String(action || '')] || String(action || '-').replace(/_/g, ' ');
    }

    public async setQualityWorkspace(workspace: string) {
        if (!['files', 'documents', 'datasets'].includes(workspace)) return;
        this.activeQualityWorkspace = workspace;
        const query = workspace === 'files' ? '' : `?workspace=${encodeURIComponent(workspace)}`;
        history.replaceState(null, '', `/agent/quality${query}`);
        await this.service.render();
    }

    private prepareKnowledgeCatalog() {
        this.knowledgeCatalogData.documents = (this.knowledgeCatalogData.documents || []).map((document: any) => ({
            ...document,
            editTitle: document.editTitle ?? document.title,
            editOwner: document.editOwner ?? document.owner,
            editTags: document.editTags ?? (document.tags || []).join(', '),
            editVisibility: document.editVisibility ?? document.visibility,
        }));
    }

    public async refreshKnowledgeCatalog(render: boolean = true) {
        if (this.knowledgeLoading) return;
        this.knowledgeLoading = true;
        this.sectionErrors.knowledge = '';
        if (render) await this.service.render();
        try {
            this.knowledgeCatalogData = await this.callApi('knowledge_catalog', { include_archived: this.showArchivedKnowledge }, '문서·데이터셋 카탈로그를 불러오지 못했습니다.');
            this.prepareKnowledgeCatalog();
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '문서·데이터셋 카탈로그를 불러오지 못했습니다.');
        }
        this.knowledgeLoading = false;
        if (render) await this.service.render();
    }

    public async uploadKnowledgeDocument() {
        if (this.knowledgeBusy) return;
        this.sectionErrors.knowledge = '';
        let files: any = null;
        try {
            files = await this.service.file.select({ accept: '.txt,.md,.pdf,.docx,.hwp,.hwpx', multiple: false });
        } catch (error) {
            files = null;
        }
        if (!files || !files.length) return;
        const file = files[0];
        const form = new FormData();
        form.append('file', file);
        form.append('title', this.documentForm.title || '');
        form.append('owner', this.documentForm.owner || '');
        form.append('tags', this.documentForm.tags || '');
        form.append('visibility', this.documentForm.visibility || 'project');
        this.knowledgeBusy = true;
        this.documentUploadProgress = 0;
        await this.service.render();
        try {
            const response: any = await this.service.file.upload(
                wiz.url('knowledge_document_upload'),
                form,
                async (percent: number) => {
                    this.documentUploadProgress = Math.round(percent || 0);
                    await this.service.render();
                }
            );
            if (!response || Number(response.code) !== 200) {
                throw new Error(response?.data?.message || response?.message || '문서 등록에 실패했습니다.');
            }
            this.documentForm = { title: '', owner: '', tags: '', visibility: 'project' };
            await this.refreshKnowledgeCatalog(false);
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '문서 등록에 실패했습니다.');
        }
        this.knowledgeBusy = false;
        this.documentUploadProgress = 0;
        await this.service.render();
    }

    public async saveKnowledgeDocument(document: any) {
        if (this.knowledgeBusy || !document?.id) return;
        this.knowledgeBusy = true;
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            await this.callApi('knowledge_document_update', {
                id: document.id,
                title: document.editTitle,
                owner: document.editOwner,
                tags: document.editTags,
                visibility: document.editVisibility,
                privacyApproved: Boolean(document.privacyApproved),
            }, '문서 메타데이터를 저장하지 못했습니다.');
            await this.refreshKnowledgeCatalog(false);
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '문서 메타데이터를 저장하지 못했습니다.');
        }
        this.knowledgeBusy = false;
        await this.service.render();
    }

    public async transitionKnowledgeDocument(document: any, target: string) {
        if (this.knowledgeBusy || !document?.id) return;
        this.knowledgeBusy = true;
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            await this.callApi('knowledge_document_transition', { id: document.id, target }, '문서 상태를 변경하지 못했습니다.');
            if (this.selectedDocumentDetail?.document?.id === document.id) this.selectedDocumentDetail = null;
            if (this.selectedDocumentPage?.documentId === document.id) this.selectedDocumentPage = null;
            await this.refreshKnowledgeCatalog(false);
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '문서 상태를 변경하지 못했습니다.');
        }
        this.knowledgeBusy = false;
        await this.service.render();
    }

    public async reprocessKnowledgeDocument(document: any) {
        if (this.knowledgeBusy || !document?.id) return;
        this.knowledgeBusy = true;
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            await this.callApi('knowledge_document_reprocess', { id: document.id }, '문서를 재처리하지 못했습니다.');
            if (this.selectedDocumentDetail?.document?.id === document.id) this.selectedDocumentDetail = null;
            if (this.selectedDocumentPage?.documentId === document.id) this.selectedDocumentPage = null;
            await this.refreshKnowledgeCatalog(false);
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '문서를 재처리하지 못했습니다.');
        }
        this.knowledgeBusy = false;
        await this.service.render();
    }

    public async openKnowledgeDocumentPage(document: any, page: number = 1) {
        if (this.documentPageLoading || !document?.id || document?.extension !== 'pdf') return;
        const boundedPage = Math.max(1, Math.min(Number(page || 1), Number(document.pageCount || 300)));
        this.documentPageLoading = true;
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            this.selectedDocumentPage = await this.callApi('knowledge_document_page_preview', {
                id: document.id,
                page: boundedPage,
            }, 'PDF 페이지 미리보기를 불러오지 못했습니다.');
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, 'PDF 페이지 미리보기를 불러오지 못했습니다.');
        }
        this.documentPageLoading = false;
        await this.service.render();
    }

    public async openKnowledgeDocument(document: any) {
        if (!document?.id) return;
        this.sectionErrors.knowledge = '';
        try {
            this.selectedDocumentDetail = await this.callApi('knowledge_document_detail', { id: document.id }, '문서 상세를 불러오지 못했습니다.');
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '문서 상세를 불러오지 못했습니다.');
        }
        await this.service.render();
    }

    public documentStatusLabel(status: any) {
        const labels: any = {
            'ready-for-review': '검토 대기',
            'ocr-required': 'OCR 처리 필요',
            'security-scan-required': '악성코드 검사 대기',
            'processing-failed': '문서 처리 실패',
            'rejected-malware': '악성코드 탐지 · 거부',
            approved: '승인 · AI 검색 가능',
            archived: '보관됨',
        };
        return labels[String(status || '')] || String(status || '상태 확인 필요');
    }

    public documentIndexLabel(document: any) {
        if (document?.indexStatus === 'local-index-ready') return `로컬 색인 ${document.chunkCount || 0}개`;
        if (document?.indexStatus === 'hybrid-index-ready') return `키워드·의미 색인 ${document.chunkCount || 0}개`;
        if (document?.indexStatus === 'blocked-ocr') return 'OCR 처리 전 색인 차단';
        if (document?.indexStatus === 'blocked-security-scan') return '악성코드 검사 전 색인 차단';
        if (document?.indexStatus === 'blocked-parse') return '문서 구조 오류로 색인 차단';
        return '색인 상태 확인 필요';
    }

    public documentCanApprove(document: any) {
        if (document?.status !== 'ready-for-review') return false;
        if (!['local-index-ready', 'hybrid-index-ready'].includes(document?.indexStatus)) return false;
        if (document?.malwareStatus !== 'clean') return false;
        return document?.privacyStatus !== 'review-required' || Boolean(document?.privacyApproved);
    }

    public documentRestoreStatus(document: any) {
        if (document?.preArchiveStatus && document.preArchiveStatus !== 'approved') return document.preArchiveStatus;
        if (['local-index-ready', 'hybrid-index-ready'].includes(document?.indexStatus)) return 'ready-for-review';
        return document?.malwareStatus === 'clean' ? 'ocr-required' : 'security-scan-required';
    }

    public datasetPayload() {
        return {
            name: this.datasetForm.name,
            description: this.datasetForm.description,
            owner: this.datasetForm.owner,
            visibility: this.datasetForm.visibility,
            readers: this.datasetForm.readers,
            editors: this.datasetForm.editors,
            schema: this.datasetForm.schemaText,
            lineage: JSON.stringify({
                documents: String(this.datasetForm.lineageDocuments || '').split(',').map((value: string) => value.trim()).filter(Boolean),
                datasets: String(this.datasetForm.lineageDatasets || '').split(',').map((value: string) => value.trim()).filter(Boolean),
            }),
        };
    }

    public resetDatasetForm() {
        this.datasetForm = {
            id: '', name: '', description: '', owner: '', visibility: 'project',
            readers: 'researcher, admin', editors: 'admin',
            schemaText: '[\n  {"name": "id", "type": "string", "required": true}\n]',
            lineageDocuments: '', lineageDatasets: ''
        };
        this.selectedDatasetDetail = null;
        this.datasetRowMode = 'append';
        this.datasetRowKeyField = 'id';
        this.datasetRowBusy = false;
        this.datasetRowUploadStatus = { uploading: false, percent: 0, filename: '' };
    }

    public async editKnowledgeDataset(dataset: any) {
        if (!dataset || dataset.readOnly) return;
        this.datasetForm = {
            id: dataset.id,
            name: dataset.name,
            description: dataset.description || '',
            owner: dataset.owner || '',
            visibility: dataset.visibility || 'project',
            readers: (dataset.acl?.readers || []).join(', '),
            editors: (dataset.acl?.editors || []).join(', '),
            schemaText: JSON.stringify(dataset.schema || [], null, 2),
            lineageDocuments: (dataset.lineage?.documents || []).join(', '),
            lineageDatasets: (dataset.lineage?.datasets || []).join(', '),
        };
        this.selectedDatasetDetail = {
            dataset,
            rowStorage: dataset.rowStorage || { storageState: dataset.storageState || 'not-initialized' },
            rowPage: null,
            rowVersions: [],
        };
        this.datasetRowMode = dataset.rowStorage?.storageState === 'schema-replace-required' ? 'replace' : 'append';
        this.datasetRowKeyField = (dataset.schema || []).some((field: any) => field?.name === 'id') ? 'id' : '';
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            const detail = await this.callApi(
                'knowledge_dataset_detail', { id: dataset.id, limit: 20 },
                '데이터셋 행과 버전을 불러오지 못했습니다.'
            );
            if (this.datasetForm.id === dataset.id) this.selectedDatasetDetail = detail;
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '데이터셋 행과 버전을 불러오지 못했습니다.');
        }
        await this.service.render();
    }

    public async saveKnowledgeDataset() {
        if (this.knowledgeBusy) return;
        this.knowledgeBusy = true;
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            const params: any = this.datasetPayload();
            let result: any;
            if (this.datasetForm.id) {
                params.id = this.datasetForm.id;
                result = await this.callApi('knowledge_dataset_update', params, '데이터셋을 수정하지 못했습니다.');
            } else {
                result = await this.callApi('knowledge_dataset_create', params, '데이터셋을 생성하지 못했습니다.');
            }
            await this.refreshKnowledgeCatalog(false);
            const saved = (this.knowledgeCatalogData.datasets || []).find((item: any) => item.id === result?.id);
            if (saved) await this.editKnowledgeDataset(saved);
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '데이터셋을 저장하지 못했습니다.');
        }
        this.knowledgeBusy = false;
        await this.service.render();
    }

    public datasetStorageLabel(storage: any) {
        const labels: any = {
            'sqlite-versioned': '행 저장 활성',
            'not-initialized': '행 저장 준비 전',
            'schema-replace-required': '스키마 교체 적재 필요',
            'soft-deleted': '행 저장 보관됨',
            'sync-error': '행 저장소 확인 필요',
            'bundled-read-only': '시스템 샘플 읽기 전용',
        };
        return labels[String(storage?.storageState || storage || '')] || '행 저장 상태 확인 필요';
    }

    public datasetCellValue(row: any, field: string) {
        const value = row?.[field];
        if (value === null || value === undefined || value === '') return '-';
        if (typeof value === 'object') {
            try { return JSON.stringify(value); } catch (_error) { return '[객체]'; }
        }
        return String(value);
    }

    public async syncKnowledgeDatasetStore() {
        const datasetId = this.selectedDatasetDetail?.dataset?.id;
        if (!datasetId || this.datasetRowBusy) return;
        this.datasetRowBusy = true;
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            await this.callApi(
                'knowledge_dataset_store_sync', { id: datasetId },
                '행 저장소 상태를 동기화하지 못했습니다.'
            );
            const dataset = (this.knowledgeCatalogData.datasets || []).find((item: any) => item.id === datasetId)
                || this.selectedDatasetDetail.dataset;
            await this.editKnowledgeDataset(dataset);
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '행 저장소 상태를 동기화하지 못했습니다.');
        }
        this.datasetRowBusy = false;
        await this.service.render();
    }

    public async uploadKnowledgeDatasetRows() {
        const detail = this.selectedDatasetDetail;
        const dataset = detail?.dataset;
        if (!dataset?.id || this.datasetRowBusy || this.datasetRowUploadStatus.uploading) return;
        this.sectionErrors.knowledge = '';
        let files: any = null;
        try {
            files = await this.service.file.select({ accept: '.csv,.json,.xlsx', multiple: false });
        } catch (_error) {
            files = null;
        }
        if (!files || !files.length) return;
        const file = files[0];
        const form = new FormData();
        form.append('file', file);
        form.append('id', dataset.id);
        form.append('mode', this.datasetRowMode);
        form.append('key_field', this.datasetRowKeyField || '');
        form.append('expected_version_id', detail?.rowStorage?.currentVersionId || '');
        this.datasetRowBusy = true;
        this.datasetRowUploadStatus = { uploading: true, percent: 0, filename: file.name || 'dataset.csv' };
        await this.service.render();
        try {
            const response: any = await this.service.file.upload(
                wiz.url('knowledge_dataset_rows_upload'),
                form,
                async (percent: number) => {
                    this.datasetRowUploadStatus.percent = Math.round(percent || 0);
                    await this.service.render();
                }
            );
            const envelope = this.payload(response?.data || response);
            if (!response || Number(response.code) !== 200) {
                throw new Error(envelope?.error?.message || envelope?.message || response?.message || '행 파일 적재에 실패했습니다.');
            }
            this.selectedDatasetDetail = {
                ...detail,
                dataset: { ...dataset, rowStorage: envelope.rowStorage, storageState: envelope.rowStorage?.storageState, rowCount: envelope.rowStorage?.rowCount },
                rowStorage: envelope.rowStorage,
                rowPage: envelope.rowPage,
                rowVersions: envelope.rowVersions || [],
                lastWrite: envelope.write,
            };
            await this.refreshKnowledgeCatalog(false);
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '행 파일 적재에 실패했습니다.');
        }
        this.datasetRowBusy = false;
        this.datasetRowUploadStatus = { uploading: false, percent: 0, filename: '' };
        await this.service.render();
    }

    public async loadKnowledgeDatasetRows(cursor: string = '', versionId: string = '', append: boolean = false) {
        const detail = this.selectedDatasetDetail;
        const datasetId = detail?.dataset?.id;
        if (!datasetId || this.datasetRowBusy) return;
        this.datasetRowBusy = true;
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            const page = await this.callApi('knowledge_dataset_rows', {
                id: datasetId,
                limit: 20,
                cursor: cursor || '',
                version_id: versionId || '',
            }, '데이터셋 행을 불러오지 못했습니다.');
            const priorRows = append ? (detail.rowPage?.rows || []) : [];
            this.selectedDatasetDetail = {
                ...detail,
                rowPage: { ...page, rows: [...priorRows, ...(page.rows || [])] },
                rowStorage: { ...detail.rowStorage, viewedVersionId: page.versionId },
            };
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '데이터셋 행을 불러오지 못했습니다.');
        }
        this.datasetRowBusy = false;
        await this.service.render();
    }

    public async loadNextKnowledgeDatasetRows() {
        const page = this.selectedDatasetDetail?.rowPage;
        if (!page?.nextCursor) return;
        await this.loadKnowledgeDatasetRows(page.nextCursor, page.versionId || '', true);
    }

    public async loadKnowledgeDatasetVersion(version: any) {
        if (!version?.versionId) return;
        await this.loadKnowledgeDatasetRows('', version.versionId, false);
    }

    public async transitionKnowledgeDataset(dataset: any, target: string) {
        if (this.knowledgeBusy || !dataset?.id || dataset?.readOnly) return;
        this.knowledgeBusy = true;
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            await this.callApi('knowledge_dataset_transition', { id: dataset.id, target }, '데이터셋 상태를 변경하지 못했습니다.');
            if (this.datasetForm.id === dataset.id) this.resetDatasetForm();
            await this.refreshKnowledgeCatalog(false);
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '데이터셋 상태를 변경하지 못했습니다.');
        }
        this.knowledgeBusy = false;
        await this.service.render();
    }

    public datasetStatusLabel(status: any) {
        const labels: any = { draft: '초안', active: '활성', deprecated: '사용 중단 예정', archived: '보관됨' };
        return labels[String(status || '')] || String(status || '상태 확인 필요');
    }

    public async runDatasetMaintenance(action: string, backupId: string = '') {
        if (this.datasetMaintenanceBusy) return;
        if (action === 'gc' && !this.datasetMaintenancePreview?.planToken) {
            await this.service.modal.error('보존 정리 계획이 없거나 만료되었습니다. 미리보기를 다시 실행해주세요.');
            return;
        }
        const confirmations: any = {
            backup: 'CREATE DATASET BACKUP',
            gc: 'DELETE OLD DATASET VERSIONS',
        };
        if (confirmations[action]) {
            const confirmed = await this.service.modal.show({
                title: action === 'backup' ? '데이터셋 저장소 백업' : '데이터셋 버전 보존 정리',
                message: action === 'backup'
                    ? '행 저장소를 온라인 백업하고 SHA-256 및 SQLite 무결성 검증 정보를 기록합니다.'
                    : (this.datasetMaintenancePreview?.truncated
                        ? '현재 버전과 보존 범위를 보호하고 미리보기에 포함된 1개 배치만 정리합니다. 완료 후 남은 후보를 다시 미리보기해야 합니다.'
                        : '현재 버전, 데이터셋별 최근 10개 버전, 30일 이내 버전은 보존하고 미리보기에서 선택된 오래된 버전만 삭제합니다.'),
                action: action === 'backup' ? '검증 백업 생성' : (this.datasetMaintenancePreview?.truncated ? '선택 배치 정리' : '미리보기대로 정리'),
                cancel: '취소',
                actionBtn: action === 'backup' ? 'success' : 'warning',
                status: action === 'backup' ? 'success' : 'warning',
            });
            if (!confirmed) return;
        }
        this.datasetMaintenanceBusy = action;
        this.sectionErrors.knowledge = '';
        await this.service.render();
        try {
            const response = await this.callApi('knowledge_dataset_store_maintenance', {
                action,
                backup_id: backupId,
                confirmation: confirmations[action] || '',
                expected_plan: action === 'gc' ? this.datasetMaintenancePreview?.planToken || '' : '',
                keep_recent: 10,
                min_age_days: 30,
                max_versions: 500,
            }, '데이터셋 저장소 유지보수에 실패했습니다.');
            this.datasetMaintenanceData = response;
            if (action === 'gc-preview') this.datasetMaintenancePreview = response.result;
            if (action === 'backup-verify' && response.result?.valid !== true) {
                const reason = (response.result?.errors || []).join(', ') || '백업 검증 결과가 유효하지 않습니다.';
                throw new Error(reason);
            }
            if (action === 'verify' && response.result?.database?.quickCheck && response.result.database.quickCheck !== 'ok') {
                throw new Error('데이터셋 저장소 SQLite 무결성 검증에 실패했습니다.');
            }
            if (response.result?.ok === false) {
                throw new Error('데이터셋 저장소 유지보수 결과가 유효하지 않습니다.');
            }
            if (['verify', 'backup', 'backup-verify', 'gc'].includes(action)) {
                const message = action === 'backup'
                    ? '데이터셋 저장소 검증 백업을 생성했습니다.'
                    : action === 'backup-verify'
                        ? '선택한 백업의 체크섬과 SQLite 무결성을 확인했습니다.'
                        : action === 'gc'
                            ? (response.result?.truncated
                                ? '선택된 보존 정리 배치를 완료했습니다. 남은 후보는 미리보기를 다시 실행해 확인해주세요.'
                                : '미리보기의 보존 정책대로 데이터셋 버전을 정리했습니다.')
                            : '데이터셋 저장소 무결성 검증을 완료했습니다.';
                await this.service.modal.success(message);
            }
            if (action === 'gc') this.datasetMaintenancePreview = null;
        } catch (error: any) {
            this.sectionErrors.knowledge = this.errorText(error, '데이터셋 저장소 유지보수에 실패했습니다.');
        }
        this.datasetMaintenanceBusy = '';
        await this.service.render();
    }

    public datasetMaintenanceHasWork() {
        const preview = this.datasetMaintenancePreview || {};
        return Number(preview.selectedVersions || 0) > 0 || Number(preview.orphanRowValuesBefore || 0) > 0;
    }

    public datasetMaintenanceCanExecute() {
        return this.datasetMaintenanceHasWork() && Boolean(this.datasetMaintenancePreview?.planToken);
    }

    public normalizeWorkflowTab(tab: string) {
        return ['templates', 'result', 'history'].includes(tab || '') ? tab : 'templates';
    }

    public workflowRunCount() {
        const count = this.workflowData.stats?.totalRuns;
        return Number.isFinite(Number(count)) ? Number(count) : (this.workflowData.history?.length || 0);
    }

    public workflowAverageTimeLabel() {
        if (this.workflowRunCount() <= 0) return '-';
        const elapsed = Number(this.workflowData.stats?.avgElapsedMs);
        return Number.isFinite(elapsed) ? `${Math.round(elapsed)}ms` : '-';
    }

    public workflowSuccessRateLabel() {
        if (this.workflowRunCount() <= 0) return '-';
        const rate = Number(this.workflowData.stats?.successRate);
        if (!Number.isFinite(rate)) return '-';
        const percent = rate <= 1 ? rate * 100 : rate;
        return `${Math.max(0, Math.min(100, Math.round(percent)))}%`;
    }

    public workflowTabClass(tab: string) {
        const base = 'h-12 border-b-2 px-1 text-sm font-semibold transition-colors';
        if (this.activeWorkflowTab === tab) return `${base} border-[#2563eb] text-[#0f172a]`;
        return `${base} border-transparent text-[#64748b] hover:text-[#0f172a]`;
    }

    public async setWorkflowTab(tab: string) {
        this.activeWorkflowTab = this.normalizeWorkflowTab(tab);
        this.syncAgentSectionState('workflows');
        await this.service.render();
    }

    public workflowTemplatesFiltered() {
        const q = (this.workflowSearch || '').trim().toLowerCase();
        return (this.workflowData.templates || []).filter((tmpl: any) => {
            const matchesText = !q || `${tmpl.title} ${tmpl.description} ${tmpl.input || ''} ${tmpl.scenarioId || ''} ${(tmpl.nodes || []).join(' ')}`.toLowerCase().indexOf(q) >= 0;
            const matchesFilter = this.workflowFilter === 'all' || tmpl.difficulty === this.workflowFilter || (this.workflowFilter === 'parallel' && tmpl.parallel);
            return matchesText && matchesFilter;
        });
    }

    public ensureWorkflowSelection() {
        const templates = this.workflowData.templates || [];
        if (!this.selectedWorkflowId && templates.length) this.selectedWorkflowId = templates[0].id;
        this.selectedWorkflow = templates.find((tmpl: any) => tmpl.id === this.selectedWorkflowId) || templates[0] || null;
        if (this.selectedWorkflow) this.selectedWorkflowId = this.selectedWorkflow.id;
        if (!this.selectedWorkflowRun && this.workflowData.history?.length) {
            this.selectedWorkflowRun = this.workflowData.history[0];
        }
    }

    public async selectWorkflow(tmpl: any) {
        if (!tmpl) return;
        this.selectedWorkflowId = tmpl.id;
        this.selectedWorkflow = tmpl;
        if (tmpl.input && (!this.workflowRunInput || this.workflowRunInput === 'Lot A13 이상 원인 분석')) {
            this.workflowRunInput = tmpl.input;
        }
        this.syncAgentSectionState('workflows');
        await this.service.render();
    }

    public workflowStateClass(state: string) {
        if (state === 'completed') return 'bg-green-50 text-green-700';
        if (state === 'running') return 'bg-[#eaf2ff] text-[#2563eb]';
        if (state === 'failed') return 'bg-red-50 text-red-700';
        return 'bg-[#f4f7fb] text-[#64748b]';
    }

    public workflowStatusLabel(state: string) {
        const labels: any = {
            completed: '완료',
            running: '실행 중',
            failed: '실패',
            partial_success: '부분 완료',
            cancelled: '취소',
            waiting: '대기'
        };
        return labels[state] || state || '-';
    }

    public workflowStepStateClass(state: string) {
        if (state === 'completed') return 'bg-green-50 text-green-700';
        if (state === 'running') return 'bg-[#eaf2ff] text-[#2563eb]';
        if (state === 'failed') return 'bg-red-50 text-red-700';
        return 'bg-[#f4f7fb] text-[#64748b]';
    }

    public workflowStepStateLabel(state: string) {
        return this.workflowStatusLabel(state);
    }

    public workflowNodeLabel(node: string) {
        const labels: any = {
            'process.search': '공정 데이터 검색',
            'model.predict': 'AI 모델 실행',
            'chart.render': '차트 렌더링',
            'trace.compare': 'Trace 비교',
            'report.compose': '보고서 작성',
            'optimize.recommend': '조건 최적화',
            'rag.search': '문서 RAG 검색',
            'quality.validate': '품질 검증',
            'ingestion.monitor': '수집 모니터링',
            'access.audit': '권한·감사 확인',
            'operations.metrics': '운영 지표 확인',
            'mcp.health': 'MCP 상태 점검',
            'serving.status': 'LLM 서빙 상태',
            'performance': '성능 지표',
            'conversation.history': '대화 이력',
            'training.scenarios': '학습 시나리오',
            'glossary': '용어사전',
            'demo.run': '검수 데모',
            'verification': '검증 스코어링',
            'permission.registry': '권한 레지스트리',
            'security.backup': '보안·백업 점검'
        };
        return labels[node] || node || '-';
    }

    public workflowNodeShort(node: string) {
        const labels: any = {
            'process.search': 'process.search',
            'model.predict': 'predict',
            'chart.render': 'chart.render',
            'trace.compare': 'trace.compare',
            'report.compose': 'compose',
            'optimize.recommend': 'optimize',
            'rag.search': 'rag.search',
            'quality.validate': 'quality',
            'ingestion.monitor': 'ingestion',
            'access.audit': 'audit',
            'operations.metrics': 'ops',
            'mcp.health': 'mcp',
            'serving.status': 'serving',
            'performance': 'perf',
            'conversation.history': 'history',
            'training.scenarios': 'training',
            'glossary': 'glossary',
            'demo.run': 'demo',
            'verification': 'verify',
            'permission.registry': 'permission',
            'security.backup': 'security'
        };
        return labels[node] || node || '-';
    }

    public workflowNodeSummary(tmpl: any) {
        return (tmpl?.nodes || []).map((node: string) => this.workflowNodeShort(node)).join(' · ');
    }

    public workflowTemplateItemClass(tmpl: any) {
        return this.selectedWorkflowId === tmpl?.id ? 'is-selected' : '';
    }

    public workflowDifferenceNote(tmpl: any) {
        if (tmpl?.scenarioId) return 'PDF 사용자 시나리오를 화면 경로, 질문 예시, 도구 단계, 완료 산출물로 바꾼 실행 레시피입니다.';
        if (tmpl?.id !== 'wf-process-model-chart') return '';
        return '워크플로는 공정 검색, 모델 예측, 차트 렌더링을 하나의 자동 실행 레시피로 묶습니다. 예측/추론 화면은 모델 선택, 입력값, Trace·최적화 조건을 직접 바꾸며 결과를 해석하는 분석 작업 화면입니다.';
    }

    public workflowResult() {
        return this.selectedWorkflowRun || (this.workflowData.history || [])[0] || null;
    }

    public workflowResultSummary(run: any) {
        if (!run) return '워크플로를 실행하면 이 영역에 결과가 표시됩니다.';
        if (run.summary) return run.summary;
        return `${run.title || run.template || '워크플로'} 실행이 ${run.state || 'completed'} 상태로 완료되었습니다.`;
    }

    public workflowOutputs(run: any) {
        if (!run) return [];
        if (run.outputs?.length) return run.outputs;
        return [
            { label: '실행 대상', value: run.request?.input || run.inputs?.input || run.template || '-' },
            { label: '완료 단계', value: `${run.steps?.length || 0} steps` },
            { label: '실행 시간', value: `${run.elapsedMs || 0}ms` },
        ];
    }

    public workflowProgressPercent(run: any) {
        const metrics = run?.metrics || {};
        const total = Number(metrics.totalSteps || run?.steps?.length || 0);
        if (!total) return 0;
        const completed = Number(metrics.completedSteps || (run?.steps || []).filter((step: any) => step.state === 'completed').length || 0);
        return Math.max(0, Math.min(100, Math.round((completed / total) * 100)));
    }

    public workflowResultChecks(run: any) {
        if (!run) return [];
        if (run.qualityChecks?.length) return run.qualityChecks;
        const total = run.steps?.length || 0;
        const completed = (run.steps || []).filter((step: any) => step.state === 'completed').length;
        const artifacts = run.artifacts?.length || 0;
        return [
            { label: completed === total ? '정상' : '확인', status: completed === total ? 'pass' : 'warn', detail: `${completed}/${total} 도구 단계 완료` },
            { label: artifacts > 0 ? '생성' : '대기', status: artifacts > 0 ? 'pass' : 'info', detail: `${artifacts}개 산출물 참조 생성` },
            { label: '검토', status: 'review', detail: '엔지니어가 결과 요약과 산출물을 확인한 뒤 후속 조치를 확정' },
        ];
    }

    public workflowCheckClass(status: string) {
        if (status === 'pass') return 'bg-green-50 text-green-700';
        if (status === 'warn') return 'bg-[#fff7ed] text-[#b45309]';
        if (status === 'review') return 'bg-[#eaf2ff] text-[#2563eb]';
        return 'bg-[#f4f7fb] text-[#64748b]';
    }

    public workflowHistoryItems() {
        return (this.workflowData.history || []).slice(0, 12);
    }

    public workflowRunInputLabel(run: any) {
        return run?.request?.input || run?.inputs?.input || run?.template || '-';
    }

    public workflowChartPointClass(point: any) {
        if (point?.status === 'ok') return 'bg-[#2563eb]';
        if (point?.status === 'warn') return 'bg-amber-400';
        if (point?.status === 'hot') return 'bg-red-500';
        if (point?.status === 'idle') return 'bg-gray-400';
        return 'bg-[#2563eb]';
    }

    public workflowChartPointLabel(point: any) {
        if (!point) return '-';
        if (point.status) return `${point.x},${point.y}`;
        return String(point.y ?? point.value ?? point.x ?? '-');
    }

    public workflowChartPointHeight(point: any) {
        const value = Number(point?.y ?? point?.value ?? 0);
        return Math.max(18, Math.min(100, value)) + '%';
    }

    public async selectWorkflowRun(run: any) {
        this.selectedWorkflowRun = run;
        if (run?.template) {
            this.selectedWorkflowId = run.template;
            this.ensureWorkflowSelection();
        }
        this.activeWorkflowTab = 'result';
        this.syncAgentSectionState('workflows');
        await this.service.render();
    }

    public async openWorkflowPrompt(tmpl: any = null) {
        const selected = tmpl || this.selectedWorkflow;
        this.input = selected?.input || `${selected?.title || '워크플로'}를 ${this.workflowRunInput || 'Lot A13'} 기준으로 실행 계획과 결과를 설명해줘`;
        this.section = 'chat';
        this.service.href('/agent/chat');
        await this.ask();
    }

    public async resetWorkflowFilters() {
        this.workflowSearch = '';
        this.workflowFilter = 'all';
        this.activeWorkflowTab = 'templates';
        this.ensureWorkflowSelection();
        this.syncAgentSectionState('workflows');
        await this.service.render();
    }

    public async runWorkflow(templateId: string = '') {
        if (this.runningWorkflow) return;
        this.ensureWorkflowSelection();
        const targetTemplate = templateId || this.selectedWorkflowId;
        if (!targetTemplate) return;
        this.runningWorkflow = targetTemplate;
        this.sectionErrors.workflows = '';
        this.syncAgentSectionState('workflows');
        await this.service.render();
        try {
            const result = await this.callApi('workflow_run_template', { template: targetTemplate, input: this.workflowRunInput, filter: this.workflowFilter }, '워크플로 실행에 실패했습니다.');
            this.workflowData.history = [result, ...(this.workflowData.history || [])].slice(0, 20);
            this.selectedWorkflowRun = result;
            this.selectedWorkflowId = targetTemplate;
            this.ensureWorkflowSelection();
            this.actionResult = { type: 'workflow', result };
            this.activeWorkflowTab = 'result';
            this.syncAgentSectionState('workflows');
        } catch (error: any) {
            this.sectionErrors.workflows = this.errorText(error);
        }
        this.runningWorkflow = '';
        await this.service.render();
    }

    public analysisCatalogModels() {
        return this.analysisCatalogData.modelRegistry?.registry || [];
    }

    public selectedAnalysisCatalogModel() {
        const models = this.analysisCatalogModels();
        return models.find((model: any) => model.id === this.analysisModelId) || models[0] || null;
    }

    public analysisModelGuide(model: any) {
        const guides: any = {
            'vm-thickness': {
                kicker: 'VIRTUAL METROLOGY',
                summary: '온도·압력·RF 전력·공정 시간으로 웨이퍼 두께를 계측 전에 추정합니다.',
                useCase: '목표 두께 편차를 조기에 확인하고 실제 계측·공정 검토의 우선순위를 정합니다.',
                result: '예측 두께 · 신뢰구간 · 신뢰도 · 변수 기여도'
            },
            'etch-endpoint-anomaly': {
                kicker: 'ANOMALY DETECTION',
                summary: '식각 공정의 압력·RF 전력·시간 조건이 샘플 기준에서 얼마나 벗어났는지 평가합니다.',
                useCase: '상대 이상 징후를 선별하고 정상 Lot·Trace에서 먼저 확인할 변수를 정합니다.',
                result: '이상 점수 · 심각도 · 신뢰도 · 영향 변수 후보'
            }
        };
        return guides[model?.id] || {
            kicker: String(model?.category || 'AI MODEL').toUpperCase(),
            summary: model?.task || '선택한 공정 모델의 입력과 출력을 테스트합니다.',
            useCase: '비식별 샘플 레코드에서 모델 실행 계약을 확인합니다.',
            result: (model?.outputSchema || []).join(' · ')
        };
    }

    public analysisCatalogModelInputs(model: any) {
        const schema = model?.inputSchema || {};
        const fields = Array.isArray(schema) ? schema : (schema.required || schema.numericFeatures || []);
        return (fields || []).map((field: any) => this.analysisVariableLabel(String(field))).join(' · ') || '-';
    }

    public analysisCatalogModelOutputs(model: any) {
        return (model?.outputSchema || []).map((field: any) => this.resultLabel(String(field))).join(' · ') || '-';
    }

    public async selectAnalysisCatalogModel(model: any) {
        if (!model?.id) return;
        this.analysisModelId = model.id;
        await this.service.render();
    }

    public async openAnalysisTest(model: any = null) {
        const selected = model || this.selectedAnalysisCatalogModel();
        if (selected?.id) this.analysisModelId = selected.id;
        this.analysisWorkspaceOpen = true;
        this.activeAnalysisTab = 'model';
        this.analysisInputsDirty = true;
        this.syncAgentSectionState('analysis');
        await this.runAnalysis();
    }

    public async closeAnalysisTest() {
        this.analysisWorkspaceOpen = false;
        this.activeAnalysisTab = 'model';
        this.syncAgentSectionState('analysis');
        await this.service.render();
    }

    public analysisVariableDefinitions() {
        return this.analysisVariableFieldDefinitions;
    }

    public analysisVariableLabel(key: string) {
        const labels: any = {
            temperature: '온도', pressure: '압력', power: 'RF 전력', time: '공정 시간',
            process: '공정', target: '목표값', recordId: '레코드'
        };
        return labels[key] || key;
    }

    public analysisModelVariableFields() {
        const model = this.selectedAnalysisModel();
        const schema = model?.inputSchema || {};
        const numeric = Array.isArray(schema?.numericFeatures) ? schema.numericFeatures : [];
        const allowed = numeric.length ? numeric : ['temperature', 'pressure', 'power', 'time'];
        return this.analysisVariableDefinitions().filter((field: any) => allowed.indexOf(field.key) >= 0);
    }

    public analysisInputOverrides() {
        const result: any = {};
        this.analysisModelVariableFields().forEach((field: any) => {
            const value = Number(this.analysisVariables[field.key]);
            if (this.analysisVariables[field.key] !== null && this.analysisVariables[field.key] !== '' && Number.isFinite(value)) {
                result[field.key] = value;
            }
        });
        return result;
    }

    public analysisVariablesValid() {
        return this.analysisModelVariableFields().every((field: any) => {
            const raw = this.analysisVariables[field.key];
            if (raw === null || raw === '') return true;
            const value = Number(raw);
            return Number.isFinite(value) && value >= field.min && value <= field.max;
        });
    }

    public analysisRequestParams() {
        return {
            query: this.analysisQuery || '',
            model: this.analysisModelId || '',
            metric: this.analysisMetric || 'thickness',
            target: this.analysisTarget,
            mode: this.analysisMode || 'auto',
            record_id: this.selectedAnalysisRecordId || '',
            rca: this.selectedRcaFactorName || '',
            recipe: this.selectedOptimizationRecipeId || '',
            ...this.analysisInputOverrides(),
            source_scope: 'sample'
        };
    }

    public analysisPurposeCards() {
        const flow = this.analysisData.executionFlow || {};
        const skills = flow.skills || [];
        const completedSkills = skills.filter((skill: any) => skill.status === 'completed').length;
        const model = flow.model || this.selectedAnalysisModel();
        return [
            {
                label: '데이터 경계',
                value: '비식별 샘플',
                detail: '운영 데이터 혼합 없음 · 생산 판정 금지'
            },
            {
                label: '사용자 질의',
                value: this.analysisQuery || '질의 입력',
                detail: this.selectedAnalysisRecordId || '레코드 자동 선택'
            },
            {
                label: '문맥·의도',
                value: flow.intent?.name || this.analysisData.agentTrace?.intent || '해석 대기',
                detail: 'Lot · 공정 · 지표 엔티티 정규화'
            },
            {
                label: 'Skill 실행',
                value: skills.length ? `${completedSkills}/${skills.length} 완료` : '계획 대기',
                detail: skills.map((skill: any) => skill.tool).slice(0, 2).join(' · ') || 'Tool 계획'
            },
            {
                label: 'AI 모델·답변',
                value: model?.id || '모델 대기',
                detail: `${model?.framework || '-'} · ${this.analysisData.finalAnswer?.status === 'completed' ? '답변 완료' : '답변 대기'}`
            }
        ];
    }

    public analysisExecutionSteps() {
        const fallback = [
            { id: 'query', label: '사용자 질의', status: 'pending', summary: this.analysisQuery || '질의 입력', purpose: '질문과 분석 조건 확정' },
            { id: 'intent', label: '문맥·의도', status: 'pending', summary: '의도 분석 대기', purpose: '의도와 공정 엔티티 해석' },
            { id: 'skill', label: 'Skill 실행', status: 'pending', summary: 'Skill 계획 대기', purpose: '데이터·분석 Tool 순차 실행' },
            { id: 'model', label: 'AI 예측·분석', status: 'pending', summary: '모델 실행 대기', purpose: '오픈소스 모델과 RCA 결과 검증' },
            { id: 'answer', label: '답변', status: 'pending', summary: '답변 대기', purpose: '예측·원인·조치를 한 답변으로 전달' }
        ];
        const expected = ['query', 'intent', 'skill', 'model', 'answer'];
        const received = this.analysisData.executionFlow?.steps;
        if (!Array.isArray(received)) return fallback;
        const byId: any = {};
        received.forEach((step: any) => {
            if (expected.indexOf(step?.id) >= 0) byId[step.id] = step;
        });
        return fallback.map((step: any) => ({ ...step, ...(byId[step.id] || {}) }));
    }

    public analysisExecutionTab(stepId: string) {
        const mapping: any = { query: 'record', intent: 'model', skill: 'result', model: 'result', answer: 'answer' };
        return mapping[stepId] || 'model';
    }

    public analysisExecutionStepClass(step: any) {
        const tab = this.analysisExecutionTab(step?.id);
        const classes = this.analysisTabClass(tab).split(' ').filter(Boolean);
        if (step?.status === 'completed' && classes.indexOf('is-ready') < 0) classes.push('is-ready');
        if (step?.status === 'failed' || step?.status === 'partial_success') classes.push('is-warning');
        return classes.join(' ');
    }

    public async setAnalysisExecutionStep(step: any) {
        await this.setAnalysisTab(this.analysisExecutionTab(step?.id));
    }

    public analysisFlowSteps() {
        return [
            { id: 'model', label: '테스트 설정', icon: 'fa-solid fa-microchip', purpose: '질의·모델·변수' },
            { id: 'record', label: '분석 대상', icon: 'fa-solid fa-table-list', purpose: 'Lot·Recipe 확정' },
            { id: 'result', label: '분석 결과', icon: 'fa-solid fa-chart-line', purpose: '예측·원인·방향 병렬 검토' },
            { id: 'answer', label: '답변', icon: 'fa-solid fa-comment-dots', purpose: '결론·근거 전달' }
        ];
    }

    public analysisStepPurpose(stepId: string) {
        return this.analysisFlowSteps().find((step: any) => step.id === stepId)?.purpose || '';
    }

    public analysisFlowNarrative() {
        return '사용자 질의 → 문맥·의도 분석 → Skill 실행 → AI 예측·결과 분석 → 근거 제한형 답변';
    }

    public analysisNextActionLabel() {
        if (this.analysisRunning) return '현재 조건으로 예측, 원인 후보, 목표 기준 최적화 방향을 함께 계산하고 있습니다.';
        if (!(this.analysisModelId || this.analysisData.selectedModel?.id)) return '모델을 확정하면 레코드 조건과 VM 예측 결과가 연결됩니다.';
        if (!this.selectedAnalysisRecordId) return '분석할 레코드를 확정하면 VM 예측값을 먼저 확인할 수 있습니다.';
        if (this.analysisInputsDirty) return '변경한 조건으로 다시 실행하면 세 분석 결과가 함께 갱신됩니다.';
        if (!this.analysisData.analytics?.sample?.virtualMetrology) return '분석 실행으로 VM 예측값과 신뢰구간을 생성합니다.';
        if (!this.selectedRcaFactor()) return 'VM 결론을 기준으로 RCA 원인 후보를 확인하세요.';
        if (this.analysisSelectionsDirty) return '원인 후보와 목표 기준 Recipe 선택을 최종 답변에 반영하세요.';
        if (this.analysisData.finalAnswer?.status === 'completed') return '완료된 답변과 실행 근거를 확인하거나 대화 화면으로 그대로 전달할 수 있습니다.';
        if (!this.selectedOptimizationRecipe()) return '목표 오차 기준의 Recipe 후보를 선택하세요.';
        return '최종 답변과 JSON 실행 근거를 생성합니다.';
    }

    public normalizeAnalysisTab(tab: string) {
        if (['vm', 'rca', 'optimize'].indexOf(tab || '') >= 0) return 'result';
        const allowed = this.analysisFlowSteps().map((step: any) => step.id);
        return allowed.indexOf(tab || '') >= 0 ? tab : 'model';
    }

    public analysisModeToTab(mode: string) {
        if (mode === 'rca' || mode === 'vm' || mode === 'optimize') return 'result';
        return '';
    }

    public async setAnalysisTab(tab: string) {
        this.activeAnalysisTab = this.normalizeAnalysisTab(tab);
        this.syncAgentSectionState('analysis');
        await this.service.render();
    }

    public async moveAnalysisTab(tab: string) {
        const nextTab = this.normalizeAnalysisTab(tab);
        await this.setAnalysisTab(nextTab);
        setTimeout(() => document.getElementById(`analysis-tab-${nextTab}`)?.focus(), 0);
    }

    public async handleAnalysisTabKeydown(event: KeyboardEvent, stepId: string) {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (keys.indexOf(event.key) < 0) return;
        const steps = this.analysisFlowSteps().filter((step: any) => this.analysisStepAccessible(step.id));
        if (!steps.length) return;
        const currentIndex = Math.max(0, steps.findIndex((step: any) => step.id === stepId));
        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + steps.length) % steps.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % steps.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = steps.length - 1;
        event.preventDefault();
        const nextId = steps[nextIndex].id;
        await this.setAnalysisTab(nextId);
        document.getElementById(`analysis-tab-${nextId}`)?.focus();
    }

    public analysisTabReady(stepId: string) {
        if (stepId === 'model') return Boolean(
            String(this.analysisQuery || '').trim()
            && this.analysisTargetValid()
            && this.analysisVariablesValid()
            && (this.analysisModelId || this.analysisData.selectedModel?.id)
        );
        if (stepId === 'record') return Boolean(this.selectedAnalysisRecordId);
        if (stepId === 'result') return !this.analysisInputsDirty && Boolean(
            this.analysisData.analytics?.sample?.virtualMetrology
            || this.rcaFactors().length
            || this.analysisData.optimization?.recommendation
        );
        if (stepId === 'answer') return !this.analysisInputsDirty && !this.analysisSelectionsDirty && this.analysisData.finalAnswer?.status === 'completed';
        return false;
    }

    public analysisTabClass(stepId: string) {
        const classes = [];
        if (this.activeAnalysisTab === stepId) classes.push('is-active');
        if (this.analysisTabReady(stepId)) classes.push('is-ready');
        return classes.join(' ');
    }

    public analysisStepAccessible(stepId: string) {
        if (stepId === 'model') return true;
        if (stepId === 'record') return this.analysisTabReady('model');
        if (stepId === 'result') return this.analysisTabReady('result');
        return this.analysisTabReady(stepId);
    }

	    public analysisStepSummary(stepId: string) {
	        if (stepId === 'model') return this.selectedAnalysisModel()?.name || `${this.analysisCatalogModels().length}개 모델`;
	        if (stepId === 'record') return this.selectedAnalysisRecordId || `${this.analysisRecordOptions().length}개 후보`;
	        if (stepId === 'result') return `${this.virtualMetrologyValue()} · ${this.selectedRcaFactor()?.name || 'RCA'} · ${this.selectedOptimizationRecipe()?.id || 'Recipe'}`;
	        if (stepId === 'answer') return this.analysisTabReady('answer') ? '답변 준비' : '대기';
	        return '';
	    }

	    public activeAnalysisLabel() {
	        const labels: any = {
	            model: '1. 요청·모델·변수 설정',
	            record: '2. 분석 대상 선택',
	            result: '3. 분석 결과 병렬 검토',
	            answer: '4. 최종 답변 확인'
	        };
	        return labels[this.activeAnalysisTab] || '분석 결과';
	    }

    public analysisPreviousTab() {
        const steps = this.analysisFlowSteps();
        const index = steps.findIndex((step: any) => step.id === this.activeAnalysisTab);
        return index > 0 ? steps[index - 1].id : 'model';
    }

    public analysisTargetValid() {
        const target = Number(this.analysisTarget);
        return Number.isFinite(target) && target > 0 && target <= 1000000;
    }

    public markAnalysisInputsDirty() {
        this.analysisInputsDirty = true;
        this.syncAgentSectionState('analysis');
    }

    public analysisExecutionCompletedCount() {
        return this.analysisExecutionSteps().filter((step: any) => step.status === 'completed').length;
    }

    public analysisExecutionStatusClass(status: string) {
        if (status === 'completed') return 'is-completed';
        if (status === 'running' || status === 'in_progress') return 'is-running';
        if (status === 'failed' || status === 'partial_success') return 'is-warning';
        return 'is-pending';
    }

    public analysisExecutionStatusLabel(status: string) {
        if (status === 'completed') return '완료';
        if (status === 'running' || status === 'in_progress') return '실행 중';
        if (status === 'failed') return '실패';
        if (status === 'partial_success') return '일부 완료';
        return '대기';
    }

    public analysisFlowStepClass(stepId: string) {
        return this.analysisTabClass(stepId);
    }

    public applyAnalysisResponseState() {
        const selected = this.analysisData.selectedModel || {};
        const request = this.analysisData.request || {};
        const responseTarget = Number(request.target);
        if (Number.isFinite(responseTarget) && responseTarget > 0 && responseTarget <= 1000000) {
            this.analysisTarget = responseTarget;
        }
        if (!this.analysisModelId && selected.id) this.analysisModelId = selected.id;
        const records = this.analysisData.process?.records || [];
        if (!this.selectedAnalysisRecordId && records.length) this.selectedAnalysisRecordId = records[0].id;
        this.selectedAnalysisRecord = this.analysisData.selectedRecord || (records.length ? { record: records.find((record: any) => record.id === this.selectedAnalysisRecordId) || records[0] } : null);
        const selectedRecord = this.selectedAnalysisRecord?.record || {};
        const responseOverrides = request.inputOverrides || {};
        this.analysisVariableDefinitions().forEach((field: any) => {
            const value = responseOverrides[field.key] ?? selectedRecord[field.key];
            const numeric = Number(value);
            if (value !== undefined && value !== null && value !== '' && Number.isFinite(numeric)) {
                this.analysisVariables[field.key] = numeric;
            }
        });
        const factors = this.rcaFactors();
        const serverRcaName = this.analysisData.selectedRca?.name || this.analysisData.finalAnswer?.selectedRca?.name || '';
        if (serverRcaName && factors.some((factor: any) => factor.name === serverRcaName)) {
            this.selectedRcaFactorName = serverRcaName;
        } else if (!factors.some((factor: any) => factor.name === this.selectedRcaFactorName)) {
            this.selectedRcaFactorName = factors[0]?.name || '';
        }
        const recipes = this.optimizationRecipes();
        const serverRecipeId = this.analysisData.selectedRecipe?.id || this.analysisData.finalAnswer?.selectedRecipe?.id || '';
        if (serverRecipeId && recipes.some((recipe: any) => recipe.id === serverRecipeId)) {
            this.selectedOptimizationRecipeId = serverRecipeId;
        } else if (!recipes.some((recipe: any) => recipe.id === this.selectedOptimizationRecipeId)) {
            this.selectedOptimizationRecipeId = recipes[0]?.id || '';
        }
    }

    public analysisRecords() {
        return this.analysisData.process?.records || [];
    }

    public analysisRecordOptions() {
        const rows = [...(this.analysisData.process?.records || [])];
        const selected = this.analysisData.selectedRecord?.record || this.selectedAnalysisRecord?.record;
        if (selected?.id && !rows.some((record: any) => record.id === selected.id)) {
            rows.unshift(selected);
        }
        return rows;
    }

    public selectedAnalysisModel() {
        const registry = this.analysisData.modelRegistry?.registry || [];
        const catalog = this.analysisCatalogModels();
        return registry.find((model: any) => model.id === this.analysisModelId)
            || catalog.find((model: any) => model.id === this.analysisModelId)
            || this.analysisData.selectedModel
            || this.selectedAnalysisCatalogModel()
            || {};
    }

    public analysisModelStatusClass(status: string) {
        if (status === 'ready' || status === 'sample-ready') return 'analysis-status analysis-status--ready';
        if (status === 'mock') return 'analysis-status analysis-status--mock';
        return 'analysis-status';
    }

    public analysisMetricLabel(metric: string) {
        const labels: any = {
            thickness: '두께',
            uniformity: '균일도',
            defect: '결함',
            yieldScore: '수율',
            resistance: '저항'
        };
        return labels[metric] || metric || '-';
    }

    public recordMetricValue(record: any) {
        if (!record) return '-';
        const value = record[this.analysisMetric];
        if (value === undefined || value === null || value === '') return '-';
        return value;
    }

    public resultLabel(key: string) {
        const labels: any = {
            score: 'score',
            severity: 'severity',
            factors: 'factors',
            predictedThickness: '예측 두께',
            confidenceInterval: 'CI',
            uncertainty: '불확실성',
            recipes: '후보',
            risk: 'risk',
            label: 'label',
            confidence: 'confidence'
        };
        return labels[key] || key;
    }

    public compactResultValue(value: any) {
        if (Array.isArray(value)) {
            if (value.length === 2 && value.every((item: any) => typeof item === 'number')) return `${value[0]}~${value[1]}`;
            return `${value.length}개`;
        }
        if (value && typeof value === 'object') {
            if (Array.isArray(value.recipes)) return `${value.recipes.length}개 후보`;
            return `${Object.keys(value).length}개`;
        }
        if (typeof value === 'number') {
            return Number.isInteger(value) ? String(value) : String(Math.round(value * 1000) / 1000);
        }
        return value || '-';
    }

    public modelResultChips() {
        const raw = this.analysisData.modelRun?.raw || {};
        return Object.keys(raw).slice(0, 4).map((key: string) => ({
            label: this.resultLabel(key),
            value: this.compactResultValue(raw[key])
        }));
    }

    public topRcaFactors() {
        return this.rcaFactors().slice(0, 3);
    }

    public rcaFactors() {
        return this.analysisData.analytics?.sample?.rca?.factors || [];
    }

    public selectedRcaFactor() {
        const factors = this.rcaFactors();
        return factors.find((factor: any) => factor.name === this.selectedRcaFactorName) || factors[0] || null;
    }

    public async selectRcaFactor(factor: any) {
        if (this.analysisRunning || !factor?.name) return;
        this.selectedRcaFactorName = factor.name;
        this.activeAnalysisTab = 'result';
        this.analysisSelectionsDirty = true;
        this.syncAgentSectionState('analysis');
        await this.service.render();
    }

    public rcaFactorImpactLabel(factor: any) {
        const value = Number(factor?.contribution);
        return Number.isFinite(value) ? `${Math.round(value * 100)}%` : '-';
    }

    public virtualMetrologyValue() {
        const vm = this.analysisData.analytics?.sample?.virtualMetrology || {};
        const value = vm.predictedThickness;
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return '-';
        return `${Math.round(numeric * 100) / 100}nm`;
    }

    public virtualMetrologyNumericValue() {
        const vm = this.analysisData.analytics?.sample?.virtualMetrology || this.analysisData.modelRun?.raw || {};
        const value = vm.predictedThickness;
        const numeric = Number(value);
        return Number.isFinite(numeric) ? numeric : null;
    }

    public virtualMetrologyDelta() {
        const value = this.virtualMetrologyNumericValue();
        const target = Number(this.analysisTarget);
        if (value === null || !this.analysisTargetValid() || !Number.isFinite(target)) return null;
        return Math.round((value - target) * 100) / 100;
    }

    public virtualMetrologyDeltaLabel() {
        const delta = this.virtualMetrologyDelta();
        if (delta === null) return '편차 대기';
        if (delta === 0) return '±0nm';
        const sign = delta > 0 ? '+' : '-';
        return `${sign}${Math.abs(delta)}nm`;
    }

    public virtualMetrologyJudgementLabel() {
        const vm = this.analysisData.analytics?.sample?.virtualMetrology || {};
        if (vm.available === false) return '두께 예측 없음';
        const delta = this.virtualMetrologyDelta();
        if (delta === null) return '예측 대기';
        if (!this.virtualMetrologyDirectionResolved()) return '방향 미확정';
        const abs = Math.abs(delta);
        if (abs <= 0.3) return '목표권';
        return delta > 0 ? '목표 초과' : '목표 미달';
    }

    public virtualMetrologyJudgementClass() {
        const delta = this.virtualMetrologyDelta();
        if (delta === null) return 'is-pending';
        if (!this.virtualMetrologyDirectionResolved()) return 'is-watch';
        const abs = Math.abs(delta);
        if (abs <= 0.3) return 'is-ok';
        if (abs <= 1) return 'is-watch';
        return 'is-hot';
    }

    public virtualMetrologyConclusion() {
        const record = this.selectedAnalysisRecord?.record;
        const delta = this.virtualMetrologyDelta();
        if (delta === null) return '모델과 레코드를 선택하면 VM 예측 결론이 표시됩니다.';
        if (!this.virtualMetrologyDirectionResolved()) {
            return `${record?.id || '선택 레코드'}의 점추정은 ${this.virtualMetrologyValue()}(${this.virtualMetrologyDeltaLabel()})이지만, CI ${this.virtualMetrologyInterval()}와 신뢰도 ${this.analysisConfidenceLabel()}를 고려하면 목표 대비 방향을 확정할 수 없습니다.`;
        }
        if (delta === 0) return `${record?.id || '선택 레코드'}는 목표 ${this.analysisTarget}nm와 같은 수준으로 예측됩니다. RCA 후보는 예방 점검 관점에서 확인하세요.`;
        const direction = delta > 0 ? '높게' : '낮게';
        const action = delta > 0 ? '식각 제거량 또는 endpoint 조건 보정이 필요합니다.' : '과보정 여부와 목표 미달 리스크를 확인해야 합니다.';
        return `${record?.id || '선택 레코드'}는 목표 ${this.analysisTarget}nm 대비 ${this.virtualMetrologyDeltaLabel()} ${direction} 예측됩니다. ${action}`;
    }

    public virtualMetrologyConfidenceNote() {
        const vm = this.analysisData.analytics?.sample?.virtualMetrology || {};
        const uncertainty = vm.uncertainty ?? '-';
        return `신뢰도 ${this.analysisConfidenceLabel()} · CI ${this.virtualMetrologyInterval()} · 불확실성 ${uncertainty}${vm.uncertaintyUnit === 'nm' ? 'nm' : ''}`;
    }

    public virtualMetrologyDirectionResolved() {
        const resolved = this.analysisData.finalAnswer?.conclusion?.directionResolved;
        if (typeof resolved === 'boolean') return resolved;
        const confidence = this.analysisConfidenceValue();
        const interval = this.analysisData.analytics?.sample?.virtualMetrology?.confidenceInterval || [];
        const target = Number(this.analysisTarget);
        if (confidence !== null && confidence < 60) return false;
        if (Array.isArray(interval) && interval.length >= 2 && Number(interval[0]) <= target && target <= Number(interval[1])) return false;
        return true;
    }

	    public virtualMetrologyInterval() {
	        const interval = this.analysisData.analytics?.sample?.virtualMetrology?.confidenceInterval || [];
	        if (!Array.isArray(interval) || interval.length < 2) return '-';
            const low = Number(interval[0]);
            const high = Number(interval[1]);
            if (!Number.isFinite(low) || !Number.isFinite(high)) return '-';
	        return `${Math.round(low * 100) / 100}~${Math.round(high * 100) / 100}`;
	    }

	    public virtualMetrologyHalfInterval() {
	        const interval = this.analysisData.analytics?.sample?.virtualMetrology?.confidenceInterval || [];
	        if (!Array.isArray(interval) || interval.length < 2) return '-';
	        const half = Math.abs(Number(interval[1]) - Number(interval[0])) / 2;
	        if (!Number.isFinite(half)) return '-';
	        return `${Math.round(half * 10) / 10}nm`;
	    }

	    public analysisConfidenceValue() {
	        const raw = this.analysisData.modelRun?.raw || {};
	        if (typeof raw.confidence === 'number') {
	            return raw.confidence <= 1 ? Math.round(raw.confidence * 100) : Math.round(raw.confidence);
	        }
	        const uncertainty = this.analysisData.analytics?.sample?.virtualMetrology?.uncertainty ?? raw.uncertainty;
	        if (typeof uncertainty === 'number') {
	            return Math.max(0, Math.min(99, Math.round(100 - uncertainty * 28)));
	        }
	        return null;
	    }

	    public analysisConfidenceLabel() {
	        const value = this.analysisConfidenceValue();
	        return value === null ? '-' : `${value}%`;
	    }

	    public analysisChartPoints() {
	        const points = this.analysisData.modelRun?.chart?.points || this.analysisData.chart?.points || [];
	        return (points || []).filter((point: any) => typeof point === 'number' && Number.isFinite(point));
	    }

	    public analysisChartHeight(value: number) {
	        const points = this.analysisChartPoints();
	        if (!points.length) return '45%';
	        const min = Math.min(...points);
	        const max = Math.max(...points);
	        if (max === min) return '70%';
	        const ratio = (Number(value) - min) / (max - min);
	        return `${Math.round(36 + ratio * 58)}%`;
	    }

	    public analysisChartLabel(value: number) {
	        if (Number.isInteger(value)) return String(value);
	        return String(Math.round(value * 10) / 10);
	    }

	    public optimizationRecipes() {
	        return (this.analysisData.optimization?.recommendation?.recipes || []).slice(0, 3);
	    }

    public selectedOptimizationRecipe() {
        const recipes = this.optimizationRecipes();
        return recipes.find((recipe: any) => recipe.id === this.selectedOptimizationRecipeId) || recipes[0] || null;
    }

    public selectedOptimizationRecipeSummary(recipe: any = this.selectedOptimizationRecipe()) {
        if (!recipe) return '추천 recipe가 아직 없습니다.';
        return `${recipe.temperature}C · ${recipe.pressure}Torr · ${recipe.time}s · 오차 ${recipe.targetError}`;
    }

    public optimizationRcaEvidence(recipe: any = this.selectedOptimizationRecipe(), factor: any = this.selectedRcaFactor()) {
        if (!recipe) return '목표 오차를 비교할 Recipe 후보를 선택하세요.';
        const rcaNote = factor ? `RCA에서는 ${this.analysisVariableLabel(factor.name)}을 별도 확인 대상으로 선택했습니다.` : 'RCA 확인 변수는 선택하지 않았습니다.';
        return `${recipe.id}는 목표 ${this.analysisTarget} 기준 오차 ${recipe.targetError}의 과거 샘플 후보입니다. ${rcaNote} 이 Recipe 순위에는 RCA 선택값이 반영되지 않습니다.`;
    }

    public analysisFinalSummaryRows() {
        const factor = this.selectedRcaFactor();
        const recipe = this.selectedOptimizationRecipe();
        return [
            { label: 'VM 결론', value: this.virtualMetrologyJudgementLabel(), detail: this.virtualMetrologyConclusion() },
            { label: 'RCA 확인 후보', value: factor?.name || 'RCA 후보', detail: factor?.description || '확인할 영향 변수를 선택하세요.' },
            { label: '목표 기준 후보', value: recipe?.id || 'Recipe 후보', detail: this.optimizationRcaEvidence(recipe, factor) }
        ];
    }

    public async selectOptimizationRecipe(recipe: any) {
        if (this.analysisRunning || !recipe?.id) return;
        this.selectedOptimizationRecipeId = recipe.id;
        this.activeAnalysisTab = 'result';
        this.analysisSelectionsDirty = true;
        this.syncAgentSectionState('analysis');
        await this.service.render();
    }

    public async changeAnalysisModel() {
        if (this.analysisRunning) return;
        const selected = this.selectedAnalysisModel();
        if (selected?.id) this.analysisData.selectedModel = selected;
        this.markAnalysisInputsDirty();
        await this.service.render();
    }

    public async selectAnalysisModel(model: any) {
        if (this.analysisRunning || !model?.id) return;
        this.analysisModelId = model.id;
        this.analysisData.selectedModel = model;
        this.markAnalysisInputsDirty();
        await this.service.render();
    }

    public async selectAnalysisRecord(record: any) {
        if (this.analysisRunning || !record?.id) return;
        this.selectedAnalysisRecordId = record.id;
        this.selectedAnalysisRecord = { record };
        this.analysisVariableDefinitions().forEach((field: any) => {
            const value = Number(record[field.key]);
            this.analysisVariables[field.key] = Number.isFinite(value) ? value : null;
        });
        this.markAnalysisInputsDirty();
        await this.service.render();
    }

    public async runAnalysisForRecord(record: any) {
        if (!record?.id) return;
        this.selectedAnalysisRecordId = record.id;
        this.analysisQuery = `${record.lot} ${record.process} ${record.id} ${this.analysisMetric} 예측과 원인 분석`;
        await this.runAnalysis();
    }

    public async runAnalysis(nextTab: string = '') {
        if (this.analysisRunning) return;
        this.analysisRunning = true;
        this.sectionErrors.analysis = '';
        this.syncAgentSectionState('analysis');
        await this.service.render();
        try {
            this.analysisData = await this.callApi('analysis_hub', this.analysisRequestParams(), 'AI 분석 실행에 실패했습니다.');
            this.applyAnalysisResponseState();
            this.analysisInputsDirty = false;
            this.analysisSelectionsDirty = false;
            if (nextTab) this.activeAnalysisTab = this.normalizeAnalysisTab(nextTab);
            this.actionResult = { type: 'analysis', result: this.analysisData.modelRun };
            this.syncAgentSectionState('analysis');
        } catch (error: any) {
            this.sectionErrors.analysis = this.errorText(error);
        }
        this.analysisRunning = false;
        await this.service.render();
        if (nextTab && !this.sectionErrors.analysis) {
            const completedTab = this.normalizeAnalysisTab(nextTab);
            setTimeout(() => document.getElementById(`analysis-tab-${completedTab}`)?.focus(), 0);
        }
    }

    public async completeAnalysisReview() {
        if (this.analysisSelectionsDirty) {
            await this.runAnalysis('answer');
            return;
        }
        await this.moveAnalysisTab('answer');
    }

    public async sendAnalysisToChat() {
        const finalAnswer = this.analysisData.finalAnswer || {};
        const executionFlow = this.analysisData.executionFlow || {};
        if (!finalAnswer.text) return;
        const question = finalAnswer.query || this.analysisQuery || '샘플 공정 분석';
        const pipeline = this.analysisData.orchestration?.pipeline || {};
        const actions = (pipeline.actions || []).map((action: any) => ({
            name: action.name,
            status: action.status,
            elapsedMs: action.elapsedMs,
            outputRef: action.outputRef,
            error: action.error
        }));
        const meta = {
            question,
            intent: executionFlow.intent?.name || this.analysisData.agentTrace?.intent || 'anomaly',
            analysis: {
                ...(executionFlow.intent || {}),
                executionFlow,
                finalAnswer
            },
            trace: this.analysisData.agentTrace,
            traceCompare: this.analysisData.trace,
            stages: (executionFlow.steps || []).map((step: any) => ({
                name: step.label,
                status: step.status === 'completed' ? 'done' : step.status,
                detail: step.summary || step.purpose,
                elapsedMs: 0
            })),
            toolPlan: (executionFlow.skills || []).map((skill: any) => ({
                name: skill.tool,
                label: skill.name,
                status: skill.status === 'completed' ? 'ready' : 'planned',
                latency: `${skill.elapsedMs || 0}ms`,
                permission: 'researcher'
            })),
            actions,
            chart: this.analysisData.chart,
            orchestration: this.analysisData.orchestration,
            dataScope: finalAnswer.dataScope || 'sample',
            interpretation: '비식별 샘플 데이터와 오픈소스 모델 결과이며 생산 판정에는 사용할 수 없습니다.',
            artifactPolicy: {
                progress: true,
                execution: true,
                traceCompare: Boolean(this.analysisData.trace),
                chart: Boolean(this.analysisData.chart)
            }
        };
        this.lastQuestion = question;
        this.messages.push({ role: 'user', content: question });
        this.messages.push(this.assistantMessageFromMeta(meta, finalAnswer.text, question, this.analysisData.modelRun?.elapsedMs || 0));
        this.section = 'chat';
        history.replaceState(null, '', '/agent/chat');
        this.syncFloatingChatVisibility();
        await this.saveHistory(question);
        await this.service.render();
    }

    public async downloadAnalysisJson() {
        await this.service.file.download({
            provenance: this.sampleExportContext(),
            request: this.analysisRequestParams(),
            selectedRecord: this.selectedAnalysisRecord,
            result: this.analysisData
        }, 'nanofab-analysis-result.json');
    }

    public traceRequestParams() {
        return {
            base: this.traceBase || '',
            target: this.traceTarget || '',
            metric: this.traceMetric || 'pressure',
            mode: this.traceMode || 'lot',
            lot: this.traceFilters.lot || '',
            process: this.traceFilters.process || '',
            equipment: this.traceFilters.equipment || '',
            status: this.traceFilters.status || '',
        };
    }

    public applyTraceResponseState() {
        const request = this.traceData?.request || {};
        const filters = request.filters || {};
        if (request.target) this.traceTarget = request.target;
        if (request.metric) this.traceMetric = request.metric;
        if (request.mode) this.traceMode = request.mode;
        this.traceFilters = {
            lot: filters.lot || (this.traceTargetIsLot(this.traceTarget) ? this.traceTarget : ''),
            process: filters.process || '',
            equipment: filters.equipment || (!filters.lot && this.traceTargetIsEquipment(this.traceTarget) ? this.traceTarget : ''),
            status: filters.status || '',
        };
    }

    public onTraceFilterChange(changedKey: string = '') {
        if (changedKey === 'lot' && this.traceFilters.lot) {
            this.traceTarget = this.traceFilters.lot;
            this.traceMode = 'lot';
        } else if (this.traceFilters.lot) {
            this.traceTarget = this.traceFilters.lot;
            this.traceMode = 'lot';
        } else if (this.traceFilters.equipment) {
            this.traceTarget = this.traceFilters.equipment;
            this.traceMode = 'equipment';
        } else if (this.traceTargetIsLot(this.traceTarget)) {
            this.traceMode = 'lot';
        }
        this.syncAgentSectionState('trace');
    }

    public traceFacetOptions(key: string) {
        const facets = this.traceData.targetFacets || this.explorerData.search?.facets || {};
        const values = facets[key] || this.traceStaticFacetOptions(key);
        return (values || []).filter((value: any, index: number, rows: any[]) => value && rows.indexOf(value) === index);
    }

    private traceStaticFacetOptions(key: string) {
        const map: any = {
            lot: ['Lot A13', 'Lot B22', 'Lot E08', 'Lot G17', 'Lot H31', 'Lot L06'],
            process: ['photo', 'etch', 'deposition', 'cmp', 'metrology', 'implant', 'clean', 'oxidation', 'anneal', 'epitaxy', 'inspection', 'packaging'],
            equipment: ['LAM-E14', 'EBARA-C03', 'AMAT-D07', 'AMAT-D09', 'KLA-INS22', 'TEL-F12', 'ASM-EPI03'],
            status: ['ok', 'watch', 'hot'],
        };
        return map[key] || [];
    }

    public traceTargetSummary() {
        const filters = [
            this.traceFilters.lot,
            this.traceFilters.process,
            this.traceFilters.equipment,
            this.traceFilters.status,
        ].filter(Boolean);
        return filters.length ? filters.join(' · ') : (this.traceTarget || 'Target 자동');
    }

    public traceTargetIsLot(target: string) {
        return /^Lot\s+/i.test(String(target || '').trim());
    }

    public traceTargetIsEquipment(target: string) {
        const value = String(target || '').trim();
        return Boolean(value && !this.traceTargetIsLot(value) && value.toLowerCase() !== 'baseline' && value.indexOf(',') < 0);
    }

    public traceTabs() {
        const deviationCount = this.traceData.deviationSegments?.length || 0;
        const contextCount = (this.traceData.targetContext?.process?.length || 0) +
            (this.traceData.targetContext?.sensors?.length || 0) +
            (this.traceData.targetContext?.events?.length || 0);
        const actionCount = (this.traceData.recommendations?.length || 0) +
            (this.traceData.causeCandidates?.length || 0);

        return [
            { id: 'waveform', kicker: '비슷한 정도', label: '파형 요약', meta: `${((this.traceData.similarity || 0) * 100).toFixed(1)}%`, description: '기준 파형과 대상 파형이 얼마나 비슷한지 한눈에 확인' },
            { id: 'deviation', kicker: '확인 지점', label: '차이 구간', meta: `${deviationCount}개`, description: '기준보다 차이가 커서 먼저 볼 시점' },
            { id: 'context', kicker: '관련 근거', label: '근거 데이터', meta: `${contextCount}건`, description: '차이 구간을 설명할 센서, 장비 이벤트, 공정 이력' },
            { id: 'actions', kicker: '다음 확인', label: '후속 액션', meta: `${actionCount}개`, description: '가능 원인과 이어서 확인할 작업' },
        ];
    }

    public traceComparisonModels() {
        const unit = this.traceUnit();
        const apiModels = this.traceData.comparisonModels || [];
        const source = apiModels.length ? apiModels : this.traceStaticTargetOptions().slice(0, 8);
        const currentTarget = String(this.traceTarget || '').trim();
        return source.map((model: any) => {
            const value = model.value || model.label || '';
            const risk = model.risk || this.traceModelRisk(model);
            const similarity = Number(model.similarity);
            const deviationCount = Number(model.deviationCount || 0);
            const maxDiff = Number(model.maxDiff || 0);
            return {
                ...model,
                value,
                label: model.label || value,
                scope: model.scope || this.traceModelScope(model),
                badge: model.badge || (String(value).indexOf('Lot ') === 0 ? 'Lot 모델' : '장비 모델'),
                mode: model.mode || (String(value).indexOf('Lot ') === 0 ? 'lot' : 'equipment'),
                risk,
                selected: value === currentTarget,
                scoreText: Number.isFinite(similarity) && similarity > 0 ? `${(similarity * 100).toFixed(1)}%` : '-',
                deviationText: Number.isFinite(deviationCount) ? `${deviationCount}개` : '-',
                maxDiffText: Number.isFinite(maxDiff) && maxDiff > 0 ? `${this.formatTraceValue(maxDiff)}${unit}` : '-',
            };
        });
    }

    public traceModelCardClass(model: any) {
        return `${model?.selected ? 'is-selected ' : ''}is-${model?.risk || 'ok'}`;
    }

    public async selectTraceModel(model: any) {
        if (!model?.value || this.traceRunning) return;
        this.traceTarget = model.value;
        this.traceMode = model.mode || (String(model.value).indexOf('Lot ') === 0 ? 'lot' : 'equipment');
        await this.runTraceCompare();
    }

    public async setTraceTab(tabId: string) {
        this.traceActiveTab = this.normalizeTraceTab(tabId);
        this.syncAgentSectionState('trace');
        await this.service.render();
    }

    private normalizeTraceTab(tabId: string) {
        const allowed = ['waveform', 'deviation', 'context', 'actions'];
        return allowed.indexOf(tabId || '') >= 0 ? tabId : 'waveform';
    }

    public traceSeries(seriesName: string) {
        const index = seriesName === 'target' ? 1 : 0;
        const rows = this.traceData.overlaySeries?.[index]?.data || [];
        return rows.map((value: any) => Number(value)).filter((value: number) => Number.isFinite(value));
    }

    public traceHasSeries() {
        return this.traceSeries('baseline').length > 0 && this.traceSeries('target').length > 0;
    }

    public tracePointCount() {
        return Math.min(this.traceSeries('baseline').length, this.traceSeries('target').length);
    }

    public traceDeviationRangeLabel() {
        const segments = this.traceData.deviationSegments || [];
        if (!segments.length) return '없음';
        const indexes = segments.map((segment: any) => this.traceSegmentIndex(segment));
        const start = Math.min(...indexes);
        const end = Math.max(...indexes);
        return `index ${start}${start === end ? '' : '-' + end}`;
    }

    public traceUnit() {
        return this.traceData.metric?.unit || '';
    }

    public traceMetricTitle() {
        const labels: any = {
            pressure: 'Pressure',
            power: 'RF Power',
            temperature: 'Temperature',
            particle: 'Particle',
        };
        const label = labels[this.traceMetric] || this.traceMetric || 'Trace';
        return `${label}${this.traceUnit() ? ' · ' + this.traceUnit() : ''}`;
    }

    private tracePlotBox() {
        return { left: 48, right: 696, top: 24, bottom: 218, width: 648, height: 194 };
    }

    private traceChartDomain() {
        const values = [...this.traceSeries('baseline'), ...this.traceSeries('target')];
        if (!values.length) return { min: 0, max: 1, span: 1 };
        const rawMin = Math.min(...values);
        const rawMax = Math.max(...values);
        const rawSpan = Math.max(rawMax - rawMin, Math.max(Math.abs(rawMax), 1) * 0.08, 1);
        const pad = rawSpan * 0.16;
        const min = Math.max(0, rawMin - pad);
        const max = rawMax + pad;
        return { min, max, span: Math.max(max - min, 1) };
    }

    private traceX(index: number, total: number) {
        const plot = this.tracePlotBox();
        if (total <= 1) return plot.left;
        return plot.left + (index / (total - 1)) * plot.width;
    }

    private traceY(value: number) {
        const plot = this.tracePlotBox();
        const domain = this.traceChartDomain();
        return plot.bottom - ((Number(value || 0) - domain.min) / domain.span) * plot.height;
    }

    public traceChartPoints(seriesName: string) {
        const series = this.traceSeries(seriesName);
        return series.map((value: number, index: number) => ({
            index,
            value,
            x: this.traceX(index, series.length),
            y: this.traceY(value),
            label: this.formatTraceValue(value),
        }));
    }

    public traceLinePoints(seriesName: string) {
        return this.traceChartPoints(seriesName).map((point: any) => `${point.x.toFixed(1)},${point.y.toFixed(1)}`).join(' ');
    }

    public traceSeriesLabelTransform(seriesName: string) {
        const points = this.traceChartPoints(seriesName);
        const plot = this.tracePlotBox();
        if (!points.length) return `translate(${plot.left} ${plot.top})`;
        const point = points[points.length - 1];
        const x = Math.min(plot.right - 58, point.x + 10);
        const y = Math.max(plot.top + 12, Math.min(plot.bottom - 8, point.y));
        return `translate(${x.toFixed(1)} ${y.toFixed(1)})`;
    }

    public traceAreaPath() {
        const baseline = this.traceChartPoints('baseline');
        const target = this.traceChartPoints('target');
        const count = Math.min(baseline.length, target.length);
        if (!count) return '';
        const top = target.slice(0, count).map((point: any, index: number) => `${index === 0 ? 'M' : 'L'} ${point.x.toFixed(1)} ${point.y.toFixed(1)}`).join(' ');
        const bottom = baseline.slice(0, count).reverse().map((point: any) => `L ${point.x.toFixed(1)} ${point.y.toFixed(1)}`).join(' ');
        return `${top} ${bottom} Z`;
    }

    public traceAxisTicks() {
        const plot = this.tracePlotBox();
        const domain = this.traceChartDomain();
        return [0, 0.25, 0.5, 0.75, 1].map((ratio: number) => {
            const value = domain.max - domain.span * ratio;
            return {
                y: plot.top + plot.height * ratio,
                label: this.formatTraceValue(value),
            };
        });
    }

    public traceDeviationBands() {
        const baseline = this.traceSeries('baseline');
        const target = this.traceSeries('target');
        const count = Math.min(baseline.length, target.length);
        const plot = this.tracePlotBox();
        if (!count) return [];
        const step = count > 1 ? plot.width / (count - 1) : plot.width;
        const maxDiff = Math.max(...this.traceComparisonRows().map((row: any) => row.diff), 1);
        return (this.traceData.deviationSegments || []).map((segment: any) => {
            const index = this.traceSegmentIndex(segment);
            const x = this.traceX(index, count);
            const half = Math.max(10, step * 0.38);
            const left = Math.max(plot.left, x - half);
            const right = Math.min(plot.right, x + half);
            const opacity = Math.max(0.14, Math.min(0.34, Number(segment.diff || 0) / maxDiff * 0.34));
            return {
                path: `M ${left.toFixed(1)} ${plot.top} L ${right.toFixed(1)} ${plot.top} L ${right.toFixed(1)} ${plot.bottom} L ${left.toFixed(1)} ${plot.bottom} Z`,
                opacity,
            };
        });
    }

    public traceDeviationMarkerTransform(segment: any) {
        const target = this.traceSeries('target');
        const count = target.length || this.traceSeries('baseline').length || 1;
        const index = this.traceSegmentIndex(segment);
        const value = target[index] ?? segment?.target ?? 0;
        return `translate(${this.traceX(index, count).toFixed(1)} ${this.traceY(value).toFixed(1)})`;
    }

    public traceMarkerStem(segment: any) {
        const target = this.traceSeries('target');
        const index = this.traceSegmentIndex(segment);
        const y = this.traceY(target[index] ?? segment?.target ?? 0);
        return y < 52 ? 18 : -18;
    }

    public traceMarkerLabelY(segment: any) {
        return this.traceMarkerStem(segment) > 0 ? 31 : -24;
    }

    public traceMarkerLabel(segment: any) {
        return `차이 ${this.formatTraceValue(segment?.diff || 0)}`;
    }

    public traceComparisonRows() {
        const baseline = this.traceSeries('baseline');
        const target = this.traceSeries('target');
        const count = Math.min(baseline.length, target.length);
        const diffs = Array.from({ length: count }).map((_: any, index: number) => Math.abs((target[index] || 0) - (baseline[index] || 0)));
        const maxDiff = Math.max(...diffs, 1);
        const deviationIndexes = new Set((this.traceData.deviationSegments || []).map((segment: any) => this.traceSegmentIndex(segment)));
        const selectedIndex = this.selectedTraceSegment ? this.traceSegmentIndex(this.selectedTraceSegment) : -1;
        return Array.from({ length: count }).map((_: any, index: number) => {
            const diff = diffs[index] || 0;
            const level = deviationIndexes.has(index) ? (diff >= maxDiff * 0.75 ? 'hot' : 'watch') : 'ok';
            const className = `${level === 'hot' ? 'is-hot' : level === 'watch' ? 'is-watch' : 'is-ok'}${selectedIndex === index ? ' is-selected' : ''}`;
            return {
                index,
                baseline: baseline[index],
                target: target[index],
                diff,
                diffText: this.formatTraceValue(diff),
                diffPercent: Math.max(8, Math.round((diff / maxDiff) * 100)),
                className,
                title: `시점 ${index} · 기준 ${this.formatTraceValue(baseline[index])} · 대상 ${this.formatTraceValue(target[index])} · 차이 ${this.formatTraceValue(diff)}`,
            };
        });
    }

    public traceSelectedSegment() {
        if (this.selectedTraceSegment) return this.normalizeTraceSegment(this.selectedTraceSegment);
        const firstSegment = (this.traceData.deviationSegments || [])[0];
        if (firstSegment) return this.normalizeTraceSegment(firstSegment);
        return this.tracePeakDeviationSegment();
    }

    public tracePeakDeviationSegment() {
        const rows = this.traceComparisonRows();
        if (!rows.length) return null;
        const peak = rows.reduce((max: any, row: any) => Number(row.diff || 0) > Number(max.diff || 0) ? row : max, rows[0]);
        return this.normalizeTraceSegment({
            index: peak.index,
            baseline: peak.baseline,
            target: peak.target,
            diff: peak.diff,
            interpretation: `전체 ${rows.length}개 시점 중 ${peak.index}번 지점에서 가장 큰 차이가 확인됩니다.`,
        });
    }

    private normalizeTraceSegment(segment: any) {
        if (!segment) return null;
        const index = this.traceSegmentIndex(segment);
        const baseline = segment.baseline !== undefined ? segment.baseline : this.traceSeries('baseline')[index];
        const target = segment.target !== undefined ? segment.target : this.traceSeries('target')[index];
        const diff = segment.diff !== undefined ? segment.diff : Math.abs(Number(target || 0) - Number(baseline || 0));
        return {
            ...segment,
            index,
            baseline: this.formatTraceValue(Number(baseline || 0)),
            target: this.formatTraceValue(Number(target || 0)),
            diff: this.formatTraceValue(Number(diff || 0)),
            rawDiff: Number(diff || 0),
            interpretation: segment.interpretation || `${index}번 지점에서 기준보다 ${this.formatTraceValue(Number(diff || 0))}${this.traceUnit()} 차이가 납니다.`,
        };
    }

    public traceDetailMetrics() {
        const summary = this.traceData.metricSummary || {};
        const peak = this.tracePeakDeviationSegment();
        const threshold = Number(this.traceData.metric?.threshold || 0);
        return [
            { label: '기준 평균', value: `${this.formatTraceValue(summary.baselineMean || 0)}${this.traceUnit()}`, note: this.traceBase || 'baseline' },
            { label: '대상 평균', value: `${this.formatTraceValue(summary.targetMean || 0)}${this.traceUnit()}`, note: this.traceTarget || 'target' },
            { label: '평균 차이', value: `${this.formatTraceValue(this.traceAverageAbsDiff())}${this.traceUnit()}`, note: `${this.tracePointCount()}개 지점 기준` },
            { label: '가장 큰 차이', value: peak ? `${peak.index}번 지점` : '-', note: peak ? `차이 ${peak.diff}${this.traceUnit()}` : '대기' },
            { label: '관리 기준', value: `${this.formatTraceValue(threshold)}${this.traceUnit()}`, note: this.traceRiskLabel() },
        ];
    }

    public traceAverageAbsDiff() {
        const rows = this.traceComparisonRows();
        if (!rows.length) return 0;
        return rows.reduce((sum: number, row: any) => sum + Number(row.diff || 0), 0) / rows.length;
    }

    public traceFocusCards() {
        const selected = this.traceSelectedSegment();
        const evidence = this.traceEvidenceHighlights()[0];
        return [
            {
                kicker: '중점 지점',
                title: selected ? `index ${selected.index}` : this.traceDeviationRangeLabel(),
                detail: this.traceFocusReason(selected),
                tone: this.traceRiskLabel() === '중점 확인' ? 'hot' : this.traceRiskLabel() === '관찰' ? 'watch' : 'ok',
            },
            {
                kicker: '문제 양상',
                title: this.traceFocusProblemLabel(selected),
                detail: selected ? `기준 ${selected.baseline}${this.traceUnit()} 대비 대상 ${selected.target}${this.traceUnit()}로 차이 ${selected.diff}${this.traceUnit()}입니다.` : this.traceNarrative(),
                tone: selected && Number(selected.rawDiff || 0) > 0 ? 'watch' : 'ok',
            },
            {
                kicker: '확인 근거',
                title: evidence?.title || '연결 근거 없음',
                detail: evidence ? `${evidence.type} · ${evidence.detail}` : '공정 이력, 센서 이벤트, 계측 레코드를 함께 확인하세요.',
                tone: evidence?.tone || 'ok',
            },
        ];
    }

    public traceFocusReason(segment: any) {
        if (!this.traceHasSeries()) return '비교할 파형 데이터가 없습니다.';
        if (!segment || !(this.traceData.deviationSegments || []).length) return '대상 파형이 기준 관리 범위 안쪽에 있어 추가 이탈 지점은 없습니다.';
        const threshold = Number(this.traceData.metric?.threshold || 0);
        const diff = Number(segment.rawDiff || segment.diff || 0);
        if (threshold > 0 && diff >= threshold) {
            return `차이 ${this.formatTraceValue(diff)}${this.traceUnit()}가 관리 기준 ${this.formatTraceValue(threshold)}${this.traceUnit()} 이상이라 먼저 확인해야 합니다.`;
        }
        return this.traceNarrative();
    }

    public traceFocusProblemLabel(segment: any) {
        if (!segment) return this.traceRiskLabel();
        const baseline = Number(segment.baseline || 0);
        const target = Number(segment.target || 0);
        if (target > baseline) return '대상값 상승';
        if (target < baseline) return '대상값 하락';
        return '기준과 유사';
    }

    public traceSegmentImpactLabel(segment: any) {
        const diff = Number(segment?.rawDiff ?? segment?.diff ?? 0);
        const threshold = Number(this.traceData.metric?.threshold || 0);
        if (threshold > 0 && diff >= threshold * 1.35) return '높음';
        if (threshold > 0 && diff >= threshold) return '주의';
        if (diff > 0) return '낮음';
        return '대기';
    }

    public traceContextTotal() {
        const context = this.traceData.targetContext || {};
        return (context.process?.length || 0) + (context.sensors?.length || 0) + (context.events?.length || 0);
    }

    public traceEvidenceHighlights() {
        const context = this.traceData.targetContext || {};
        const rows: any[] = [];
        (context.sensors || []).slice(0, 3).forEach((sensor: any) => {
            rows.push({
                type: 'sensor',
                title: sensor.sensor || sensor.id || 'sensor',
                meta: `${sensor.equipment || this.traceTarget} · avg ${sensor.avg ?? '-'}${sensor.unit || ''}`,
                detail: `${sensor.trend || sensor.status || 'trend'} · baseline ${sensor.baseline ?? '-'}${sensor.unit || ''}`,
                tone: sensor.status || 'ok',
            });
        });
        (context.events || []).slice(0, 2).forEach((event: any) => {
            rows.push({
                type: 'event',
                title: event.type || '장비 이벤트',
                meta: `${event.equipment || this.traceTarget} · ${event.time || ''}`,
                detail: event.message || event.severity || '이벤트 확인',
                tone: event.severity === 'high' ? 'hot' : event.severity === 'medium' ? 'watch' : 'ok',
            });
        });
        [...(context.process || [])].slice(-2).reverse().forEach((record: any) => {
            rows.push({
                type: 'process',
                title: `${record.id || record.lot || 'record'} · ${record.process || 'process'}`,
                meta: `${record.equipment || '-'} · ${record.date || ''}`,
                detail: `uniformity ${record.uniformity ?? '-'}% · defect ${record.defect ?? '-'}`,
                tone: record.status || 'ok',
            });
        });
        (this.traceData.causeCandidates || []).slice(0, 2).forEach((cause: string) => {
            rows.push({
                type: 'cause',
                title: cause,
                meta: this.traceMetricTitle(),
                detail: `${this.traceDeviationRangeLabel()} 구간과 함께 확인`,
                tone: 'hot',
            });
        });
        return rows.slice(0, 7);
    }

    public traceEvidenceToneClass(tone: string) {
        if (tone === 'hot' || tone === 'high') return 'is-hot';
        if (tone === 'watch' || tone === 'medium') return 'is-watch';
        return 'is-ok';
    }

    public async selectTraceIndex(index: number) {
        const segment = (this.traceData.deviationSegments || []).find((item: any) => this.traceSegmentIndex(item) === index);
        if (segment) {
            this.selectedTraceSegment = segment;
        } else {
            const row = this.traceComparisonRows().find((item: any) => item.index === index);
            if (row) {
                this.selectedTraceSegment = {
                    index,
                    baseline: this.formatTraceValue(row.baseline),
                    target: this.formatTraceValue(row.target),
                    diff: row.diffText,
                    interpretation: `${index}번 지점의 차이는 ${row.diffText}${this.traceUnit() ? this.traceUnit() : ''}로 관리 범위 안쪽입니다.`,
                };
            }
        }
        await this.service.render();
    }

    public traceNarrative() {
        const segments = this.traceData.deviationSegments || [];
        if (!this.traceHasSeries()) return '비교할 기준 파형과 대상 파형 데이터가 없습니다.';
        if (!segments.length) return '대상 파형이 기준 파형의 관리 범위 안에서 움직이고 있습니다.';
        const indexes = segments.map((segment: any) => this.traceSegmentIndex(segment));
        const start = Math.min(...indexes);
        const end = Math.max(...indexes);
        const direction = Number(segments[0]?.target || 0) >= Number(segments[0]?.baseline || 0) ? '상승' : '하락';
        return `${start}${start === end ? '' : '-' + end}번 구간에서 대상 파형이 기준 파형보다 ${direction}했습니다. 해당 구간의 센서 이벤트와 공정 이력을 우선 확인하세요.`;
    }

    public traceRiskLabel() {
        const count = this.traceData.deviationSegments?.length || 0;
        if (!this.traceHasSeries()) return '대기';
        if (count >= 3 || (this.traceData.similarity || 0) < 0.75) return '중점 확인';
        if (count > 0) return '관찰';
        return '정상 범위';
    }

    public traceRiskClass() {
        const label = this.traceRiskLabel();
        if (label === '중점 확인') return 'trace-risk-hot';
        if (label === '관찰') return 'trace-risk-watch';
        return 'trace-risk-ok';
    }

    public traceChartAriaLabel() {
        return `${this.traceBase}와 ${this.traceTarget}의 ${this.traceMetricTitle()} 비교 그래프. ${this.traceNarrative()}`;
    }

    private traceSegmentIndex(segment: any) {
        const index = Number(segment?.index || 0);
        return Number.isFinite(index) ? index : 0;
    }

    private formatTraceValue(value: number) {
        const num = Number(value || 0);
        if (Math.abs(num) >= 100) return num.toFixed(0);
        if (Math.abs(num) >= 10) return num.toFixed(1).replace(/\.0$/, '');
        return num.toFixed(2).replace(/0$/, '').replace(/\.0$/, '');
    }

    private traceStaticTargetOptions() {
        return [
            { value: 'Lot A13', label: 'Lot A13 · CMP/Etch · EBARA-C03 · watch/hot' },
            { value: 'Lot B22', label: 'Lot B22 · Deposition · AMAT-D07 · ok' },
            { value: 'Lot E08', label: 'Lot E08 · CVD/CMP · AMAT-D09 · hot' },
            { value: 'Lot G17', label: 'Lot G17 · Ox/Anneal · TEL-F12 · ok/watch' },
            { value: 'Lot H31', label: 'Lot H31 · Epitaxy/Inspection · ASM-EPI03 · watch' },
            { value: 'Lot L06', label: 'Lot L06 · Etch · LAM-E14 · hot' },
            { value: 'LAM-E14', label: 'LAM-E14 · Etch 장비 · watch/hot' },
            { value: 'EBARA-C03', label: 'EBARA-C03 · CMP 장비 · watch/hot' },
            { value: 'KLA-INS22', label: 'KLA-INS22 · Inspection 장비 · watch' },
        ];
    }

    public traceTargetOptions() {
        const apiModels = this.traceData.comparisonModels || [];
        const options = apiModels.length
            ? apiModels.map((model: any) => ({
                value: model.value,
                label: `${model.label || model.value} · ${model.scope || this.traceModelScope(model)} · ${model.risk || this.traceModelRisk(model)}`,
            }))
            : this.traceStaticTargetOptions();
        const currentTarget = String(this.traceTarget || '').trim();
        if (currentTarget && !options.some((option) => option.value === currentTarget)) {
            return [{ value: currentTarget, label: `${currentTarget} · 현재 Target` }, ...options];
        }
        return options;
    }

    private traceModelScope(model: any) {
        const label = String(model?.label || '');
        const parts = label.split('·').map((part: string) => part.trim()).filter(Boolean);
        return parts.length > 1 ? parts.slice(1).join(' · ') : 'Trace 비교 대상';
    }

    private traceModelRisk(model: any) {
        const label = String(model?.label || model?.scope || '').toLowerCase();
        if (label.indexOf('hot') >= 0) return 'hot';
        if (label.indexOf('watch') >= 0) return 'watch';
        return 'ok';
    }

    public onTraceTargetChange() {
        const target = String(this.traceTarget || '');
        this.traceMode = target && target.indexOf('Lot ') !== 0 && target !== 'baseline' ? 'equipment' : 'lot';
        if (this.traceTargetIsLot(target)) {
            this.traceFilters.lot = target;
            this.traceFilters.equipment = '';
        } else if (this.traceTargetIsEquipment(target)) {
            this.traceFilters.equipment = target;
            this.traceFilters.lot = '';
        }
        this.syncAgentSectionState('trace');
    }

    public ensureTraceSegment() {
        const segments = this.traceData.deviationSegments || [];
        if (!this.selectedTraceSegment && segments.length) this.selectedTraceSegment = segments[0];
    }

    public async selectTraceSegment(segment: any) {
        this.selectedTraceSegment = segment;
        await this.service.render();
    }

    public segmentImpactClass(segment: any) {
        const diff = Number(segment?.rawDiff ?? segment?.diff ?? 0);
        const threshold = Number(this.traceData.metric?.threshold || 0);
        if (threshold > 0 && diff >= threshold * 1.35) return 'border-red-200 bg-red-50 text-red-700';
        if (threshold > 0 && diff >= threshold) return 'border-amber-200 bg-[#fff7ed] text-[#b45309]';
        if (diff >= 25) return 'border-red-200 bg-red-50 text-red-700';
        if (diff >= 12) return 'border-amber-200 bg-[#fff7ed] text-[#b45309]';
        return 'border-[#d9e1ec] bg-white text-[#475569]';
    }

    public async runTraceCompare() {
        if (this.traceRunning) return;
        this.traceRunning = true;
        this.sectionErrors.trace = '';
        this.syncAgentSectionState('trace');
        await this.service.render();
        try {
            this.traceData = await this.callApi('trace_panel', this.traceRequestParams(), 'Trace 비교에 실패했습니다.');
            this.selectedTraceSegment = null;
            this.applyTraceResponseState();
            this.ensureTraceSegment();
            this.actionResult = { type: 'trace', result: this.traceData };
            this.syncAgentSectionState('trace');
        } catch (error: any) {
            this.sectionErrors.trace = this.errorText(error);
        }
        this.traceRunning = false;
        await this.service.render();
    }

    public async sendTraceToChat() {
        this.input = `${this.traceBase}와 ${this.traceTargetSummary()} Trace 비교 결과에서 ${this.traceMetric} 기준 중점 확인 지점과 원인 후보를 정답 형태로 설명해줘`;
        this.section = 'chat';
        this.service.href('/agent/chat');
        await this.ask();
    }

    public async downloadTraceJson() {
        await this.service.file.download({ provenance: this.sampleExportContext(), request: this.traceRequestParams(), result: this.traceData, selectedSegment: this.selectedTraceSegment }, 'nanofab-trace-compare.json');
    }

    public visualizationRequestParams() {
        return { chart: this.chartType || 'wafermap', dataset: this.visualizationDataset || 'Lot A13', metric: this.visualizationMetric || 'thickness' };
    }

    public ensureVisualizationSelection() {
        const recs = this.visualizationReportData.visualization?.recommendations || [];
        const recommendedType = this.visualizationReportData.recommendation?.dataType || '';
        const matched = recs.find((rec: any) => rec.dataType === recommendedType);
        const stillAvailable = recs.find((rec: any) => rec.dataType === this.selectedVisualizationRecommendation?.dataType);
        if (recs.length && (!this.selectedVisualizationRecommendation || !stillAvailable)) {
            this.selectedVisualizationRecommendation = matched || recs[0];
        }
        if (!this.selectedVisualizationChart) this.selectedVisualizationChart = this.chartType;
        this.reportPreview = this.visualizationReportData.report?.sample || this.reportPreview || null;
        if (!this.selectedVisualizationPoint) {
            const points = this.visualizationPoints();
            this.selectedVisualizationPoint = points.find((point: any) => point.status === 'hot' || point.status === 'watch' || point.status === 'warn') || points[0] || null;
        }
    }

    public visualizationChartFamily() {
        const chart = this.chartType || this.visualizationReportData.rendered?.type || '';
        if (['wafermap', 'defect_map', 'measurement_layer'].indexOf(chart) >= 0) return 'wafer';
        if (['scatter', 'contour', 'heatmap'].indexOf(chart) >= 0) return 'scatter';
        if (['histogram', 'boxplot', 'bar'].indexOf(chart) >= 0) return 'bar';
        return 'trend';
    }

    public visualizationPoints() {
        const family = this.visualizationChartFamily();
        const rendered = this.visualizationReportData.rendered?.series || [];
        const wafer = this.visualizationReportData.visualization?.waferMap?.dies || [];
        const points = family === 'wafer' && wafer.length ? wafer : rendered;
        return (points || []).filter((point: any) => {
            if (!this.linkedVisualizationStatus) return true;
            return point.status === this.linkedVisualizationStatus || (this.linkedVisualizationStatus === 'watch' && point.status === 'warn');
        });
    }

    public visualizationRecords() {
        const records = this.visualizationReportData.process?.records || [];
        if (!this.linkedVisualizationStatus) return records;
        return records.filter((record: any) => record.status === this.linkedVisualizationStatus);
    }

    public visualizationTransform() {
        return `translateX(${this.visualizationPan}px) scale(${this.visualizationZoom})`;
    }

    public visualizationStatusClass(status: string) {
        const map: any = {
            ok: 'is-ok',
            watch: 'is-watch',
            warn: 'is-watch',
            hot: 'is-hot',
            idle: 'is-idle',
        };
        return map[status] || 'is-idle';
    }

    public visualizationButtonClass(action: string) {
        return this.activeVisualizationInteraction === action ? 'is-active' : '';
    }

    public visualizationPointClass(point: any) {
        const classes = [this.visualizationStatusClass(point?.status)];
        if (this.selectedVisualizationPoint && this.visualizationPointKey(this.selectedVisualizationPoint) === this.visualizationPointKey(point)) classes.push('is-selected');
        if (this.visualizationBrushActive && ['hot', 'watch', 'warn'].indexOf(point?.status) < 0) classes.push('is-muted');
        return classes.join(' ');
    }

    public visualizationPointKey(point: any) {
        return point?.id || point?.label || `${point?.x}-${point?.y}-${point?.value}`;
    }

    public selectVisualizationPoint(point: any) {
        this.selectedVisualizationPoint = point;
        this.activeVisualizationInteraction = 'hover';
        this.visualizationActionMessage = `${point?.label || point?.id || 'point'} 선택 · ${point?.status || 'status'} · ${this.visualizationValueText(point)}`;
        this.service.render();
    }

    public waferPointX(point: any) {
        const grid = this.visualizationReportData.visualization?.waferMap?.grid || 5;
        return Math.round(((Number(point?.x || 0) + 1) / (grid + 1)) * 100);
    }

    public waferPointY(point: any) {
        const grid = this.visualizationReportData.visualization?.waferMap?.grid || 5;
        return Math.round(((Number(point?.y || 0) + 1) / (grid + 1)) * 100);
    }

    public visualizationValue(point: any) {
        const value = point?.value ?? point?.y ?? 0;
        return Number(value) || 0;
    }

    public visualizationValueText(point: any) {
        const value = point?.value ?? point?.y;
        if (value === null || value === undefined || value === '') return '-';
        if (typeof value === 'number') return `${Math.round(value * 100) / 100}`;
        return String(value);
    }

    public visualizationBarPercent(point: any) {
        const values = this.visualizationPoints().map((item: any) => this.visualizationValue(item)).filter((value: number) => value > 0);
        const max = Math.max(...values, 1);
        return Math.max(8, Math.round((this.visualizationValue(point) / max) * 100));
    }

    public visualizationScatterX(point: any) {
        const points = this.visualizationPoints();
        const values = points.map((item: any) => Number(item.x || 0));
        const min = Math.min(...values, 0);
        const max = Math.max(...values, 1);
        const span = Math.max(max - min, 0.01);
        return Math.round(((Number(point?.x || 0) - min) / span) * 82 + 9);
    }

    public visualizationScatterY(point: any) {
        const points = this.visualizationPoints();
        const values = points.map((item: any) => this.visualizationValue(item));
        const min = Math.min(...values, 0);
        const max = Math.max(...values, 1);
        const span = Math.max(max - min, 0.01);
        return Math.round(91 - ((this.visualizationValue(point) - min) / span) * 82);
    }

    public interactionLabel(action: string) {
        const map: any = {
            hover: '선택',
            zoom: '확대',
            pan: '이동',
            brushing: '브러싱',
            linked_filtering: '연동 필터',
            image_export: '이미지',
            data_export: '데이터',
        };
        return map[action] || action;
    }

    public linkedFilterLabel() {
        if (!this.linkedVisualizationStatus) return '전체';
        const map: any = { ok: '정상', watch: '관찰', hot: '위험' };
        return map[this.linkedVisualizationStatus] || this.linkedVisualizationStatus;
    }

    public async runVisualizationInteraction(action: string) {
        this.activeVisualizationInteraction = action;
        if (action === 'hover') {
            const points = this.visualizationPoints();
            this.selectedVisualizationPoint = points.find((point: any) => point.status === 'hot' || point.status === 'watch' || point.status === 'warn') || points[0] || null;
            this.visualizationActionMessage = '주요 포인트를 선택했습니다.';
        } else if (action === 'zoom') {
            this.visualizationZoom = this.visualizationZoom >= 1.35 ? 1 : Math.round((this.visualizationZoom + 0.18) * 100) / 100;
            this.visualizationActionMessage = `확대 배율 ${this.visualizationZoom.toFixed(2)}x`;
        } else if (action === 'pan') {
            this.visualizationPan = this.visualizationPan >= 18 ? -18 : this.visualizationPan + 18;
            this.visualizationActionMessage = `가로 이동 ${this.visualizationPan}px`;
        } else if (action === 'brushing') {
            this.visualizationBrushActive = !this.visualizationBrushActive;
            this.visualizationActionMessage = this.visualizationBrushActive ? '위험/관찰 포인트를 강조했습니다.' : '브러싱을 해제했습니다.';
        } else if (action === 'linked_filtering') {
            const order = ['', 'watch', 'hot', 'ok'];
            const next = order[(order.indexOf(this.linkedVisualizationStatus) + 1) % order.length];
            this.linkedVisualizationStatus = next;
            this.selectedVisualizationPoint = this.visualizationPoints()[0] || null;
            this.visualizationActionMessage = `연동 필터: ${this.linkedFilterLabel()}`;
        } else if (action === 'image_export') {
            this.downloadVisualizationImage();
            this.visualizationActionMessage = '현재 차트를 SVG로 내보냈습니다.';
        } else if (action === 'data_export') {
            await this.downloadVisualizationData();
            this.visualizationActionMessage = '현재 차트 데이터를 JSON으로 내보냈습니다.';
        }
        await this.service.render();
    }

    public async selectVisualizationRecommendation(rec: any, chart: string = '') {
        this.selectedVisualizationRecommendation = rec;
        this.selectedVisualizationChart = chart || rec?.charts?.[0] || this.chartType;
        this.chartType = this.selectedVisualizationChart;
        await this.runVisualization();
    }

    public async runVisualization() {
        if (this.visualizationRunning) return;
        this.visualizationRunning = true;
        this.sectionErrors.visualization = '';
        this.syncAgentSectionState('visualization');
        await this.service.render();
        try {
            this.visualizationReportData = await this.callApi('visualization_report', this.visualizationRequestParams(), '시각화 실행에 실패했습니다.');
            this.selectedVisualizationPoint = null;
            this.ensureVisualizationSelection();
            this.actionResult = { type: 'visualization', result: this.visualizationReportData.rendered };
            this.visualizationActionMessage = `${this.visualizationDataset} ${this.visualizationMetric} ${this.chartType} 렌더링 완료`;
            this.syncAgentSectionState('visualization');
        } catch (error: any) {
            this.sectionErrors.visualization = this.errorText(error);
        }
        this.visualizationRunning = false;
        await this.service.render();
    }

    public async downloadVisualizationJson() {
        await this.service.file.download({ provenance: this.sampleExportContext(), request: this.visualizationRequestParams(), result: this.visualizationReportData, reportPreview: this.reportPreview }, 'nanofab-insight-visualization.json');
    }

    public async downloadVisualizationData() {
        await this.service.file.download({
            provenance: this.sampleExportContext(),
            request: this.visualizationRequestParams(),
            chart: this.visualizationReportData.rendered,
            points: this.visualizationPoints(),
            records: this.visualizationRecords(),
            selectedPoint: this.selectedVisualizationPoint,
            filter: this.linkedVisualizationStatus || 'all',
        }, 'nanofab-insight-chart-data.json');
    }

    public downloadVisualizationImage() {
        const width = 720;
        const height = 420;
        const points = this.visualizationPoints();
        const family = this.visualizationChartFamily();
        const colors: any = { ok: '#2563eb', watch: '#d97706', warn: '#d97706', hot: '#be123c', idle: '#94a3b8' };
        const provenance = this.sampleExportContext();
        let body = `<rect width="${width}" height="${height}" rx="18" fill="#f8fafc"/><text x="28" y="38" font-size="18" font-weight="700" fill="#0f172a">${this.svgEscape(this.visualizationDataset)} ${this.svgEscape(this.visualizationMetric)} ${this.svgEscape(this.chartType)}</text><text x="28" y="62" font-size="11" fill="#b45309">샘플 데이터 · 기준 ${this.svgEscape(provenance.dataAsOf)} · 실제 생산 판단용 아님</text>`;
        if (family === 'wafer') {
            body += `<circle cx="360" cy="220" r="145" fill="#ffffff" stroke="#cbd5e1" stroke-width="2"/>`;
            points.forEach((point: any) => {
                const x = 215 + (this.waferPointX(point) / 100) * 290;
                const y = 75 + (this.waferPointY(point) / 100) * 290;
                body += `<rect x="${x - 16}" y="${y - 12}" width="32" height="24" rx="5" fill="${colors[point.status] || colors.idle}"/>`;
            });
        } else {
            const max = Math.max(...points.map((point: any) => this.visualizationValue(point)), 1);
            points.forEach((point: any, index: number) => {
                const barWidth = Math.max(18, 560 / Math.max(points.length, 1) - 8);
                const x = 70 + index * (barWidth + 8);
                const h = Math.max(12, (this.visualizationValue(point) / max) * 260);
                const y = 360 - h;
                body += `<rect x="${x}" y="${y}" width="${barWidth}" height="${h}" rx="5" fill="${colors[point.status] || '#2563eb'}"/>`;
            });
            body += `<line x1="58" y1="360" x2="660" y2="360" stroke="#cbd5e1"/>`;
        }
        const metadata = this.svgEscape(JSON.stringify(provenance));
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><metadata>${metadata}</metadata>${body}</svg>`;
        const blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'nanofab-insight-chart.svg';
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    }

    public svgEscape(value: any) {
        return String(value || '').replace(/[&<>"']/g, (char: string) => {
            const map: any = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
            return map[char] || char;
        });
    }

    public async sendVisualizationToChat() {
        this.input = `${this.visualizationDataset} ${this.visualizationMetric} ${this.chartType} 시각화와 보고서 초안을 바탕으로 인사이트 정답을 작성해줘`;
        this.section = 'chat';
        this.service.href('/agent/chat');
        await this.ask();
    }

    public async validateQuality() {
        if (this.qualityChecking) return;
        this.qualityChecking = true;
        this.sectionErrors.quality = '';
        await this.service.render();
        try {
            const result = await this.callApi('quality_validate', {}, '품질 검증에 실패했습니다.');
            this.dataQualityData.quality = {
                ...(this.dataQualityData.quality || {}),
                sample: result
            };
            this.actionResult = { type: 'quality', result };
        } catch (error: any) {
            this.sectionErrors.quality = this.errorText(error);
        }
        this.qualityChecking = false;
        await this.service.render();
    }

    public async refreshAdminConsole() {
        if (this.adminRefreshing) return;
        this.adminRefreshing = true;
        this.sectionErrors.admin = '';
        await this.service.render();
        try {
            this.adminConsoleData = await this.callApi('admin_console', {}, '관리자 데이터 갱신에 실패했습니다.');
        } catch (error: any) {
            this.sectionErrors.admin = this.errorText(error);
        }
        this.adminRefreshing = false;
        await this.service.render();
    }

    public async selectAdminSettingsWorkspace(workspace: string) {
        const normalized = ['llm', 'document-ai', 'operations'].includes(workspace) ? workspace : 'llm';
        this.adminSettingsWorkspace = normalized;
        this.syncAgentSectionState('admin');
        if (normalized === 'document-ai' && !this.documentPipelineData.stages?.length) {
            await this.loadDocumentPipelineSettings(false);
        } else if (normalized === 'llm' && !this.llmSettingsData.models?.length) {
            await this.loadLlmSettings(false);
        } else if (normalized === 'operations' && !this.adminConsoleData.operations?.module) {
            await this.refreshAdminConsole();
        }
        await this.service.render();
    }

    public async loadDocumentPipelineSettings(render: boolean = true) {
        if (this.documentPipelineLoading) return;
        this.documentPipelineLoading = true;
        this.sectionErrors['document-pipeline-settings'] = '';
        if (render) await this.service.render();
        try {
            const data = await this.callApi(
                'document_pipeline_settings', {}, '문서 AI·데이터 처리 설정을 불러오지 못했습니다.'
            );
            this.applyDocumentPipelineData(data);
        } catch (error: any) {
            this.sectionErrors['document-pipeline-settings'] = this.errorText(
                error, '문서 AI·데이터 처리 설정을 불러오지 못했습니다.'
            );
        }
        this.documentPipelineLoading = false;
        if (render) await this.service.render();
    }

    private applyDocumentPipelineData(data: any) {
        this.documentPipelineData = data || this.documentPipelineData;
        const settings = data?.settings || {};
        const availableFormats = ['pdf', 'docx', 'hwp', 'hwpx', 'txt', 'md'];
        const configuredFormats = Array.isArray(settings.formats)
            ? settings.formats.map((value: any) => String(value || '').toLowerCase()).filter((value: string) => availableFormats.includes(value))
            : availableFormats;
        this.documentPipelineForm = {
            formats: configuredFormats.length ? configuredFormats : availableFormats,
            ocr_enabled: settings.ocr_enabled !== false,
            ocr_language: settings.ocr_language || 'kor+eng',
            extract_text: settings.extract_text !== false,
            extract_table: settings.extract_table !== false,
            extract_formula: settings.extract_formula !== false,
            chunk_size: Number(settings.chunk_size ?? 900),
            chunk_overlap: Number(settings.chunk_overlap ?? 120),
            metadata_model: settings.metadata_model || data?.activeMetadataModel || '',
            category_min: 1,
            category_max: Number(settings.category_max ?? 4),
            embedding_model: settings.embedding_model || '',
            qdrant_enabled: Boolean(settings.qdrant_enabled),
            qdrant_url: settings.qdrant_url || 'http://127.0.0.1:6333',
            qdrant_collection: settings.qdrant_collection || 'nanofab_documents',
            qdrant_distance: settings.qdrant_distance || 'Cosine'
        };
    }

    public documentPipelineFormats() {
        return this.documentPipelineFormatOptions;
    }

    public documentPipelineFormatEnabled(format: string) {
        return (this.documentPipelineForm.formats || []).includes(format);
    }

    public documentMetadataModelSelectable(model: any) {
        const engine = String(model?.engine || model?.provider || '').toLowerCase();
        const status = String(model?.status || '').toLowerCase();
        return ['ollama', 'openai'].includes(engine) && !['missing', 'needs_key'].includes(status);
    }

    public async toggleDocumentPipelineFormat(format: string, checked: boolean) {
        const formats = new Set<string>(this.documentPipelineForm.formats || []);
        if (checked) formats.add(format);
        else formats.delete(format);
        this.documentPipelineForm.formats = this.documentPipelineFormats()
            .map((item: any) => item.id)
            .filter((item: string) => formats.has(item));
        await this.service.render();
    }

    public documentPipelineStageLabel(stage: any) {
        return stage?.label || stage?.name || stage?.id || '-';
    }

    public documentPipelineStageState(stage: any) {
        const state = String(stage?.state || stage?.status || 'unavailable').toLowerCase();
        if (['ready', 'configured', 'completed', 'enabled'].includes(state)) return '준비';
        if (['degraded', 'partial', 'fallback', 'attention'].includes(state)) return '확인 필요';
        if (['disabled', 'off'].includes(state)) return '사용 안 함';
        return '미준비';
    }

    public documentPipelineStageClass(stage: any) {
        const label = this.documentPipelineStageState(stage);
        if (label === '준비') return 'is-ready';
        if (label === '사용 안 함') return 'is-disabled';
        if (label === '확인 필요') return 'is-warning';
        return 'is-blocked';
    }

    private documentPipelineValidationMessage() {
        const form = this.documentPipelineForm;
        const chunkSize = Number(form.chunk_size);
        const overlap = Number(form.chunk_overlap);
        const categoryMax = Number(form.category_max);
        if (!(form.formats || []).length) return '처리할 문서 형식을 1개 이상 선택해주세요.';
        if (!form.extract_text && !form.extract_table && !form.extract_formula) return '텍스트·표·수식 중 1개 이상의 구조를 선택해주세요.';
        if (!Number.isInteger(chunkSize) || chunkSize < 256 || chunkSize > 4096) return '청크 크기는 256~4,096자 사이의 정수여야 합니다.';
        if (!Number.isInteger(overlap) || overlap < 0 || overlap >= chunkSize) return '청크 중첩은 0 이상이며 청크 크기보다 작아야 합니다.';
        if (!Number.isInteger(categoryMax) || categoryMax < 1 || categoryMax > 4) return '문서 카테고리는 최소 1개, 최대 4개까지 설정할 수 있습니다.';
        if (form.qdrant_enabled && !String(form.qdrant_url || '').trim()) return 'Qdrant URL을 입력해주세요.';
        if (form.qdrant_enabled && !String(form.qdrant_collection || '').trim()) return 'Qdrant 컬렉션을 입력해주세요.';
        return '';
    }

    public async saveDocumentPipelineSettings() {
        if (this.documentPipelineSaving) return;
        const invalid = this.documentPipelineValidationMessage();
        if (invalid) {
            await this.service.modal.error(invalid);
            return;
        }
        this.documentPipelineSaving = true;
        this.sectionErrors['document-pipeline-settings'] = '';
        await this.service.render();
        try {
            const data = await this.callApi('save_document_pipeline_settings', {
                ...this.documentPipelineForm,
                category_min: 1,
                category_max: Math.min(4, Math.max(1, Number(this.documentPipelineForm.category_max || 4)))
            }, '문서 AI·데이터 처리 설정을 저장하지 못했습니다.');
            this.applyDocumentPipelineData(data);
            await this.service.modal.success('문서 AI·데이터 처리 설정을 저장했습니다. 미승인 문서는 재처리 시 새 설정이 적용됩니다.');
        } catch (error: any) {
            this.sectionErrors['document-pipeline-settings'] = this.errorText(error);
            await this.service.modal.error(this.sectionErrors['document-pipeline-settings']);
        }
        this.documentPipelineSaving = false;
        await this.service.render();
    }

    public async testDocumentPipeline() {
        if (this.documentPipelineTesting) return;
        const invalid = this.documentPipelineValidationMessage();
        if (invalid) {
            await this.service.modal.error(invalid);
            return;
        }
        this.documentPipelineTesting = true;
        this.sectionErrors['document-pipeline-settings'] = '';
        this.documentPipelineTestResult = null;
        await this.service.render();
        try {
            this.documentPipelineTestResult = await this.callApi(
                'test_document_pipeline', this.documentPipelineForm, '문서 처리 모델 연결 점검에 실패했습니다.'
            );
        } catch (error: any) {
            this.sectionErrors['document-pipeline-settings'] = this.errorText(error);
        }
        this.documentPipelineTesting = false;
        await this.service.render();
    }

    public async loadLlmSettings(render: boolean = true) {
        if (this.llmSettingsLoading) return;
        this.llmSettingsLoading = true;
        this.sectionErrors['llm-settings'] = '';
        if (render) await this.service.render();
        try {
            const data = await this.callApi('llm_settings', {}, 'LLM 설정을 불러오지 못했습니다.');
            this.applyLlmSettingsData(data);
        } catch (error: any) {
            this.sectionErrors['llm-settings'] = this.errorText(error);
        }
        this.llmSettingsLoading = false;
        if (render) await this.service.render();
    }

    private applyLlmSettingsData(data: any) {
        this.llmSettingsData = data || this.llmSettingsData;
        this.modelServing = data || this.modelServing;
        const params = data?.params || {};
        const activeModel = data?.activeModel || data?.settings?.active_model || data?.models?.[0]?.id || '';
        this.llmSettingsForm = {
            model: activeModel,
            provider: data?.provider || data?.settings?.provider || 'ollama',
            temperature: params.temperature ?? 0.2,
            top_p: params.top_p ?? 0.9,
            max_tokens: params.max_tokens ?? 1024,
            ollama_base_url: data?.ollama?.baseUrl || data?.settings?.ollama_base_url || ''
        };
    }

    public llmModels() {
        return this.llmSettingsData.models || [];
    }

    public llmDownloadedModels() {
        const supported = this.llmModels().filter((model: any) => ['ollama', 'openai'].includes(model.engine));
        const rows = supported.filter((model: any) => model.engine !== 'ollama' || model.downloaded);
        return rows.length ? rows : supported;
    }

    public llmSelectedModel() {
        return this.llmModels().find((model: any) => model.id === this.llmSettingsForm.model) || this.llmSettingsData.selectedModel || {};
    }

    public llmModelSelectable(model: any) {
        if (!model) return false;
        if (!['ollama', 'openai'].includes(model.engine)) return false;
        if (model.engine !== 'ollama') return model.status !== 'needs_key';
        return model.downloaded || model.status === 'unknown';
    }

    public llmModelRowClass(model: any) {
        const base = 'grid w-full gap-3 px-4 py-3 text-left transition md:grid-cols-[minmax(0,1fr)_100px_100px_80px]';
        const selected = this.llmSettingsForm.model === model.id ? 'bg-[#eaf2ff]' : 'bg-white hover:bg-[#f4f7fb]';
        const disabled = this.llmModelSelectable(model) ? '' : ' opacity-60';
        return `${base} ${selected}${disabled}`;
    }

    public llmModelStatusLabel(model: any) {
        const status = model?.status || '';
        const labels: any = {
            ready: '사용 가능',
            configured: '설정됨',
            missing: '미다운로드',
            unknown: '확인 필요',
            cloud_auth_required: '인증 필요',
            needs_key: '키 필요',
            compatible: '호환',
            standby: '대기'
        };
        return labels[status] || status || '-';
    }

    public llmModelStatusClass(model: any) {
        const status = model?.status || '';
        if (status === 'ready' || model?.downloaded) return 'bg-green-50 text-green-700';
        if (status === 'missing' || status === 'needs_key') return 'bg-red-50 text-red-700';
        if (status === 'cloud_auth_required') return 'bg-[#fff7ed] text-[#b45309]';
        return 'bg-[#f4f7fb] text-[#64748b]';
    }

    public llmServingStateLabel(status: any) {
        const state = status?.state || (status?.healthy ? 'healthy' : 'degraded');
        const labels: any = {
            healthy: '정상',
            degraded: '저하',
            blocked: '차단'
        };
        return labels[state] || (status?.healthy ? '정상' : '확인 필요');
    }

    public llmServingStateClass(status: any) {
        const state = status?.state || (status?.healthy ? 'healthy' : 'degraded');
        if (state === 'healthy') return 'text-green-700';
        if (state === 'blocked') return 'text-red-700';
        return 'text-[#b45309]';
    }

    public llmServingReason(status: any) {
        return status?.reason || status?.chatCheck?.error || status?.baseUrl || status?.checkEndpoint || '-';
    }

    public async chooseLlmModel(model: any) {
        if (!this.llmModelSelectable(model)) return;
        this.llmSettingsForm.model = model.id;
        this.llmSettingsForm.provider = model.engine === 'openai' ? 'openai' : 'ollama';
        await this.service.render();
    }

    public async saveLlmSettings() {
        if (this.llmSettingsSaving) return;
        if (!this.llmSettingsForm.model) {
            await this.service.modal.error('모델을 선택해주세요.');
            return;
        }
        this.llmSettingsSaving = true;
        this.sectionErrors['llm-settings'] = '';
        await this.service.render();
        try {
            const data = await this.callApi('save_llm_settings', this.llmSettingsForm, 'LLM 설정 저장에 실패했습니다.');
            this.applyLlmSettingsData(data);
            await this.service.modal.success('LLM 모델 설정을 저장했습니다.');
        } catch (error: any) {
            this.sectionErrors['llm-settings'] = this.errorText(error);
            await this.service.modal.error(this.sectionErrors['llm-settings']);
        }
        this.llmSettingsSaving = false;
        await this.service.render();
    }

    public async syncLlmModels() {
        if (this.llmSettingsSyncing) return;
        this.llmSettingsSyncing = true;
        this.sectionErrors['llm-settings'] = '';
        await this.service.render();
        try {
            this.actionResult = { type: 'llm-sync', result: await this.callApi('sync_ollama_models', {}, 'Ollama 모델 동기화에 실패했습니다.') };
            await this.loadLlmSettings(false);
        } catch (error: any) {
            this.sectionErrors['llm-settings'] = this.errorText(error);
        }
        this.llmSettingsSyncing = false;
        await this.service.render();
    }

    public async testLlmSettings() {
        if (this.llmSettingsTesting) return;
        this.llmSettingsTesting = true;
        this.sectionErrors['llm-settings'] = '';
        await this.service.render();
        try {
            this.llmTestResult = await this.callApi('infer_model', {
                model: this.llmSettingsForm.model,
                prompt: this.llmTestPrompt
            }, '선택 모델 테스트에 실패했습니다.');
        } catch (error: any) {
            this.sectionErrors['llm-settings'] = this.errorText(error);
        }
        this.llmSettingsTesting = false;
        await this.service.render();
    }

    public async selectTrainingScenario(scenario: any) {
        this.input = scenario.prompt || '';
        this.navTo('chat');
        await this.service.render();
    }

    public async generateReport(templateId: string) {
        if (this.reportGenerating) return;
        this.reportGenerating = true;
        this.sectionErrors.visualization = '';
        await this.service.render();
        try {
            const result = await this.callApi('report_compose', {
                template: templateId,
                title: `${this.visualizationDataset} ${this.visualizationMetric} 인사이트`,
                summary: `${this.visualizationDataset} 데이터와 ${this.chartType} 차트 결과를 기반으로 생성했습니다.`,
                analysis: this.visualizationReportData.rendered?.caption || '',
                data_sources: 'process.search, trace.compare, chart.render',
                conclusion: '선택된 인사이트를 기준으로 원인 후보와 후속 조치를 검증하세요.'
            }, '보고서 생성에 실패했습니다.');
            this.reportPreview = result;
            this.visualizationReportData.report = {
                ...(this.visualizationReportData.report || {}),
                sample: result,
                history: [result, ...(this.visualizationReportData.report?.history || [])].slice(0, 5)
            };
            this.actionResult = { type: 'report', result };
        } catch (error: any) {
            this.sectionErrors.visualization = this.errorText(error);
        }
        this.reportGenerating = false;
        await this.service.render();
    }

    public async selectReportTemplate(template: any) {
        this.reportTemplate = template?.id || template || this.reportTemplate;
        await this.generateReport(this.reportTemplate);
    }

    public currentReportStatus() {
        return this.reportPreview?.exportStatus || this.reportPreview?.status || this.visualizationReportData.report?.sample?.exportStatus || this.visualizationReportData.report?.status || 'draft_only';
    }

    public reportStatusLabel(status: string) {
        const labels: any = {
            draft_only: 'Markdown 초안',
            draft: '초안',
            available: '사용 가능',
            planned: '준비 중'
        };
        return labels[status] || status || '초안';
    }

    public currentReportNotice() {
        return this.reportPreview?.exportNotice || this.visualizationReportData.report?.exportNotice || this.visualizationReportData.report?.sample?.exportNotice || '현재는 Markdown 초안만 활성화되어 있으며 PDF/HTML export package는 준비 중입니다.';
    }

    public async openReportInChat() {
        if (!this.reportPreview) return;
        this.messages.push({
            role: 'assistant',
            content: this.reportPreview.markdown || this.reportPreview.title || '보고서를 생성했습니다.',
            citations: ['report.compose: ' + this.reportPreview.id]
        });
        this.navTo('chat');
        await this.service.render();
    }

    public async loadBackendHistory(reset: boolean = true, force: boolean = false) {
        if (this.conversationHistoryLoading) return;
        if (reset && this.historyBackendLoaded && !force) return;
        const requestSeq = ++this.historyRequestSeq;
        const page = reset ? 1 : Number(this.historyPagination.page || 1) + 1;
        this.conversationHistoryLoading = true;
        try {
            const result = await this.callApi('load_history', {
                page,
                dump: this.historyPagination.dump || 10,
                search: this.historySearch || '',
            }, '대화 이력을 불러오지 못했습니다.');
            if (requestSeq !== this.historyRequestSeq) return;
            const backendItems = result.items || [];
            const localItems = this.historyItems.filter((item: any) => Array.isArray(item.messages));
            const localById = new Map<string, any>();
            localItems.forEach((item: any) => localById.set(String(item.id), item));
            const hydratedBackendItems = backendItems.map((item: any) => localById.get(String(item.id)) || item);
            const merged = reset
                ? (Number(result.pagination?.total || 0) > 0 ? hydratedBackendItems : localItems)
                : [...this.historyItems, ...hydratedBackendItems];
            const seen = new Set();
            this.historyItems = merged.filter((item: any) => {
                if (seen.has(item.id)) return false;
                seen.add(item.id);
                return true;
            });
            this.historyPagination = result.pagination || { page, dump: 10, total: backendItems.length, totalPages: 1 };
            this.historyHealth = result.health || this.historyHealth;
            this.historyBackendLoaded = true;
        } catch (error: any) {
            if (requestSeq === this.historyRequestSeq) {
                this.sectionErrors.chat = this.errorText(error);
                await this.loadHistoryHealth(false);
            }
        } finally {
            if (requestSeq === this.historyRequestSeq) {
                this.conversationHistoryLoading = false;
                await this.service.render();
            }
        }
    }

    public async searchBackendHistory() {
        this.historyBackendLoaded = false;
        this.historyPagination.page = 1;
        await this.loadBackendHistory(true, true);
    }

    public hasMoreBackendHistory() {
        return Number(this.historyPagination.page || 1) < Number(this.historyPagination.totalPages || 1);
    }

    public async loadMoreHistory() {
        if (!this.hasMoreBackendHistory()) return;
        await this.loadBackendHistory(false, true);
    }

    public async loadHistoryHealth(render: boolean = true) {
        try {
            this.historyHealth = await this.callApi('history_health', {}, '대화 이력 상태를 확인하지 못했습니다.');
        } catch (error: any) {
            this.historyHealth = {
                status: 'unavailable',
                healthy: false,
                backups: [],
                message: this.errorText(error, '대화 이력 상태를 확인하지 못했습니다.'),
            };
        }
        if (render) await this.service.render();
    }

    public latestHistoryBackup() {
        return (this.historyHealth?.backups || [])[0] || null;
    }

    public historyHealthLabel() {
        const labels: any = {
            healthy: '서버 이력 정상',
            empty: '서버 이력 비어 있음',
            corrupt: '이력 파일 손상',
            oversized: '이력 파일 크기 초과',
            unavailable: '상태 확인 실패',
        };
        return labels[this.historyHealth?.status] || '이력 상태 확인 중';
    }

    public async recoverHistory(reset: boolean = false) {
        if (this.historyRecoveryBusy) return;
        const backup = this.latestHistoryBackup();
        if (!reset && !backup) return;
        const confirmed = await this.service.modal.show({
            title: reset ? '손상 이력 초기화' : '대화 이력 복원',
            message: reset
                ? '현재 손상 파일을 격리하고 서버 이력을 비웁니다. 브라우저에 남은 대화는 유지됩니다.'
                : `검증된 백업 ${backup.items || 0}건으로 복원하고 현재 파일은 격리 보관합니다.`,
            action: reset ? '격리 후 초기화' : '검증 백업 복원',
            actionBtn: reset ? 'error' : 'success',
            status: reset ? 'error' : 'success',
        });
        if (!confirmed) return;
        this.historyRecoveryBusy = true;
        await this.service.render();
        try {
            const result = await this.callApi('history_recover', {
                action: reset ? 'reset' : 'restore',
                backup_id: reset ? '' : backup.id,
                confirmation: reset ? 'RESET CORRUPT HISTORY' : 'RESTORE HISTORY',
            }, '대화 이력을 복구하지 못했습니다.');
            this.historyHealth = result.health || this.historyHealth;
            this.historyBackendLoaded = false;
            this.sectionErrors.chat = '';
            await this.loadBackendHistory(true, true);
        } catch (error: any) {
            this.sectionErrors.chat = this.errorText(error, '대화 이력을 복구하지 못했습니다.');
            await this.loadHistoryHealth(false);
        } finally {
            this.historyRecoveryBusy = false;
            await this.service.render();
        }
    }

    public filterScenario(sc: any) {
        return !this.trainingRole || sc.audience === this.trainingRole;
    }

    public statusDotClass(status: string) {
        const map: any = {
            ok: 'bg-[#0f766e]', watch: 'bg-amber-500', hot: 'bg-red-500',
            ready: 'bg-[#2e6fae]', mock: 'bg-[#94a3b8]', planned: 'bg-gray-400', completed: 'bg-[#0f766e]'
        };
        return map[status] || 'bg-gray-400';
    }

    public trendBarHeight(v: number, arr: number[]) {
        const max = Math.max(...arr, 1);
        return Math.max(16, Math.round((v / max) * 80)) + '%';
    }

    public traceBarHeight(v: number) {
        const value = Math.abs(Number(v || 0));
        const scaled = value < 10 ? value * 34 : value < 120 ? value : Math.sqrt(value) * 3;
        return Math.max(8, Math.min(96, Math.round(scaled))) + '%';
    }
}

export default PageAgentComponent;